/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/helpers/cache.module.ts":
/*!*************************************!*\
  !*** ./src/helpers/cache.module.ts ***!
  \*************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Cache = void 0;
const _helpers_1 = __webpack_require__(/*! ./ */ "./src/helpers/index.ts");
const KEY_SEP = '.$';
const KEY_PREFIX = `icsai.smarthub.cache${KEY_SEP}`;
const sec = 1;
const min = sec * 60;
const hr = min * 60;
const day = hr * 24;
const ttlValues = { sec, min, hr, day };
const storage = (options) => (options === null || options === void 0 ? void 0 : options.storage) == 'local'
    ? localStorage
    : sessionStorage;
const hasExpired = (time, options) => {
    var _a, _b;
    const ttl = (_a = options === null || options === void 0 ? void 0 : options.ttl) !== null && _a !== void 0 ? _a : 0;
    const seconds = typeof ttl === 'number' && ttl > 0
        ? ttl
        : typeof ttl === 'object' && ttl
            ? ttlValues[(_b = ttl.unit) !== null && _b !== void 0 ? _b : 'hr'] * (ttl.value || 1)
            : 0;
    if (seconds > 0) {
        const date = new Date(time);
        date.setSeconds(date.getSeconds() + seconds);
        return date <= new Date();
    }
    return false;
};
const getKey = (name, options) => {
    const prefix = (options === null || options === void 0 ? void 0 : options.prefix) || '';
    return `${KEY_PREFIX}${prefix}${name}`;
};
const getHash = ({ hash: hashOption } = {}, hash) => (hash === null || hash === void 0 ? void 0 : hash.length) ? hash
    : (hashOption === null || hashOption === void 0 ? void 0 : hashOption.length) ? hashOption
        : null;
const set = (name, value, options, valueHash) => {
    const cacheKey = getKey(name, options);
    const cache = storage(options);
    if (value == null)
        cache.removeItem(cacheKey);
    else {
        const hash = getHash(options, valueHash);
        const time = (new Date()).getTime();
        cache.setItem(cacheKey, JSON.stringify([time, value, hash]));
    }
};
const get = (name, options, valueHash) => {
    const cacheKey = getKey(name, options);
    const cache = storage(options);
    const rawCacheValue = cache.getItem(cacheKey);
    if (rawCacheValue === null || rawCacheValue === void 0 ? void 0 : rawCacheValue.length) {
        try {
            const hash = getHash(options, valueHash);
            const [time, value, currentHash] = JSON.parse(rawCacheValue);
            if (!hasExpired(time, options) && currentHash == hash)
                return value;
        }
        catch (ex) {
            _helpers_1.Logger.warn("Failed to parse cache value", { rawCacheValue, name, options });
        }
        cache.removeItem(cacheKey);
    }
    return null;
};
exports.Cache = { set, get };


/***/ }),

/***/ "./src/helpers/concat-middleware.fn.ts":
/*!*********************************************!*\
  !*** ./src/helpers/concat-middleware.fn.ts ***!
  \*********************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.concatMiddleware = void 0;
//TODO readability
const concatMiddleware = (...middlewares) => {
    return options => {
        const setup = middlewares.reduce((setup, middleware) => middleware ? [...setup, middleware(options)] : setup, []);
        return last => {
            const stack = setup.slice();
            const work = (...args) => {
                const next = stack.shift();
                return (next ? next(work) : last)(...args);
            };
            return work;
        };
    };
};
exports.concatMiddleware = concatMiddleware;


/***/ }),

/***/ "./src/helpers/index.ts":
/*!******************************!*\
  !*** ./src/helpers/index.ts ***!
  \******************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./logger.module */ "./src/helpers/logger.module.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./cache.module */ "./src/helpers/cache.module.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./replace-text.fn */ "./src/helpers/replace-text.fn.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./concat-middleware.fn */ "./src/helpers/concat-middleware.fn.ts"), exports);


/***/ }),

/***/ "./src/helpers/logger.module.ts":
/*!**************************************!*\
  !*** ./src/helpers/logger.module.ts ***!
  \**************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Logger = void 0;
const error = (message, raise, context) => {
    console.log(`ERROR: ${message}`, context);
    if (raise)
        throw new Error(message);
};
const warn = (message, context) => {
    console.log(`WARN: ${message}`, context);
};
const info = (message, context) => {
    console.log(`INFO: ${message}`, context);
};
exports.Logger = { error, info, warn };


/***/ }),

/***/ "./src/helpers/replace-text.fn.ts":
/*!****************************************!*\
  !*** ./src/helpers/replace-text.fn.ts ***!
  \****************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.deepReplaceParams = exports.replacement = void 0;
const replacement = (text, params) => {
    const isTrue = true;
    let startIdx = 0;
    let endIdx = 0;
    while (isTrue) {
        startIdx = text.indexOf("{", endIdx);
        if (!~startIdx)
            break;
        endIdx = text.indexOf("}", startIdx);
        if (!~endIdx)
            break;
        const paths = text.substr(startIdx + 1, endIdx - startIdx - 1).split(".");
        let obj = params;
        for (let i = 0; i < paths.length; i++) {
            obj = obj[paths[i]];
            if (!obj)
                break;
            if (i == paths.length - 1)
                text = `${text.substr(0, startIdx)}${obj}${text.substr(endIdx + 1)}`;
        }
    }
    return text;
};
exports.replacement = replacement;
const deepReplaceParams = (obj, params) => {
    if (typeof obj == 'string')
        return exports.replacement(obj, params);
    if (Array.isArray(obj))
        return obj.map(val => exports.deepReplaceParams(val, params));
    else
        return Object.keys(obj).reduce((ret, key) => {
            const val = obj[key];
            return Object.assign(Object.assign({}, ret), { [key]: exports.deepReplaceParams(val, params) });
        }, {});
};
exports.deepReplaceParams = deepReplaceParams;


/***/ }),

/***/ "./src/hooks/index.ts":
/*!****************************!*\
  !*** ./src/hooks/index.ts ***!
  \****************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useHasPermission = exports.useGetThemeImageURI = exports.useThemeImageURI = exports.useHookRef = exports.useAsyncEffect = exports.useGetFile = exports.useFile = exports.useBookmarks = exports.useBookmark = exports.useTransform = exports.useFetch = exports.useContentFormat = exports.createFormatter = exports.useFormat = exports.useRender = exports.useHandleSubmit = exports.useHandleLink = exports.useHandleSkill = exports.useHandleCommand = exports.invokeSkill = exports.useInvokeSkill = exports.sendMessage = exports.useSendMessage = exports.sendBackChannel = exports.useSendBackChannel = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
var use_send_back_channel_hook_1 = __webpack_require__(/*! ./use-send-back-channel.hook */ "./src/hooks/use-send-back-channel.hook.ts");
Object.defineProperty(exports, "useSendBackChannel", ({ enumerable: true, get: function () { return use_send_back_channel_hook_1.useSendBackChannel; } }));
Object.defineProperty(exports, "sendBackChannel", ({ enumerable: true, get: function () { return use_send_back_channel_hook_1.sendBackChannel; } }));
var use_send_message_hook_1 = __webpack_require__(/*! ./use-send-message.hook */ "./src/hooks/use-send-message.hook.ts");
Object.defineProperty(exports, "useSendMessage", ({ enumerable: true, get: function () { return use_send_message_hook_1.useSendMessage; } }));
Object.defineProperty(exports, "sendMessage", ({ enumerable: true, get: function () { return use_send_message_hook_1.sendMessage; } }));
var use_invoke_skill_hook_1 = __webpack_require__(/*! ./use-invoke-skill.hook */ "./src/hooks/use-invoke-skill.hook.ts");
Object.defineProperty(exports, "useInvokeSkill", ({ enumerable: true, get: function () { return use_invoke_skill_hook_1.useInvokeSkill; } }));
Object.defineProperty(exports, "invokeSkill", ({ enumerable: true, get: function () { return use_invoke_skill_hook_1.invokeSkill; } }));
var use_handle_command_hook_1 = __webpack_require__(/*! ./use-handle-command.hook */ "./src/hooks/use-handle-command.hook.ts");
Object.defineProperty(exports, "useHandleCommand", ({ enumerable: true, get: function () { return use_handle_command_hook_1.useHandleCommand; } }));
var use_handle_skill_hook_1 = __webpack_require__(/*! ./use-handle-skill.hook */ "./src/hooks/use-handle-skill.hook.ts");
Object.defineProperty(exports, "useHandleSkill", ({ enumerable: true, get: function () { return use_handle_skill_hook_1.useHandleSkill; } }));
var use_handle_link_hook_1 = __webpack_require__(/*! ./use-handle-link.hook */ "./src/hooks/use-handle-link.hook.ts");
Object.defineProperty(exports, "useHandleLink", ({ enumerable: true, get: function () { return use_handle_link_hook_1.useHandleLink; } }));
var use_handle_submit_hook_1 = __webpack_require__(/*! ./use-handle-submit.hook */ "./src/hooks/use-handle-submit.hook.ts");
Object.defineProperty(exports, "useHandleSubmit", ({ enumerable: true, get: function () { return use_handle_submit_hook_1.useHandleSubmit; } }));
var use_render_hook_1 = __webpack_require__(/*! ./use-render.hook */ "./src/hooks/use-render.hook.tsx");
Object.defineProperty(exports, "useRender", ({ enumerable: true, get: function () { return use_render_hook_1.useRender; } }));
var use_format_hook_1 = __webpack_require__(/*! ./use-format.hook */ "./src/hooks/use-format.hook.ts");
Object.defineProperty(exports, "useFormat", ({ enumerable: true, get: function () { return use_format_hook_1.useFormat; } }));
Object.defineProperty(exports, "createFormatter", ({ enumerable: true, get: function () { return use_format_hook_1.createFormatter; } }));
var use_content_format_hook_1 = __webpack_require__(/*! ./use-content-format.hook */ "./src/hooks/use-content-format.hook.ts");
Object.defineProperty(exports, "useContentFormat", ({ enumerable: true, get: function () { return use_content_format_hook_1.useContentFormat; } }));
var use_fetch_hook_1 = __webpack_require__(/*! ./use-fetch.hook */ "./src/hooks/use-fetch.hook.ts");
Object.defineProperty(exports, "useFetch", ({ enumerable: true, get: function () { return use_fetch_hook_1.useFetch; } }));
var use_transform_hook_1 = __webpack_require__(/*! ./use-transform.hook */ "./src/hooks/use-transform.hook.ts");
Object.defineProperty(exports, "useTransform", ({ enumerable: true, get: function () { return use_transform_hook_1.useTransform; } }));
var use_bookmark_hook_1 = __webpack_require__(/*! ./use-bookmark.hook */ "./src/hooks/use-bookmark.hook.ts");
Object.defineProperty(exports, "useBookmark", ({ enumerable: true, get: function () { return use_bookmark_hook_1.useBookmark; } }));
var use_bookmarks_hook_1 = __webpack_require__(/*! ./use-bookmarks.hook */ "./src/hooks/use-bookmarks.hook.ts");
Object.defineProperty(exports, "useBookmarks", ({ enumerable: true, get: function () { return use_bookmarks_hook_1.useBookmarks; } }));
var use_file_hook_1 = __webpack_require__(/*! ./use-file.hook */ "./src/hooks/use-file.hook.ts");
Object.defineProperty(exports, "useFile", ({ enumerable: true, get: function () { return use_file_hook_1.useFile; } }));
Object.defineProperty(exports, "useGetFile", ({ enumerable: true, get: function () { return use_file_hook_1.useGetFile; } }));
var use_async_effect_hook_1 = __webpack_require__(/*! ./use-async-effect.hook */ "./src/hooks/use-async-effect.hook.ts");
Object.defineProperty(exports, "useAsyncEffect", ({ enumerable: true, get: function () { return use_async_effect_hook_1.useAsyncEffect; } }));
var use_hook_ref_hook_1 = __webpack_require__(/*! ./use-hook-ref.hook */ "./src/hooks/use-hook-ref.hook.ts");
Object.defineProperty(exports, "useHookRef", ({ enumerable: true, get: function () { return use_hook_ref_hook_1.useHookRef; } }));
var use_theme_image_hook_1 = __webpack_require__(/*! ./use-theme-image.hook */ "./src/hooks/use-theme-image.hook.ts");
Object.defineProperty(exports, "useThemeImageURI", ({ enumerable: true, get: function () { return use_theme_image_hook_1.useThemeImageURI; } }));
Object.defineProperty(exports, "useGetThemeImageURI", ({ enumerable: true, get: function () { return use_theme_image_hook_1.useGetThemeImageURI; } }));
var use_has_permission_hook_1 = __webpack_require__(/*! ./use-has-permission.hook */ "./src/hooks/use-has-permission.hook.ts");
Object.defineProperty(exports, "useHasPermission", ({ enumerable: true, get: function () { return use_has_permission_hook_1.useHasPermission; } }));
tslib_1.__exportStar(__webpack_require__(/*! ./use-order.hook */ "./src/hooks/use-order.hook.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./use-condition.hooks */ "./src/hooks/use-condition.hooks/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./use-handle-panel.hook */ "./src/hooks/use-handle-panel.hook.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./use-event-dispatch.hook */ "./src/hooks/use-event-dispatch.hook.ts"), exports);


/***/ }),

/***/ "./src/hooks/use-action-router.hook.ts":
/*!*********************************************!*\
  !*** ./src/hooks/use-action-router.hook.ts ***!
  \*********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useActionRouter = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = __webpack_require__(/*! react */ "react");
const state_1 = __webpack_require__(/*! ../state */ "./src/state/index.ts");
const use_fetch_hook_1 = __webpack_require__(/*! ./use-fetch.hook */ "./src/hooks/use-fetch.hook.ts");
const use_format_hook_1 = __webpack_require__(/*! ./use-format.hook */ "./src/hooks/use-format.hook.ts");
const use_transform_hook_1 = __webpack_require__(/*! ./use-transform.hook */ "./src/hooks/use-transform.hook.ts");
const use_hook_ref_hook_1 = __webpack_require__(/*! ./use-hook-ref.hook */ "./src/hooks/use-hook-ref.hook.ts");
const useActionRouter = () => {
    const providersRef = use_hook_ref_hook_1.useHookRef(state_1.useProviders);
    const knownUrisRef = use_hook_ref_hook_1.useHookRef(state_1.useKnownUris);
    const formatterRef = use_hook_ref_hook_1.useHookRef(use_format_hook_1.useFormat, {
        knownUris: knownUrisRef.current
    });
    const fetch = use_fetch_hook_1.useFetch();
    const transform = use_transform_hook_1.useTransform();
    return react_1.useCallback((action) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        return providersRef.current.route.reduce((promise, provider) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
            return promise.then(route => {
                return route !== null && route !== void 0 ? route : provider.route(action, fetch, transform, formatterRef.current);
            });
        }), Promise.resolve(null));
    }), []);
};
exports.useActionRouter = useActionRouter;


/***/ }),

/***/ "./src/hooks/use-async-effect.hook.ts":
/*!********************************************!*\
  !*** ./src/hooks/use-async-effect.hook.ts ***!
  \********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useAsyncEffect = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const useAsyncEffect = (fn, deps) => {
    react_1.useEffect(() => {
        fn();
    }, deps);
};
exports.useAsyncEffect = useAsyncEffect;


/***/ }),

/***/ "./src/hooks/use-bookmark.hook.ts":
/*!****************************************!*\
  !*** ./src/hooks/use-bookmark.hook.ts ***!
  \****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useBookmark = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const _state_1 = __webpack_require__(/*! ../state */ "./src/state/index.ts");
const react_1 = __webpack_require__(/*! react */ "react");
const use_hook_ref_hook_1 = __webpack_require__(/*! ./use-hook-ref.hook */ "./src/hooks/use-hook-ref.hook.ts");
const use_transform_hook_1 = __webpack_require__(/*! ./use-transform.hook */ "./src/hooks/use-transform.hook.ts");
const useBookmark = (info) => {
    const authRef = use_hook_ref_hook_1.useHookRef(_state_1.useAuth);
    const transform = use_transform_hook_1.useTransform();
    const providersRef = use_hook_ref_hook_1.useHookRef(_state_1.useProviders);
    const [id, setId] = react_1.useState(null);
    react_1.useEffect(() => {
        if (info === null || info === void 0 ? void 0 : info.ref)
            (() => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
                const id = info.ref.$schema == "https://ics.ai/smarthub/bookmark/ref"
                    ? yield providersRef.current.bookmark.has(info.ref, authRef.current)
                    : info.ref.$id;
                setId(id);
            }))();
    }, [info]);
    const toggle = react_1.useCallback(() => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        const bookmarks = providersRef.current.bookmark;
        if (!(id === null || id === void 0 ? void 0 : id.length)) {
            const { $id } = yield bookmarks.add(info.data, info.refresh, authRef.current, transform);
            setId($id);
        }
        else {
            yield bookmarks.remove(id, authRef.current);
            setId(null);
        }
    }), [id, info]);
    return react_1.useMemo(() => ([(id === null || id === void 0 ? void 0 : id.length) > 0, toggle]), [id, toggle]);
};
exports.useBookmark = useBookmark;


/***/ }),

/***/ "./src/hooks/use-bookmarks.hook.ts":
/*!*****************************************!*\
  !*** ./src/hooks/use-bookmarks.hook.ts ***!
  \*****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useBookmarks = void 0;
const _state_1 = __webpack_require__(/*! ../state */ "./src/state/index.ts");
const react_1 = __webpack_require__(/*! react */ "react");
const use_fetch_hook_1 = __webpack_require__(/*! ./use-fetch.hook */ "./src/hooks/use-fetch.hook.ts");
const use_hook_ref_hook_1 = __webpack_require__(/*! ./use-hook-ref.hook */ "./src/hooks/use-hook-ref.hook.ts");
const use_transform_hook_1 = __webpack_require__(/*! ./use-transform.hook */ "./src/hooks/use-transform.hook.ts");
const useBookmarks = () => {
    const authRef = use_hook_ref_hook_1.useHookRef(_state_1.useAuth);
    const providersRef = use_hook_ref_hook_1.useHookRef(_state_1.useProviders);
    const transform = use_transform_hook_1.useTransform();
    const fetch = use_fetch_hook_1.useFetch();
    const query = react_1.useCallback((params, refiners, continuation) => {
        return providersRef.current.bookmark.query(params, {
            auth: authRef.current,
            continuation,
            refiners
        });
    }, []);
    const refresh = react_1.useCallback((bookmark) => {
        return providersRef.current.bookmark.refresh(bookmark, authRef.current, fetch, transform);
    }, []);
    return react_1.useMemo(() => ([query, refresh]), [query, refresh]);
};
exports.useBookmarks = useBookmarks;


/***/ }),

/***/ "./src/hooks/use-condition.hooks/index.ts":
/*!************************************************!*\
  !*** ./src/hooks/use-condition.hooks/index.ts ***!
  \************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./test-condition.helper */ "./src/hooks/use-condition.hooks/test-condition.helper.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./use-condition.hook */ "./src/hooks/use-condition.hooks/use-condition.hook.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./use-conditions.hook */ "./src/hooks/use-condition.hooks/use-conditions.hook.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./use-test-condition.hook */ "./src/hooks/use-condition.hooks/use-test-condition.hook.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./use-test-conditions.hook */ "./src/hooks/use-condition.hooks/use-test-conditions.hook.ts"), exports);


/***/ }),

/***/ "./src/hooks/use-condition.hooks/test-condition.helper.ts":
/*!****************************************************************!*\
  !*** ./src/hooks/use-condition.hooks/test-condition.helper.ts ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.testCondition = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const _models_1 = __webpack_require__(/*! ../../models */ "./src/models/index.ts");
const testCondition = (condition, state, transform, fetch) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    const { $schema, consumes, query } = condition || {};
    if (!condition || !$schema || (!query && !(consumes === null || consumes === void 0 ? void 0 : consumes.length)))
        return true;
    const { data: items } = query
        ? yield fetch(query, state)
        : { data: null };
    const params = Object.assign(Object.assign({}, state), { $schema,
        items });
    const { result: { success } = {} } = transform(_models_1.IConditionResultSchema, params);
    return success;
});
exports.testCondition = testCondition;


/***/ }),

/***/ "./src/hooks/use-condition.hooks/test-conditions.helper.ts":
/*!*****************************************************************!*\
  !*** ./src/hooks/use-condition.hooks/test-conditions.helper.ts ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.testConditions = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const _hooks_1 = __webpack_require__(/*! ./.. */ "./src/hooks/index.ts");
const emptyResults = [];
const testConditions = (conditional, state, transform, fetch) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    if (!(conditional === null || conditional === void 0 ? void 0 : conditional.length))
        return emptyResults;
    const promises = yield Promise.all(conditional.map((c) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        const result = yield _hooks_1.testCondition(c.condition, state, transform, fetch);
        return result
            ? c
            : undefined;
    })));
    const items = promises.filter(c => c !== undefined);
    return items.length
        ? items
        : emptyResults;
});
exports.testConditions = testConditions;


/***/ }),

/***/ "./src/hooks/use-condition.hooks/use-condition.hook.ts":
/*!*************************************************************!*\
  !*** ./src/hooks/use-condition.hooks/use-condition.hook.ts ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCondition = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const _hooks_1 = __webpack_require__(/*! ./.. */ "./src/hooks/index.ts");
const _state_1 = __webpack_require__(/*! ../../state */ "./src/state/index.ts");
const react_1 = __webpack_require__(/*! react */ "react");
const test_condition_helper_1 = __webpack_require__(/*! ./test-condition.helper */ "./src/hooks/use-condition.hooks/test-condition.helper.ts");
const useCondition = (conditional, type, level) => {
    const { condition, condition: { $id, consumes = [] } = {} } = conditional;
    const [sharedState, setSharedState] = _state_1.useSharedStates($id, type, level);
    const fetch = _hooks_1.useFetch();
    const transform = _hooks_1.useTransform();
    const [state, setState] = react_1.useState();
    react_1.useEffect(() => setSharedState(consumes), [consumes]);
    _hooks_1.useAsyncEffect(() => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        if (!condition)
            setState(conditional);
        const result = yield test_condition_helper_1.testCondition(condition, sharedState, transform, fetch);
        if (result)
            setState(result ? conditional : null);
    }), [conditional, sharedState]);
    return state;
};
exports.useCondition = useCondition;


/***/ }),

/***/ "./src/hooks/use-condition.hooks/use-conditions.hook.ts":
/*!**************************************************************!*\
  !*** ./src/hooks/use-condition.hooks/use-conditions.hook.ts ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useConditions = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const _hooks_1 = __webpack_require__(/*! ./.. */ "./src/hooks/index.ts");
const _state_1 = __webpack_require__(/*! ../../state */ "./src/state/index.ts");
const react_1 = __webpack_require__(/*! react */ "react");
const test_conditions_helper_1 = __webpack_require__(/*! ./test-conditions.helper */ "./src/hooks/use-condition.hooks/test-conditions.helper.ts");
const useConditions = (id, conditional, type, level) => {
    const [sharedState, setSharedState] = _state_1.useSharedStates(id, type, level);
    const fetch = _hooks_1.useFetch();
    const transform = _hooks_1.useTransform();
    const [state, setState] = react_1.useState();
    react_1.useEffect(() => {
        const consumes = conditional === null || conditional === void 0 ? void 0 : conditional.reduce((all, c) => {
            var _a;
            return [
                ...(((_a = c.condition) === null || _a === void 0 ? void 0 : _a.consumes) || []),
                ...all
            ];
        }, []);
        setSharedState(consumes);
    }, [conditional]);
    _hooks_1.useAsyncEffect(() => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        const results = yield test_conditions_helper_1.testConditions(conditional, sharedState, transform, fetch);
        setState(results);
    }), [sharedState, conditional]);
    return state;
};
exports.useConditions = useConditions;


/***/ }),

/***/ "./src/hooks/use-condition.hooks/use-test-condition.hook.ts":
/*!******************************************************************!*\
  !*** ./src/hooks/use-condition.hooks/use-test-condition.hook.ts ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useTestCondition = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const _hooks_1 = __webpack_require__(/*! ./.. */ "./src/hooks/index.ts");
const _state_1 = __webpack_require__(/*! ../../state */ "./src/state/index.ts");
const react_1 = __webpack_require__(/*! react */ "react");
const test_condition_helper_1 = __webpack_require__(/*! ./test-condition.helper */ "./src/hooks/use-condition.hooks/test-condition.helper.ts");
const useTestCondition = () => {
    const fetch = _hooks_1.useFetch();
    const transform = _hooks_1.useTransform();
    const getState = _state_1.useGetSharedStates();
    return react_1.useCallback((condition) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        const { $schema, consumes, query } = condition || {};
        if (!condition || !$schema || (!query && !(consumes === null || consumes === void 0 ? void 0 : consumes.length)))
            return true;
        const state = (consumes === null || consumes === void 0 ? void 0 : consumes.length) ? yield getState(consumes)
            : null;
        return test_condition_helper_1.testCondition(condition, state, transform, fetch);
    }), [fetch, transform]);
};
exports.useTestCondition = useTestCondition;


/***/ }),

/***/ "./src/hooks/use-condition.hooks/use-test-conditions.hook.ts":
/*!*******************************************************************!*\
  !*** ./src/hooks/use-condition.hooks/use-test-conditions.hook.ts ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useTestConditions = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const _hooks_1 = __webpack_require__(/*! ./.. */ "./src/hooks/index.ts");
const _state_1 = __webpack_require__(/*! ../../state */ "./src/state/index.ts");
const react_1 = __webpack_require__(/*! react */ "react");
const test_conditions_helper_1 = __webpack_require__(/*! ./test-conditions.helper */ "./src/hooks/use-condition.hooks/test-conditions.helper.ts");
const useTestConditions = (id, conditional, type, level) => {
    const [sharedState, setSharedState] = _state_1.useSharedStates(id, type, level);
    const fetch = _hooks_1.useFetch();
    const transform = _hooks_1.useTransform();
    react_1.useEffect(() => {
        const consumes = conditional === null || conditional === void 0 ? void 0 : conditional.reduce((all, c) => {
            var _a;
            return [
                ...(((_a = c.condition) === null || _a === void 0 ? void 0 : _a.consumes) || []),
                ...all
            ];
        }, []);
        setSharedState(consumes);
    }, [conditional]);
    return react_1.useCallback(() => tslib_1.__awaiter(void 0, void 0, void 0, function* () { return test_conditions_helper_1.testConditions(conditional, sharedState, transform, fetch); }), [sharedState, conditional]);
};
exports.useTestConditions = useTestConditions;


/***/ }),

/***/ "./src/hooks/use-content-format.hook.ts":
/*!**********************************************!*\
  !*** ./src/hooks/use-content-format.hook.ts ***!
  \**********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useContentFormat = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const state_1 = __webpack_require__(/*! ../state */ "./src/state/index.ts");
const use_format_hook_1 = __webpack_require__(/*! ./use-format.hook */ "./src/hooks/use-format.hook.ts");
const _helpers_1 = __webpack_require__(/*! ../helpers */ "./src/helpers/index.ts");
const use_hook_ref_hook_1 = __webpack_require__(/*! ./use-hook-ref.hook */ "./src/hooks/use-hook-ref.hook.ts");
const useContentFormat = (providerName) => {
    const providersRef = use_hook_ref_hook_1.useHookRef(state_1.useProviders);
    const knownUrisRef = use_hook_ref_hook_1.useHookRef(state_1.useKnownUris);
    const formatterRef = use_hook_ref_hook_1.useHookRef(use_format_hook_1.useFormat, {
        knownUris: knownUrisRef.current
    });
    return react_1.useCallback((content, options) => {
        const provider = providersRef.current.format.find(p => p.name == providerName);
        if (provider) {
            const formatOptions = Object.assign(Object.assign({}, options), { formatter: formatterRef.current });
            return provider.process(content, formatOptions);
        }
        else {
            _helpers_1.Logger.error(`Content format provider ${providerName} not found. Check component config`);
            return Promise.reject();
        }
    }, []);
};
exports.useContentFormat = useContentFormat;


/***/ }),

/***/ "./src/hooks/use-event-dispatch.hook.ts":
/*!**********************************************!*\
  !*** ./src/hooks/use-event-dispatch.hook.ts ***!
  \**********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useEventDispatch = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const on = (handlers, fn) => {
    if (!~handlers.indexOf(fn))
        handlers.push(fn);
};
const off = (handlers, fn) => {
    const idx = handlers.indexOf(fn);
    if (~idx)
        handlers.splice(idx, 1);
};
const dispatch = (handlers, current, previous) => {
    handlers.forEach(h => {
        setTimeout(() => {
            h(current, previous);
        }, 0);
    });
};
const useEventDispatch = (value, handler) => {
    const handlersRef = react_1.useRef([]);
    const valueRef = react_1.useRef();
    const lastValueRef = react_1.useRef(valueRef.current);
    valueRef.current = value;
    react_1.useEffect(() => {
        if (handler)
            on(handlersRef.current, handler);
    }, [handler]);
    react_1.useEffect(() => {
        dispatch(handlersRef.current, value, lastValueRef.current);
    }, [value]);
    const getter = react_1.useCallback(() => valueRef.current, []);
    const dispatchCallback = react_1.useCallback((fn) => {
        if (fn)
            return on(handlersRef.current, fn);
        else
            return {
                on: (fn) => {
                    on(handlersRef.current, fn);
                },
                off: (fn) => {
                    off(handlersRef.current, fn);
                },
            };
    }, []);
    return [getter, dispatchCallback];
};
exports.useEventDispatch = useEventDispatch;


/***/ }),

/***/ "./src/hooks/use-fetch.hook.ts":
/*!*************************************!*\
  !*** ./src/hooks/use-fetch.hook.ts ***!
  \*************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useFetch = void 0;
const _state_1 = __webpack_require__(/*! ../state */ "./src/state/index.ts");
const react_1 = __webpack_require__(/*! react */ "react");
const use_hook_ref_hook_1 = __webpack_require__(/*! ./use-hook-ref.hook */ "./src/hooks/use-hook-ref.hook.ts");
const useFetch = () => {
    const providersRef = use_hook_ref_hook_1.useHookRef(_state_1.useContentProviders);
    const fetchRef = use_hook_ref_hook_1.useHookRef(_state_1.useFetchMiddleware);
    const authRef = use_hook_ref_hook_1.useHookRef(_state_1.useAuth);
    const knownUrisRef = use_hook_ref_hook_1.useHookRef(_state_1.useKnownUris);
    const profileRef = use_hook_ref_hook_1.useHookRef(_state_1.useProfile);
    return react_1.useCallback((query, params, continuation, body) => {
        return fetchRef.current({
            context: {
                auth: authRef.current,
                profile: profileRef.current,
                params,
                continuation,
                knownUris: knownUrisRef.current,
                body
            },
            query: query,
            providers: providersRef.current,
            fetch: fetchRef.current
        });
    }, []);
};
exports.useFetch = useFetch;


/***/ }),

/***/ "./src/hooks/use-file.hook.ts":
/*!************************************!*\
  !*** ./src/hooks/use-file.hook.ts ***!
  \************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useGetFile = exports.useFile = void 0;
const _helpers_1 = __webpack_require__(/*! ../helpers */ "./src/helpers/index.ts");
const _state_1 = __webpack_require__(/*! ../state */ "./src/state/index.ts");
const react_1 = __webpack_require__(/*! react */ "react");
const use_hook_ref_hook_1 = __webpack_require__(/*! ./use-hook-ref.hook */ "./src/hooks/use-hook-ref.hook.ts");
//TODO move profile and entity to params
const useFile = () => {
    const providersRef = use_hook_ref_hook_1.useHookRef(_state_1.useProviders);
    const authRef = use_hook_ref_hook_1.useHookRef(_state_1.useAuth);
    const knownUrisRef = use_hook_ref_hook_1.useHookRef(_state_1.useKnownUris);
    const profileRef = use_hook_ref_hook_1.useHookRef(_state_1.useProfile);
    const entityRef = use_hook_ref_hook_1.useHookRef(_state_1.usePanelEntity);
    const upload = react_1.useCallback((file, query, params) => {
        const provider = providersRef.current.file.find(p => p.name == query.provider);
        if (!provider)
            _helpers_1.Logger.error(`Could not find provider: ${query.provider}`, true, { query });
        return provider === null || provider === void 0 ? void 0 : provider.upload(file, query, {
            auth: authRef.current,
            profile: profileRef.current,
            entity: entityRef.current,
            params,
            knownUris: knownUrisRef.current,
        });
    }, []);
    const download = react_1.useCallback((query, type, params, fileName) => {
        const provider = providersRef.current.file.find(p => p.name == query.provider);
        if (!provider)
            _helpers_1.Logger.error(`Could not find provider: ${query.provider}`, true, { query });
        return provider === null || provider === void 0 ? void 0 : provider.download(query, {
            auth: authRef.current,
            profile: profileRef.current,
            entity: entityRef.current,
            params,
            knownUris: knownUrisRef.current,
        }, type, fileName);
    }, []);
    return react_1.useMemo(() => [upload, download], [upload, download]);
};
exports.useFile = useFile;
const useGetFile = () => {
    const providersRef = use_hook_ref_hook_1.useHookRef(_state_1.useProviders);
    const authRef = use_hook_ref_hook_1.useHookRef(_state_1.useAuth);
    const knownUrisRef = use_hook_ref_hook_1.useHookRef(_state_1.useKnownUris);
    const profileRef = use_hook_ref_hook_1.useHookRef(_state_1.useProfile);
    const entityRef = use_hook_ref_hook_1.useHookRef(_state_1.usePanelEntity);
    return react_1.useCallback((query, type, params, fileName) => {
        const provider = providersRef.current.file.find(p => p.name == query.provider);
        if (!provider)
            _helpers_1.Logger.error(`Could not find provider: ${query.provider}`, true, { query });
        return provider === null || provider === void 0 ? void 0 : provider.download(query, {
            auth: authRef.current,
            profile: profileRef.current,
            entity: entityRef.current,
            params,
            knownUris: knownUrisRef.current,
        }, type, fileName);
    }, []);
};
exports.useGetFile = useGetFile;


/***/ }),

/***/ "./src/hooks/use-format.hook.ts":
/*!**************************************!*\
  !*** ./src/hooks/use-format.hook.ts ***!
  \**************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createFormatter = exports.useFormat = void 0;
const _helpers_1 = __webpack_require__(/*! ../helpers */ "./src/helpers/index.ts");
const react_1 = __webpack_require__(/*! react */ "react");
const has = (target, key) => true;
const get = (target, key) => (key === Symbol.unscopables)
    ? undefined
    : target[key];
const useFormat = (params) => {
    const globalParams = params !== null && params !== void 0 ? params : {};
    const proxy = new Proxy(globalParams, { has, get });
    return react_1.useCallback((template, params) => {
        try {
            if (params)
                Object.assign(globalParams, params);
            const code = new Function('context', `with (context) {return \`${template}\`;}`);
            return code(proxy);
        }
        catch (ex) {
            _helpers_1.Logger.error(`Failed to format string ${template} error: ${ex}`, false, { template, params, ex });
        }
        return template;
    }, [proxy]);
};
exports.useFormat = useFormat;
const createFormatter = (params) => {
    const globalParams = params !== null && params !== void 0 ? params : {};
    const proxy = new Proxy(globalParams, { has, get });
    return (template, params) => {
        try {
            if (params)
                Object.assign(globalParams, params);
            const code = new Function('context', `with (context) {return \`${template}\`;}`);
            return code(proxy);
        }
        catch (ex) {
            _helpers_1.Logger.error(`Failed to format string ${template} error: ${ex}`, false, { template, params, ex });
        }
        return template;
    };
};
exports.createFormatter = createFormatter;


/***/ }),

/***/ "./src/hooks/use-handle-back-channel.hook.ts":
/*!***************************************************!*\
  !*** ./src/hooks/use-handle-back-channel.hook.ts ***!
  \***************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useHandleBackChannel = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = __webpack_require__(/*! react */ "react");
const _hooks_1 = __webpack_require__(/*! ./ */ "./src/hooks/index.ts");
const useHandleBackChannel = () => {
    const sendBackChannel = _hooks_1.useSendBackChannel();
    return react_1.useCallback((action) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        yield sendBackChannel(action.message);
        return Promise.resolve({ success: true });
    }), []);
};
exports.useHandleBackChannel = useHandleBackChannel;


/***/ }),

/***/ "./src/hooks/use-handle-command.hook.ts":
/*!**********************************************!*\
  !*** ./src/hooks/use-handle-command.hook.ts ***!
  \**********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useHandleCommand = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = __webpack_require__(/*! react */ "react");
const _models_1 = __webpack_require__(/*! ../models */ "./src/models/index.ts");
const models_1 = __webpack_require__(/*! ../models */ "./src/models/index.ts");
const use_handle_skill_hook_1 = __webpack_require__(/*! ./use-handle-skill.hook */ "./src/hooks/use-handle-skill.hook.ts");
const use_handle_submit_hook_1 = __webpack_require__(/*! ./use-handle-submit.hook */ "./src/hooks/use-handle-submit.hook.ts");
const use_handle_link_hook_1 = __webpack_require__(/*! ./use-handle-link.hook */ "./src/hooks/use-handle-link.hook.ts");
const use_handle_page_hook_1 = __webpack_require__(/*! ./use-handle-page.hook */ "./src/hooks/use-handle-page.hook.ts");
const use_action_router_hook_1 = __webpack_require__(/*! ./use-action-router.hook */ "./src/hooks/use-action-router.hook.ts");
const use_handle_message_hook_1 = __webpack_require__(/*! ./use-handle-message.hook */ "./src/hooks/use-handle-message.hook.ts");
const use_handle_back_channel_hook_1 = __webpack_require__(/*! ./use-handle-back-channel.hook */ "./src/hooks/use-handle-back-channel.hook.ts");
const use_handle_panel_hook_1 = __webpack_require__(/*! ./use-handle-panel.hook */ "./src/hooks/use-handle-panel.hook.ts");
const _state_1 = __webpack_require__(/*! ../state */ "./src/state/index.ts");
//TODO refine responses
const useHandleCommand = () => {
    const openPage = use_handle_page_hook_1.useHandlePage();
    const openLink = use_handle_link_hook_1.useHandleLink();
    const invokeSkill = use_handle_skill_hook_1.useHandleSkill();
    const submit = use_handle_submit_hook_1.useHandleSubmit();
    const locale = _state_1.useLocale();
    const router = use_action_router_hook_1.useActionRouter();
    const sendMessage = use_handle_message_hook_1.useHandleMessage();
    const sendBackChannel = use_handle_back_channel_hook_1.useHandleBackChannel();
    const openPanel = use_handle_panel_hook_1.useHandlePanel();
    const handleAction = react_1.useCallback((action) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        if (action.$schema == _models_1.RouteActionSchema) {
            const next = yield router(action);
            action =
                next && next.$schema != _models_1.RouteActionSchema
                    ? next
                    : {
                        $schema: _models_1.LinkActionSchema,
                        uri: action.uri,
                    };
        }
        return action.$schema == models_1.PageActionSchema
            ? openPage(action)
            : action.$schema == _models_1.LinkActionSchema
                ? openLink(action)
                : action.$schema == _models_1.SkillActionSchema
                    ? invokeSkill(action)
                    : action.$schema == _models_1.MessageActionSchema
                        ? sendMessage(action)
                        : action.$schema == _models_1.BackChannelActionSchema
                            ? sendBackChannel(action)
                            : action.$schema == _models_1.SubmitActionSchema
                                ? submit(action)
                                : action.$schema == _models_1.LocationActionSchema
                                    ? openPanel(action)
                                    : Promise.resolve({
                                        success: true,
                                    });
    }), [locale]);
    return react_1.useCallback((action) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        return Array.isArray(action)
            ? action.length > 1
                ? Promise.all(action.map((a) => handleAction(a)))
                : handleAction(action[0])
            : handleAction(action);
    }), [locale]);
};
exports.useHandleCommand = useHandleCommand;


/***/ }),

/***/ "./src/hooks/use-handle-link.hook.ts":
/*!*******************************************!*\
  !*** ./src/hooks/use-handle-link.hook.ts ***!
  \*******************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useHandleLink = void 0;
const _state_1 = __webpack_require__(/*! ../state */ "./src/state/index.ts");
const react_1 = __webpack_require__(/*! react */ "react");
const useHandleLink = () => {
    const locale = _state_1.useLocale();
    return react_1.useCallback(({ uri }) => {
        if (typeof uri == "object") {
            window.open(uri[locale], "_blank");
            return Promise.resolve({
                success: true,
            });
        }
        else {
            window.open(uri, "_blank");
            return Promise.resolve({
                success: true,
            });
        }
    }, [locale]);
};
exports.useHandleLink = useHandleLink;


/***/ }),

/***/ "./src/hooks/use-handle-message.hook.ts":
/*!**********************************************!*\
  !*** ./src/hooks/use-handle-message.hook.ts ***!
  \**********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useHandleMessage = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = __webpack_require__(/*! react */ "react");
const _hooks_1 = __webpack_require__(/*! ./ */ "./src/hooks/index.ts");
const useHandleMessage = () => {
    const sendMessage = _hooks_1.useSendMessage();
    return react_1.useCallback((action) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        yield sendMessage(action.message);
        return Promise.resolve({ success: true });
    }), []);
};
exports.useHandleMessage = useHandleMessage;


/***/ }),

/***/ "./src/hooks/use-handle-page.hook.ts":
/*!*******************************************!*\
  !*** ./src/hooks/use-handle-page.hook.ts ***!
  \*******************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useHandlePage = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const _state_1 = __webpack_require__(/*! ../state */ "./src/state/index.ts");
//TODO move to config
const DefaultPagePanel = "panel.page";
const useHandlePage = () => {
    const setPanel = _state_1.useSetPanelId('page');
    return react_1.useCallback(({ type, uri }) => {
        const panelId = type !== null && type !== void 0 ? type : DefaultPagePanel;
        setPanel(panelId, uri);
        return Promise.resolve({ success: true });
    }, []);
};
exports.useHandlePage = useHandlePage;


/***/ }),

/***/ "./src/hooks/use-handle-panel.hook.ts":
/*!********************************************!*\
  !*** ./src/hooks/use-handle-panel.hook.ts ***!
  \********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useHandlePanel = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const _state_1 = __webpack_require__(/*! ../state */ "./src/state/index.ts");
const useHandlePanel = () => {
    const setMainPanel = _state_1.useSetPanelId('main');
    const setPagePanel = _state_1.useSetPanelId('page');
    return react_1.useCallback(({ type, id, tab, entity }) => {
        if (type == 'main')
            setMainPanel(id, entity, tab);
        else
            setPagePanel(id, entity, tab);
        return Promise.resolve({ success: true });
    }, []);
};
exports.useHandlePanel = useHandlePanel;


/***/ }),

/***/ "./src/hooks/use-handle-skill.hook.ts":
/*!********************************************!*\
  !*** ./src/hooks/use-handle-skill.hook.ts ***!
  \********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useHandleSkill = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = __webpack_require__(/*! react */ "react");
const use_invoke_skill_hook_1 = __webpack_require__(/*! ./use-invoke-skill.hook */ "./src/hooks/use-invoke-skill.hook.ts");
const useHandleSkill = () => {
    const invokeSkill = use_invoke_skill_hook_1.useInvokeSkill();
    return react_1.useCallback((action) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        yield invokeSkill(action);
        return Promise.resolve({ success: true });
    }), []);
};
exports.useHandleSkill = useHandleSkill;


/***/ }),

/***/ "./src/hooks/use-handle-submit.hook.ts":
/*!*********************************************!*\
  !*** ./src/hooks/use-handle-submit.hook.ts ***!
  \*********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useHandleSubmit = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const _state_1 = __webpack_require__(/*! ../state */ "./src/state/index.ts");
const react_1 = __webpack_require__(/*! react */ "react");
const use_hook_ref_hook_1 = __webpack_require__(/*! ./use-hook-ref.hook */ "./src/hooks/use-hook-ref.hook.ts");
const useHandleSubmit = () => {
    const providersRef = use_hook_ref_hook_1.useHookRef(_state_1.useContentProviders);
    const authRef = use_hook_ref_hook_1.useHookRef(_state_1.useAuth);
    const knownUrisRef = use_hook_ref_hook_1.useHookRef(_state_1.useKnownUris);
    const profileRef = use_hook_ref_hook_1.useHookRef(_state_1.useProfile);
    return react_1.useCallback(({ headers, uri, body, method, provider }) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        const prov = providersRef.current.find(p => p.name == provider);
        if (!prov)
            return Promise.reject({
                success: false,
                message: "No provider"
            });
        const response = yield prov.submit({
            id: "",
            provider,
            method,
            uri,
            request: {
                headers,
            }, response: {
                schema: ""
            }
        }, {
            auth: authRef.current,
            profile: profileRef.current,
            knownUris: knownUrisRef.current,
            body
        });
        return {
            success: true,
            data: response
        };
    }), []);
};
exports.useHandleSubmit = useHandleSubmit;


/***/ }),

/***/ "./src/hooks/use-has-permission.hook.ts":
/*!**********************************************!*\
  !*** ./src/hooks/use-has-permission.hook.ts ***!
  \**********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useHasPermission = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const use_hook_ref_hook_1 = __webpack_require__(/*! ./use-hook-ref.hook */ "./src/hooks/use-hook-ref.hook.ts");
const index_1 = __webpack_require__(/*! ../index */ "./src/index.ts");
const react_1 = __webpack_require__(/*! react */ "react");
const hasPermission = (permission, providers, auth) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    const provider = providers.find(p => p.name == permission.provider);
    if (provider)
        return provider.has(permission, auth);
    else {
        index_1.Logger.error(`Permission provider ${permission.provider} not found. Check component config`, true, { permission });
        return Promise.reject(false);
    }
});
const getRefLevel = ({ name, level }, state) => {
    const { permissionLevel } = (state === null || state === void 0 ? void 0 : state[name]) || {};
    if (!permissionLevel)
        return null;
    const levels = Array.isArray(permissionLevel)
        ? permissionLevel
        : [permissionLevel];
    return levels.find(({ name }) => name == level);
};
const isLevel = (permission) => permission.hasOwnProperty('right');
const getLevels = (def, state) => {
    if (!def)
        return null;
    const defs = Array.isArray(def)
        ? def
        : [def];
    if (!defs.length)
        return [];
    return defs.reduce((levels, def) => {
        const level = isLevel(def)
            ? def
            : getRefLevel(def, state);
        return levels && level
            ? [
                ...levels,
                level
            ]
            : null;
    }, []);
};
const useHasPermission = () => {
    const providersRef = use_hook_ref_hook_1.useHookRef(index_1.useProviders);
    const providers = providersRef.current.permissions;
    const auth = index_1.useAuth();
    return react_1.useCallback((permission, state) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        const levels = getLevels(permission, state);
        if (!levels)
            return true;
        else if (levels.length > 1) {
            const perms = levels.map(p => hasPermission(p, providers, auth));
            const results = yield Promise.all(perms);
            return results.includes(true);
        }
        return hasPermission(levels[0], providers, auth);
    }), []);
};
exports.useHasPermission = useHasPermission;


/***/ }),

/***/ "./src/hooks/use-hook-ref.hook.ts":
/*!****************************************!*\
  !*** ./src/hooks/use-hook-ref.hook.ts ***!
  \****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useHookRef = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const useHookRef = (...[useHook, ...args]) => {
    const value = useHook(...args);
    const ref = react_1.useRef(value);
    react_1.useEffect(() => {
        ref.current = value;
    }, [value]);
    return ref;
};
exports.useHookRef = useHookRef;


/***/ }),

/***/ "./src/hooks/use-invoke-skill.hook.ts":
/*!********************************************!*\
  !*** ./src/hooks/use-invoke-skill.hook.ts ***!
  \********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useInvokeSkill = exports.invokeSkill = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = __webpack_require__(/*! react */ "react");
const _state_1 = __webpack_require__(/*! ../state */ "./src/state/index.ts");
const _helpers_1 = __webpack_require__(/*! ../helpers */ "./src/helpers/index.ts");
const use_hook_ref_hook_1 = __webpack_require__(/*! ./use-hook-ref.hook */ "./src/hooks/use-hook-ref.hook.ts");
const transformLocationItem = ({ id, entity }) => ({
    id: id || "",
    entity: entity || "",
});
const transformLocationItems = ({ panel, tab }) => ({
    panel: transformLocationItem(panel || {}),
    layout: transformLocationItem(tab || {}),
    tab: transformLocationItem(tab || {}),
});
const transformLocation = ({ page, main }) => ({
    main: transformLocationItems(main || {}),
    page: transformLocationItems(page || {}),
});
//TODO fix contract with skill... remove layout and validation
const getContext = ({ location: loc, path: url }, source, action) => {
    var _a;
    const { main, page } = transformLocation(loc);
    return Object.assign(Object.assign({}, action.context), {
        source,
        location: Object.assign({ main,
            page, title: source.title, url }, (_a = action.context) === null || _a === void 0 ? void 0 : _a.location),
    });
};
//TODO refactor location
const invokeSkill = (directline, config, profile, source, location, action) => {
    const context = getContext(location, source, action);
    return new Promise((resolve, reject) => {
        const activity = {
            from: {
                name: profile.displayName,
                id: config.bot.user.id,
                role: "user",
                iconUrl: profile.image,
            },
            channelData: {
                context,
                messageBack: {
                    displayText: action.invokeText,
                },
            },
            type: "message",
            text: action.ref,
        };
        directline.postActivity(activity).subscribe(function (id) {
            _helpers_1.Logger.info("activated skill:" + id + " sent", activity);
            resolve(activity);
        });
    });
};
exports.invokeSkill = invokeSkill;
const useInvokeSkill = () => {
    const dlContextRef = use_hook_ref_hook_1.useHookRef(_state_1.useDirectline);
    const sourceInfoRef = use_hook_ref_hook_1.useHookRef(_state_1.useSourceInfo);
    const profileRef = use_hook_ref_hook_1.useHookRef(_state_1.useProfile);
    const locationRef = use_hook_ref_hook_1.useHookRef(_state_1.useAppLocation);
    const scopeRef = use_hook_ref_hook_1.useHookRef(_state_1.useChatScope);
    const globalScopesRef = use_hook_ref_hook_1.useHookRef(_state_1.useGlobalChatScopes);
    const setChatScope = _state_1.useSetChatScope();
    const focus = _state_1.useFocus();
    return react_1.useCallback((action) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        const { directline, config } = dlContextRef.current;
        if (((_a = scopeRef.current) === null || _a === void 0 ? void 0 : _a.target) != "bot" && ((_b = globalScopesRef.current) === null || _b === void 0 ? void 0 : _b.length))
            setChatScope(globalScopesRef.current[0]);
        focus("chat-controls");
        return exports.invokeSkill(directline, config, profileRef.current, sourceInfoRef.current, locationRef.current, action);
    }), []);
};
exports.useInvokeSkill = useInvokeSkill;


/***/ }),

/***/ "./src/hooks/use-order.hook.ts":
/*!*************************************!*\
  !*** ./src/hooks/use-order.hook.ts ***!
  \*************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useOrdered = exports.useOrder = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const order = (items) => {
    if (!(items === null || items === void 0 ? void 0 : items.length))
        return { items: [], preferred: null };
    const orderedItems = items.sort((a, b) => a.order - b.order);
    const preferred = orderedItems.find(i => i.preferred) || orderedItems[0];
    return {
        items: orderedItems,
        preferred
    };
};
const useOrder = () => {
    return order;
};
exports.useOrder = useOrder;
const useOrdered = (items) => {
    return react_1.useMemo(() => order(items), [items]);
};
exports.useOrdered = useOrdered;


/***/ }),

/***/ "./src/hooks/use-render.hook.tsx":
/*!***************************************!*\
  !*** ./src/hooks/use-render.hook.tsx ***!
  \***************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useRender = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const _state_1 = __webpack_require__(/*! ../state */ "./src/state/index.ts");
const _models_1 = __webpack_require__(/*! ../models */ "./src/models/index.ts");
const react_2 = __webpack_require__(/*! react */ "react");
const use_hook_ref_hook_1 = __webpack_require__(/*! ./use-hook-ref.hook */ "./src/hooks/use-hook-ref.hook.ts");
const useRender = () => {
    const renderRef = use_hook_ref_hook_1.useHookRef(_state_1.useRenderMiddleware);
    return react_2.useCallback((component, options, FallBack) => {
        var _a;
        const definition = (typeof component == 'string')
            ? {
                $id: component,
                $schema: _models_1.IComponentSchema,
                template: component
            }
            : component;
        return !((_a = definition === null || definition === void 0 ? void 0 : definition.template) === null || _a === void 0 ? void 0 : _a.length) && FallBack
            ? (children) => react_1.default.createElement(FallBack, { config: definition !== null && definition !== void 0 ? definition : {
                    $id: `component.fallback.${(new Date()).getTime()}`,
                    $schema: _models_1.IComponentSchema,
                    template: `component.fallback.${(new Date()).getTime()}`
                }, data: options }, children)
            : renderRef.current({
                component: definition,
                options,
                FallBack
            });
    }, []);
};
exports.useRender = useRender;


/***/ }),

/***/ "./src/hooks/use-send-back-channel.hook.ts":
/*!*************************************************!*\
  !*** ./src/hooks/use-send-back-channel.hook.ts ***!
  \*************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useSendBackChannel = exports.sendBackChannel = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const _state_1 = __webpack_require__(/*! ../state */ "./src/state/index.ts");
const use_hook_ref_hook_1 = __webpack_require__(/*! ./use-hook-ref.hook */ "./src/hooks/use-hook-ref.hook.ts");
const sendBackChannel = (directline, config, profile, sourceInfo, message) => {
    return new Promise((resolve, reject) => {
        const sourceMessage = Object.assign(Object.assign({}, message), { source: sourceInfo });
        const activity = {
            from: {
                name: profile.displayName,
                id: config.bot.user.id,
                role: "user",
                iconUrl: profile.thumbnailUri,
            },
            name: `${message.type}.${message.version}`,
            type: "event",
            value: sourceMessage,
        };
        directline.postActivity(activity).subscribe(function (id) {
            resolve(activity);
        });
    });
};
exports.sendBackChannel = sendBackChannel;
const useSendBackChannel = () => {
    const dlContextRef = use_hook_ref_hook_1.useHookRef(_state_1.useDirectline);
    const sourceInfoRef = use_hook_ref_hook_1.useHookRef(_state_1.useSourceInfo);
    const profileRef = use_hook_ref_hook_1.useHookRef(_state_1.useProfile);
    return react_1.useCallback((message) => {
        const { directline, config } = dlContextRef.current;
        return exports.sendBackChannel(directline, config, profileRef.current, sourceInfoRef.current, message);
    }, []);
};
exports.useSendBackChannel = useSendBackChannel;


/***/ }),

/***/ "./src/hooks/use-send-message.hook.ts":
/*!********************************************!*\
  !*** ./src/hooks/use-send-message.hook.ts ***!
  \********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useSendMessage = exports.sendMessage = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const _state_1 = __webpack_require__(/*! ../state */ "./src/state/index.ts");
const use_hook_ref_hook_1 = __webpack_require__(/*! ./use-hook-ref.hook */ "./src/hooks/use-hook-ref.hook.ts");
const sendMessage = (directline, config, profile, sourceInfo, message, displayMessage, context) => {
    const sourceMessage = Object.assign(Object.assign({}, context), { source: sourceInfo });
    return new Promise((resolve, reject) => {
        const activity = {
            from: {
                name: profile.displayName,
                id: config.bot.user.id,
                role: "user",
                iconUrl: profile.thumbnailUri,
            },
            channelData: {
                context: sourceMessage,
            },
            type: "message",
            text: message,
        };
        if (displayMessage !== null && displayMessage !== undefined) {
            activity.channelData = Object.assign(Object.assign({}, activity.channelData), { messageBack: { displayText: displayMessage } });
        }
        directline.postActivity(activity).subscribe(function (id) {
            resolve(activity);
        });
    });
};
exports.sendMessage = sendMessage;
const useSendMessage = () => {
    const dlContextRef = use_hook_ref_hook_1.useHookRef(_state_1.useDirectline);
    const sourceInfoRef = use_hook_ref_hook_1.useHookRef(_state_1.useSourceInfo);
    const profileRef = use_hook_ref_hook_1.useHookRef(_state_1.useProfile);
    return react_1.useCallback((message, displayMessage, context) => {
        const { directline, config } = dlContextRef.current;
        return exports.sendMessage(directline, config, profileRef.current, sourceInfoRef.current, message, displayMessage, context);
    }, []);
};
exports.useSendMessage = useSendMessage;


/***/ }),

/***/ "./src/hooks/use-theme-image.hook.ts":
/*!*******************************************!*\
  !*** ./src/hooks/use-theme-image.hook.ts ***!
  \*******************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useGetThemeImageURI = exports.useThemeImageURI = void 0;
const _state_1 = __webpack_require__(/*! ../state */ "./src/state/index.ts");
const react_1 = __webpack_require__(/*! react */ "react");
const sizes = {
    small: "S",
    medium: "M",
    large: "L",
    default: "L"
};
const getThemeImageURI = (theme, image, defaultSize, defaultPalette) => {
    if (typeof image == 'string')
        return theme.image[image];
    const { name, definition: { prefix, size, palette } = {}, uri } = image;
    let imageUri;
    if (prefix === null || prefix === void 0 ? void 0 : prefix.length)
        imageUri = theme.image[`${prefix}On${(palette === null || palette === void 0 ? void 0 : palette.length) ? palette : defaultPalette}${sizes[(size === null || size === void 0 ? void 0 : size.length) ? size : defaultSize]}`];
    if (!imageUri && (name === null || name === void 0 ? void 0 : name.length))
        imageUri = theme.image[name];
    if (!imageUri && (uri === null || uri === void 0 ? void 0 : uri.length))
        imageUri = uri;
    return imageUri;
};
const useThemeImageURI = (image, defaultSize, defaultPalette) => {
    const { definition: theme } = _state_1.useTheme();
    return react_1.useMemo(() => {
        return getThemeImageURI(theme, image, defaultSize, defaultPalette);
    }, [image, defaultSize, defaultPalette, theme]);
};
exports.useThemeImageURI = useThemeImageURI;
const useGetThemeImageURI = () => {
    const { definition: theme } = _state_1.useTheme();
    return react_1.useCallback((image, defaultSize, defaultPalette) => {
        return getThemeImageURI(theme, image, defaultSize, defaultPalette);
    }, [theme]);
};
exports.useGetThemeImageURI = useGetThemeImageURI;


/***/ }),

/***/ "./src/hooks/use-transform.hook.ts":
/*!*****************************************!*\
  !*** ./src/hooks/use-transform.hook.ts ***!
  \*****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useTransform = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const _state_1 = __webpack_require__(/*! ../state */ "./src/state/index.ts");
const use_hook_ref_hook_1 = __webpack_require__(/*! ./use-hook-ref.hook */ "./src/hooks/use-hook-ref.hook.ts");
const useTransform = () => {
    const transformRef = use_hook_ref_hook_1.useHookRef(_state_1.useTransformMiddleware);
    const knownUrisRef = use_hook_ref_hook_1.useHookRef(_state_1.useKnownUris);
    const profileRef = use_hook_ref_hook_1.useHookRef(_state_1.useProfile);
    const stringsRef = use_hook_ref_hook_1.useHookRef(_state_1.useLocalizeConfig);
    return react_1.useCallback((targetSchema, data, params) => {
        return data == null || (Array.isArray(data) && data.length == 0)
            ? data
            : transformRef.current({
                targetSchema,
                data,
                params,
                profile: profileRef.current,
                knownUris: knownUrisRef.current,
                strings: stringsRef.current
            });
    }, []);
};
exports.useTransform = useTransform;


/***/ }),

/***/ "./src/index.ts":
/*!**********************!*\
  !*** ./src/index.ts ***!
  \**********************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./helpers */ "./src/helpers/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./models */ "./src/models/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./state */ "./src/state/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./styles */ "./src/styles/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./hooks */ "./src/hooks/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./transform */ "./src/transform/index.ts"), exports);


/***/ }),

/***/ "./src/models/app/app-action.interface.ts":
/*!************************************************!*\
  !*** ./src/models/app/app-action.interface.ts ***!
  \************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.AppActionPosition = void 0;
var AppActionPosition;
(function (AppActionPosition) {
    AppActionPosition["nearBefore"] = "nearBefore";
    AppActionPosition["nearAfter"] = "nearAfter";
    AppActionPosition["farBefore"] = "farBefore";
    AppActionPosition["farAfter"] = "farAfter";
    AppActionPosition["moreBefore"] = "moreBefore";
    AppActionPosition["moreAfter"] = "moreAfter";
})(AppActionPosition = exports.AppActionPosition || (exports.AppActionPosition = {}));


/***/ }),

/***/ "./src/models/app/app-config.interface.ts":
/*!************************************************!*\
  !*** ./src/models/app/app-config.interface.ts ***!
  \************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/app/app-location.interface.ts":
/*!**************************************************!*\
  !*** ./src/models/app/app-location.interface.ts ***!
  \**************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/app/app.types.ts":
/*!*************************************!*\
  !*** ./src/models/app/app.types.ts ***!
  \*************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/app/cache-options.interface.ts":
/*!***************************************************!*\
  !*** ./src/models/app/cache-options.interface.ts ***!
  \***************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/app/cache-ttl.interface.ts":
/*!***********************************************!*\
  !*** ./src/models/app/cache-ttl.interface.ts ***!
  \***********************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/app/event-dispatch.interface.ts":
/*!****************************************************!*\
  !*** ./src/models/app/event-dispatch.interface.ts ***!
  \****************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/app/index.ts":
/*!*********************************!*\
  !*** ./src/models/app/index.ts ***!
  \*********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./source-info.interface */ "./src/models/app/source-info.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./app-config.interface */ "./src/models/app/app-config.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./app.types */ "./src/models/app/app.types.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./app-action.interface */ "./src/models/app/app-action.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./view-config.interface */ "./src/models/app/view-config.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./known-uris.interface */ "./src/models/app/known-uris.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./middleware-config.interface */ "./src/models/app/middleware-config.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./smarthub-api.interface */ "./src/models/app/smarthub-api.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./view-config.interface */ "./src/models/app/view-config.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./event-dispatch.interface */ "./src/models/app/event-dispatch.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./tpc-check-config.interface */ "./src/models/app/tpc-check-config.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./app-location.interface */ "./src/models/app/app-location.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./state-ref.interface */ "./src/models/app/state-ref.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./state-partition.interface */ "./src/models/app/state-partition.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./cache-options.interface */ "./src/models/app/cache-options.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./cache-ttl.interface */ "./src/models/app/cache-ttl.interface.ts"), exports);


/***/ }),

/***/ "./src/models/app/known-uris.interface.ts":
/*!************************************************!*\
  !*** ./src/models/app/known-uris.interface.ts ***!
  \************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/app/middleware-config.interface.ts":
/*!*******************************************************!*\
  !*** ./src/models/app/middleware-config.interface.ts ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/app/smarthub-api.interface.ts":
/*!**************************************************!*\
  !*** ./src/models/app/smarthub-api.interface.ts ***!
  \**************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/app/source-info.interface.ts":
/*!*************************************************!*\
  !*** ./src/models/app/source-info.interface.ts ***!
  \*************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/app/state-partition.interface.ts":
/*!*****************************************************!*\
  !*** ./src/models/app/state-partition.interface.ts ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/app/state-ref.interface.ts":
/*!***********************************************!*\
  !*** ./src/models/app/state-ref.interface.ts ***!
  \***********************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/app/tpc-check-config.interface.ts":
/*!******************************************************!*\
  !*** ./src/models/app/tpc-check-config.interface.ts ***!
  \******************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/app/view-config.interface.ts":
/*!*************************************************!*\
  !*** ./src/models/app/view-config.interface.ts ***!
  \*************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/auth/auth-context.interface.ts":
/*!***************************************************!*\
  !*** ./src/models/auth/auth-context.interface.ts ***!
  \***************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/auth/auth-provider.interface.ts":
/*!****************************************************!*\
  !*** ./src/models/auth/auth-provider.interface.ts ***!
  \****************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/auth/index.ts":
/*!**********************************!*\
  !*** ./src/models/auth/index.ts ***!
  \**********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./auth-context.interface */ "./src/models/auth/auth-context.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./user.interface */ "./src/models/auth/user.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./service-user.interface */ "./src/models/auth/service-user.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./auth-provider.interface */ "./src/models/auth/auth-provider.interface.ts"), exports);


/***/ }),

/***/ "./src/models/auth/service-user.interface.ts":
/*!***************************************************!*\
  !*** ./src/models/auth/service-user.interface.ts ***!
  \***************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/auth/user.interface.ts":
/*!*******************************************!*\
  !*** ./src/models/auth/user.interface.ts ***!
  \*******************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/bookmarks/bookmark-provider.interface.ts":
/*!*************************************************************!*\
  !*** ./src/models/bookmarks/bookmark-provider.interface.ts ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/bookmarks/bookmark.interface.ts":
/*!****************************************************!*\
  !*** ./src/models/bookmarks/bookmark.interface.ts ***!
  \****************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/bookmarks/index.ts":
/*!***************************************!*\
  !*** ./src/models/bookmarks/index.ts ***!
  \***************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./bookmark-provider.interface */ "./src/models/bookmarks/bookmark-provider.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./bookmark.interface */ "./src/models/bookmarks/bookmark.interface.ts"), exports);


/***/ }),

/***/ "./src/models/bot/index.ts":
/*!*********************************!*\
  !*** ./src/models/bot/index.ts ***!
  \*********************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/components/coachmark-info.interface.ts":
/*!***********************************************************!*\
  !*** ./src/models/components/coachmark-info.interface.ts ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/components/command-action.interface.ts":
/*!***********************************************************!*\
  !*** ./src/models/components/command-action.interface.ts ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.LocationActionSchema = exports.BackChannelActionSchema = exports.MessageActionSchema = exports.SubmitActionSchema = exports.SkillActionSchema = exports.PageActionSchema = exports.LinkActionSchema = exports.RouteActionSchema = exports.ActionSchema = void 0;
exports.ActionSchema = "https://ics.ai/smarthub/action";
exports.RouteActionSchema = "https://ics.ai/smarthub/action/route";
exports.LinkActionSchema = "https://ics.ai/smarthub/action/link";
exports.PageActionSchema = "https://ics.ai/smarthub/action/page";
exports.SkillActionSchema = "https://ics.ai/smarthub/action/skill";
exports.SubmitActionSchema = "https://ics.ai/smarthub/action/submit";
exports.MessageActionSchema = "https://ics.ai/smarthub/action/message";
exports.BackChannelActionSchema = "https://ics.ai/smarthub/action/back-channel";
exports.LocationActionSchema = "https://ics.ai/smarthub/action/location";


/***/ }),

/***/ "./src/models/components/component-chrome.interface.ts":
/*!*************************************************************!*\
  !*** ./src/models/components/component-chrome.interface.ts ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/components/component-props.interface.ts":
/*!************************************************************!*\
  !*** ./src/models/components/component-props.interface.ts ***!
  \************************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/components/component-tokens.interface.ts":
/*!*************************************************************!*\
  !*** ./src/models/components/component-tokens.interface.ts ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, exports) => {


//TODO - break out into type specific config
Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/components/component.interface.ts":
/*!******************************************************!*\
  !*** ./src/models/components/component.interface.ts ***!
  \******************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.IComponentSchema = void 0;
exports.IComponentSchema = 'https://ics.ai/smarthub/component';


/***/ }),

/***/ "./src/models/components/condition-result.interface.ts":
/*!*************************************************************!*\
  !*** ./src/models/components/condition-result.interface.ts ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.IConditionResultSchema = void 0;
exports.IConditionResultSchema = "https://ics.ai/smarthub/condition-result";


/***/ }),

/***/ "./src/models/components/condition.interface.ts":
/*!******************************************************!*\
  !*** ./src/models/components/condition.interface.ts ***!
  \******************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/components/conditional.interface.ts":
/*!********************************************************!*\
  !*** ./src/models/components/conditional.interface.ts ***!
  \********************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/components/data-set.interface.ts":
/*!*****************************************************!*\
  !*** ./src/models/components/data-set.interface.ts ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/components/data-sets.interface.ts":
/*!******************************************************!*\
  !*** ./src/models/components/data-sets.interface.ts ***!
  \******************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/components/dock-config.interface.ts":
/*!********************************************************!*\
  !*** ./src/models/components/dock-config.interface.ts ***!
  \********************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/components/dock-size-config.interface.ts":
/*!*************************************************************!*\
  !*** ./src/models/components/dock-size-config.interface.ts ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/components/grid.interface.ts":
/*!*************************************************!*\
  !*** ./src/models/components/grid.interface.ts ***!
  \*************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/components/index.ts":
/*!****************************************!*\
  !*** ./src/models/components/index.ts ***!
  \****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./props-with-child.type */ "./src/models/components/props-with-child.type.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./props-with-children.type */ "./src/models/components/props-with-children.type.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./props-with-children-fn.type */ "./src/models/components/props-with-children-fn.type.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./refiner.interface */ "./src/models/components/refiner.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./panels-provider.interface */ "./src/models/components/panels-provider.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./command-action.interface */ "./src/models/components/command-action.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./panel-entity.interface */ "./src/models/components/panel-entity.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./coachmark-info.interface */ "./src/models/components/coachmark-info.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./panel-view.interface */ "./src/models/components/panel-view.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./panel-template.interface */ "./src/models/components/panel-template.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./panel-tab.interface */ "./src/models/components/panel-tab.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./panel-icon.interface */ "./src/models/components/panel-icon.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./data-set.interface */ "./src/models/components/data-set.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./data-sets.interface */ "./src/models/components/data-sets.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./panel.interface */ "./src/models/components/panel.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./panel-dock.interface */ "./src/models/components/panel-dock.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./responsive.interface */ "./src/models/components/responsive.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./grid.interface */ "./src/models/components/grid.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./zone.interface */ "./src/models/components/zone.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./layout.interface */ "./src/models/components/layout.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./component.interface */ "./src/models/components/component.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./component-chrome.interface */ "./src/models/components/component-chrome.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./component-props.interface */ "./src/models/components/component-props.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./condition.interface */ "./src/models/components/condition.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./conditional.interface */ "./src/models/components/conditional.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./component-tokens.interface */ "./src/models/components/component-tokens.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./template-component.interface */ "./src/models/components/template-component.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./dock-config.interface */ "./src/models/components/dock-config.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./dock-size-config.interface */ "./src/models/components/dock-size-config.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./ordered.interface */ "./src/models/components/ordered.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./query.interface */ "./src/models/components/query.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./regions.interface */ "./src/models/components/regions.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./condition-result.interface */ "./src/models/components/condition-result.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./queryable.interface */ "./src/models/components/queryable.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./launcher-config.interface */ "./src/models/components/launcher-config.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./pages-config.interface */ "./src/models/components/pages-config.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./splash-config.interface */ "./src/models/components/splash-config.interface.ts"), exports);


/***/ }),

/***/ "./src/models/components/launcher-config.interface.ts":
/*!************************************************************!*\
  !*** ./src/models/components/launcher-config.interface.ts ***!
  \************************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/components/layout.interface.ts":
/*!***************************************************!*\
  !*** ./src/models/components/layout.interface.ts ***!
  \***************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/components/ordered.interface.ts":
/*!****************************************************!*\
  !*** ./src/models/components/ordered.interface.ts ***!
  \****************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/components/pages-config.interface.ts":
/*!*********************************************************!*\
  !*** ./src/models/components/pages-config.interface.ts ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/components/panel-dock.interface.ts":
/*!*******************************************************!*\
  !*** ./src/models/components/panel-dock.interface.ts ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/components/panel-entity.interface.ts":
/*!*********************************************************!*\
  !*** ./src/models/components/panel-entity.interface.ts ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.IPanelEntityListSchema = exports.IPanelEntitySchema = void 0;
exports.IPanelEntitySchema = "https://ics.ai/smarthub/panel/entity";
exports.IPanelEntityListSchema = "https://ics.ai/smarthub/panel/entity/list";


/***/ }),

/***/ "./src/models/components/panel-icon.interface.ts":
/*!*******************************************************!*\
  !*** ./src/models/components/panel-icon.interface.ts ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/components/panel-tab.interface.ts":
/*!******************************************************!*\
  !*** ./src/models/components/panel-tab.interface.ts ***!
  \******************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.IPanelTabSchema = void 0;
exports.IPanelTabSchema = 'https://ics.ai/smarthub/tab';


/***/ }),

/***/ "./src/models/components/panel-template.interface.ts":
/*!***********************************************************!*\
  !*** ./src/models/components/panel-template.interface.ts ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.IPanelTemplateSchema = void 0;
exports.IPanelTemplateSchema = 'https://ics.ai/smarthub/template';


/***/ }),

/***/ "./src/models/components/panel-view.interface.ts":
/*!*******************************************************!*\
  !*** ./src/models/components/panel-view.interface.ts ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/components/panel.interface.ts":
/*!**************************************************!*\
  !*** ./src/models/components/panel.interface.ts ***!
  \**************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.IPanelSchema = void 0;
exports.IPanelSchema = 'https://ics.ai/smarthub/panel';


/***/ }),

/***/ "./src/models/components/panels-provider.interface.ts":
/*!************************************************************!*\
  !*** ./src/models/components/panels-provider.interface.ts ***!
  \************************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/components/props-with-child.type.ts":
/*!********************************************************!*\
  !*** ./src/models/components/props-with-child.type.ts ***!
  \********************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/components/props-with-children-fn.type.ts":
/*!**************************************************************!*\
  !*** ./src/models/components/props-with-children-fn.type.ts ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/components/props-with-children.type.ts":
/*!***********************************************************!*\
  !*** ./src/models/components/props-with-children.type.ts ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/components/query.interface.ts":
/*!**************************************************!*\
  !*** ./src/models/components/query.interface.ts ***!
  \**************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/components/queryable.interface.ts":
/*!******************************************************!*\
  !*** ./src/models/components/queryable.interface.ts ***!
  \******************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/components/refiner.interface.ts":
/*!****************************************************!*\
  !*** ./src/models/components/refiner.interface.ts ***!
  \****************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/components/regions.interface.ts":
/*!****************************************************!*\
  !*** ./src/models/components/regions.interface.ts ***!
  \****************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/components/responsive.interface.ts":
/*!*******************************************************!*\
  !*** ./src/models/components/responsive.interface.ts ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/components/splash-config.interface.ts":
/*!**********************************************************!*\
  !*** ./src/models/components/splash-config.interface.ts ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/components/template-component.interface.ts":
/*!***************************************************************!*\
  !*** ./src/models/components/template-component.interface.ts ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/components/zone.interface.ts":
/*!*************************************************!*\
  !*** ./src/models/components/zone.interface.ts ***!
  \*************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/content/index.ts":
/*!*************************************!*\
  !*** ./src/models/content/index.ts ***!
  \*************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.IPageMetadataSchema = void 0;
var page_interface_1 = __webpack_require__(/*! ./page.interface */ "./src/models/content/page.interface.ts");
Object.defineProperty(exports, "IPageMetadataSchema", ({ enumerable: true, get: function () { return page_interface_1.IPageMetadataSchema; } }));


/***/ }),

/***/ "./src/models/content/page.interface.ts":
/*!**********************************************!*\
  !*** ./src/models/content/page.interface.ts ***!
  \**********************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.IPageMetadataSchema = void 0;
exports.IPageMetadataSchema = "https://ics.ai/smarthub/page";


/***/ }),

/***/ "./src/models/context/api-context.interface.ts":
/*!*****************************************************!*\
  !*** ./src/models/context/api-context.interface.ts ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/context/app-context.interface.ts":
/*!*****************************************************!*\
  !*** ./src/models/context/app-context.interface.ts ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/context/breakpoint-context.interface.ts":
/*!************************************************************!*\
  !*** ./src/models/context/breakpoint-context.interface.ts ***!
  \************************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/context/chatbot-context.interface.ts":
/*!*********************************************************!*\
  !*** ./src/models/context/chatbot-context.interface.ts ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/context/current-panel-context.interface.ts":
/*!***************************************************************!*\
  !*** ./src/models/context/current-panel-context.interface.ts ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/context/index.ts":
/*!*************************************!*\
  !*** ./src/models/context/index.ts ***!
  \*************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./api-context.interface */ "./src/models/context/api-context.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./chatbot-context.interface */ "./src/models/context/chatbot-context.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./middleware-context.interface */ "./src/models/context/middleware-context.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./provider-context.interface */ "./src/models/context/provider-context.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./app-context.interface */ "./src/models/context/app-context.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./theme-context.interface */ "./src/models/context/theme-context.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./current-panel-context.interface */ "./src/models/context/current-panel-context.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./location-context.interface */ "./src/models/context/location-context.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./notification-context.interface */ "./src/models/context/notification-context.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./preference-context.interface */ "./src/models/context/preference-context.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./tpc-check-context.interface */ "./src/models/context/tpc-check-context.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./breakpoint-context.interface */ "./src/models/context/breakpoint-context.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./panel-view-context.interface */ "./src/models/context/panel-view-context.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./page-context.interface */ "./src/models/context/page-context.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./personality-context.interface */ "./src/models/context/personality-context.interface.ts"), exports);


/***/ }),

/***/ "./src/models/context/location-context.interface.ts":
/*!**********************************************************!*\
  !*** ./src/models/context/location-context.interface.ts ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/context/middleware-context.interface.ts":
/*!************************************************************!*\
  !*** ./src/models/context/middleware-context.interface.ts ***!
  \************************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/context/notification-context.interface.ts":
/*!**************************************************************!*\
  !*** ./src/models/context/notification-context.interface.ts ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/context/page-context.interface.ts":
/*!******************************************************!*\
  !*** ./src/models/context/page-context.interface.ts ***!
  \******************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/context/panel-view-context.interface.ts":
/*!************************************************************!*\
  !*** ./src/models/context/panel-view-context.interface.ts ***!
  \************************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/context/personality-context.interface.ts":
/*!*************************************************************!*\
  !*** ./src/models/context/personality-context.interface.ts ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/context/preference-context.interface.ts":
/*!************************************************************!*\
  !*** ./src/models/context/preference-context.interface.ts ***!
  \************************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/context/provider-context.interface.ts":
/*!**********************************************************!*\
  !*** ./src/models/context/provider-context.interface.ts ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/context/theme-context.interface.ts":
/*!*******************************************************!*\
  !*** ./src/models/context/theme-context.interface.ts ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/context/tpc-check-context.interface.ts":
/*!***********************************************************!*\
  !*** ./src/models/context/tpc-check-context.interface.ts ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/index.ts":
/*!*****************************!*\
  !*** ./src/models/index.ts ***!
  \*****************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./app */ "./src/models/app/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./auth */ "./src/models/auth/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./bot */ "./src/models/bot/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./bookmarks */ "./src/models/bookmarks/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./components */ "./src/models/components/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./content */ "./src/models/content/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./middleware */ "./src/models/middleware/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./profile */ "./src/models/profile/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./theme */ "./src/models/theme/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./preference */ "./src/models/preference/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./context */ "./src/models/context/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./localize */ "./src/models/localize/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./notifications */ "./src/models/notifications/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./permission */ "./src/models/permission/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./query */ "./src/models/query/index.ts"), exports);


/***/ }),

/***/ "./src/models/localize/index.ts":
/*!**************************************!*\
  !*** ./src/models/localize/index.ts ***!
  \**************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.LocalizeDefaultConfig = exports.LocalizeLanguages = exports.LocalizeKeys = void 0;
var localize_keys_enum_1 = __webpack_require__(/*! ./localize-keys.enum */ "./src/models/localize/localize-keys.enum.ts");
Object.defineProperty(exports, "LocalizeKeys", ({ enumerable: true, get: function () { return localize_keys_enum_1.LocalizeKeys; } }));
var localize_languages_enum_1 = __webpack_require__(/*! ./localize-languages.enum */ "./src/models/localize/localize-languages.enum.ts");
Object.defineProperty(exports, "LocalizeLanguages", ({ enumerable: true, get: function () { return localize_languages_enum_1.LocalizeLanguages; } }));
var localize_default_config_const_1 = __webpack_require__(/*! ./localize-default-config.const */ "./src/models/localize/localize-default-config.const.ts");
Object.defineProperty(exports, "LocalizeDefaultConfig", ({ enumerable: true, get: function () { return localize_default_config_const_1.LocalizeDefaultConfig; } }));


/***/ }),

/***/ "./src/models/localize/localize-default-config.const.ts":
/*!**************************************************************!*\
  !*** ./src/models/localize/localize-default-config.const.ts ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.LocalizeDefaultConfig = void 0;
const localize_languages_enum_1 = __webpack_require__(/*! ./localize-languages.enum */ "./src/models/localize/localize-languages.enum.ts");
exports.LocalizeDefaultConfig = {
    defaultLanguage: localize_languages_enum_1.LocalizeLanguages.en,
    [localize_languages_enum_1.LocalizeLanguages.en]: {
        webchat: {
            TEXT_INPUT_PLACEHOLDER: "Ask me a question?",
            TRANSCRIPT_ARIA_LABEL_ALT: "Conversation messages, use arrow keys, home and end to navigate the messages. Use the escape key to return to the chat text box",
        },
        cardLabel: "use enter to view card detail",
        chatFooterTitle: "Useful links menu.",
        chatFooterLabel: "List of useful links.",
        focusZoneHorizontalLabel: "Use left and right arrows, home and end keys to select items",
        focusZoneVerticalLabel: "Use arrow, page, home and end keys to select items",
        focusZoneBothLabel: "Use left and right arrows, home and end keys to select items",
        skipToChat: "Skip to Chat",
        skipToMain: "Skip to Main content",
        commonDateFormat: "d MMMM YYYY",
        commonDateTimeFormat: "d MMMM YYYY HH:mm",
        msPowerAppError: "Could not load Microsoft Power App, no App Id was provided",
        msFormError: "Could not load Microsoft Form, no URL was provided",
        imageError: "Could not load image, no URL was provided",
        pageError: "Could not load page, no URL was provided",
        missingProvider: "Missing provider or provider name.",
        invalidSchema: "The data response contains a mismatching schema",
        noResults: "We couldn't find what you're looking for",
        noResultsCalender: "We couldn't find any upcoming calender events",
        na: "Not Applicable",
        noSubject: "No Subject",
        noResultsHeading: "No results found",
        noResultsTitle: "No results found",
        noResultsDescription: "We couldn't find what you're looking for",
        suffixItems: "list of items",
        fetchingItems: "The list is loading, please wait",
        panelNavTitle: "Panel Navigation",
        loadMore: "Load More",
        loadMoreDesc: "Load more items into the list",
        aboutButtonDesc: "Click to view About information",
        aboutButtonTitle: "About",
        aboutCloseButtonTitle: "Close the about panel",
        historyNextTitle: "Click to go forward to the next view",
        historyBackTitle: "Click to go back to the last view",
        navTitle: "SmartHub navigation",
        navMenuTitle: "SmartHub panel navigation",
        navOptionsTitle: "SmartHub options menu",
        aboutPanelTitle: "About",
        aboutVersionPrefix: "Version",
        aboutPublishedPrefix: "Published by",
        aboutEnvironmentPrefix: "Environment",
        themePanelTitle: "Themes",
        themeButtonDesc: "Click to view themes",
        themeButtonTitle: "Themes",
        themeCloseButtonTitle: "Close the theme panel",
        refineByText: "Filter by",
        refineByTitle: "Filtered by",
        refineByDesc: "The list is being filtered by",
        refineByValueTitle: "Filter by",
        refineByValueDesc: "Filter the list by",
        sortByText: "Sort by",
        sortByTitle: "Sorted by",
        sortByDesc: "The list has been sorted by",
        sortByValueTitle: "Sort by",
        sortByValueDesc: "Sort the list by",
        azFilterValueDesc: "Filter the list by the letter",
        azFilterValueTitle: "Filter by letter",
        azFilterText: "Starts with",
        azFilterSecondaryText: "Letter: ",
        azFilterDesc: "The list has been filtered by the letter ",
        azFilterTitle: "Filtered by letter",
        feedbackButtonTitle: "Feedback",
        layoutNavTitle: "Panel navigation, click a link to view contents",
        pageMenuTitle: "Page menu",
        pageMenuLabel: "Menu options for current page.",
        pageMenuCloseDesc: "Close the current page",
        pageMenuCloseTitle: "Close page",
        pageMenuCloseText: "Close",
        chatMenuTitle: "Chat menu",
        chatMenuLabel: "Options to control chat dialog.",
        chatMenuResetDesc: "Reset the chat conversation",
        chatMenuResetTitle: "Reset conversation",
        chatMenuResetText: "Reset",
        chatMenuLauncherDesc: "Launch the Actions Panel",
        chatMenuLauncherTitle: "Show Actions",
        chatMenuLauncherText: "Actions",
        chatMenuCloseTitle: "Close",
        chatMenuCloseDesc: "Close the chat conversation",
        chatMenuCloseText: "Close chat",
        chatControlsLabel: "Type your message and use enter key or send button to send. Use the attachment button to send a file.",
        chatControlsTitle: "Message controls",
        fullDockButtonText: "Full",
        fullDockButtonDesc: "View full screen",
        fullDockButtonTitle: "Full screen",
        wideDockButtonText: "Wide",
        wideDockButtonDesc: "Dock content in wide view",
        wideDockButtonTitle: "Wide view",
        splitDockButtonText: "Split",
        splitDockButtonDesc: "Dock content in split view",
        splitDockButtonTitle: "Split view",
        narrowDockButtonText: "Narrow",
        narrowDockButtonDesc: "Dock content in narrow view",
        narrowDockButtonTitle: "Narrow view",
        assideDockButtonText: "Asside",
        assideDockButtonDesc: "Dock content in asside view",
        assideDockButtonTitle: "Asside view",
        sideBarClose: "Close",
        sideBarCloseDesc: "Close the side bar",
        sideBarCommandBar: "Side bar controls",
        persona: "User profile for",
        personaAria: "View user profile for",
        hierarchyExpand: "Expand users hierarchy chart",
        hierarchyCollapse: "Collapse users hierarchy chart",
        profileProject: "Project",
        profileSkill: "Skill",
        profileSchool: "School",
        profileInterest: "Interest",
        profileTitle: "Your profile information",
        profilePersonalInfo: "Personal Info",
        profileProjects: "Projects involving",
        profileInterests: "Interests listed for",
        profileSkills: "Skills listed for",
        profileSchools: "Schools attended by",
        profileContactInfo: "Contact information for",
        profileBirthday: "Birthday",
        contactTitle: "Contact snippet for user",
        contactOption: "Contact info for user",
        btnCopy: "Copy selected details",
        copyIcn: "Copy Icon",
        pageTypeLabel: "The page type is",
        pageTitleLabel: "The page title is",
        pageBylineLabel: "The page byline is",
        pageDatelineLabel: "The page dateline is",
        pageDescriptionLabel: "The page description is",
        pageParentLabel: "The content area for the page",
        expandPageNavLabel: "Expand page navigation",
        collapsePageNavLabel: "Collapse page navigation",
        pageNavLinkLabel: "Navigate to",
        expandComponent: "Expand",
        minimiseComponent: "Minimise",
        activityEditedLabel: "Last updated by",
        activityCreatedLabel: "Created by",
        activityOwnedLabel: "Content owned by",
        activityPublishedLabel: "Published in",
        pageEditorsTitle: "Editors",
        pageParentTitle: "Location",
        pageCategoriesTitle: "Tags",
        thumbnailImageLabel: "Thumbnail image for page",
        pageImageLabel: "Main image for page",
        eventLocLabel: "Location",
        eventStartLabel: "From",
        eventEndLabel: "To",
        eventLinkLabel: "More info",
        locAddressLabel: "Address",
        locTypeLabel: "Location type",
        locEmailLabel: "Contact email",
        locPhoneLabel: "Contact telephone:",
        pageDatePublishLabel: "Last published",
        pageDateLastReviewLabel: "Last reviewed",
        pageDateNextReviewLabel: "Next review due",
        pageVersionLabel: "Version",
        collapseOptions: "Collapse options",
        expandOptions: "Expand options",
        themeListLabel: "Select from available themes",
        themeButtonText: "Select",
        themeButtonLabel: "Select this theme",
        lightThemeTypeTitle: "Light themes",
        darkThemeTypeTitle: "Dark themes",
        contrastThemeTypeTitle: "High contrast themes",
        toneThemeTypeTitle: "Tonal themes",
        imageSelectTypeError: "The selected file is in the wrong format. Please select an image.",
        imageSelectSizeError: "The selected file is too large. Please select a smaller image.",
        imageSaveText: "Save",
        imageSaveLabel: "Save the selected image",
        imageCancelText: "Cancel",
        imageCancelLabel: "Discard the selected image",
        imageRemoveText: "Remove",
        imageRemoveLabel: "Discard the current image",
        imageSelectLabel: "Select an image to display on SmartHub banners",
        imageSelectText: "Select an image",
        imageSelectSecondaryText: "Customise your SmartHub",
        startEmailText: "Send email",
        startEmailLabel: "Send email to",
        startChatText: "Start chat",
        startChatLabel: "Start chat with",
        startCallText: "Call phone",
        startCallLabel: "Call",
        startCallMobileText: "Call mobile",
        startCallMobileLabel: "Call",
        pinLink: "Pin link",
        logoImage: "SmartHub logo",
        notificationAnnounce: "A new notification has appeared",
        notificationActions: "Available actions for this notification",
        bookmark: "Bookmark",
        unbookmark: "Unbookmark",
        chatClearText: "Clear",
        chatUploadText: "Attach",
        chatQueryText: "Query",
        chatSendText: "Send",
        chatSendLabel: "Send the message",
        chatSearchLabel: "Search for selected terms",
        chatClearLabel: "Clear the search terms",
        chatUploadLabel: "Send a file to the chatbot",
        chatSendTitle: "Send the message",
        chatSearchTitle: "Search for selected terms",
        chatClearTitle: "Clear the search terms",
        chatUploadTitle: "Send a file to the chatbot",
        chatPlaceholder: "Ask me a question",
        sideBarCoachAlert: "A coach mark has appeared and the side bar has closed",
        sideBarCoachDesc: "Press enter or alt + C to open the coachmark help information",
        sideBarCoachLabel: "Side bar coach notification",
        sideBarCoachTitle: "Sidebar controls",
        sideBarCoachText: "The side bar can be opened using this menu button. The side bar will remember your choice the next time you view this panel.",
        hideCoachMark: "Dismiss this coach mark",
        contentViewDesc: "Expand the panel content to fill the screen",
        contentViewDescExpanded: "Reduce the panel content to show all panel features",
        contentViewText: "Expand content",
        contentViewTextExpanded: "Reduce content",
        noMeeting: "No scheduled meetings",
        meetingAttendeeAria: "List of attendees",
        join: "Join",
        joinMeeting: "Join meeting",
        meetingFreeFor: "Free for",
        meetingFreeFrom: "from",
        allDay: "All day event",
        viewMore: "View more",
        nextUpIn: "Next up in",
        inProgress: "Meeting in-progress",
        panelMenuMoreLabel: "View more panel options",
        panelMenuMoreText: "More",
        mainMenuPrimaryLabel: "SmartHub panel main navigation menu",
        mainMenuSecondaryLabel: "SmartHub panel options menu",
        dockSize: "Size",
        dockSizeAriaLabel: "Expand this button's options to choose the size of the chat",
        dockSizeTitle: "Choose the size of the chat",
        dockSizeOptions: {
            narrow: {
                text: "Narrow",
                title: "Narrow chat panel",
                ariaLabel: "Select this option for a narrow chat panel",
            },
            split: {
                text: "Split",
                title: "Split chat panel",
                ariaLabel: "Select this option for a split chat panel",
            },
            wide: {
                text: "Wide",
                title: "Wide chat panel",
                ariaLabel: "Select this option for a wide chat panel",
            },
            full: {
                text: "Full",
                title: "Full screen chat panel",
                ariaLabel: "Select this option for a full screen chat panel",
            },
        },
        dockPosition: "Dock",
        dockPositionAriaLabel: "Expand this button's options to choose the position of the chat",
        dockPositionTitle: "Choose the position of the chat",
        dockPositionOptions: {
            right: {
                text: "Right",
                title: "Dock the chat to the right",
                ariaLabel: "Select this option to dock the chat to the right",
            },
            left: {
                text: "Left",
                title: "Dock the chat to the left",
                ariaLabel: "Select this option to dock the chat to the left",
            },
        },
        launchButtonLabel: "Launch the chatbot",
        launchButtonTitle: "Launch the chatbot",
        launchButtonAlt: "chatbot launch button image",
        chatSplashAcceptCbxLabel: "Accept the terms and conditions",
        chatSplashAcceptCbxTitle: "Accept the terms and conditions",
        chatSplashConfirmBtnLabel: "By clicking this button you accept the privacy policy and agree to open SmartChat",
        chatSplashConfirmBtnText: "Continue",
        chatSplashConfirmBtnTitle: "Continue to the chat",
        chatSplashCancelBtnLabel: "By clicking this button the chatbot is closed",
        chatSplashCancelBtnText: "Close",
        chatSplashCancelBtnTitle: "Cancel and close the chat window",
        chatHeadTitle: "Hi, I'm SmartChat",
        chatHeadTitleLabel: "Hi, I'm SmartChat",
        chatHeadSubTitle: "I'm here to answer your questions. How can I help you?",
        chatHeadSubTitleLabel: "I'm here to answer your questions. How can I help you?",
        chatHeadImageAlt: "Chatbot avatar image",
        chatPoweredByLabel: "Visit the ICS.AI website for more information about SmartChat.",
        chatPoweredByTitle: "Powered by ICS.AI SmartChat, visit the website for more information.",
        chatPoweredByAlt: "ICS.AI SmartChat Logo Image",
        chatSigningInMessage: "Your sign in request is being processed, please wait.",
        tpcMessage: {
            chat: {
                okText: "Ok",
                okTitle: "Close the dialog and continue to use the chatbot",
                okLabel: "Close the dialog and continue to use the chatbot",
                cancelText: "Cancel",
                cancelTitle: "Close the dialog and return to the page",
                cancelLabel: "Close the dialog and return to the page",
                infoText: "More info",
                infoTitle: "Open a help page to find out more",
                infoLabel: "Open a help page to find out more",
                closeText: "Close",
                closeTitle: "Close the dialog and return to the page",
                closeLabel: "Close the dialog and return to the page",
                title: "Third-party cookies",
                subText: {
                    warn: "Your bowser has disabled the use of third party cookies. The chatbot requires third-party cookies to provide a seamless login experience. Click the close button to close the browser tab or click the more info button for help.",
                    info: "Your bowser has disabled the use of third party cookies. The chatbot uses these to provide a seamless login experience. You may find some features are unavailable, click the more info button for help.",
                },
            },
            full: {
                okText: "Ok",
                okTitle: "Close the dialog and continue to use the SmartHub",
                okLabel: "Close the dialog and continue to use the SmartHub",
                infoText: "More info",
                infoTitle: "Open a help page to find out more",
                infoLabel: "Open a help page to find out more",
                closeText: "Close",
                closeTitle: "Close the browser tab",
                closeLabel: "Close the browser tab",
                title: "Third-party cookies",
                subText: {
                    warn: "Your bowser has disabled the use of third party cookies. The SmartHub requires third-party cookies to provide a seamless login experience. Click the close button to close the browser tab or click the more info button for help.",
                    info: "Your bowser has disabled the use of third party cookies. The SmartHub uses these to provide a seamless login experience. You may find some features are unavailable, click the more info button for help.",
                },
            },
        },
        carousel: {
            dotLabel: "Select item, number",
            dotTitle: "View",
            previousLabel: "Move to the previous item",
            previousTitle: "Previous",
            nextLabel: "Move the next item",
            nextTitle: "Next",
        },
        chatControlsCoachAlert: "A coach mark has appeared, find out about the search options",
        chatControlsCoachDesc: "Press enter or alt + C to open help information about the search options",
        chatControlsCoachLabel: "Search options coach notification",
        chatControlsCoachTitle: "Search Box - Felix",
        chatControlsCoachText: "Click the button below to view search options, they range from 'this place' to 'everything'. Type your search term(s) into the text box.",
        layoutMenuCoachAlert: "A coach mark has appeared, find out about in-panel navigation",
        layoutMenuCoachDesc: "Press enter or alt + C to open help information about the in-panel navigation",
        layoutMenuCoachLabel: "Search options coach notification",
        layoutMenuCoachTitle: "In panel navigation",
        layoutMenuCoachText: "A hubs content is presented under a series of tabs, click a tab to navigate to that panel.",
        bookmarkCoachAlert: "A coach mark has appeared, find out about bookmarking",
        bookmarkCoachDesc: "Press enter or alt + C to open help information about bookmarking",
        bookmarkCoachLabel: "Bookmarking coach notification",
        bookmarkCoachTitle: "Bookmarking",
        bookmarkCoachText: "Click on the bookmark icon to save a link to this content within your My Stuff. You can bookmark news, guides, people…everything!",
        contentExpandCoachAlert: "A coach mark has appeared, find out about content options",
        contentExpandCoachDesc: "Press enter or alt + C to open help information about content options",
        contentExpandCoachLabel: "Content options coach notification",
        contentExpandCoachTitle: "Content Options",
        contentExpandCoachText: "You can use the re-size options to change the size of the page viewing panel, you can also hide and show the page details section using the arrows icon to the right.",
        feedbackCoachAlert: "A coach mark has appeared, find out about user feedback",
        feedbackCoachDesc: "Press enter or alt + C to open help information about user feedback",
        feedbackCoachLabel: "User feedback coach notification",
        feedbackCoachTitle: "User Feedback",
        feedbackCoachText: "Use this to report a problem, tell us what you like or don't like and leave us your ideas to improve the SmartHub.",
        profileCoachAlert: "A coach mark has appeared, find out about profile details",
        profileCoachDesc: "Press enter or alt + C to open help information about profile details",
        profileCoachLabel: "Profile details coach notification",
        profileCoachTitle: "Profile Details",
        profileCoachText: "Click on a colleague to view their contact details and who they work with. You can even trigger an email, send a teams message or call them.",
        editPageLabel: "Open and edit the page in the browser",
        editPageTitle: "Edit page in the browser",
        editPageText: "Edit this page",
        refinerTitle: "Refine by:",
        refinerExpandTitle: "Expand to view refinement options",
        showRefiners: "Show refiners",
        hideRefiners: "Hide refiners",
        personaLinkTitle: "Open the profile panel for",
        personaLinkAria: "View profile for",
        tileTitle: "Open",
        slideTitle: "Open",
        linkTileAria: "",
        linkTileTitle: "Open",
        iconBack: "Click to go back to previous view",
        iconForward: "Click to go forward to the next view",
        iconHome: "Click to go back to SmartHub Home",
        rootLabelFull: "SmartHub",
        rootLabelChat: "SmartChat dialog",
        chatPanelLabel: "Chat panel",
        chatStartLabel: "Start of the chat panel, press escape to close",
        chatStartText: "Start of chat panel",
        chatEndLabel: "End of chat panel, press escape to close",
        chatEndText: "End of chat panel",
        mainPanelLabel: "Start of the main panel, press escape to close",
        mainStartLabel: "Start of the main panel",
        mainStartText: "Start of main panel",
        mainEndLabel: "End of main panel, press escape to close",
        mainEndText: "End of main panel",
        pagePanelLabel: "Page panel",
        pageStartLabel: "Start of the page panel, press escape to close",
        pageStartText: "Start of page panel",
        pageEndLabel: "End of page panel, press escape to close",
        pageEndText: "End of page panel",
        commentForm: {
            saveButtonText: "Save",
            saveButtonLabel: "Save this comment",
            cancelButtonText: "Cancel",
            cancelButtonLabel: "Cancel changes and return",
            deleteButtonText: "Delete",
            deleteButtonLabel: "Remove this comment",
            clearButtonText: "Clear",
            clearButtonLabel: "Clear the form",
            textBoxTitle: "Enter your comment",
            textBoxLabel: "Enter your comment",
            confirmDelete: "Are you sure you want to delete this comment?",
            errorEmptyComment: "The comment field is required, please enter text",
            errorCommentTooLong: "Comments are limited to ${maxLength} characters. Please reduce the text and try again",
        },
        clearAllDesc: "Clear selected filters",
        clearAllTitle: "Clear selected filters",
        clearAllText: "Clear all",
    },
    [localize_languages_enum_1.LocalizeLanguages.cy]: {
        webchat: {
            TEXT_INPUT_PLACEHOLDER: "Gofynnwch gwestiwn i mi?",
            TRANSCRIPT_ARIA_LABEL_ALT: "Negeseuon sgwrs, defnyddio bysellau saeth, cartref a diwedd i lywio negeseuon. Defnyddiwch yr allwedd dianc i ddychwelyd i'r blwch testun sgwrsio",
        },
        cardLabel: "Defnyddiwch Rhowch i weld manylion cardiau",
        chatFooterTitle: "Dewislen dolenni defnyddiol.",
        chatFooterLabel: "Rhestr o gysylltiadau defnyddiol.",
        focusZoneHorizontalLabel: "Defnyddiwch saethau chwith a dde, allweddi cartref a diwedd i ddewis eitemau",
        focusZoneVerticalLabel: "Defnyddiwch bysellau saeth, tudalen, cartref a diwedd i ddewis eitemau",
        focusZoneBothLabel: "Defnyddiwch saethau chwith a dde, allweddi cartref a diwedd i ddewis eitemau",
        skipToChat: "Skip to Chat",
        skipToMain: "Neidio i'r prif gynnwys",
        commonDateFormat: "d MMMM YYYY",
        commonDateTimeFormat: "d MMMM YYYY Hh: mm",
        msPowerAppError: "Methu llwytho Microsoft Power App, ni ddarparwyd unrhyw App Id",
        msFormError: "Methu llwytho Microsoft Form, ni ddarparwyd URL",
        imageError: "Methu llwytho llun, ni ddarparwyd URL",
        pageError: "Methu llwytho tudalen, ni ddarparwyd URL",
        missingProvider: "Enw'r darparwr neu ddarparwr sydd ar goll.",
        invalidSchema: "Mae'r ymateb data yn cynnwys sgema camgyfatebol",
        noResults: "Ni allwn ddod o hyd i'r hyn rydych chi'n chwilio amdano",
        noResultsCalender: "Ni allem ddod o hyd i unrhyw ddigwyddiadau calendr sydd ar ddod",
        na: "Amherthnasol",
        noSubject: "Dim pwnc",
        noResultsHeading: "Dim canlyniadau i'w canfod",
        noResultsTitle: "Dim canlyniadau i'w canfod",
        noResultsDescription: "Ni allwn ddod o hyd i'r hyn rydych chi'n chwilio amdano",
        suffixItems: "Rhestr o eitemau",
        fetchingItems: "Mae'r rhestr yn llwytho, arhoswch os gwelwch yn dda",
        panelNavTitle: "Panelau Navigation",
        loadMore: "Llwytho Mwy",
        loadMoreDesc: "Llwytho mwy o eitemau i mewn i'r rhestr",
        aboutButtonDesc: "Cliciwch i weld gwybodaeth",
        aboutButtonTitle: "Ynghylch",
        aboutCloseButtonTitle: "Cau'r Ynglŷn â'r Panel",
        historyNextTitle: "Cliciwch i symud ymlaen i'r olygfa nesaf",
        historyBackTitle: "Cliciwch i fynd yn ôl i'r dudalen olaf",
        navTitle: "Llywio SmartHub",
        navMenuTitle: "Llywio panel SmartHub",
        navOptionsTitle: "Dewislen opsiynau SmartHub",
        aboutPanelTitle: "Ynghylch",
        aboutVersionPrefix: "Fersiwn",
        aboutPublishedPrefix: "Cyhoeddwyd gan",
        aboutEnvironmentPrefix: "Amgylchedd",
        themePanelTitle: "Themâu",
        themeButtonDesc: "Cliciwch i weld themâu",
        themeButtonTitle: "Themâu",
        themeCloseButtonTitle: "Cau'r panel thema",
        refineByText: "Hidlo gan",
        refineByTitle: "Hidlwyd gan",
        refineByDesc: "Mae'r rhestr yn cael ei hidlo gan",
        refineByValueTitle: "Hidlo gan",
        refineByValueDesc: "Hidlo'r rhestr gan",
        sortByText: "Trefnu yn ôl",
        sortByTitle: "Trefnwyd gan",
        sortByDesc: "Mae'r rhestr wedi cael ei sortio gan",
        sortByValueTitle: "Trefnu yn ôl",
        sortByValueDesc: "Trefnwch y rhestr yn ôl",
        azFilterValueDesc: "Hidlo'r rhestr gan y llythyr",
        azFilterValueTitle: "Hidlo trwy lythyr",
        azFilterText: "Dechrau gyda",
        azFilterSecondaryText: "Llythyr: ",
        azFilterDesc: "Mae'r rhestr wedi'i hidlo gan y llythyr ",
        azFilterTitle: "Hidlo trwy lythyr",
        feedbackButtonTitle: "Adborth",
        layoutNavTitle: "Llywio panel, cliciwch dolen i weld cynnwys",
        pageMenuTitle: "Bwydlen tudalen",
        pageMenuLabel: "Dewisiadau dewislen ar gyfer y dudalen gyfredol.",
        pageMenuCloseDesc: "Cau'r dudalen gyfredol",
        pageMenuCloseTitle: "Tudalen agos",
        pageMenuCloseText: "Cau",
        chatMenuTitle: "Bwydlen sgwrsio",
        chatMenuLabel: "Opsiynau i reoli sgwrs deialog.",
        chatMenuResetDesc: "Ailosod y sgwrs sgwrsio",
        chatMenuResetTitle: "Ailosodwch sgwrs",
        chatMenuResetText: "Ailosod",
        chatMenuLauncherDesc: "Lansio'r Panel Camau Gweithredu",
        chatMenuLauncherTitle: "Dangos Gweithredoedd",
        chatMenuLauncherText: "Gweithredoedd",
        chatMenuCloseTitle: "Cau",
        chatMenuCloseDesc: "Cau'r sgwrs sgwrsio",
        chatMenuCloseText: "Sgwrs agos",
        chatControlsLabel: "Teipiwch eich neges a defnyddiwch Rhowch allwedd neu anfon botwm i'w anfon. Defnyddiwch y botwm atodiad i anfon ffeil.",
        chatControlsTitle: "Rheolaethau negeseuon",
        fullDockButtonText: "Llawn",
        fullDockButtonDesc: "Gweld sgrin lawn",
        fullDockButtonTitle: "Sgrin lawn",
        wideDockButtonText: "Llydan",
        wideDockButtonDesc: "Cynnwys dociau yn eang",
        wideDockButtonTitle: "Golygfa eang",
        splitDockButtonText: "Hollti",
        splitDockButtonDesc: "Cynnwys y doc yn split view",
        splitDockButtonTitle: "Rhannwch farn",
        narrowDockButtonText: "Cul",
        narrowDockButtonDesc: "Cynnwys y doc yn gul wedd",
        narrowDockButtonTitle: "Golygfa gul",
        assideDockButtonText: "Assided",
        assideDockButtonDesc: "Cynnwys dociau yn asside view",
        assideDockButtonTitle: "Assideview",
        sideBarClose: "Cau",
        sideBarCloseDesc: "Cau'r bar ochr",
        sideBarCommandBar: "Rheolaethau bar ochr",
        persona: "Proffil defnyddiwr ar gyfer",
        personaAria: "Gweld proffil defnyddiwr ar gyfer",
        hierarchyExpand: "Ehangu siart hierarchaeth defnyddwyr",
        hierarchyCollapse: "Cwymp defnyddwyr hierarchaeth siart",
        profileProject: "Prosiect",
        profileSkill: "Medr",
        profileSchool: "Ysgol",
        profileInterest: "Diddordeb",
        profileTitle: "Eich gwybodaeth proffil",
        profilePersonalInfo: "Gwybodaeth Bersonol",
        profileProjects: "Prosiectau sy'n cynnwys",
        profileInterests: "Diddordebau a restrir ar gyfer",
        profileSkills: "Sgiliau a restrir ar gyfer",
        profileSchools: "Ysgolion a fynychwyd gan",
        profileContactInfo: "Gwybodaeth gyswllt ar gyfer",
        profileBirthday: "Penblwydd",
        contactTitle: "Snippet cyswllt ar gyfer defnyddiwr",
        contactOption: "Gwybodaeth gyswllt i'r defnyddiwr",
        btnCopy: "Copïwch fanylion dethol",
        copyIcn: "Copi Icon",
        pageTypeLabel: "Y math o dudalen yw",
        pageTitleLabel: "Enw'r dudalen yw",
        pageBylineLabel: "Mae'r dudalen yn is-lein",
        pageDatelineLabel: "Dyddiad y dudalen yw",
        pageDescriptionLabel: "Disgrifiad o'r dudalen yw",
        pageParentLabel: "Yr ardal gynnwys ar gyfer y dudalen",
        expandPageNavLabel: "Ehangu llywio tudalennau",
        collapsePageNavLabel: "Torri tudalen llywio",
        pageNavLinkLabel: "Navigate to",
        expandComponent: "Ehangu",
        minimiseComponent: "Minimeiddio",
        activityEditedLabel: "Diweddarwyd ddiwethaf gan",
        activityCreatedLabel: "Crëwyd gan",
        activityOwnedLabel: "Cynnwys sy'n eiddo i",
        activityPublishedLabel: "Cyhoeddwyd yn",
        pageEditorsTitle: "Golygyddion",
        pageParentTitle: "Lleoliad",
        pageCategoriesTitle: "Tagiau",
        thumbnailImageLabel: "Delwedd bawd ar gyfer tudalen",
        pageImageLabel: "Prif ddelwedd ar gyfer tudalen",
        eventLocLabel: "Lleoliad",
        eventStartLabel: "O",
        eventEndLabel: "I",
        eventLinkLabel: "Mwy o wybodaeth",
        locAddressLabel: "Cyfeiriad",
        locTypeLabel: "Math o leoliad",
        locEmailLabel: "Cysylltwch ag e-bost",
        locPhoneLabel: "Ffôn cyswllt:",
        pageDatePublishLabel: "Cyhoeddwyd ddiwethaf",
        pageDateLastReviewLabel: "Adolygwyd ddiwethaf",
        pageDateNextReviewLabel: "Disgwyl adolygiad nesaf",
        pageVersionLabel: "Fersiwn",
        collapseOptions: "Opsiynau cwympo",
        expandOptions: "Ehangu opsiynau",
        themeListLabel: "Dewiswch o'r themâu sydd ar gael",
        themeButtonText: "Dewis",
        themeButtonLabel: "Dewiswch y thema hon",
        lightThemeTypeTitle: "Themâu ysgafn",
        darkThemeTypeTitle: "Themâu tywyll",
        contrastThemeTypeTitle: "Themâu cyferbyniad uchel",
        toneThemeTypeTitle: "Themâu tonyddol",
        imageSelectTypeError: "Mae'r ffeil a ddewiswyd yn y fformat anghywir. Dewiswch ddelwedd.",
        imageSelectSizeError: "Mae'r ffeil a ddewiswyd yn rhy fawr. Dewiswch lun llai os gwelwch yn dda.",
        imageSaveText: "Achub",
        imageSaveLabel: "Cadw'r ddelwedd a ddewiswyd",
        imageCancelText: "Canslo",
        imageCancelLabel: "Taflwch y ddelwedd a ddewiswyd",
        imageRemoveText: "Dileu",
        imageRemoveLabel: "Taflwch y ddelwedd gyfredol",
        imageSelectLabel: "Dewiswch ddelwedd i'w harddangos ar baneri SmartHub",
        imageSelectText: "Dewiswch ddelwedd",
        imageSelectSecondaryText: "Addasu eich SmartHub",
        startEmailText: "Anfon e-bost",
        startEmailLabel: "Anfonwch e-bost at",
        startChatText: "Dechrau sgwrs",
        startChatLabel: "Dechrau sgwrsio gyda",
        startCallText: "Ffoniwch ffôn",
        startCallLabel: "Galw",
        startCallMobileText: "Ffoniwch ffôn symudol",
        startCallMobileLabel: "Galw",
        pinLink: "Cyswllt pin",
        logoImage: "Logo SmartHub",
        notificationAnnounce: "Mae hysbysiad newydd wedi ymddangos",
        notificationActions: "Camau gweithredu ar gael ar gyfer yr hysbysiad hwn",
        bookmark: "Dalennod",
        unbookmark: "Unbookmark",
        chatClearText: "Clirio",
        chatUploadText: "Atodi",
        chatQueryText: "Ymholiad",
        chatSendText: "Anfon",
        chatSendLabel: "Anfonwch y neges",
        chatSearchLabel: "Chwilio am dermau dethol",
        chatClearLabel: "Clirio'r termau chwilio",
        chatUploadLabel: "Anfon ffeil i'r chatbot",
        chatSendTitle: "Anfonwch y neges",
        chatSearchTitle: "Chwilio am dermau dethol",
        chatClearTitle: "Clirio'r termau chwilio",
        chatUploadTitle: "Anfon ffeil i'r chatbot",
        chatPlaceholder: "Gofynnwch gwestiwn i mi",
        sideBarCoachAlert: "Mae marc hyfforddwr wedi ymddangos ac mae'r bar ochr wedi cau",
        sideBarCoachDesc: "Gwasgwch enter neu alt + C i agor y wybodaeth cymorth Nod Hyfforddwr",
        sideBarCoachLabel: "Hysbysiad hyfforddwr bar ochr",
        sideBarCoachTitle: "Rheolaethau bar ochr",
        sideBarCoachText: "Gellir agor y bar ochr gan ddefnyddio'r botwm dewislen hon. Bydd y bar ochr yn cofio eich dewis y tro nesaf y byddwch yn gweld y panel hwn.",
        hideCoachMark: "Diystyru'r marc hyfforddwr hwn",
        contentViewDesc: "Ehangu cynnwys y panel i lenwi'r sgrin",
        contentViewDescExpanded: "Lleihau cynnwys y panel i ddangos holl nodweddion y panel",
        contentViewText: "Ehangu cynnwys",
        contentViewTextExpanded: "Lleihau cynnwys",
        noMeeting: "Dim cyfarfodydd wedi'u trefnu",
        meetingAttendeeAria: "Rhestr o fynychwyr",
        join: "Ymuno",
        joinMeeting: "Ymunwch â'r cyfarfod",
        meetingFreeFor: "Am ddim ar gyfer",
        meetingFreeFrom: "o",
        allDay: "Digwyddiad drwy'r dydd",
        viewMore: "Gweld mwy",
        nextUpIn: "Nesaf i fyny yn",
        inProgress: "Cyfarfod ar y gweill",
        panelMenuMoreLabel: "Gweld mwy o opsiynau panel",
        panelMenuMoreText: "Rhagor",
        mainMenuPrimaryLabel: "Prif ddewislen llywio panel SmartHub",
        mainMenuSecondaryLabel: "Dewislen opsiynau panel SmartHub",
        dockSize: "Maint",
        dockSizeAriaLabel: "Ehangu opsiynau botwm hwn i ddewis maint y sgwrs",
        dockSizeTitle: "Dewiswch faint y sgwrs",
        dockSizeOptions: {
            narrow: {
                text: "Cul",
                title: "Panel sgwrsio cul",
                ariaLabel: "Dewiswch yr opsiwn hwn ar gyfer panel sgwrsio cul",
            },
            split: {
                text: "Hollti",
                title: "Rhannu panel sgwrsio",
                ariaLabel: "Dewiswch yr opsiwn hwn ar gyfer rhaniad panel sgwrsio",
            },
            wide: {
                text: "Llydan",
                title: "panel sgwrsio eang",
                ariaLabel: "Dewiswch yr opsiwn hwn ar gyfer panel sgwrsio eang",
            },
            full: {
                text: "Llawn",
                title: "panel sgwrsio sgrin llawn",
                ariaLabel: "Dewiswch yr opsiwn hwn ar gyfer panel sgwrsio sgrin llawn",
            },
        },
        dockPosition: "Doc",
        dockPositionAriaLabel: "Ehangu opsiynau botwm hwn i ddewis y sefyllfa y sgwrs",
        dockPositionTitle: "Dewiswch y sefyllfa y sgwrs",
        dockPositionOptions: {
            right: {
                text: "Dde",
                title: "Docio'r sgwrs i'r dde",
                ariaLabel: "Dewiswch yr opsiwn hwn i docio'r sgwrs i'r dde",
            },
            left: {
                text: "Chwith",
                title: "Docio'r sgwrs i'r chwith",
                ariaLabel: "Dewiswch yr opsiwn hwn i docio'r sgwrs i'r chwith",
            },
        },
        launchButtonLabel: "Lansio'r chatbot",
        launchButtonTitle: "Lansio'r chatbot",
        launchButtonAlt: "Delwedd botwm lansio Chatbot",
        chatSplashAcceptCbxLabel: "Derbyn y telerau ac amodau",
        chatSplashAcceptCbxTitle: "Derbyn y telerau ac amodau",
        chatSplashConfirmBtnLabel: "Drwy glicio ar y botwm hwn rydych yn derbyn y polisi preifatrwydd ac yn cytuno i agor SmartChat",
        chatSplashConfirmBtnText: "Parhau",
        chatSplashConfirmBtnTitle: "Parhau yn y sgwrs",
        chatSplashCancelBtnLabel: "Drwy glicio ar y botwm hwn mae'r chatbot ar gau",
        chatSplashCancelBtnText: "Cau",
        chatSplashCancelBtnTitle: "Canslo a chau'r ffenestr sgwrsio",
        chatHeadTitle: "Hi, I'm SmartChat",
        chatHeadTitleLabel: "Hi, I'm SmartChat",
        chatHeadSubTitle: "Rwyf yma i ateb eich cwestiynau. Sut allaf eich helpu?",
        chatHeadSubTitleLabel: "Rwyf yma i ateb eich cwestiynau. Sut allaf eich helpu?",
        chatHeadImageAlt: "Delwedd avatar Chatbot",
        chatPoweredByLabel: "Ewch i'r ICS. Gwefan AI am fwy o wybodaeth am SmartChat.",
        chatPoweredByTitle: "Wedi'i bweru gan ICS. AI SmartChat, ewch i'r wefan am fwy o wybodaeth.",
        chatPoweredByAlt: ".ICS. AI SmartChat Logo Delwedd",
        chatSigningInMessage: "Mae eich arwydd ar gais yn cael ei brosesu, arhoswch os gwelwch yn dda.",
        tpcMessage: {
            chat: {
                okText: "Ocê",
                okTitle: "Caewch y dialog a pharhau i ddefnyddio'r chatbot",
                okLabel: "Caewch y dialog a pharhau i ddefnyddio'r chatbot",
                cancelText: "Canslo",
                cancelTitle: "Cau'r dialog a dychwelyd i'r dudalen",
                cancelLabel: "Cau'r dialog a dychwelyd i'r dudalen",
                infoText: "Mwy o wybodaeth",
                infoTitle: "Agorwch dudalen gymorth i ddarganfod mwy",
                infoLabel: "Agorwch dudalen gymorth i ddarganfod mwy",
                closeText: "Cau",
                closeTitle: "Cau'r dialog a dychwelyd i'r dudalen",
                closeLabel: "Cau'r dialog a dychwelyd i'r dudalen",
                title: "Cwcis trydydd parti",
                subText: {
                    warn: "Mae eich porwr wedi analluogi'r defnydd o gwcis trydydd parti. Mae'r chatbot yn gofyn am gwcis trydydd parti i ddarparu profiad mewngofnodi di-dor. Cliciwch y botwm cau i gau'r tab porwr neu cliciwch ar y botwm mwy o wybodaeth am help.",
                    info: "Mae eich porwr wedi analluogi'r defnydd o gwcis trydydd parti. Mae'r chatbot yn defnyddio'r rhain i ddarparu profiad mewngofnodi di-dor. Efallai y gwelwch nad yw rhai nodweddion ar gael, cliciwch ar y botwm mwy o wybodaeth am help.",
                },
            },
            full: {
                okText: "Ocê",
                okTitle: "Caewch y dialog a pharhau i ddefnyddio'r SmartHub",
                okLabel: "Caewch y dialog a pharhau i ddefnyddio'r SmartHub",
                infoText: "Mwy o wybodaeth",
                infoTitle: "Agorwch dudalen gymorth i ddarganfod mwy",
                infoLabel: "Agorwch dudalen gymorth i ddarganfod mwy",
                closeText: "Cau",
                closeTitle: "Cau tab y porwr",
                closeLabel: "Cau tab y porwr",
                title: "Cwcis trydydd parti",
                subText: {
                    warn: "Mae eich porwr wedi analluogi'r defnydd o gwcis trydydd parti. Mae'r SmartHub yn gofyn am gwcis trydydd parti i ddarparu profiad mewngofnodi di-dor. Cliciwch y botwm cau i gau'r tab porwr neu cliciwch ar y botwm mwy o wybodaeth am help.",
                    info: "Mae eich porwr wedi analluogi'r defnydd o gwcis trydydd parti. Mae'r SmartHub yn defnyddio'r rhain i ddarparu profiad mewngofnodi di-dor. Efallai y gwelwch nad yw rhai nodweddion ar gael, cliciwch ar y botwm mwy o wybodaeth am help.",
                },
            },
        },
        carousel: {
            dotLabel: "Dewiswch eitem, rhif",
            dotTitle: "Golwg",
            previousLabel: "Symud i'r eitem flaenorol",
            previousTitle: "Blaenorol",
            nextLabel: "Symudwch yr eitem nesaf",
            nextTitle: "Nesaf",
        },
        chatControlsCoachAlert: "Mae marc hyfforddwr wedi ymddangos, darganfyddwch am yr opsiynau chwilio",
        chatControlsCoachDesc: "Pwyswch enter neu alt + C i agor gwybodaeth am yr opsiynau chwilio",
        chatControlsCoachLabel: "Hysbysu hyfforddwr opsiynau chwilio",
        chatControlsCoachTitle: "Blwch Chwilio - Felix",
        chatControlsCoachText: "Cliciwch y botwm isod i weld opsiynau chwilio, maent yn amrywio o 'y lle hwn' i 'bopeth'. Teipiwch eich term (au) chwilio yn y blwch testun.",
        layoutMenuCoachAlert: "Mae marc hyfforddwr wedi ymddangos, darganfyddwch am lywio yn y panel",
        layoutMenuCoachDesc: "Pwyswch enter neu alt + C i agor gwybodaeth am y llywio yn y panel",
        layoutMenuCoachLabel: "Hysbysu hyfforddwr opsiynau chwilio",
        layoutMenuCoachTitle: "Wrth lywio panel",
        layoutMenuCoachText: "Mae cynnwys hybiau yn cael ei gyflwyno o dan gyfres o dabiau, cliciwch tab i lywio i'r panel hwnnw.",
        bookmarkCoachAlert: "Mae marc hyfforddwr wedi ymddangos, darganfyddwch am farcio llyfrau",
        bookmarkCoachDesc: "Pwyswch enter neu alt + C i agor gwybodaeth am lyfrnodi",
        bookmarkCoachLabel: "Hysbysiad hyfforddwr Bookmarking",
        bookmarkCoachTitle: "Llyfrnodi",
        bookmarkCoachText: "Cliciwch ar yr eicon nod tudalen i gadw dolen i'r cynnwys hwn o fewn eich Pethau. Gallwch nodi tudalennau, newyddion, canllawiau, pobl... popeth!",
        contentExpandCoachAlert: "Mae marc hyfforddwr wedi ymddangos, darganfyddwch am opsiynau cynnwys",
        contentExpandCoachDesc: "Pwyswch enter neu alt + C i agor gwybodaeth am opsiynau cynnwys",
        contentExpandCoachLabel: "Hysbysiad hyfforddwr opsiynau cynnwys",
        contentExpandCoachTitle: "Opsiynau Cynnwys",
        contentExpandCoachText: "Gallwch ddefnyddio'r opsiynau ail-faint i newid maint panel gwylio'r dudalen, gallwch hefyd guddio a dangos yr adran manylion tudalen gan ddefnyddio'r eicon saethau i'r dde.",
        feedbackCoachAlert: "Mae marc hyfforddwr wedi ymddangos, darganfyddwch am adborth defnyddwyr",
        feedbackCoachDesc: "Pwyswch enter neu alt + C i agor gwybodaeth am adborth defnyddwyr",
        feedbackCoachLabel: "Hysbysu hyfforddwr adborth defnyddwyr",
        feedbackCoachTitle: "Adborth Defnyddwyr",
        feedbackCoachText: "Defnyddiwch hwn i roi gwybod am broblem, dywedwch wrthym beth yr ydych yn eu hoffi neu nad ydych yn eu hoffi a gadewch eich syniadau i ni wella'r SmartHub.",
        profileCoachAlert: "Mae marc hyfforddwr wedi ymddangos, darganfyddwch am fanylion proffil",
        profileCoachDesc: "Pwyswch enter neu alt + C i agor gwybodaeth am fanylion proffil",
        profileCoachLabel: "Manylion proffil hysbysiad hyfforddwr",
        profileCoachTitle: "Manylion Proffil",
        profileCoachText: "Cliciwch ar gydweithiwr i weld ei fanylion cyswllt a gyda phwy mae'n gweithio. Gallwch hyd yn oed sbarduno e-bost, anfon neges tîm neu eu ffonio.",
        editPageLabel: "Agor a golygu'r dudalen yn y porwr",
        editPageTitle: "Golygu tudalen yn y porwr",
        editPageText: "Golygu'r dudalen hon",
        refinerTitle: "Mireinio gan:",
        refinerExpandTitle: "Ehangu i weld opsiynau mireinio",
        showRefiners: "Dangos purwyr",
        hideRefiners: "Cuddio purwyr",
        personaLinkTitle: "Agor y panel proffil ar gyfer",
        personaLinkAria: "Gweld proffil ar gyfer",
        tileTitle: "Agor",
        slideTitle: "Agor",
        linkTileAria: "",
        linkTileTitle: "Agor",
        iconBack: "Cliciwch i fynd yn ôl i'r olygfa flaenorol",
        iconForward: "Cliciwch i symud ymlaen i'r olygfa nesaf",
        iconHome: "Cliciwch i fynd yn ôl i SmartHub Home",
        rootLabelFull: "SmartHub",
        rootLabelChat: "SmartChat deialog",
        chatPanelLabel: "Sgwrs panel",
        chatStartLabel: "Dechrau'r panel sgwrsio, dianc i'r wasg i gau",
        chatStartText: "Dechrau'r panel sgwrsio",
        chatEndLabel: "Diwedd y panel sgwrsio, dianc i'r wasg i gau",
        chatEndText: "Panel Diwedd Sgwrs",
        mainPanelLabel: "Dechrau'r prif banel, dianc i'r wasg i gau",
        mainStartLabel: "Dechrau'r prif banel",
        mainStartText: "Dechrau'r prif banel",
        mainEndLabel: "Diwedd y prif banel, dianc i'r wasg i gau",
        mainEndText: "Diwedd y prif banel",
        pagePanelLabel: "panel tudalen",
        pageStartLabel: "Dechrau'r panel dudalen, dianc i'r wasg i gau",
        pageStartText: "Dechrau'r panel tudalen",
        pageEndLabel: "Panel diwedd y dudalen, dianc i'r wasg i gau",
        pageEndText: "panel diwedd tudalen",
        commentForm: {
            saveButtonText: "Achub",
            saveButtonLabel: "Cadw'r sylw hwn",
            cancelButtonText: "Canslo",
            cancelButtonLabel: "Canslo newidiadau a dychwelyd",
            deleteButtonText: "Dileu",
            deleteButtonLabel: "Dileu'r sylw hwn",
            clearButtonText: "Clirio",
            clearButtonLabel: "Clirio'r ffurflen",
            textBoxTitle: "Rhowch eich sylw",
            textBoxLabel: "Rhowch eich sylw",
            confirmDelete: "Ydych chi'n siwr eich bod am ddileu'r sylw hwn?",
            errorEmptyComment: "Mae angen y maes sylwadau, nodwch destun",
            errorCommentTooLong: "Mae sylwadau wedi'u cyfyngu i nodau $ {maxLength}. Lleihau'r testun a cheisiwch eto",
        },
        clearAllDesc: "hidlwyr a ddewiswyd yn glir",
        clearAllTitle: "hidlwyr a ddewiswyd yn glir",
        clearAllText: "Clirio popeth",
    },
};


/***/ }),

/***/ "./src/models/localize/localize-keys.enum.ts":
/*!***************************************************!*\
  !*** ./src/models/localize/localize-keys.enum.ts ***!
  \***************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.LocalizeKeys = void 0;
var LocalizeKeys;
(function (LocalizeKeys) {
    LocalizeKeys["cardLabel"] = "cardLabel";
    LocalizeKeys["skipToChat"] = "skipToChat";
    LocalizeKeys["skipToMain"] = "skipToMain";
    LocalizeKeys["commonDateFormat"] = "commonDateFormat";
    LocalizeKeys["commonDateTimeFormat"] = "commonDateTimeFormat";
    LocalizeKeys["webchat"] = "webchat";
    LocalizeKeys["msFormError"] = "msFormError";
    LocalizeKeys["imageError"] = "imageError";
    LocalizeKeys["missingProvider"] = "missingProvider";
    LocalizeKeys["invalidSchema"] = "invalidSchema";
    LocalizeKeys["noResults"] = "noResults";
    LocalizeKeys["noResultsCalender"] = "noResultsCalender";
    LocalizeKeys["na"] = "na";
    LocalizeKeys["noResultsHeading"] = "noResultsHeading";
    LocalizeKeys["noResultsTitle"] = "noResultsTitle";
    LocalizeKeys["noResultsDescription"] = "noResultsDescription";
    LocalizeKeys["noSubject"] = "noSubject";
    LocalizeKeys["suffixItems"] = "suffixItems";
    LocalizeKeys["fetchingItems"] = "fetchingItems";
    LocalizeKeys["panelNavTitle"] = "panelNavTitle";
    LocalizeKeys["loadMore"] = "loadMore";
    LocalizeKeys["loadMoreDesc"] = "loadMoreDesc";
    LocalizeKeys["aboutButtonTitle"] = "aboutButtonTitle";
    LocalizeKeys["aboutButtonDesc"] = "aboutButtonDesc";
    LocalizeKeys["aboutCloseButtonTitle"] = "aboutCloseButtonTitle";
    LocalizeKeys["themePanelTitle"] = "themePanelTitle";
    LocalizeKeys["themeButtonDesc"] = "themeButtonDesc";
    LocalizeKeys["themeButtonTitle"] = "themeButtonTitle";
    LocalizeKeys["themeCloseButtonTitle"] = "themeCloseButtonTitle";
    LocalizeKeys["historyNextTitle"] = "historyNextTitle";
    LocalizeKeys["historyBackTitle"] = "historyBackTitle";
    LocalizeKeys["navTitle"] = "navTitle";
    LocalizeKeys["navMenuTitle"] = "navMenuTitle";
    LocalizeKeys["navOptionsTitle"] = "navOptionsTitle";
    LocalizeKeys["aboutPanelTitle"] = "aboutPanelTitle";
    LocalizeKeys["aboutVersionPrefix"] = "aboutVersionPrefix";
    LocalizeKeys["aboutPublishedPrefix"] = "aboutPublishedPrefix";
    LocalizeKeys["aboutEnvironmentPrefix"] = "aboutEnvironmentPrefix";
    LocalizeKeys["refineByText"] = "refineByText";
    LocalizeKeys["refineByTitle"] = "refineByTitle";
    LocalizeKeys["refineByDesc"] = "refineByDesc";
    LocalizeKeys["refineByValueTitle"] = "refineByValueTitle";
    LocalizeKeys["refineByValueDesc"] = "refineByValueDesc";
    LocalizeKeys["sortByText"] = "sortByText";
    LocalizeKeys["sortByTitle"] = "sortByTitle";
    LocalizeKeys["sortByDesc"] = "sortByDesc";
    LocalizeKeys["sortByValueTitle"] = "sortByValueTitle";
    LocalizeKeys["sortByValueDesc"] = "sortByValueDesc";
    LocalizeKeys["azFilterValueDesc"] = "azFilterValueDesc";
    LocalizeKeys["azFilterValueTitle"] = "azFilterValueTitle";
    LocalizeKeys["azFilterText"] = "azFilterText";
    LocalizeKeys["azFilterSecondaryText"] = "azFilterSecondaryText";
    LocalizeKeys["azFilterDesc"] = "azFilterDesc";
    LocalizeKeys["azFilterTitle"] = "azFilterTitle";
    LocalizeKeys["pageError"] = "pageError";
    LocalizeKeys["feedbackButtonTitle"] = "feedbackButtonTitle";
    LocalizeKeys["layoutNavTitle"] = "layoutNavTitle";
    LocalizeKeys["pageMenuTitle"] = "pageMenuTitle";
    LocalizeKeys["pageMenuLabel"] = "pageMenuLabel";
    LocalizeKeys["pageMenuCloseDesc"] = "pageMenuCloseDesc";
    LocalizeKeys["pageMenuCloseTitle"] = "pageMenuCloseTitle";
    LocalizeKeys["pageMenuCloseText"] = "pageMenuCloseText";
    LocalizeKeys["chatMenuTitle"] = "chatMenuTitle";
    LocalizeKeys["chatMenuLabel"] = "chatMenuLabel";
    LocalizeKeys["chatMenuResetDesc"] = "chatMenuResetDesc";
    LocalizeKeys["chatMenuResetTitle"] = "chatMenuResetTitle";
    LocalizeKeys["chatMenuResetText"] = "chatMenuResetText";
    LocalizeKeys["chatMenuLauncherDesc"] = "chatMenuLauncherDesc";
    LocalizeKeys["chatMenuLauncherTitle"] = "chatMenuLauncherTitle";
    LocalizeKeys["chatMenuLauncherText"] = "chatMenuLauncherText";
    LocalizeKeys["chatMenuCloseTitle"] = "chatMenuCloseTitle";
    LocalizeKeys["chatMenuCloseDesc"] = "chatMenuCloseDesc";
    LocalizeKeys["chatMenuCloseText"] = "chatMenuCloseText";
    LocalizeKeys["fullDockButtonText"] = "fullDockButtonText";
    LocalizeKeys["fullDockButtonDesc"] = "fullDockButtonDesc";
    LocalizeKeys["fullDockButtonTitle"] = "fullDockButtonTitle";
    LocalizeKeys["wideDockButtonText"] = "wideDockButtonText";
    LocalizeKeys["wideDockButtonDesc"] = "wideDockButtonDesc";
    LocalizeKeys["wideDockButtonTitle"] = "wideDockButtonTitle";
    LocalizeKeys["splitDockButtonText"] = "splitDockButtonText";
    LocalizeKeys["splitDockButtonDesc"] = "splitDockButtonDesc";
    LocalizeKeys["splitDockButtonTitle"] = "splitDockButtonTitle";
    LocalizeKeys["narrowDockButtonText"] = "narrowDockButtonText";
    LocalizeKeys["narrowDockButtonDesc"] = "narrowDockButtonDesc";
    LocalizeKeys["narrowDockButtonTitle"] = "narrowDockButtonTitle";
    LocalizeKeys["assideDockButtonText"] = "assideDockButtonText";
    LocalizeKeys["assideDockButtonDesc"] = "assideDockButtonDesc";
    LocalizeKeys["assideDockButtonTitle"] = "assideDockButtonTitle";
    LocalizeKeys["msPowerAppError"] = "msPowerAppError";
    LocalizeKeys["startEmailText"] = "startEmailText";
    LocalizeKeys["startEmailLabel"] = "startEmailLabel";
    LocalizeKeys["startChatText"] = "startChatText";
    LocalizeKeys["startChatLabel"] = "startChatLabel";
    LocalizeKeys["startCallText"] = "startCallText";
    LocalizeKeys["startCallLabel"] = "startCallLabel";
    LocalizeKeys["startCallMobileText"] = "startCallMobileText";
    LocalizeKeys["startCallMobileLabel"] = "startCallMobileLabel";
    LocalizeKeys["sideBarClose"] = "sideBarClose";
    LocalizeKeys["sideBarCloseDesc"] = "sideBarCloseDesc";
    LocalizeKeys["sideBarCommandBar"] = "sideBarCommandBar";
    LocalizeKeys["persona"] = "persona";
    LocalizeKeys["personaAria"] = "personaAria";
    LocalizeKeys["hierarchyExpand"] = "hierarchyExpand";
    LocalizeKeys["hierarchyCollapse"] = "hierarchyCollapse";
    LocalizeKeys["profileTitle"] = "profileTitle";
    LocalizeKeys["profilePersonalInfo"] = "profilePersonalInfo";
    LocalizeKeys["profileProjects"] = "profileProjects";
    LocalizeKeys["profileSkills"] = "profileSkills";
    LocalizeKeys["profileSchools"] = "profileSchools";
    LocalizeKeys["profileInterests"] = "profileInterests";
    LocalizeKeys["profileProject"] = "profileProject";
    LocalizeKeys["profileSkill"] = "profileSkill";
    LocalizeKeys["profileSchool"] = "profileSchool";
    LocalizeKeys["profileInterest"] = "profileInterest";
    LocalizeKeys["profileContactInfo"] = "profileContactInfo";
    LocalizeKeys["profileBirthday"] = "profileBirthday";
    LocalizeKeys["contactTitle"] = "contactTitle";
    LocalizeKeys["contactOption"] = "contactOption";
    LocalizeKeys["btnCopy"] = "btnCopy";
    LocalizeKeys["copyIcn"] = "copyIcn";
    LocalizeKeys["pageTypeLabel"] = "pageTypeLabel";
    LocalizeKeys["pageTitleLabel"] = "pageTitleLabel";
    LocalizeKeys["pageBylineLabel"] = "pageBylineLabel";
    LocalizeKeys["pageDatelineLabel"] = "pageDatelineLabel";
    LocalizeKeys["pageDescriptionLabel"] = "pageDescriptionLabel";
    LocalizeKeys["pageParentLabel"] = "pageParentLabel";
    LocalizeKeys["expandPageNavLabel"] = "expandPageNavLabel";
    LocalizeKeys["collapsePageNavLabel"] = "collapsePageNavLabel";
    LocalizeKeys["pageNavLinkLabel"] = "pageNavLinkLabel";
    LocalizeKeys["expandComponent"] = "expandComponent";
    LocalizeKeys["minimiseComponent"] = "minimiseComponent";
    LocalizeKeys["activityEditedLabel"] = "activityEditedLabel";
    LocalizeKeys["activityCreatedLabel"] = "activityCreatedLabel";
    LocalizeKeys["activityOwnedLabel"] = "activityOwnedLabel";
    LocalizeKeys["activityPublishedLabel"] = "activityPublishedLabel";
    LocalizeKeys["pageEditorsTitle"] = "pageEditorsTitle";
    LocalizeKeys["pageParentTitle"] = "pageParentTitle";
    LocalizeKeys["pageCategoriesTitle"] = "pageCategoriesTitle";
    LocalizeKeys["thumbnailImageLabel"] = "thumbnailImageLabel";
    LocalizeKeys["pageImageLabel"] = "pageImageLabel";
    LocalizeKeys["eventLocLabel"] = "eventLocLabel";
    LocalizeKeys["eventStartLabel"] = "eventStartLabel";
    LocalizeKeys["eventEndLabel"] = "eventEndLabel";
    LocalizeKeys["eventLinkLabel"] = "eventLinkLabel";
    LocalizeKeys["locAddressLabel"] = "locAddressLabel";
    LocalizeKeys["locTypeLabel"] = "locTypeLabel";
    LocalizeKeys["locEmailLabel"] = "locEmailLabel";
    LocalizeKeys["locPhoneLabel"] = "locPhoneLabel";
    LocalizeKeys["pageDatePublishLabel"] = "pageDatePublishLabel";
    LocalizeKeys["pageDateLastReviewLabel"] = "pageDateLastReviewLabel";
    LocalizeKeys["pageDateNextReviewLabel"] = "pageDateNextReviewLabel";
    LocalizeKeys["pageVersionLabel"] = "pageVersionLabel";
    LocalizeKeys["collapseOptions"] = "collapseOptions";
    LocalizeKeys["expandOptions"] = "expandOptions";
    LocalizeKeys["themeListLabel"] = "themeListLabel";
    LocalizeKeys["themeButtonText"] = "themeButtonText";
    LocalizeKeys["themeButtonLabel"] = "themeButtonLabel";
    LocalizeKeys["lightThemeTypeTitle"] = "lightThemeTypeTitle";
    LocalizeKeys["midThemeTypeTitle"] = "midThemeTypeTitle";
    LocalizeKeys["darkThemeTypeTitle"] = "darkThemeTypeTitle";
    LocalizeKeys["contrastThemeTypeTitle"] = "contrastThemeTypeTitle";
    LocalizeKeys["toneThemeTypeTitle"] = "toneThemeTypeTitle";
    LocalizeKeys["imageSelectTypeError"] = "imageSelectTypeError";
    LocalizeKeys["imageSelectSizeError"] = "imageSelectSizeError";
    LocalizeKeys["imageSaveText"] = "imageSaveText";
    LocalizeKeys["imageSaveLabel"] = "imageSaveLabel";
    LocalizeKeys["imageCancelText"] = "imageCancelText";
    LocalizeKeys["imageCancelLabel"] = "imageCancelLabel";
    LocalizeKeys["imageRemoveText"] = "imageRemoveText";
    LocalizeKeys["imageRemoveLabel"] = "imageRemoveLabel";
    LocalizeKeys["imageSelectLabel"] = "imageSelectLabel";
    LocalizeKeys["imageSelectText"] = "imageSelectText";
    LocalizeKeys["imageSelectSecondaryText"] = "imageSelectSecondaryText";
    LocalizeKeys["pinLink"] = "pinLink";
    LocalizeKeys["logoImage"] = "logoImage";
    LocalizeKeys["notificationAnnounce"] = "notificationAnnounce";
    LocalizeKeys["notificationActions"] = "notificationActions";
    LocalizeKeys["chatSendLabel"] = "chatSendLabel";
    LocalizeKeys["chatSearchLabel"] = "chatSearchLabel";
    LocalizeKeys["chatClearLabel"] = "chatClearLabel";
    LocalizeKeys["chatUploadLabel"] = "chatUploadLabel";
    LocalizeKeys["chatSendTitle"] = "chatSendTitle";
    LocalizeKeys["chatSearchTitle"] = "chatSearchTitle";
    LocalizeKeys["chatClearTitle"] = "chatClearTitle";
    LocalizeKeys["chatUploadTitle"] = "chatUploadTitle";
    LocalizeKeys["chatPlaceholder"] = "chatPlaceholder";
    LocalizeKeys["sideBarCoachAlert"] = "sideBarCoachAlert";
    LocalizeKeys["sideBarCoachDesc"] = "sideBarCoachDesc";
    LocalizeKeys["sideBarCoachLabel"] = "sideBarCoachLabel";
    LocalizeKeys["sideBarCoachTitle"] = "sideBarCoachTitle";
    LocalizeKeys["sideBarCoachText"] = "sideBarCoachText";
    LocalizeKeys["hideCoachMark"] = "hideCoachMark";
    LocalizeKeys["contentViewDesc"] = "contentViewDesc";
    LocalizeKeys["contentViewDescExpanded"] = "contentViewDescExpanded";
    LocalizeKeys["contentViewText"] = "contentViewText";
    LocalizeKeys["contentViewTextExpanded"] = "contentViewTextExpanded";
    LocalizeKeys["panelMenuMoreLabel"] = "panelMenuMoreLabel";
    LocalizeKeys["panelMenuMoreText"] = "panelMenuMoreText";
    LocalizeKeys["mainMenuPrimaryLabel"] = "mainMenuPrimaryLabel";
    LocalizeKeys["mainMenuSecondaryLabel"] = "mainMenuSecondaryLabel";
    LocalizeKeys["launchButtonLabel"] = "launchButtonLabel";
    LocalizeKeys["launchButtonTitle"] = "launchButtonTitle";
    LocalizeKeys["launchButtonAlt"] = "launchButtonAlt";
    LocalizeKeys["chatSplashAcceptCbxLabel"] = "chatSplashAcceptCbxLabel";
    LocalizeKeys["chatSplashAcceptCbxTitle"] = "chatSplashAcceptCbxTitle";
    LocalizeKeys["chatSplashConfirmBtnLabel"] = "chatSplashConfirmBtnLabel";
    LocalizeKeys["chatSplashConfirmBtnText"] = "chatSplashConfirmBtnText";
    LocalizeKeys["chatSplashConfirmBtnTitle"] = "chatSplashConfirmBtnTitle";
    LocalizeKeys["chatSplashCancelBtnLabel"] = "chatSplashCancelBtnLabel";
    LocalizeKeys["chatSplashCancelBtnText"] = "chatSplashCancelBtnText";
    LocalizeKeys["chatSplashCancelBtnTitle"] = "chatSplashCancelBtnTitle";
    LocalizeKeys["chatHeadTitle"] = "chatHeadTitle";
    LocalizeKeys["chatHeadTitleLabel"] = "chatHeadTitleLabel";
    LocalizeKeys["chatHeadSubTitle"] = "chatHeadSubTitle";
    LocalizeKeys["chatHeadSubTitleLabel"] = "chatHeadSubTitleLabel";
    LocalizeKeys["chatHeadImageAlt"] = "chatHeadImageAlt";
    LocalizeKeys["chatPoweredByLabel"] = "chatPoweredByLabel";
    LocalizeKeys["chatPoweredByTitle"] = "chatPoweredByTitle";
    LocalizeKeys["chatPoweredByAlt"] = "chatPoweredByAlt";
    LocalizeKeys["chatSigningInMessage"] = "chatSigningInMessage";
    LocalizeKeys["tpcMessage"] = "tpcMessage";
    LocalizeKeys["chatFooterLabel"] = "chatFooterLabel";
    LocalizeKeys["chatFooterTitle"] = "chatFooterTitle";
    LocalizeKeys["focusZoneHorizontalLabel"] = "focusZoneHorizontalLabel";
    LocalizeKeys["focusZoneVerticalLabel"] = "focusZoneVerticalLabel";
    LocalizeKeys["focusZoneBothLabel"] = "focusZoneBothLabel";
    LocalizeKeys["chatControlsLabel"] = "chatControlsLabel";
    LocalizeKeys["chatControlsTitle"] = "chatControlsTitle";
    LocalizeKeys["carousel"] = "carousel";
    LocalizeKeys["editPageLabel"] = "editPageLabel";
    LocalizeKeys["editPageTitle"] = "editPageTitle";
    LocalizeKeys["editPageText"] = "editPageText";
    LocalizeKeys["refinerTitle"] = "refinerTitle";
    LocalizeKeys["refinerExpandTitle"] = "refinerExpandTitle";
    LocalizeKeys["showRefiners"] = "showRefiners";
    LocalizeKeys["hideRefiners"] = "hideRefiners";
    LocalizeKeys["personaLinkTitle"] = "personaLinkTitle";
    LocalizeKeys["personaLinkAria"] = "personaLinkAria";
    LocalizeKeys["tileTitle"] = "tileTitle";
    LocalizeKeys["slideTitle"] = "slideTitle";
    LocalizeKeys["linkTileAria"] = "linkTileAria";
    LocalizeKeys["linkTileTitle"] = "linkTileTitle";
    LocalizeKeys["iconBack"] = "iconBack";
    LocalizeKeys["iconForward"] = "iconForward";
    LocalizeKeys["iconHome"] = "iconHome";
    LocalizeKeys["rootLabelFull"] = "rootLabelFull";
    LocalizeKeys["rootLabelChat"] = "rootLabelChat";
    LocalizeKeys["chatPanelLabel"] = "chatPanelLabel";
    LocalizeKeys["chatStartLabel"] = "chatStartLabel";
    LocalizeKeys["chatStartText"] = "chatStartText";
    LocalizeKeys["chatEndLabel"] = "chatEndLabel";
    LocalizeKeys["chatEndText"] = "chatEndText";
    LocalizeKeys["mainPanelLabel"] = "mainPanelLabel";
    LocalizeKeys["mainStartLabel"] = "mainStartLabel";
    LocalizeKeys["mainStartText"] = "mainStartText";
    LocalizeKeys["mainEndLabel"] = "mainEndLabel";
    LocalizeKeys["mainEndText"] = "mainEndText";
    LocalizeKeys["pagePanelLabel"] = "pagePanelLabel";
    LocalizeKeys["pageStartLabel"] = "pageStartLabel";
    LocalizeKeys["pageStartText"] = "pageStartText";
    LocalizeKeys["pageEndLabel"] = "pageEndLabel";
    LocalizeKeys["pageEndText"] = "pageEndText";
    LocalizeKeys["commentForm"] = "commentForm";
    LocalizeKeys["clearAllDesc"] = "clearAllDesc";
    LocalizeKeys["clearAllTitle"] = "clearAllTitle";
    LocalizeKeys["clearAllText"] = "clearAllText";
    LocalizeKeys["chatClearText"] = "chatClearText";
    LocalizeKeys["chatUploadText"] = "chatUploadText";
    LocalizeKeys["chatQueryText"] = "chatQueryText";
    LocalizeKeys["chatSendText"] = "chatSendText";
})(LocalizeKeys = exports.LocalizeKeys || (exports.LocalizeKeys = {}));


/***/ }),

/***/ "./src/models/localize/localize-languages.enum.ts":
/*!********************************************************!*\
  !*** ./src/models/localize/localize-languages.enum.ts ***!
  \********************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.LocalizeLanguages = void 0;
var LocalizeLanguages;
(function (LocalizeLanguages) {
    LocalizeLanguages["ab"] = "ab";
    LocalizeLanguages["aa"] = "aa";
    LocalizeLanguages["af"] = "af";
    LocalizeLanguages["ak"] = "ak";
    LocalizeLanguages["sq"] = "sq";
    LocalizeLanguages["am"] = "am";
    LocalizeLanguages["ar"] = "ar";
    LocalizeLanguages["an"] = "an";
    LocalizeLanguages["hy"] = "hy";
    LocalizeLanguages["as"] = "as";
    LocalizeLanguages["av"] = "av";
    LocalizeLanguages["ae"] = "ae";
    LocalizeLanguages["ay"] = "ay";
    LocalizeLanguages["az"] = "az";
    LocalizeLanguages["bm"] = "bm";
    LocalizeLanguages["ba"] = "ba";
    LocalizeLanguages["eu"] = "eu";
    LocalizeLanguages["be"] = "be";
    LocalizeLanguages["bn"] = "bn";
    LocalizeLanguages["bh"] = "bh";
    LocalizeLanguages["bi"] = "bi";
    LocalizeLanguages["bs"] = "bs";
    LocalizeLanguages["br"] = "br";
    LocalizeLanguages["bg"] = "bg";
    LocalizeLanguages["my"] = "my";
    LocalizeLanguages["ca"] = "ca";
    LocalizeLanguages["ch"] = "ch";
    LocalizeLanguages["ce"] = "ce";
    LocalizeLanguages["ny"] = "ny";
    LocalizeLanguages["zh"] = "zh";
    LocalizeLanguages["cv"] = "cv";
    LocalizeLanguages["kw"] = "kw";
    LocalizeLanguages["co"] = "co";
    LocalizeLanguages["cr"] = "cr";
    LocalizeLanguages["hr"] = "hr";
    LocalizeLanguages["cs"] = "cs";
    LocalizeLanguages["da"] = "da";
    LocalizeLanguages["dv"] = "dv";
    LocalizeLanguages["nl"] = "nl";
    LocalizeLanguages["dz"] = "dz";
    LocalizeLanguages["en"] = "en";
    LocalizeLanguages["eo"] = "eo";
    LocalizeLanguages["et"] = "et";
    LocalizeLanguages["ee"] = "ee";
    LocalizeLanguages["fo"] = "fo";
    LocalizeLanguages["fj"] = "fj";
    LocalizeLanguages["fi"] = "fi";
    LocalizeLanguages["fr"] = "fr";
    LocalizeLanguages["ff"] = "ff";
    LocalizeLanguages["gl"] = "gl";
    LocalizeLanguages["ka"] = "ka";
    LocalizeLanguages["de"] = "de";
    LocalizeLanguages["el"] = "el";
    LocalizeLanguages["gn"] = "gn";
    LocalizeLanguages["gu"] = "gu";
    LocalizeLanguages["ht"] = "ht";
    LocalizeLanguages["ha"] = "ha";
    LocalizeLanguages["he"] = "he";
    LocalizeLanguages["hz"] = "hz";
    LocalizeLanguages["hi"] = "hi";
    LocalizeLanguages["ho"] = "ho";
    LocalizeLanguages["hu"] = "hu";
    LocalizeLanguages["ia"] = "ia";
    LocalizeLanguages["id"] = "id";
    LocalizeLanguages["ie"] = "ie";
    LocalizeLanguages["ga"] = "ga";
    LocalizeLanguages["ig"] = "ig";
    LocalizeLanguages["ik"] = "ik";
    LocalizeLanguages["io"] = "io";
    LocalizeLanguages["is"] = "is";
    LocalizeLanguages["it"] = "it";
    LocalizeLanguages["iu"] = "iu";
    LocalizeLanguages["ja"] = "ja";
    LocalizeLanguages["jv"] = "jv";
    LocalizeLanguages["kl"] = "kl";
    LocalizeLanguages["kn"] = "kn";
    LocalizeLanguages["kr"] = "kr";
    LocalizeLanguages["ks"] = "ks";
    LocalizeLanguages["kk"] = "kk";
    LocalizeLanguages["km"] = "km";
    LocalizeLanguages["ki"] = "ki";
    LocalizeLanguages["rw"] = "rw";
    LocalizeLanguages["ky"] = "ky";
    LocalizeLanguages["kv"] = "kv";
    LocalizeLanguages["kg"] = "kg";
    LocalizeLanguages["ko"] = "ko";
    LocalizeLanguages["ku"] = "ku";
    LocalizeLanguages["kj"] = "kj";
    LocalizeLanguages["la"] = "la";
    LocalizeLanguages["lb"] = "lb";
    LocalizeLanguages["lg"] = "lg";
    LocalizeLanguages["li"] = "li";
    LocalizeLanguages["ln"] = "ln";
    LocalizeLanguages["lo"] = "lo";
    LocalizeLanguages["lt"] = "lt";
    LocalizeLanguages["lu"] = "lu";
    LocalizeLanguages["lv"] = "lv";
    LocalizeLanguages["gv"] = "gv";
    LocalizeLanguages["mk"] = "mk";
    LocalizeLanguages["mg"] = "mg";
    LocalizeLanguages["ms"] = "ms";
    LocalizeLanguages["ml"] = "ml";
    LocalizeLanguages["mt"] = "mt";
    LocalizeLanguages["mi"] = "mi";
    LocalizeLanguages["mr"] = "mr";
    LocalizeLanguages["mh"] = "mh";
    LocalizeLanguages["mn"] = "mn";
    LocalizeLanguages["na"] = "na";
    LocalizeLanguages["nv"] = "nv";
    LocalizeLanguages["nd"] = "nd";
    LocalizeLanguages["ne"] = "ne";
    LocalizeLanguages["ng"] = "ng";
    LocalizeLanguages["nb"] = "nb";
    LocalizeLanguages["nn"] = "nn";
    LocalizeLanguages["no"] = "no";
    LocalizeLanguages["ii"] = "ii";
    LocalizeLanguages["nr"] = "nr";
    LocalizeLanguages["oc"] = "oc";
    LocalizeLanguages["oj"] = "oj";
    LocalizeLanguages["cu"] = "cu";
    LocalizeLanguages["om"] = "om";
    LocalizeLanguages["or"] = "or";
    LocalizeLanguages["os"] = "os";
    LocalizeLanguages["pa"] = "pa";
    LocalizeLanguages["pi"] = "pi";
    LocalizeLanguages["fa"] = "fa";
    LocalizeLanguages["pl"] = "pl";
    LocalizeLanguages["ps"] = "ps";
    LocalizeLanguages["pt"] = "pt";
    LocalizeLanguages["qu"] = "qu";
    LocalizeLanguages["rm"] = "rm";
    LocalizeLanguages["rn"] = "rn";
    LocalizeLanguages["ro"] = "ro";
    LocalizeLanguages["ru"] = "ru";
    LocalizeLanguages["sa"] = "sa";
    LocalizeLanguages["sc"] = "sc";
    LocalizeLanguages["sd"] = "sd";
    LocalizeLanguages["se"] = "se";
    LocalizeLanguages["sm"] = "sm";
    LocalizeLanguages["sg"] = "sg";
    LocalizeLanguages["sr"] = "sr";
    LocalizeLanguages["gd"] = "gd";
    LocalizeLanguages["sn"] = "sn";
    LocalizeLanguages["si"] = "si";
    LocalizeLanguages["sk"] = "sk";
    LocalizeLanguages["sl"] = "sl";
    LocalizeLanguages["so"] = "so";
    LocalizeLanguages["st"] = "st";
    LocalizeLanguages["es"] = "es";
    LocalizeLanguages["su"] = "su";
    LocalizeLanguages["sw"] = "sw";
    LocalizeLanguages["ss"] = "ss";
    LocalizeLanguages["sv"] = "sv";
    LocalizeLanguages["ta"] = "ta";
    LocalizeLanguages["te"] = "te";
    LocalizeLanguages["tg"] = "tg";
    LocalizeLanguages["th"] = "th";
    LocalizeLanguages["ti"] = "ti";
    LocalizeLanguages["bo"] = "bo";
    LocalizeLanguages["tk"] = "tk";
    LocalizeLanguages["tl"] = "tl";
    LocalizeLanguages["tn"] = "tn";
    LocalizeLanguages["to"] = "to";
    LocalizeLanguages["tr"] = "tr";
    LocalizeLanguages["ts"] = "ts";
    LocalizeLanguages["tt"] = "tt";
    LocalizeLanguages["tw"] = "tw";
    LocalizeLanguages["ty"] = "ty";
    LocalizeLanguages["ug"] = "ug";
    LocalizeLanguages["uk"] = "uk";
    LocalizeLanguages["ur"] = "ur";
    LocalizeLanguages["uz"] = "uz";
    LocalizeLanguages["ve"] = "ve";
    LocalizeLanguages["vi"] = "vi";
    LocalizeLanguages["vo"] = "vo";
    LocalizeLanguages["wa"] = "wa";
    LocalizeLanguages["cy"] = "cy";
    LocalizeLanguages["wo"] = "wo";
    LocalizeLanguages["fy"] = "fy";
    LocalizeLanguages["xh"] = "xh";
    LocalizeLanguages["yi"] = "yi";
    LocalizeLanguages["yo"] = "yo";
    LocalizeLanguages["za"] = "za";
    LocalizeLanguages["zu"] = "zu";
})(LocalizeLanguages = exports.LocalizeLanguages || (exports.LocalizeLanguages = {}));


/***/ }),

/***/ "./src/models/middleware/action/index.ts":
/*!***********************************************!*\
  !*** ./src/models/middleware/action/index.ts ***!
  \***********************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/middleware/activity/index.ts":
/*!*************************************************!*\
  !*** ./src/models/middleware/activity/index.ts ***!
  \*************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/middleware/attachment/index.ts":
/*!***************************************************!*\
  !*** ./src/models/middleware/attachment/index.ts ***!
  \***************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/middleware/base/base-collection.middleware.ts":
/*!******************************************************************!*\
  !*** ./src/models/middleware/base/base-collection.middleware.ts ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.BaseMiddlewareCollection = void 0;
class BaseMiddlewareCollection {
    constructor() {
        this._middlewares = [];
    }
    testFallback(config, info) {
        return false;
    }
    get middleware() {
        return () => next => (info) => {
            let middleware = this._middlewares.find(m => {
                return m.test ? m.test(info) : this.testFallback(m, info);
            });
            if (middleware)
                return middleware.handle(info);
            else
                return next(info);
        };
    }
    upsert(render) {
        if (render instanceof Array) {
            render.forEach(render => {
                this.upsert(render);
            });
            return;
        }
        let removeIdx = this._middlewares.findIndex((item, i) => {
            return item.id == render.id;
        });
        if (removeIdx >= 0)
            this._middlewares.splice(removeIdx, 1, render);
        else
            this._middlewares.splice(0, 0, render);
        this._middlewares.sort((a, b) => {
            return b.priority - a.priority;
        });
    }
}
exports.BaseMiddlewareCollection = BaseMiddlewareCollection;


/***/ }),

/***/ "./src/models/middleware/base/index.ts":
/*!*********************************************!*\
  !*** ./src/models/middleware/base/index.ts ***!
  \*********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./base-collection.middleware */ "./src/models/middleware/base/base-collection.middleware.ts"), exports);


/***/ }),

/***/ "./src/models/middleware/fetch/index.ts":
/*!**********************************************!*\
  !*** ./src/models/middleware/fetch/index.ts ***!
  \**********************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/middleware/index.ts":
/*!****************************************!*\
  !*** ./src/models/middleware/index.ts ***!
  \****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./action */ "./src/models/middleware/action/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./activity */ "./src/models/middleware/activity/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./attachment */ "./src/models/middleware/attachment/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./base */ "./src/models/middleware/base/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./fetch */ "./src/models/middleware/fetch/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./render */ "./src/models/middleware/render/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./transform */ "./src/models/middleware/transform/index.ts"), exports);


/***/ }),

/***/ "./src/models/middleware/render/index.ts":
/*!***********************************************!*\
  !*** ./src/models/middleware/render/index.ts ***!
  \***********************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/middleware/transform/expression-function.interface.ts":
/*!**************************************************************************!*\
  !*** ./src/models/middleware/transform/expression-function.interface.ts ***!
  \**************************************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/middleware/transform/index.ts":
/*!**************************************************!*\
  !*** ./src/models/middleware/transform/index.ts ***!
  \**************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./expression-function.interface */ "./src/models/middleware/transform/expression-function.interface.ts"), exports);


/***/ }),

/***/ "./src/models/notifications/index.ts":
/*!*******************************************!*\
  !*** ./src/models/notifications/index.ts ***!
  \*******************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.INotificationSchema = void 0;
var notification_interface_1 = __webpack_require__(/*! ./notification.interface */ "./src/models/notifications/notification.interface.ts");
Object.defineProperty(exports, "INotificationSchema", ({ enumerable: true, get: function () { return notification_interface_1.INotificationSchema; } }));


/***/ }),

/***/ "./src/models/notifications/notification.interface.ts":
/*!************************************************************!*\
  !*** ./src/models/notifications/notification.interface.ts ***!
  \************************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.INotificationSchema = void 0;
exports.INotificationSchema = "https://ics.ai/smarthub/notification";


/***/ }),

/***/ "./src/models/permission/index.ts":
/*!****************************************!*\
  !*** ./src/models/permission/index.ts ***!
  \****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./permission-context-item.interface */ "./src/models/permission/permission-context-item.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./permission.interface */ "./src/models/permission/permission.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./permission-level.interface */ "./src/models/permission/permission-level.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./permission-provider-config.interface */ "./src/models/permission/permission-provider-config.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./permission-provider.interface */ "./src/models/permission/permission-provider.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./permission-ref.interface */ "./src/models/permission/permission-ref.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./permission.types */ "./src/models/permission/permission.types.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./secured.interface */ "./src/models/permission/secured.interface.ts"), exports);


/***/ }),

/***/ "./src/models/permission/permission-context-item.interface.ts":
/*!********************************************************************!*\
  !*** ./src/models/permission/permission-context-item.interface.ts ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/permission/permission-level.interface.ts":
/*!*************************************************************!*\
  !*** ./src/models/permission/permission-level.interface.ts ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/permission/permission-provider-config.interface.ts":
/*!***********************************************************************!*\
  !*** ./src/models/permission/permission-provider-config.interface.ts ***!
  \***********************************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/permission/permission-provider.interface.ts":
/*!****************************************************************!*\
  !*** ./src/models/permission/permission-provider.interface.ts ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/permission/permission-ref.interface.ts":
/*!***********************************************************!*\
  !*** ./src/models/permission/permission-ref.interface.ts ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/permission/permission.interface.ts":
/*!*******************************************************!*\
  !*** ./src/models/permission/permission.interface.ts ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/permission/permission.types.ts":
/*!***************************************************!*\
  !*** ./src/models/permission/permission.types.ts ***!
  \***************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/permission/secured.interface.ts":
/*!****************************************************!*\
  !*** ./src/models/permission/secured.interface.ts ***!
  \****************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/preference/index.ts":
/*!****************************************!*\
  !*** ./src/models/preference/index.ts ***!
  \****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.preferenceKeys = void 0;
var pref_keys_const_1 = __webpack_require__(/*! ./pref-keys.const */ "./src/models/preference/pref-keys.const.ts");
Object.defineProperty(exports, "preferenceKeys", ({ enumerable: true, get: function () { return pref_keys_const_1.preferenceKeys; } }));


/***/ }),

/***/ "./src/models/preference/pref-keys.const.ts":
/*!**************************************************!*\
  !*** ./src/models/preference/pref-keys.const.ts ***!
  \**************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.preferenceKeys = void 0;
exports.preferenceKeys = {
    coachMarks: "closed-coach-marks",
    userBannerImage: "user-banner-image",
    userTheme: "user-theme",
    chatDockPosition: "chat-dock-position",
    chatDockSize: "chat-dock-size",
    pageDockPosition: "page-dock-position",
    chatLauncherState: "chat-launcher-state",
    chatPagesState: "chat-pages-state",
    pageLauncherState: "page-launcher-state",
    pageDockSize: "page-dock-size",
    mainDock: "main-dock-size",
    mainDockPosition: "main-dock-position",
    mainContentView: "main-content-view",
    pageContentView: "page-content-view",
    componentMinPrefix: "cmpnt-min-",
    entityPinPrefix: "entity-pin-",
    sideBar: "side-bar",
    layoutDir: "layout-dir",
};


/***/ }),

/***/ "./src/models/profile/index.ts":
/*!*************************************!*\
  !*** ./src/models/profile/index.ts ***!
  \*************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.IPersonSchema = void 0;
var person_interface_1 = __webpack_require__(/*! ./person.interface */ "./src/models/profile/person.interface.ts");
Object.defineProperty(exports, "IPersonSchema", ({ enumerable: true, get: function () { return person_interface_1.IPersonSchema; } }));


/***/ }),

/***/ "./src/models/profile/person.interface.ts":
/*!************************************************!*\
  !*** ./src/models/profile/person.interface.ts ***!
  \************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.IPersonSchema = void 0;
exports.IPersonSchema = "https://ics.ai/smarthub/person";


/***/ }),

/***/ "./src/models/query/index.ts":
/*!***********************************!*\
  !*** ./src/models/query/index.ts ***!
  \***********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./query-group.interface */ "./src/models/query/query-group.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./query-options.interface */ "./src/models/query/query-options.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./query-refiner.interface */ "./src/models/query/query-refiner.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./query-request.interface */ "./src/models/query/query-request.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./query-response.interface */ "./src/models/query/query-response.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./query-sort.interface */ "./src/models/query/query-sort.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./query.interface */ "./src/models/query/query.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./request-header.interface */ "./src/models/query/request-header.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./request-paging.interface */ "./src/models/query/request-paging.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./request-param.interface */ "./src/models/query/request-param.interface.ts"), exports);


/***/ }),

/***/ "./src/models/query/query-group.interface.ts":
/*!***************************************************!*\
  !*** ./src/models/query/query-group.interface.ts ***!
  \***************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/query/query-options.interface.ts":
/*!*****************************************************!*\
  !*** ./src/models/query/query-options.interface.ts ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/query/query-refiner.interface.ts":
/*!*****************************************************!*\
  !*** ./src/models/query/query-refiner.interface.ts ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/query/query-request.interface.ts":
/*!*****************************************************!*\
  !*** ./src/models/query/query-request.interface.ts ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/query/query-response.interface.ts":
/*!******************************************************!*\
  !*** ./src/models/query/query-response.interface.ts ***!
  \******************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/query/query-sort.interface.ts":
/*!**************************************************!*\
  !*** ./src/models/query/query-sort.interface.ts ***!
  \**************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/query/query.interface.ts":
/*!*********************************************!*\
  !*** ./src/models/query/query.interface.ts ***!
  \*********************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/query/request-header.interface.ts":
/*!******************************************************!*\
  !*** ./src/models/query/request-header.interface.ts ***!
  \******************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/query/request-paging.interface.ts":
/*!******************************************************!*\
  !*** ./src/models/query/request-paging.interface.ts ***!
  \******************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/query/request-param.interface.ts":
/*!*****************************************************!*\
  !*** ./src/models/query/request-param.interface.ts ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/theme/ac-keys.enum.ts":
/*!******************************************!*\
  !*** ./src/models/theme/ac-keys.enum.ts ***!
  \******************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ACContainerKeys = void 0;
var ACContainerKeys;
(function (ACContainerKeys) {
    ACContainerKeys["default"] = "default";
    ACContainerKeys["dark"] = "dark";
    ACContainerKeys["light"] = "light";
    ACContainerKeys["accent"] = "accent";
    ACContainerKeys["emphasis"] = "emphasis";
    ACContainerKeys["attention"] = "attention";
    ACContainerKeys["good"] = "good";
    ACContainerKeys["warning"] = "warning";
})(ACContainerKeys = exports.ACContainerKeys || (exports.ACContainerKeys = {}));


/***/ }),

/***/ "./src/models/theme/ac-mapping.interface.ts":
/*!**************************************************!*\
  !*** ./src/models/theme/ac-mapping.interface.ts ***!
  \**************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/theme/breakpoint.interface.ts":
/*!**************************************************!*\
  !*** ./src/models/theme/breakpoint.interface.ts ***!
  \**************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Breakpoints = exports.BreakpointNames = void 0;
var BreakpointNames;
(function (BreakpointNames) {
    BreakpointNames["xs"] = "xs";
    BreakpointNames["sm"] = "sm";
    BreakpointNames["md"] = "md";
    BreakpointNames["lg"] = "lg";
    BreakpointNames["lgx"] = "lgx";
    BreakpointNames["xl"] = "xl";
    BreakpointNames["xlx"] = "xlx";
    BreakpointNames["xxl"] = "xxl";
    BreakpointNames["xxxl"] = "xxxl";
})(BreakpointNames = exports.BreakpointNames || (exports.BreakpointNames = {}));
var Breakpoints;
(function (Breakpoints) {
    Breakpoints[Breakpoints["xs"] = 0] = "xs";
    Breakpoints[Breakpoints["sm"] = 1] = "sm";
    Breakpoints[Breakpoints["md"] = 2] = "md";
    Breakpoints[Breakpoints["lg"] = 3] = "lg";
    Breakpoints[Breakpoints["lgx"] = 4] = "lgx";
    Breakpoints[Breakpoints["xl"] = 5] = "xl";
    Breakpoints[Breakpoints["xlx"] = 6] = "xlx";
    Breakpoints[Breakpoints["xxl"] = 7] = "xxl";
    Breakpoints[Breakpoints["xxxl"] = 8] = "xxxl";
})(Breakpoints = exports.Breakpoints || (exports.Breakpoints = {}));


/***/ }),

/***/ "./src/models/theme/index.ts":
/*!***********************************!*\
  !*** ./src/models/theme/index.ts ***!
  \***********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./theme-definition.interface */ "./src/models/theme/theme-definition.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./theme-keys.enum */ "./src/models/theme/theme-keys.enum.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./theme.interface */ "./src/models/theme/theme.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./ac-keys.enum */ "./src/models/theme/ac-keys.enum.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./ac-mapping.interface */ "./src/models/theme/ac-mapping.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./theme-image.interface */ "./src/models/theme/theme-image.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./style-config.interface */ "./src/models/theme/style-config.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./breakpoint.interface */ "./src/models/theme/breakpoint.interface.ts"), exports);


/***/ }),

/***/ "./src/models/theme/style-config.interface.ts":
/*!****************************************************!*\
  !*** ./src/models/theme/style-config.interface.ts ***!
  \****************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/theme/theme-definition.interface.ts":
/*!********************************************************!*\
  !*** ./src/models/theme/theme-definition.interface.ts ***!
  \********************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/theme/theme-image.interface.ts":
/*!***************************************************!*\
  !*** ./src/models/theme/theme-image.interface.ts ***!
  \***************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
;


/***/ }),

/***/ "./src/models/theme/theme-keys.enum.ts":
/*!*********************************************!*\
  !*** ./src/models/theme/theme-keys.enum.ts ***!
  \*********************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SizeKeys = exports.PropKeys = exports.StyleKeys = exports.IconKeys = exports.ImageKeys = exports.PaletteKeys = exports.SemanticKeys = void 0;
var SemanticKeys;
(function (SemanticKeys) {
    SemanticKeys["primaryNavBackground"] = "primaryNavBackground";
    SemanticKeys["primaryNavText"] = "primaryNavText";
})(SemanticKeys = exports.SemanticKeys || (exports.SemanticKeys = {}));
var PaletteKeys;
(function (PaletteKeys) {
    PaletteKeys["primaryFull"] = "primaryFull";
    PaletteKeys["primaryFullOn"] = "primaryFullOn";
    PaletteKeys["primaryPlus2"] = "primaryPlus2";
    PaletteKeys["primaryPlus2On"] = "primaryPlus2On";
    PaletteKeys["primaryPlus1"] = "primaryPlus1";
    PaletteKeys["primaryPlus1On"] = "primaryPlus1On";
    PaletteKeys["primary"] = "primary";
    PaletteKeys["primaryOn"] = "primaryOn";
    PaletteKeys["primaryMinus1"] = "primaryMinus1";
    PaletteKeys["primaryMinus1On"] = "primaryMinus1On";
    PaletteKeys["primaryMinus2"] = "primaryMinus2";
    PaletteKeys["primaryMinus2On"] = "primaryMinus2On";
    PaletteKeys["primaryMinus3"] = "primaryMinus3";
    PaletteKeys["primaryMinus3On"] = "primaryMinus3On";
    PaletteKeys["primaryMinus4"] = "primaryMinus4";
    PaletteKeys["primaryMinus4On"] = "primaryMinus4On";
    PaletteKeys["primaryEmpty"] = "primaryEmpty";
    PaletteKeys["primaryEmptyOn"] = "primaryEmptyOn";
    PaletteKeys["neutralFull"] = "neutralFull";
    PaletteKeys["neutralFullOn"] = "neutralFullOn";
    PaletteKeys["neutralPlus5"] = "neutralPlus5";
    PaletteKeys["neutralPlus5On"] = "neutralPlus5On";
    PaletteKeys["neutralPlus4"] = "neutralPlus4";
    PaletteKeys["neutralPlus4On"] = "neutralPlus4On";
    PaletteKeys["neutralPlus3"] = "neutralPlus3";
    PaletteKeys["neutralPlus3On"] = "neutralPlus3On";
    PaletteKeys["neutralPlus2"] = "neutralPlus2";
    PaletteKeys["neutralPlus2On"] = "neutralPlus2On";
    PaletteKeys["neutralPlus1"] = "neutralPlus1";
    PaletteKeys["neutralPlus1On"] = "neutralPlus1On";
    PaletteKeys["neutral"] = "neutral";
    PaletteKeys["neutralOn"] = "neutralOn";
    PaletteKeys["neutralMinus1"] = "neutralMinus1";
    PaletteKeys["neutralMinus1On"] = "neutralMinus1On";
    PaletteKeys["neutralMinus2"] = "neutralMinus2";
    PaletteKeys["neutralMinus2On"] = "neutralMinus2On";
    PaletteKeys["neutralMinus3"] = "neutralMinus3";
    PaletteKeys["neutralMinus3On"] = "neutralMinus3On";
    PaletteKeys["neutralMinus4"] = "neutralMinus4";
    PaletteKeys["neutralMinus4On"] = "neutralMinus4On";
    PaletteKeys["neutralMinus5"] = "neutralMinus5";
    PaletteKeys["neutralMinus5On"] = "neutralMinus5On";
    PaletteKeys["neutralEmpty"] = "neutralEmpty";
    PaletteKeys["neutralEmptyOn"] = "neutralEmptyOn";
    PaletteKeys["clear"] = "clear";
    PaletteKeys["filmPlus1"] = "filmPlus1";
    PaletteKeys["filmPlus1On"] = "filmPlus1On";
    PaletteKeys["film"] = "film";
    PaletteKeys["filmOn"] = "filmOn";
    PaletteKeys["filmVar"] = "filmVar";
    PaletteKeys["filmVarOn"] = "filmVarOn";
    PaletteKeys["filmMinus1"] = "filmMinus1";
    PaletteKeys["filmMinus1On"] = "filmMinus1On";
    PaletteKeys["neutalFilm"] = "neutalFilm";
    PaletteKeys["neutalFilmOn"] = "neutalFilmOn";
    PaletteKeys["neutalFilmMinus1"] = "neutalFilmMinus1";
    PaletteKeys["neutalFilmMinus1On"] = "neutalFilmMinus1On";
    PaletteKeys["neutalFilmMinus2"] = "neutalFilmMinus2";
    PaletteKeys["neutalFilmMinus2On"] = "neutalFilmMinus2On";
    PaletteKeys["warnPlus2"] = "warnPlus2";
    PaletteKeys["warnPlus2On"] = "warnPlus2On";
    PaletteKeys["warnPlus1"] = "warnPlus1";
    PaletteKeys["warnPlus1On"] = "warnPlus1On";
    PaletteKeys["warn"] = "warn";
    PaletteKeys["warnOn"] = "warnOn";
    PaletteKeys["warnMinus1"] = "warnMinus1";
    PaletteKeys["warnMinus1On"] = "warnMinus1On";
    PaletteKeys["warnMinus2"] = "warnMinus2";
    PaletteKeys["warnMinus2On"] = "warnMinus2On";
    PaletteKeys["successPlus2"] = "successPlus2";
    PaletteKeys["successPlus2On"] = "successPlus2On";
    PaletteKeys["successPlus1"] = "successPlus1";
    PaletteKeys["successPlus1On"] = "successPlus1On";
    PaletteKeys["success"] = "success";
    PaletteKeys["successOn"] = "successOn";
    PaletteKeys["successMinus1"] = "successMinus1";
    PaletteKeys["successMinus1On"] = "successMinus1On";
    PaletteKeys["successMinus2"] = "successMinus2";
    PaletteKeys["successMinus2On"] = "successMinus2On";
    PaletteKeys["hazardPlus2"] = "hazardPlus2";
    PaletteKeys["hazardPlus2On"] = "hazardPlus2On";
    PaletteKeys["hazardPlus1"] = "hazardPlus1";
    PaletteKeys["hazardPlus1On"] = "hazardPlus1On";
    PaletteKeys["hazard"] = "hazard";
    PaletteKeys["hazardOn"] = "hazardOn";
    PaletteKeys["hazardMinus1"] = "hazardMinus1";
    PaletteKeys["hazardMinus1On"] = "hazardMinus1On";
    PaletteKeys["hazardMinus2"] = "hazardMinus2";
    PaletteKeys["hazardMinus2On"] = "hazardMinus2On";
    PaletteKeys["notifyPlus2"] = "notifyPlus2";
    PaletteKeys["notifyPlus2On"] = "notifyPlus2On";
    PaletteKeys["notifyPlus1"] = "notifyPlus1";
    PaletteKeys["notifyPlus1On"] = "notifyPlus1On";
    PaletteKeys["notify"] = "notify";
    PaletteKeys["notifyOn"] = "notifyOn";
    PaletteKeys["notifyMinus1"] = "notifyMinus1";
    PaletteKeys["notifyMinus1On"] = "notifyMinus1On";
    PaletteKeys["notifyMinus2"] = "notifyMinus2";
    PaletteKeys["notifyMinus2On"] = "notifyMinus2On";
})(PaletteKeys = exports.PaletteKeys || (exports.PaletteKeys = {}));
var ImageKeys;
(function (ImageKeys) {
    ImageKeys["appLogoNotifyL"] = "appLogoOnNotifyL";
    ImageKeys["appLogoNotifyM"] = "appLogoOnNotifyM";
    ImageKeys["appLogoNotifyS"] = "appLogoOnNotifyS";
    ImageKeys["appLogoLightL"] = "appLogoOnLightL";
    ImageKeys["appLogoLightM"] = "appLogoOnLightM";
    ImageKeys["appLogoLightS"] = "appLogoOnLightS";
    ImageKeys["appLogoDarkL"] = "appLogoOnDarkL";
    ImageKeys["appLogoDarkM"] = "appLogoOnDarkM";
    ImageKeys["appLogoDarkS"] = "appLogoOnDarkS";
    ImageKeys["appLogoOnPrimaryL"] = "appLogoOnPrimaryL";
    ImageKeys["appLogoOnPrimaryM"] = "appLogoOnPrimaryM";
    ImageKeys["appLogoOnPrimaryS"] = "appLogoOnPrimaryS";
    ImageKeys["appLogoOnEmptyL"] = "appLogoOnEmptyL";
    ImageKeys["appLogoOnEmptyM"] = "appLogoOnEmptyM";
    ImageKeys["appLogoOnEmptyS"] = "appLogoOnEmptyS";
    ImageKeys["headLogoOnPrimaryL"] = "headLogoOnPrimaryL";
    ImageKeys["headLogoOnPrimaryM"] = "headLogoOnPrimaryM";
    ImageKeys["headLogoOnPrimaryS"] = "headLogoOnPrimaryS";
    ImageKeys["headLogoOnEmptyL"] = "headLogoOnEmptyL";
    ImageKeys["headLogoOnEmptyM"] = "headLogoOnEmptyM";
    ImageKeys["headLogoOnEmptyS"] = "headLogoOnEmptyS";
    ImageKeys["iconLogoOnPrimaryL"] = "iconLogoOnPrimaryL";
    ImageKeys["iconLogoOnPrimaryM"] = "iconLogoOnPrimaryM";
    ImageKeys["iconLogoOnPrimaryS"] = "iconLogoOnPrimaryS";
    ImageKeys["iconLogoOnEmptyL"] = "iconLogoOnEmptyL";
    ImageKeys["iconLogoOnEmptyM"] = "iconLogoOnEmptyM";
    ImageKeys["iconLogoOnEmptyS"] = "iconLogoOnEmptyS";
    ImageKeys["botAvatar"] = "botAvatar";
    ImageKeys["launchButtonLeft"] = "launchButtonLeft";
    ImageKeys["launchButtonRight"] = "launchButtonRight";
    ImageKeys["chatHead"] = "chatHead";
    ImageKeys["chatPoweredBy"] = "chatPoweredBy";
})(ImageKeys = exports.ImageKeys || (exports.ImageKeys = {}));
var IconKeys;
(function (IconKeys) {
    IconKeys["any"] = "any";
})(IconKeys = exports.IconKeys || (exports.IconKeys = {}));
var StyleKeys;
(function (StyleKeys) {
    StyleKeys["chat"] = "chat";
    StyleKeys["panel"] = "panel";
})(StyleKeys = exports.StyleKeys || (exports.StyleKeys = {}));
var PropKeys;
(function (PropKeys) {
    PropKeys["chat"] = "chat";
    PropKeys["panel"] = "panel";
})(PropKeys = exports.PropKeys || (exports.PropKeys = {}));
var SizeKeys;
(function (SizeKeys) {
    SizeKeys["normal"] = "normal";
    SizeKeys["normalEm"] = "normalEm";
    SizeKeys["normalPlus"] = "normalPlus";
    SizeKeys["mega"] = "mega";
    SizeKeys["superLarge"] = "superLarge";
    SizeKeys["xxLarge"] = "xxLarge";
    SizeKeys["xxLargePlus"] = "xxLargePlus";
    SizeKeys["xLarge"] = "xLarge";
    SizeKeys["xLargePlus"] = "xLargePlus";
    SizeKeys["large"] = "large";
    SizeKeys["medium"] = "medium";
    SizeKeys["mediumPlus"] = "mediumPlus";
    SizeKeys["mediumEm"] = "mediumEm";
    SizeKeys["small"] = "small";
    SizeKeys["smallPlus"] = "smallPlus";
    SizeKeys["xSmall"] = "xSmall";
    SizeKeys["tiny"] = "tiny";
})(SizeKeys = exports.SizeKeys || (exports.SizeKeys = {}));


/***/ }),

/***/ "./src/models/theme/theme.interface.ts":
/*!*********************************************!*\
  !*** ./src/models/theme/theme.interface.ts ***!
  \*********************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.IThemeSchema = void 0;
exports.IThemeSchema = "https://ics.ai/smarthub/theme";


/***/ }),

/***/ "./src/state/context/api.context.ts":
/*!******************************************!*\
  !*** ./src/state/context/api.context.ts ***!
  \******************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.APIContext = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
exports.APIContext = react_1.createContext({
    botReady: false,
    setBotReady: () => { },
    setExtendedAPI: () => { }
});


/***/ }),

/***/ "./src/state/context/app.context.ts":
/*!******************************************!*\
  !*** ./src/state/context/app.context.ts ***!
  \******************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.AppContext = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
exports.AppContext = react_1.createContext({
    providers: null,
    actions: null,
    sourceInfo: null,
    chatScopes: [],
    knownUris: {},
    view: null,
    chromeState: 'open',
    setChromeState: (chromeState) => { },
    focus: (name) => { },
    registerFocus: (name, callback) => { },
    focusLastAction: (panelType) => { return false; },
    registerLastAction: (panelType, callback) => { },
});


/***/ }),

/***/ "./src/state/context/breakpoint.context.ts":
/*!*************************************************!*\
  !*** ./src/state/context/breakpoint.context.ts ***!
  \*************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.BreakpointContext = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
exports.BreakpointContext = react_1.createContext({
    root: null,
    current: null
});


/***/ }),

/***/ "./src/state/context/chat-bot.context.ts":
/*!***********************************************!*\
  !*** ./src/state/context/chat-bot.context.ts ***!
  \***********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ChatBotContext = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
exports.ChatBotContext = react_1.createContext({
    directlineContext: null,
    hostConfig: null,
    webChat: null,
    scope: null,
    setScope: (scope, params) => { },
    scopes: [],
    setScopes: (scopes) => { },
    reset: () => { return Promise.reject(); }
});


/***/ }),

/***/ "./src/state/context/current-panel.context.ts":
/*!****************************************************!*\
  !*** ./src/state/context/current-panel.context.ts ***!
  \****************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CurrentPanelContext = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
exports.CurrentPanelContext = react_1.createContext({
    type: 'main'
});


/***/ }),

/***/ "./src/state/context/index.ts":
/*!************************************!*\
  !*** ./src/state/context/index.ts ***!
  \************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./api.context */ "./src/state/context/api.context.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./tpc-check.context */ "./src/state/context/tpc-check.context.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./theme.context */ "./src/state/context/theme.context.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./chat-bot.context */ "./src/state/context/chat-bot.context.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./app.context */ "./src/state/context/app.context.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./panels.context */ "./src/state/context/panels.context.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./current-panel.context */ "./src/state/context/current-panel.context.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./localize.context */ "./src/state/context/localize.context.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./middleware.context */ "./src/state/context/middleware.context.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./breakpoint.context */ "./src/state/context/breakpoint.context.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./location.context */ "./src/state/context/location.context.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./notification.context */ "./src/state/context/notification.context.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./preference.context */ "./src/state/context/preference.context.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./panel-view.context */ "./src/state/context/panel-view.context.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./page.context */ "./src/state/context/page.context.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./personality.context */ "./src/state/context/personality.context.ts"), exports);


/***/ }),

/***/ "./src/state/context/localize.context.ts":
/*!***********************************************!*\
  !*** ./src/state/context/localize.context.ts ***!
  \***********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.LocalizeContext = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
exports.LocalizeContext = react_1.createContext({
    config: null,
    locale: null,
    setLocale: (lang) => { },
});


/***/ }),

/***/ "./src/state/context/location.context.ts":
/*!***********************************************!*\
  !*** ./src/state/context/location.context.ts ***!
  \***********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.LocationContext = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
exports.LocationContext = react_1.createContext({
    location: null,
    path: null
});


/***/ }),

/***/ "./src/state/context/middleware.context.ts":
/*!*************************************************!*\
  !*** ./src/state/context/middleware.context.ts ***!
  \*************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MiddlewareContext = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
exports.MiddlewareContext = react_1.createContext({});


/***/ }),

/***/ "./src/state/context/notification.context.ts":
/*!***************************************************!*\
  !*** ./src/state/context/notification.context.ts ***!
  \***************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.NotificationContext = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
exports.NotificationContext = react_1.createContext({
    notifications: [],
    dismiss: (notification) => { },
    dismissAll: () => { },
});


/***/ }),

/***/ "./src/state/context/page.context.ts":
/*!*******************************************!*\
  !*** ./src/state/context/page.context.ts ***!
  \*******************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PageContext = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
exports.PageContext = react_1.createContext({
    selectedPage: null,
    pageState: "open",
    setPageState: (chromeState) => { },
    setSelectedPage: (page) => { },
});


/***/ }),

/***/ "./src/state/context/panel-view.context.ts":
/*!*************************************************!*\
  !*** ./src/state/context/panel-view.context.ts ***!
  \*************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PanelViewContext = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
exports.PanelViewContext = react_1.createContext({
    type: 'main',
    initialFocus: null,
    actions: [],
    panel: null,
    regions: null,
    tab: null,
    tabs: [],
    template: null,
    scopes: [],
});


/***/ }),

/***/ "./src/state/context/panels.context.ts":
/*!*********************************************!*\
  !*** ./src/state/context/panels.context.ts ***!
  \*********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PanelsContext = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
exports.PanelsContext = react_1.createContext([]);


/***/ }),

/***/ "./src/state/context/personality.context.ts":
/*!**************************************************!*\
  !*** ./src/state/context/personality.context.ts ***!
  \**************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PersonalityContext = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
exports.PersonalityContext = react_1.createContext({
    personality: null,
    setPersonality: (name) => { },
});


/***/ }),

/***/ "./src/state/context/preference.context.ts":
/*!*************************************************!*\
  !*** ./src/state/context/preference.context.ts ***!
  \*************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PreferenceContext = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
exports.PreferenceContext = react_1.createContext({
    get: (key, parse, defaultValue) => { return defaultValue; },
    set: (key, value, cacheLevel) => { return Promise.resolve(); },
    remove: (key, cacheLevel) => { return Promise.resolve(); },
});


/***/ }),

/***/ "./src/state/context/theme.context.ts":
/*!********************************************!*\
  !*** ./src/state/context/theme.context.ts ***!
  \********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ThemeContext = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
exports.ThemeContext = react_1.createContext({
    theme: null,
    themes: [],
    setTheme: (id) => { }
});


/***/ }),

/***/ "./src/state/context/tpc-check.context.ts":
/*!************************************************!*\
  !*** ./src/state/context/tpc-check.context.ts ***!
  \************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TPCCheckContext = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
exports.TPCCheckContext = react_1.createContext({
    checked: false,
    enabled: false,
    level: 'none'
});


/***/ }),

/***/ "./src/state/hooks/index.ts":
/*!**********************************!*\
  !*** ./src/state/hooks/index.ts ***!
  \**********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useFocusLastAction = exports.useRegisterFocus = exports.useFocus = exports.useDismissNotifications = exports.useDismissNotification = exports.useNextNotification = exports.useNotifications = exports.useGridStyles = exports.useKnownUris = exports.useAppLocation = exports.useHostConfig = exports.useMiddleware = exports.useLocalizeConfig = exports.useSetLocale = exports.useSplash = exports.useLocale = exports.useLocalize = exports.useThemes = exports.useTheme = exports.useSetTheme = exports.useActionMiddleware = exports.useAttachmentMiddleware = exports.useActivityMiddleware = exports.useSourceInfo = exports.useResetDirectline = exports.useDirectline = exports.useGlobalChatScopes = exports.useSetChatScopes = exports.useChatScopes = exports.useSetChatScope = exports.useChatScope = exports.useContentProviders = exports.useProviders = exports.useChatConfig = exports.useAuth = exports.usePageState = exports.usePersonality = exports.usePage = exports.useRemovePreference = exports.useSetPreference = exports.useGetPreferences = exports.usePreferences = exports.useGetPreference = exports.usePreference = exports.useRenderMiddleware = exports.useTransformMiddleware = exports.useFetchMiddleware = exports.usePanels = exports.useBreakpoint = exports.useAppActions = void 0;
exports.useRegisterLastAction = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
var use_app_actions_hook_1 = __webpack_require__(/*! ./use-app-actions.hook */ "./src/state/hooks/use-app-actions.hook.ts");
Object.defineProperty(exports, "useAppActions", ({ enumerable: true, get: function () { return use_app_actions_hook_1.useAppActions; } }));
var use_breakpoint_hook_1 = __webpack_require__(/*! ./use-breakpoint.hook */ "./src/state/hooks/use-breakpoint.hook.ts");
Object.defineProperty(exports, "useBreakpoint", ({ enumerable: true, get: function () { return use_breakpoint_hook_1.useBreakpoint; } }));
var use_panels_hook_1 = __webpack_require__(/*! ./use-panels.hook */ "./src/state/hooks/use-panels.hook.ts");
Object.defineProperty(exports, "usePanels", ({ enumerable: true, get: function () { return use_panels_hook_1.usePanels; } }));
var use_fetch_middleware_hook_1 = __webpack_require__(/*! ./use-fetch-middleware.hook */ "./src/state/hooks/use-fetch-middleware.hook.ts");
Object.defineProperty(exports, "useFetchMiddleware", ({ enumerable: true, get: function () { return use_fetch_middleware_hook_1.useFetchMiddleware; } }));
var use_transform_middleware_hook_1 = __webpack_require__(/*! ./use-transform-middleware.hook */ "./src/state/hooks/use-transform-middleware.hook.ts");
Object.defineProperty(exports, "useTransformMiddleware", ({ enumerable: true, get: function () { return use_transform_middleware_hook_1.useTransformMiddleware; } }));
var use_render_middleware_hook_1 = __webpack_require__(/*! ./use-render-middleware.hook */ "./src/state/hooks/use-render-middleware.hook.ts");
Object.defineProperty(exports, "useRenderMiddleware", ({ enumerable: true, get: function () { return use_render_middleware_hook_1.useRenderMiddleware; } }));
var use_preference_hook_1 = __webpack_require__(/*! ./use-preference.hook */ "./src/state/hooks/use-preference.hook.ts");
Object.defineProperty(exports, "usePreference", ({ enumerable: true, get: function () { return use_preference_hook_1.usePreference; } }));
Object.defineProperty(exports, "useGetPreference", ({ enumerable: true, get: function () { return use_preference_hook_1.useGetPreference; } }));
var use_preferences_hook_1 = __webpack_require__(/*! ./use-preferences.hook */ "./src/state/hooks/use-preferences.hook.ts");
Object.defineProperty(exports, "usePreferences", ({ enumerable: true, get: function () { return use_preferences_hook_1.usePreferences; } }));
Object.defineProperty(exports, "useGetPreferences", ({ enumerable: true, get: function () { return use_preferences_hook_1.useGetPreferences; } }));
var use_set_preference_hook_1 = __webpack_require__(/*! ./use-set-preference.hook */ "./src/state/hooks/use-set-preference.hook.ts");
Object.defineProperty(exports, "useSetPreference", ({ enumerable: true, get: function () { return use_set_preference_hook_1.useSetPreference; } }));
var use_remove_preference_hook_1 = __webpack_require__(/*! ./use-remove-preference.hook */ "./src/state/hooks/use-remove-preference.hook.ts");
Object.defineProperty(exports, "useRemovePreference", ({ enumerable: true, get: function () { return use_remove_preference_hook_1.useRemovePreference; } }));
var use_page_hook_1 = __webpack_require__(/*! ./use-page.hook */ "./src/state/hooks/use-page.hook.ts");
Object.defineProperty(exports, "usePage", ({ enumerable: true, get: function () { return use_page_hook_1.usePage; } }));
var use_personality_hook_1 = __webpack_require__(/*! ./use-personality.hook */ "./src/state/hooks/use-personality.hook.ts");
Object.defineProperty(exports, "usePersonality", ({ enumerable: true, get: function () { return use_personality_hook_1.usePersonality; } }));
var use_page_state_hook_1 = __webpack_require__(/*! ./use-page-state.hook */ "./src/state/hooks/use-page-state.hook.ts");
Object.defineProperty(exports, "usePageState", ({ enumerable: true, get: function () { return use_page_state_hook_1.usePageState; } }));
var use_auth_hook_1 = __webpack_require__(/*! ./use-auth.hook */ "./src/state/hooks/use-auth.hook.ts");
Object.defineProperty(exports, "useAuth", ({ enumerable: true, get: function () { return use_auth_hook_1.useAuth; } }));
var use_chat_config_hook_1 = __webpack_require__(/*! ./use-chat-config.hook */ "./src/state/hooks/use-chat-config.hook.ts");
Object.defineProperty(exports, "useChatConfig", ({ enumerable: true, get: function () { return use_chat_config_hook_1.useChatConfig; } }));
var use_providers_hook_1 = __webpack_require__(/*! ./use-providers.hook */ "./src/state/hooks/use-providers.hook.ts");
Object.defineProperty(exports, "useProviders", ({ enumerable: true, get: function () { return use_providers_hook_1.useProviders; } }));
var use_content_providers_hook_1 = __webpack_require__(/*! ./use-content-providers.hook */ "./src/state/hooks/use-content-providers.hook.ts");
Object.defineProperty(exports, "useContentProviders", ({ enumerable: true, get: function () { return use_content_providers_hook_1.useContentProviders; } }));
var use_chat_scope_hook_1 = __webpack_require__(/*! ./use-chat-scope.hook */ "./src/state/hooks/use-chat-scope.hook.ts");
Object.defineProperty(exports, "useChatScope", ({ enumerable: true, get: function () { return use_chat_scope_hook_1.useChatScope; } }));
var use_set_chat_scope_hook_1 = __webpack_require__(/*! ./use-set-chat-scope.hook */ "./src/state/hooks/use-set-chat-scope.hook.ts");
Object.defineProperty(exports, "useSetChatScope", ({ enumerable: true, get: function () { return use_set_chat_scope_hook_1.useSetChatScope; } }));
var use_chat_scopes_hook_1 = __webpack_require__(/*! ./use-chat-scopes.hook */ "./src/state/hooks/use-chat-scopes.hook.ts");
Object.defineProperty(exports, "useChatScopes", ({ enumerable: true, get: function () { return use_chat_scopes_hook_1.useChatScopes; } }));
var use_set_chat_scopes_hook_1 = __webpack_require__(/*! ./use-set-chat-scopes.hook */ "./src/state/hooks/use-set-chat-scopes.hook.ts");
Object.defineProperty(exports, "useSetChatScopes", ({ enumerable: true, get: function () { return use_set_chat_scopes_hook_1.useSetChatScopes; } }));
var use_global_chat_scopes_hook_1 = __webpack_require__(/*! ./use-global-chat-scopes.hook */ "./src/state/hooks/use-global-chat-scopes.hook.ts");
Object.defineProperty(exports, "useGlobalChatScopes", ({ enumerable: true, get: function () { return use_global_chat_scopes_hook_1.useGlobalChatScopes; } }));
var use_directline_hook_1 = __webpack_require__(/*! ./use-directline.hook */ "./src/state/hooks/use-directline.hook.ts");
Object.defineProperty(exports, "useDirectline", ({ enumerable: true, get: function () { return use_directline_hook_1.useDirectline; } }));
var use_reset_directline_hook_1 = __webpack_require__(/*! ./use-reset-directline.hook */ "./src/state/hooks/use-reset-directline.hook.ts");
Object.defineProperty(exports, "useResetDirectline", ({ enumerable: true, get: function () { return use_reset_directline_hook_1.useResetDirectline; } }));
var use_source_info_hook_1 = __webpack_require__(/*! ./use-source-info.hook */ "./src/state/hooks/use-source-info.hook.ts");
Object.defineProperty(exports, "useSourceInfo", ({ enumerable: true, get: function () { return use_source_info_hook_1.useSourceInfo; } }));
var use_activity_middleware_hook_1 = __webpack_require__(/*! ./use-activity-middleware.hook */ "./src/state/hooks/use-activity-middleware.hook.ts");
Object.defineProperty(exports, "useActivityMiddleware", ({ enumerable: true, get: function () { return use_activity_middleware_hook_1.useActivityMiddleware; } }));
var use_attachment_middleware_hook_1 = __webpack_require__(/*! ./use-attachment-middleware.hook */ "./src/state/hooks/use-attachment-middleware.hook.ts");
Object.defineProperty(exports, "useAttachmentMiddleware", ({ enumerable: true, get: function () { return use_attachment_middleware_hook_1.useAttachmentMiddleware; } }));
var use_action_middleware_hook_1 = __webpack_require__(/*! ./use-action-middleware.hook */ "./src/state/hooks/use-action-middleware.hook.ts");
Object.defineProperty(exports, "useActionMiddleware", ({ enumerable: true, get: function () { return use_action_middleware_hook_1.useActionMiddleware; } }));
var use_set_theme_hook_1 = __webpack_require__(/*! ./use-set-theme.hook */ "./src/state/hooks/use-set-theme.hook.ts");
Object.defineProperty(exports, "useSetTheme", ({ enumerable: true, get: function () { return use_set_theme_hook_1.useSetTheme; } }));
var use_theme_hook_1 = __webpack_require__(/*! ./use-theme.hook */ "./src/state/hooks/use-theme.hook.ts");
Object.defineProperty(exports, "useTheme", ({ enumerable: true, get: function () { return use_theme_hook_1.useTheme; } }));
var use_themes_hook_1 = __webpack_require__(/*! ./use-themes.hook */ "./src/state/hooks/use-themes.hook.ts");
Object.defineProperty(exports, "useThemes", ({ enumerable: true, get: function () { return use_themes_hook_1.useThemes; } }));
var use_localise_hook_1 = __webpack_require__(/*! ./use-localise.hook */ "./src/state/hooks/use-localise.hook.ts");
Object.defineProperty(exports, "useLocalize", ({ enumerable: true, get: function () { return use_localise_hook_1.useLocalize; } }));
var use_locale_hook_1 = __webpack_require__(/*! ./use-locale.hook */ "./src/state/hooks/use-locale.hook.ts");
Object.defineProperty(exports, "useLocale", ({ enumerable: true, get: function () { return use_locale_hook_1.useLocale; } }));
var use_splash_hook_1 = __webpack_require__(/*! ./use-splash.hook */ "./src/state/hooks/use-splash.hook.ts");
Object.defineProperty(exports, "useSplash", ({ enumerable: true, get: function () { return use_splash_hook_1.useSplash; } }));
var use_set_locale_hook_1 = __webpack_require__(/*! ./use-set-locale.hook */ "./src/state/hooks/use-set-locale.hook.ts");
Object.defineProperty(exports, "useSetLocale", ({ enumerable: true, get: function () { return use_set_locale_hook_1.useSetLocale; } }));
var use_localize_config_hook_1 = __webpack_require__(/*! ./use-localize-config.hook */ "./src/state/hooks/use-localize-config.hook.ts");
Object.defineProperty(exports, "useLocalizeConfig", ({ enumerable: true, get: function () { return use_localize_config_hook_1.useLocalizeConfig; } }));
var use_middleware_hook_1 = __webpack_require__(/*! ./use-middleware.hook */ "./src/state/hooks/use-middleware.hook.ts");
Object.defineProperty(exports, "useMiddleware", ({ enumerable: true, get: function () { return use_middleware_hook_1.useMiddleware; } }));
var use_host_config_hook_1 = __webpack_require__(/*! ./use-host-config.hook */ "./src/state/hooks/use-host-config.hook.ts");
Object.defineProperty(exports, "useHostConfig", ({ enumerable: true, get: function () { return use_host_config_hook_1.useHostConfig; } }));
tslib_1.__exportStar(__webpack_require__(/*! ./use-view-config.hook */ "./src/state/hooks/use-view-config.hook.ts"), exports);
var use_app_location_hook_1 = __webpack_require__(/*! ./use-app-location.hook */ "./src/state/hooks/use-app-location.hook.ts");
Object.defineProperty(exports, "useAppLocation", ({ enumerable: true, get: function () { return use_app_location_hook_1.useAppLocation; } }));
var use_known_uris_hook_1 = __webpack_require__(/*! ./use-known-uris.hook */ "./src/state/hooks/use-known-uris.hook.ts");
Object.defineProperty(exports, "useKnownUris", ({ enumerable: true, get: function () { return use_known_uris_hook_1.useKnownUris; } }));
var use_grid_styles_hook_1 = __webpack_require__(/*! ./use-grid-styles.hook */ "./src/state/hooks/use-grid-styles.hook.ts");
Object.defineProperty(exports, "useGridStyles", ({ enumerable: true, get: function () { return use_grid_styles_hook_1.useGridStyles; } }));
var use_notifications_hook_1 = __webpack_require__(/*! ./use-notifications.hook */ "./src/state/hooks/use-notifications.hook.ts");
Object.defineProperty(exports, "useNotifications", ({ enumerable: true, get: function () { return use_notifications_hook_1.useNotifications; } }));
var use_next_notification_hook_1 = __webpack_require__(/*! ./use-next-notification.hook */ "./src/state/hooks/use-next-notification.hook.ts");
Object.defineProperty(exports, "useNextNotification", ({ enumerable: true, get: function () { return use_next_notification_hook_1.useNextNotification; } }));
var use_dismiss_notification_hook_1 = __webpack_require__(/*! ./use-dismiss-notification.hook */ "./src/state/hooks/use-dismiss-notification.hook.ts");
Object.defineProperty(exports, "useDismissNotification", ({ enumerable: true, get: function () { return use_dismiss_notification_hook_1.useDismissNotification; } }));
var use_dismiss_notifications_hook_1 = __webpack_require__(/*! ./use-dismiss-notifications.hook */ "./src/state/hooks/use-dismiss-notifications.hook.ts");
Object.defineProperty(exports, "useDismissNotifications", ({ enumerable: true, get: function () { return use_dismiss_notifications_hook_1.useDismissNotifications; } }));
var use_focus_hook_1 = __webpack_require__(/*! ./use-focus.hook */ "./src/state/hooks/use-focus.hook.ts");
Object.defineProperty(exports, "useFocus", ({ enumerable: true, get: function () { return use_focus_hook_1.useFocus; } }));
var use_register_focus_hook_1 = __webpack_require__(/*! ./use-register-focus.hook */ "./src/state/hooks/use-register-focus.hook.ts");
Object.defineProperty(exports, "useRegisterFocus", ({ enumerable: true, get: function () { return use_register_focus_hook_1.useRegisterFocus; } }));
var use_focus_last_action_hook_1 = __webpack_require__(/*! ./use-focus-last-action.hook */ "./src/state/hooks/use-focus-last-action.hook.ts");
Object.defineProperty(exports, "useFocusLastAction", ({ enumerable: true, get: function () { return use_focus_last_action_hook_1.useFocusLastAction; } }));
var use_register_last_action_hook_1 = __webpack_require__(/*! ./use-register-last-action.hook */ "./src/state/hooks/use-register-last-action.hook.ts");
Object.defineProperty(exports, "useRegisterLastAction", ({ enumerable: true, get: function () { return use_register_last_action_hook_1.useRegisterLastAction; } }));
tslib_1.__exportStar(__webpack_require__(/*! ./use-chrome-state.hook */ "./src/state/hooks/use-chrome-state.hook.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./use-set-bot-ready.hook */ "./src/state/hooks/use-set-bot-ready.hook.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./use-set-extended-api.hook */ "./src/state/hooks/use-set-extended-api.hook.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./use-tpc-check.hook */ "./src/state/hooks/use-tpc-check.hook.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./panel-state.hook */ "./src/state/hooks/panel-state.hook/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./shared-state.hook */ "./src/state/hooks/shared-state.hook/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./use-profile.hook */ "./src/state/hooks/use-profile.hook.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./use-bot-ready.hook */ "./src/state/hooks/use-bot-ready.hook.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./use-keywords.hook */ "./src/state/hooks/use-keywords.hook.ts"), exports);


/***/ }),

/***/ "./src/state/hooks/panel-state.hook/index.ts":
/*!***************************************************!*\
  !*** ./src/state/hooks/panel-state.hook/index.ts ***!
  \***************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./use-panel-entity-id.hook */ "./src/state/hooks/panel-state.hook/use-panel-entity-id.hook.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./use-panel-entity.hook */ "./src/state/hooks/panel-state.hook/use-panel-entity.hook.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./use-panel-id.hook */ "./src/state/hooks/panel-state.hook/use-panel-id.hook.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./use-reset-panel-id.hook */ "./src/state/hooks/panel-state.hook/use-reset-panel-id.hook.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./use-panel-type.hook */ "./src/state/hooks/panel-state.hook/use-panel-type.hook.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./use-panel-view-context.hook */ "./src/state/hooks/panel-state.hook/use-panel-view-context.hook.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./use-panel-view.hook */ "./src/state/hooks/panel-state.hook/use-panel-view.hook.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./use-tab-entity-id.hook */ "./src/state/hooks/panel-state.hook/use-tab-entity-id.hook.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./use-tab-entity.hook */ "./src/state/hooks/panel-state.hook/use-tab-entity.hook.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./use-tab-id.hook */ "./src/state/hooks/panel-state.hook/use-tab-id.hook.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./use-initial-panel-id.hook */ "./src/state/hooks/panel-state.hook/use-initial-panel-id.hook.ts"), exports);


/***/ }),

/***/ "./src/state/hooks/panel-state.hook/use-initial-panel-id.hook.ts":
/*!***********************************************************************!*\
  !*** ./src/state/hooks/panel-state.hook/use-initial-panel-id.hook.ts ***!
  \***********************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useSetInitialPanelId = void 0;
const __1 = __webpack_require__(/*! .. */ "./src/state/hooks/index.ts");
const hooks_1 = __webpack_require__(/*! ../../../hooks */ "./src/hooks/index.ts");
const react_1 = __webpack_require__(/*! react */ "react");
const _1 = __webpack_require__(/*! . */ "./src/state/hooks/panel-state.hook/index.ts");
const useSetInitialPanelId = (panelType) => {
    const currentType = __1.usePanelType();
    const type = (panelType === null || panelType === void 0 ? void 0 : panelType.length) ? panelType : currentType;
    const viewConfig = __1.useViewConfig();
    const view = viewConfig[type];
    const { initialPanel: { id, condition } = {} } = view;
    const setPanelId = _1.useSetPanelId(type);
    const panelsRef = hooks_1.useHookRef(__1.usePanels);
    const order = hooks_1.useOrder();
    return react_1.useCallback(() => {
        let panelId = id;
        if (!(panelId === null || panelId === void 0 ? void 0 : panelId.length) && condition == 'use-first') {
            const primaryPanels = panelsRef.current.filter(p => p.navigation == 'primary');
            const panel = order(primaryPanels).preferred;
            panelId = panel === null || panel === void 0 ? void 0 : panel.$id;
        }
        setPanelId(panelId);
    }, []);
};
exports.useSetInitialPanelId = useSetInitialPanelId;


/***/ }),

/***/ "./src/state/hooks/panel-state.hook/use-panel-entity-id.hook.ts":
/*!**********************************************************************!*\
  !*** ./src/state/hooks/panel-state.hook/use-panel-entity-id.hook.ts ***!
  \**********************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useSetPanelEntityId = exports.usePanelEntityId = void 0;
const _state_1 = __webpack_require__(/*! ../.. */ "./src/state/index.ts");
const react_1 = __webpack_require__(/*! react */ "react");
const stateConfig = (source) => ({
    group: 'system',
    source,
    level: 'panel',
    name: "$entityId",
    channel: "state",
});
const usePanelEntityId = (panelType) => {
    const currentType = _state_1.usePanelType();
    const type = (panelType === null || panelType === void 0 ? void 0 : panelType.length) ? panelType : currentType;
    return _state_1.useReadSharedState(stateConfig(type));
};
exports.usePanelEntityId = usePanelEntityId;
const useSetPanelEntityId = (panelType) => {
    const currentType = _state_1.usePanelType();
    const type = (panelType === null || panelType === void 0 ? void 0 : panelType.length) ? panelType : currentType;
    const setEntityId = _state_1.useSetSharedState(stateConfig(type));
    return react_1.useCallback((id) => {
        setEntityId(id);
    }, []);
};
exports.useSetPanelEntityId = useSetPanelEntityId;


/***/ }),

/***/ "./src/state/hooks/panel-state.hook/use-panel-entity.hook.ts":
/*!*******************************************************************!*\
  !*** ./src/state/hooks/panel-state.hook/use-panel-entity.hook.ts ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useSetPanelEntity = exports.usePanelEntity = void 0;
const _state_1 = __webpack_require__(/*! ../.. */ "./src/state/index.ts");
const stateConfig = (source) => ({
    group: 'system',
    source,
    level: 'panel',
    name: "$entity",
    channel: "state",
});
const usePanelEntity = (panelType) => {
    const currentType = _state_1.usePanelType();
    const type = (panelType === null || panelType === void 0 ? void 0 : panelType.length) ? panelType : currentType;
    return _state_1.useReadSharedState(stateConfig(type));
};
exports.usePanelEntity = usePanelEntity;
const useSetPanelEntity = (panelType) => {
    const currentType = _state_1.usePanelType();
    const type = (panelType === null || panelType === void 0 ? void 0 : panelType.length) ? panelType : currentType;
    return _state_1.useSetSharedState(stateConfig(type));
};
exports.useSetPanelEntity = useSetPanelEntity;


/***/ }),

/***/ "./src/state/hooks/panel-state.hook/use-panel-id.hook.ts":
/*!***************************************************************!*\
  !*** ./src/state/hooks/panel-state.hook/use-panel-id.hook.ts ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useSetPanelId = exports.usePanelId = void 0;
const _state_1 = __webpack_require__(/*! ../.. */ "./src/state/index.ts");
const index_1 = __webpack_require__(/*! ../../../index */ "./src/index.ts");
const react_1 = __webpack_require__(/*! react */ "react");
const use_panel_entity_id_hook_1 = __webpack_require__(/*! ./use-panel-entity-id.hook */ "./src/state/hooks/panel-state.hook/use-panel-entity-id.hook.ts");
const stateConfig = (source) => ({
    group: 'system',
    source,
    level: 'panel',
    name: "$id",
    channel: "state",
});
const usePanelId = (panelType) => {
    const currentType = _state_1.usePanelType();
    const type = (panelType === null || panelType === void 0 ? void 0 : panelType.length) ? panelType : currentType;
    return _state_1.useReadSharedState(stateConfig(type));
};
exports.usePanelId = usePanelId;
const useSetPanelId = (panelType) => {
    const currentType = _state_1.usePanelType();
    const type = (panelType === null || panelType === void 0 ? void 0 : panelType.length) ? panelType : currentType;
    const setPanel = _state_1.useSetSharedState(stateConfig(type));
    const setEntityId = use_panel_entity_id_hook_1.useSetPanelEntityId(type);
    const setTab = index_1.useSetTabId(type);
    const clearStates = _state_1.useClearSharedStates();
    //TODO use recoil callback?
    return react_1.useCallback((id, entityId, tabId) => {
        setPanel(id);
        setEntityId(entityId);
        setTab(tabId);
        clearStates('shared', 'state', type, 'panel');
        clearStates('shared', 'uri', type, 'panel');
    }, []);
};
exports.useSetPanelId = useSetPanelId;


/***/ }),

/***/ "./src/state/hooks/panel-state.hook/use-panel-type.hook.ts":
/*!*****************************************************************!*\
  !*** ./src/state/hooks/panel-state.hook/use-panel-type.hook.ts ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.usePanelType = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const _state_1 = __webpack_require__(/*! ../.. */ "./src/state/index.ts");
const usePanelType = () => {
    const currentCtx = react_1.useContext(_state_1.CurrentPanelContext);
    return currentCtx
        ? currentCtx.type
        : 'main';
};
exports.usePanelType = usePanelType;


/***/ }),

/***/ "./src/state/hooks/panel-state.hook/use-panel-view-context.hook.ts":
/*!*************************************************************************!*\
  !*** ./src/state/hooks/panel-state.hook/use-panel-view-context.hook.ts ***!
  \*************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.usePanelViewContext = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const context_1 = __webpack_require__(/*! ../../context */ "./src/state/context/index.ts");
const usePanelViewContext = () => {
    return react_1.useContext(context_1.PanelViewContext);
};
exports.usePanelViewContext = usePanelViewContext;


/***/ }),

/***/ "./src/state/hooks/panel-state.hook/use-panel-view.hook.ts":
/*!*****************************************************************!*\
  !*** ./src/state/hooks/panel-state.hook/use-panel-view.hook.ts ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useSetPanelView = exports.usePanelView = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const _1 = __webpack_require__(/*! . */ "./src/state/hooks/panel-state.hook/index.ts");
const __1 = __webpack_require__(/*! .. */ "./src/state/hooks/index.ts");
const stateConfig = (source) => ({
    group: 'system',
    source,
    level: 'panel',
    name: "$view",
    channel: "state",
});
const usePanelView = (panelType) => {
    const currentType = _1.usePanelType();
    const type = (panelType === null || panelType === void 0 ? void 0 : panelType.length) ? panelType : currentType;
    return __1.useReadSharedState(stateConfig(type));
};
exports.usePanelView = usePanelView;
const useSetPanelView = (panelType) => {
    const currentType = _1.usePanelType();
    const type = (panelType === null || panelType === void 0 ? void 0 : panelType.length) ? panelType : currentType;
    const setView = __1.useSetSharedState(stateConfig(type));
    return react_1.useCallback((view) => {
        setView(view);
    }, []);
};
exports.useSetPanelView = useSetPanelView;


/***/ }),

/***/ "./src/state/hooks/panel-state.hook/use-reset-panel-id.hook.ts":
/*!*********************************************************************!*\
  !*** ./src/state/hooks/panel-state.hook/use-reset-panel-id.hook.ts ***!
  \*********************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useResetPanelId = void 0;
const __1 = __webpack_require__(/*! ../ */ "./src/state/hooks/index.ts");
const hooks_1 = __webpack_require__(/*! ../../../hooks */ "./src/hooks/index.ts");
const react_1 = __webpack_require__(/*! react */ "react");
const _1 = __webpack_require__(/*! . */ "./src/state/hooks/panel-state.hook/index.ts");
const use_initial_panel_id_hook_1 = __webpack_require__(/*! ./use-initial-panel-id.hook */ "./src/state/hooks/panel-state.hook/use-initial-panel-id.hook.ts");
const useResetPanelId = (panelType) => {
    const currentType = __1.usePanelType();
    const type = (panelType === null || panelType === void 0 ? void 0 : panelType.length) ? panelType : currentType;
    const viewConfig = __1.useViewConfig();
    const view = viewConfig[type];
    const { initialPanel: { visible } = {} } = view;
    const setPanelId = use_initial_panel_id_hook_1.useSetInitialPanelId(type);
    const panelViewRef = hooks_1.useHookRef(_1.usePanelView, type);
    const setPanelView = _1.useSetPanelView(type);
    const [, setChromeState] = __1.useChromeState();
    return react_1.useCallback(() => {
        if (viewConfig.mode == "chat" && type == "chat") {
            setChromeState("closed");
        }
        else {
            setPanelView(Object.assign(Object.assign({}, panelViewRef.current), { visible }));
            setPanelId();
        }
    }, []);
};
exports.useResetPanelId = useResetPanelId;


/***/ }),

/***/ "./src/state/hooks/panel-state.hook/use-tab-entity-id.hook.ts":
/*!********************************************************************!*\
  !*** ./src/state/hooks/panel-state.hook/use-tab-entity-id.hook.ts ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useSetTabEntityId = exports.useTabEntityId = void 0;
const _state_1 = __webpack_require__(/*! ../.. */ "./src/state/index.ts");
const react_1 = __webpack_require__(/*! react */ "react");
const stateConfig = (source) => ({
    group: 'system',
    source,
    level: 'tab',
    name: "$entityId",
    channel: "state",
});
const useTabEntityId = (panelType) => {
    const currentType = _state_1.usePanelType();
    const type = (panelType === null || panelType === void 0 ? void 0 : panelType.length) ? panelType : currentType;
    return _state_1.useReadSharedState(stateConfig(type));
};
exports.useTabEntityId = useTabEntityId;
const useSetTabEntityId = (panelType) => {
    const currentType = _state_1.usePanelType();
    const type = (panelType === null || panelType === void 0 ? void 0 : panelType.length) ? panelType : currentType;
    const setEntityId = _state_1.useSetSharedState(stateConfig(type));
    return react_1.useCallback((id) => {
        setEntityId(id);
    }, []);
};
exports.useSetTabEntityId = useSetTabEntityId;


/***/ }),

/***/ "./src/state/hooks/panel-state.hook/use-tab-entity.hook.ts":
/*!*****************************************************************!*\
  !*** ./src/state/hooks/panel-state.hook/use-tab-entity.hook.ts ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useSetTabEntity = exports.useTabEntity = void 0;
const _state_1 = __webpack_require__(/*! ../.. */ "./src/state/index.ts");
const stateConfig = (source) => ({
    group: 'system',
    source,
    level: 'tab',
    name: "$entity",
    channel: "state",
});
const useTabEntity = (panelType) => {
    const currentType = _state_1.usePanelType();
    const type = (panelType === null || panelType === void 0 ? void 0 : panelType.length) ? panelType : currentType;
    return _state_1.useReadSharedState(stateConfig(type));
};
exports.useTabEntity = useTabEntity;
const useSetTabEntity = (panelType) => {
    const currentType = _state_1.usePanelType();
    const type = (panelType === null || panelType === void 0 ? void 0 : panelType.length) ? panelType : currentType;
    return _state_1.useSetSharedState(stateConfig(type));
};
exports.useSetTabEntity = useSetTabEntity;


/***/ }),

/***/ "./src/state/hooks/panel-state.hook/use-tab-id.hook.ts":
/*!*************************************************************!*\
  !*** ./src/state/hooks/panel-state.hook/use-tab-id.hook.ts ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useSetTabId = exports.useTabId = void 0;
const _state_1 = __webpack_require__(/*! ../.. */ "./src/state/index.ts");
const react_1 = __webpack_require__(/*! react */ "react");
const stateConfig = (source) => ({
    group: 'system',
    source,
    level: 'tab',
    name: "$id",
    channel: "state",
});
const useTabId = (panelType) => {
    const currentType = _state_1.usePanelType();
    const type = (panelType === null || panelType === void 0 ? void 0 : panelType.length) ? panelType : currentType;
    return _state_1.useReadSharedState(stateConfig(type));
};
exports.useTabId = useTabId;
const useSetTabId = (panelType) => {
    const currentType = _state_1.usePanelType();
    const type = (panelType === null || panelType === void 0 ? void 0 : panelType.length) ? panelType : currentType;
    const setTab = _state_1.useSetSharedState(stateConfig(type));
    const setEntityId = _state_1.useSetTabEntityId(type);
    const clearStates = _state_1.useClearSharedStates();
    return react_1.useCallback((id, entityId) => {
        setTab(id);
        setEntityId(entityId);
        clearStates('shared', 'state', type, 'tab');
        clearStates('shared', 'uri', type, 'tab');
    }, []);
};
exports.useSetTabId = useSetTabId;


/***/ }),

/***/ "./src/state/hooks/shared-state.hook/index.ts":
/*!****************************************************!*\
  !*** ./src/state/hooks/shared-state.hook/index.ts ***!
  \****************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./is-default-value.helper */ "./src/state/hooks/shared-state.hook/is-default-value.helper.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./shared-state-group-ids.atom */ "./src/state/hooks/shared-state.hook/shared-state-group-ids.atom.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./shared-state-group-items.selector */ "./src/state/hooks/shared-state.hook/shared-state-group-items.selector.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./shared-state-groups.atom */ "./src/state/hooks/shared-state.hook/shared-state-groups.atom.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./shared-state-groups.selector */ "./src/state/hooks/shared-state.hook/shared-state-groups.selector.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./shared-state-id.helper */ "./src/state/hooks/shared-state.hook/shared-state-id.helper.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./shared-state-group-id.helper */ "./src/state/hooks/shared-state.hook/shared-state-group-id.helper.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./shared-state-ids.atom */ "./src/state/hooks/shared-state.hook/shared-state-ids.atom.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./shared-state-items.atom */ "./src/state/hooks/shared-state.hook/shared-state-items.atom.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./shared-state-partition.selector */ "./src/state/hooks/shared-state.hook/shared-state-partition.selector.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./shared-state.selector */ "./src/state/hooks/shared-state.hook/shared-state.selector.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./state.atom */ "./src/state/hooks/shared-state.hook/state.atom.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./use-clear-shared-states.hook */ "./src/state/hooks/shared-state.hook/use-clear-shared-states.hook.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./use-get-shared-states.hook */ "./src/state/hooks/shared-state.hook/use-get-shared-states.hook.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./use-read-shared-state.hook */ "./src/state/hooks/shared-state.hook/use-read-shared-state.hook.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./use-set-shared-state.hook */ "./src/state/hooks/shared-state.hook/use-set-shared-state.hook.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./use-shared-state-partition.hook */ "./src/state/hooks/shared-state.hook/use-shared-state-partition.hook.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./use-shared-state.hook */ "./src/state/hooks/shared-state.hook/use-shared-state.hook.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./use-shared-states.hook */ "./src/state/hooks/shared-state.hook/use-shared-states.hook.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./use-set-shared-states.hook */ "./src/state/hooks/shared-state.hook/use-set-shared-states.hook.ts"), exports);


/***/ }),

/***/ "./src/state/hooks/shared-state.hook/is-default-value.helper.ts":
/*!**********************************************************************!*\
  !*** ./src/state/hooks/shared-state.hook/is-default-value.helper.ts ***!
  \**********************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isDefaultValue = void 0;
const recoil_1 = __webpack_require__(/*! recoil */ "recoil");
const isDefaultValue = (candidate) => candidate instanceof recoil_1.DefaultValue
    ? true
    : false;
exports.isDefaultValue = isDefaultValue;


/***/ }),

/***/ "./src/state/hooks/shared-state.hook/shared-state-group-id.helper.ts":
/*!***************************************************************************!*\
  !*** ./src/state/hooks/shared-state.hook/shared-state-group-id.helper.ts ***!
  \***************************************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.sharedStateGroupIdPrefix = exports.splitSharedStateGroupId = exports.sharedStateGroupId = void 0;
const sharedStateGroupId = (type, level, id) => {
    return ['group', (type === null || type === void 0 ? void 0 : type.length) ? type : 'main', (level === null || level === void 0 ? void 0 : level.length) ? level : 'tab', id].join('/');
};
exports.sharedStateGroupId = sharedStateGroupId;
const splitSharedStateGroupId = (id) => {
    const [, type, level] = id.split('/');
    return {
        type,
        level,
    };
};
exports.splitSharedStateGroupId = splitSharedStateGroupId;
const sharedStateGroupIdPrefix = (type, level) => `group/${(type === null || type === void 0 ? void 0 : type.length) ? `${type}/` : ''}${(level === null || level === void 0 ? void 0 : level.length) ? `${level}/` : ''}`;
exports.sharedStateGroupIdPrefix = sharedStateGroupIdPrefix;


/***/ }),

/***/ "./src/state/hooks/shared-state.hook/shared-state-group-ids.atom.ts":
/*!**************************************************************************!*\
  !*** ./src/state/hooks/shared-state.hook/shared-state-group-ids.atom.ts ***!
  \**************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.sharedStateGroupIdsAtom = void 0;
const recoil_1 = __webpack_require__(/*! recoil */ "recoil");
exports.sharedStateGroupIdsAtom = recoil_1.atom({
    key: "shared-state-group-ids",
    default: []
});


/***/ }),

/***/ "./src/state/hooks/shared-state.hook/shared-state-group-items.selector.ts":
/*!********************************************************************************!*\
  !*** ./src/state/hooks/shared-state.hook/shared-state-group-items.selector.ts ***!
  \********************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.sharedStateGroupItemsSelector = void 0;
const recoil_1 = __webpack_require__(/*! recoil */ "recoil");
const shared_state_groups_atom_1 = __webpack_require__(/*! ./shared-state-groups.atom */ "./src/state/hooks/shared-state.hook/shared-state-groups.atom.ts");
const _state_1 = __webpack_require__(/*! ../.. */ "./src/state/index.ts");
const index_1 = __webpack_require__(/*! ../../../index */ "./src/index.ts");
exports.sharedStateGroupItemsSelector = recoil_1.selectorFamily({
    key: "shared-group-items",
    get: (id) => ({ get }) => {
        const group = get(shared_state_groups_atom_1.sharedStateGroupsAtom(id));
        return group === null || group === void 0 ? void 0 : group.reduce((all, ref) => {
            const { name } = ref;
            const { type } = index_1.splitSharedStateGroupId(id);
            const stateId = _state_1.sharedStateId(ref, type);
            const value = get(_state_1.sharedStateSelector(stateId));
            return Object.assign(Object.assign({}, all), { [name]: value });
        }, {});
    }
});


/***/ }),

/***/ "./src/state/hooks/shared-state.hook/shared-state-groups.atom.ts":
/*!***********************************************************************!*\
  !*** ./src/state/hooks/shared-state.hook/shared-state-groups.atom.ts ***!
  \***********************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.sharedStateGroupsAtom = void 0;
const recoil_1 = __webpack_require__(/*! recoil */ "recoil");
exports.sharedStateGroupsAtom = recoil_1.atomFamily({
    key: "shared-state-groups",
    default: []
});


/***/ }),

/***/ "./src/state/hooks/shared-state.hook/shared-state-groups.selector.ts":
/*!***************************************************************************!*\
  !*** ./src/state/hooks/shared-state.hook/shared-state-groups.selector.ts ***!
  \***************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.sharedStateGroupsSelector = void 0;
const recoil_1 = __webpack_require__(/*! recoil */ "recoil");
const shared_state_groups_atom_1 = __webpack_require__(/*! ./shared-state-groups.atom */ "./src/state/hooks/shared-state.hook/shared-state-groups.atom.ts");
const is_default_value_helper_1 = __webpack_require__(/*! ./is-default-value.helper */ "./src/state/hooks/shared-state.hook/is-default-value.helper.ts");
const shared_state_group_ids_atom_1 = __webpack_require__(/*! ./shared-state-group-ids.atom */ "./src/state/hooks/shared-state.hook/shared-state-group-ids.atom.ts");
exports.sharedStateGroupsSelector = recoil_1.selectorFamily({
    key: "shared-state",
    get: (id) => ({ get }) => get(shared_state_groups_atom_1.sharedStateGroupsAtom(id)),
    set: (id) => ({ set, reset }, value) => {
        if (is_default_value_helper_1.isDefaultValue(value)) {
            reset(shared_state_groups_atom_1.sharedStateGroupsAtom(id));
            set(shared_state_group_ids_atom_1.sharedStateGroupIdsAtom, (current) => current.filter(cid => id !== cid));
        }
        else {
            set(shared_state_groups_atom_1.sharedStateGroupsAtom(id), value);
            set(shared_state_group_ids_atom_1.sharedStateGroupIdsAtom, (current) => [
                ...current.filter(cid => id !== cid),
                id
            ]);
        }
    }
});


/***/ }),

/***/ "./src/state/hooks/shared-state.hook/shared-state-id.helper.ts":
/*!*********************************************************************!*\
  !*** ./src/state/hooks/shared-state.hook/shared-state-id.helper.ts ***!
  \*********************************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.sharedStateIdPrefix = exports.splitSharedStateId = exports.sharedStateId = void 0;
const sharedStateId = (stateRef, currentSource) => {
    const { name, group, channel, level, alias, source: sourceRef } = stateRef || {};
    const source = (sourceRef === null || sourceRef === void 0 ? void 0 : sourceRef.length) ? sourceRef
        : currentSource;
    return [
        'item',
        (group === null || group === void 0 ? void 0 : group.length) ? group
            : 'shared',
        (channel === null || channel === void 0 ? void 0 : channel.length) ? channel
            : 'state',
        source,
        source == 'app'
            ? 'all'
            : (level === null || level === void 0 ? void 0 : level.length) ? level
                : 'tab',
        (alias === null || alias === void 0 ? void 0 : alias.length) ? alias
            : name
    ].join('/');
};
exports.sharedStateId = sharedStateId;
const splitSharedStateId = (id) => {
    const [, group, channel, source, level, name] = id.split('/');
    return {
        group,
        channel,
        source,
        level,
        name
    };
};
exports.splitSharedStateId = splitSharedStateId;
const sharedStateIdPrefix = (group, channel, source, level) => [
    'item',
    group,
    channel,
    source,
    level
].filter(s => (s === null || s === void 0 ? void 0 : s.length) > 0)
    .join('/');
exports.sharedStateIdPrefix = sharedStateIdPrefix;


/***/ }),

/***/ "./src/state/hooks/shared-state.hook/shared-state-ids.atom.ts":
/*!********************************************************************!*\
  !*** ./src/state/hooks/shared-state.hook/shared-state-ids.atom.ts ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.sharedStateIdsAtom = void 0;
const recoil_1 = __webpack_require__(/*! recoil */ "recoil");
exports.sharedStateIdsAtom = recoil_1.atom({
    key: "shared-state-ids",
    default: []
});


/***/ }),

/***/ "./src/state/hooks/shared-state.hook/shared-state-items.atom.ts":
/*!**********************************************************************!*\
  !*** ./src/state/hooks/shared-state.hook/shared-state-items.atom.ts ***!
  \**********************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.sharedStateItemsAtom = void 0;
const recoil_1 = __webpack_require__(/*! recoil */ "recoil");
exports.sharedStateItemsAtom = recoil_1.atomFamily({
    key: "shared-state-items",
    default: null
});


/***/ }),

/***/ "./src/state/hooks/shared-state.hook/shared-state-partition.selector.ts":
/*!******************************************************************************!*\
  !*** ./src/state/hooks/shared-state.hook/shared-state-partition.selector.ts ***!
  \******************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.sharedStatePartitionSelector = void 0;
const utilities_1 = __webpack_require__(/*! @fluentui/utilities */ "@fluentui/utilities");
const recoil_1 = __webpack_require__(/*! recoil */ "recoil");
const shared_state_items_atom_1 = __webpack_require__(/*! ./shared-state-items.atom */ "./src/state/hooks/shared-state.hook/shared-state-items.atom.ts");
const _state_1 = __webpack_require__(/*! ../.. */ "./src/state/index.ts");
const index_1 = __webpack_require__(/*! ../../../index */ "./src/index.ts");
const addValue = (id, value, combined) => {
    const { group, channel, source, level, name } = index_1.splitSharedStateId(id);
    const groupPart = combined[group] || (combined[group] = {});
    const channelPart = groupPart[channel] || (groupPart[channel] = {});
    const sourcePart = channelPart[source] || (channelPart[source] = {});
    const levelPart = sourcePart[level] || (sourcePart[level] = {});
    levelPart[name] = value;
};
exports.sharedStatePartitionSelector = utilities_1.memoizeFunction((id, prefix) => recoil_1.selector({
    key: id,
    get: ({ get }) => {
        const ids = get(_state_1.sharedStateIdsAtom);
        return ids
            .filter(id => id.startsWith(prefix))
            .reduce((combined, id) => {
            const value = get(shared_state_items_atom_1.sharedStateItemsAtom(id));
            addValue(id, value, combined);
            return combined;
        }, {});
    }
}));


/***/ }),

/***/ "./src/state/hooks/shared-state.hook/shared-state.selector.ts":
/*!********************************************************************!*\
  !*** ./src/state/hooks/shared-state.hook/shared-state.selector.ts ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.sharedStateSelector = void 0;
const recoil_1 = __webpack_require__(/*! recoil */ "recoil");
const is_default_value_helper_1 = __webpack_require__(/*! ./is-default-value.helper */ "./src/state/hooks/shared-state.hook/is-default-value.helper.ts");
const shared_state_ids_atom_1 = __webpack_require__(/*! ./shared-state-ids.atom */ "./src/state/hooks/shared-state.hook/shared-state-ids.atom.ts");
const shared_state_items_atom_1 = __webpack_require__(/*! ./shared-state-items.atom */ "./src/state/hooks/shared-state.hook/shared-state-items.atom.ts");
exports.sharedStateSelector = recoil_1.selectorFamily({
    key: "shared-state",
    get: (id) => ({ get }) => get(shared_state_items_atom_1.sharedStateItemsAtom(id)),
    set: (id) => ({ set, reset }, value) => {
        if (is_default_value_helper_1.isDefaultValue(value)) {
            reset(shared_state_items_atom_1.sharedStateItemsAtom(id));
            set(shared_state_ids_atom_1.sharedStateIdsAtom, (current) => current.filter(cid => id !== cid));
        }
        else {
            set(shared_state_items_atom_1.sharedStateItemsAtom(id), value);
            set(shared_state_ids_atom_1.sharedStateIdsAtom, (current) => [
                ...current.filter(cid => id !== cid),
                id
            ]);
        }
    }
});


/***/ }),

/***/ "./src/state/hooks/shared-state.hook/state.atom.ts":
/*!*********************************************************!*\
  !*** ./src/state/hooks/shared-state.hook/state.atom.ts ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.stateAtom = void 0;
const utilities_1 = __webpack_require__(/*! @fluentui/utilities */ "@fluentui/utilities");
const recoil_1 = __webpack_require__(/*! recoil */ "recoil");
exports.stateAtom = utilities_1.memoizeFunction((id, defaultValue = null) => recoil_1.atom({
    key: id,
    default: defaultValue
}));


/***/ }),

/***/ "./src/state/hooks/shared-state.hook/use-clear-shared-states.hook.ts":
/*!***************************************************************************!*\
  !*** ./src/state/hooks/shared-state.hook/use-clear-shared-states.hook.ts ***!
  \***************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useClearSharedStates = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const _state_1 = __webpack_require__(/*! ../.. */ "./src/state/index.ts");
const recoil_1 = __webpack_require__(/*! recoil */ "recoil");
const shared_state_ids_atom_1 = __webpack_require__(/*! ./shared-state-ids.atom */ "./src/state/hooks/shared-state.hook/shared-state-ids.atom.ts");
const shared_state_selector_1 = __webpack_require__(/*! ./shared-state.selector */ "./src/state/hooks/shared-state.hook/shared-state.selector.ts");
const useClearSharedStates = () => {
    return recoil_1.useRecoilCallback(({ snapshot, reset }) => (group, channel, type, level) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        const prefix = _state_1.sharedStateIdPrefix(group, channel, type, level);
        const ids = yield snapshot.getPromise(shared_state_ids_atom_1.sharedStateIdsAtom);
        ids
            .filter(id => id.startsWith(prefix))
            .forEach(id => reset(shared_state_selector_1.sharedStateSelector(id)));
    }), []);
};
exports.useClearSharedStates = useClearSharedStates;


/***/ }),

/***/ "./src/state/hooks/shared-state.hook/use-get-shared-states.hook.ts":
/*!*************************************************************************!*\
  !*** ./src/state/hooks/shared-state.hook/use-get-shared-states.hook.ts ***!
  \*************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useGetSharedStates = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const _state_1 = __webpack_require__(/*! ../.. */ "./src/state/index.ts");
const recoil_1 = __webpack_require__(/*! recoil */ "recoil");
const shared_state_items_atom_1 = __webpack_require__(/*! ./shared-state-items.atom */ "./src/state/hooks/shared-state.hook/shared-state-items.atom.ts");
const useGetSharedStates = () => {
    const type = _state_1.usePanelType();
    return recoil_1.useRecoilCallback(({ snapshot }) => (refs) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        if (!(refs === null || refs === void 0 ? void 0 : refs.length))
            return null;
        yield Promise.all(refs.map((ref) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
            const atom = shared_state_items_atom_1.sharedStateItemsAtom(_state_1.sharedStateId(ref, type));
            return snapshot.getPromise(atom);
        })));
    }), [type]);
};
exports.useGetSharedStates = useGetSharedStates;


/***/ }),

/***/ "./src/state/hooks/shared-state.hook/use-read-shared-state.hook.ts":
/*!*************************************************************************!*\
  !*** ./src/state/hooks/shared-state.hook/use-read-shared-state.hook.ts ***!
  \*************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useReadSharedState = void 0;
const recoil_1 = __webpack_require__(/*! recoil */ "recoil");
const shared_state_items_atom_1 = __webpack_require__(/*! ./shared-state-items.atom */ "./src/state/hooks/shared-state.hook/shared-state-items.atom.ts");
const use_shared_state_id_hook_1 = __webpack_require__(/*! ./use-shared-state-id.hook */ "./src/state/hooks/shared-state.hook/use-shared-state-id.hook.ts");
const useReadSharedState = (stateRef) => {
    const id = use_shared_state_id_hook_1.useSharedStateId(stateRef);
    return recoil_1.useRecoilValue(shared_state_items_atom_1.sharedStateItemsAtom(id));
};
exports.useReadSharedState = useReadSharedState;


/***/ }),

/***/ "./src/state/hooks/shared-state.hook/use-set-shared-state.hook.ts":
/*!************************************************************************!*\
  !*** ./src/state/hooks/shared-state.hook/use-set-shared-state.hook.ts ***!
  \************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useSetSharedState = void 0;
const _state_1 = __webpack_require__(/*! ../.. */ "./src/state/index.ts");
const recoil_1 = __webpack_require__(/*! recoil */ "recoil");
const use_shared_state_id_hook_1 = __webpack_require__(/*! ./use-shared-state-id.hook */ "./src/state/hooks/shared-state.hook/use-shared-state-id.hook.ts");
const emptySetter = () => { };
const useSetSharedState = (stateRef) => {
    const id = use_shared_state_id_hook_1.useSharedStateId(stateRef);
    const setState = recoil_1.useSetRecoilState(_state_1.sharedStateSelector(id));
    if (!stateRef)
        return emptySetter;
    return setState;
};
exports.useSetSharedState = useSetSharedState;


/***/ }),

/***/ "./src/state/hooks/shared-state.hook/use-set-shared-states.hook.ts":
/*!*************************************************************************!*\
  !*** ./src/state/hooks/shared-state.hook/use-set-shared-states.hook.ts ***!
  \*************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useSetSharedStates = void 0;
const _state_1 = __webpack_require__(/*! ../.. */ "./src/state/index.ts");
const recoil_1 = __webpack_require__(/*! recoil */ "recoil");
const panel_state_hook_1 = __webpack_require__(/*! ../panel-state.hook */ "./src/state/hooks/panel-state.hook/index.ts");
const useSetSharedStates = () => {
    const type = panel_state_hook_1.usePanelType();
    return recoil_1.useRecoilCallback(({ set }) => (states) => {
        states === null || states === void 0 ? void 0 : states.forEach((state) => {
            const atom = _state_1.sharedStateItemsAtom(_state_1.sharedStateId(state, type));
            set(atom, state.value);
        });
    }, []);
};
exports.useSetSharedStates = useSetSharedStates;


/***/ }),

/***/ "./src/state/hooks/shared-state.hook/use-shared-state-id.hook.ts":
/*!***********************************************************************!*\
  !*** ./src/state/hooks/shared-state.hook/use-shared-state-id.hook.ts ***!
  \***********************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useSharedStateId = void 0;
const _state_1 = __webpack_require__(/*! ../.. */ "./src/state/index.ts");
const shared_state_id_helper_1 = __webpack_require__(/*! ./shared-state-id.helper */ "./src/state/hooks/shared-state.hook/shared-state-id.helper.ts");
const useSharedStateId = (stateRef) => {
    const currentType = _state_1.usePanelType();
    return shared_state_id_helper_1.sharedStateId(stateRef, currentType);
};
exports.useSharedStateId = useSharedStateId;


/***/ }),

/***/ "./src/state/hooks/shared-state.hook/use-shared-state-partition.hook.ts":
/*!******************************************************************************!*\
  !*** ./src/state/hooks/shared-state.hook/use-shared-state-partition.hook.ts ***!
  \******************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useSharedStatePartition = void 0;
const recoil_1 = __webpack_require__(/*! recoil */ "recoil");
const _state_1 = __webpack_require__(/*! ../.. */ "./src/state/index.ts");
const shared_state_partition_selector_1 = __webpack_require__(/*! ./shared-state-partition.selector */ "./src/state/hooks/shared-state.hook/shared-state-partition.selector.ts");
const useSharedStatePartition = (group, channel, source, level) => {
    const prefix = _state_1.sharedStateIdPrefix(group, channel, source, level);
    const id = `state-partition-${prefix}`;
    return recoil_1.useRecoilValue(shared_state_partition_selector_1.sharedStatePartitionSelector(id, prefix));
};
exports.useSharedStatePartition = useSharedStatePartition;


/***/ }),

/***/ "./src/state/hooks/shared-state.hook/use-shared-state.hook.ts":
/*!********************************************************************!*\
  !*** ./src/state/hooks/shared-state.hook/use-shared-state.hook.ts ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useSharedState = void 0;
const index_1 = __webpack_require__(/*! ../../../index */ "./src/index.ts");
const recoil_1 = __webpack_require__(/*! recoil */ "recoil");
const use_shared_state_id_hook_1 = __webpack_require__(/*! ./use-shared-state-id.hook */ "./src/state/hooks/shared-state.hook/use-shared-state-id.hook.ts");
const emptyState = [null, (val) => { }];
const useSharedState = (stateRef) => {
    const id = use_shared_state_id_hook_1.useSharedStateId(stateRef);
    const [state, setState] = recoil_1.useRecoilState(index_1.sharedStateSelector(id));
    return !stateRef
        ? emptyState
        : [state, setState];
};
exports.useSharedState = useSharedState;


/***/ }),

/***/ "./src/state/hooks/shared-state.hook/use-shared-states.hook.ts":
/*!*********************************************************************!*\
  !*** ./src/state/hooks/shared-state.hook/use-shared-states.hook.ts ***!
  \*********************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useSharedStates = void 0;
const recoil_1 = __webpack_require__(/*! recoil */ "recoil");
const _state_1 = __webpack_require__(/*! ../.. */ "./src/state/index.ts");
const index_1 = __webpack_require__(/*! ../../../index */ "./src/index.ts");
const react_1 = __webpack_require__(/*! react */ "react");
const useSharedStates = (id, panelType, level) => {
    const currentType = _state_1.usePanelType();
    const type = (panelType === null || panelType === void 0 ? void 0 : panelType.length) ? panelType
        : currentType;
    const groupId = index_1.sharedStateGroupId(type, level, id);
    const setState = recoil_1.useSetRecoilState(_state_1.sharedStateGroupsSelector(groupId));
    const items = recoil_1.useRecoilValue(_state_1.sharedStateGroupItemsSelector(groupId));
    const setter = react_1.useCallback((value) => {
        setState(value);
    }, [setState]);
    return [items, setter];
};
exports.useSharedStates = useSharedStates;


/***/ }),

/***/ "./src/state/hooks/use-action-middleware.hook.ts":
/*!*******************************************************!*\
  !*** ./src/state/hooks/use-action-middleware.hook.ts ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useActionMiddleware = void 0;
const use_middleware_hook_1 = __webpack_require__(/*! ./use-middleware.hook */ "./src/state/hooks/use-middleware.hook.ts");
const _hooks_1 = __webpack_require__(/*! ../../hooks */ "./src/hooks/index.ts");
const use_focus_hook_1 = __webpack_require__(/*! ./use-focus.hook */ "./src/state/hooks/use-focus.hook.ts");
const react_1 = __webpack_require__(/*! react */ "react");
const _state_1 = __webpack_require__(/*! ./.. */ "./src/state/index.ts");
const useActionMiddleware = (props) => {
    const handleCommand = _hooks_1.useHandleCommand();
    const focus = use_focus_hook_1.useFocus();
    const localizeConfig = _state_1.useLocalizeConfig();
    const middleware = _hooks_1.useHookRef(use_middleware_hook_1.useMiddleware);
    return react_1.useMemo(() => middleware.current.action(Object.assign(Object.assign({}, props), { handleCommand,
        focus,
        localizeConfig })), [props, localizeConfig]);
};
exports.useActionMiddleware = useActionMiddleware;


/***/ }),

/***/ "./src/state/hooks/use-activity-middleware.hook.ts":
/*!*********************************************************!*\
  !*** ./src/state/hooks/use-activity-middleware.hook.ts ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useActivityMiddleware = void 0;
const use_middleware_hook_1 = __webpack_require__(/*! ./use-middleware.hook */ "./src/state/hooks/use-middleware.hook.ts");
const _hooks_1 = __webpack_require__(/*! ../../hooks */ "./src/hooks/index.ts");
const use_focus_hook_1 = __webpack_require__(/*! ./use-focus.hook */ "./src/state/hooks/use-focus.hook.ts");
const react_1 = __webpack_require__(/*! react */ "react");
const _state_1 = __webpack_require__(/*! ./.. */ "./src/state/index.ts");
const useActivityMiddleware = (props) => {
    const handleCommand = _hooks_1.useHandleCommand();
    const focus = use_focus_hook_1.useFocus();
    const localizeConfig = _state_1.useLocalizeConfig();
    const middleware = _hooks_1.useHookRef(use_middleware_hook_1.useMiddleware);
    return react_1.useMemo(() => middleware.current.activity(Object.assign(Object.assign({}, props), { localizeConfig,
        handleCommand,
        focus })), [props, localizeConfig]);
};
exports.useActivityMiddleware = useActivityMiddleware;


/***/ }),

/***/ "./src/state/hooks/use-app-actions.hook.ts":
/*!*************************************************!*\
  !*** ./src/state/hooks/use-app-actions.hook.ts ***!
  \*************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useAppActions = void 0;
const context_1 = __webpack_require__(/*! ../context */ "./src/state/context/index.ts");
const react_1 = __webpack_require__(/*! react */ "react");
const useAppActions = () => {
    return react_1.useContext(context_1.AppContext).actions;
};
exports.useAppActions = useAppActions;


/***/ }),

/***/ "./src/state/hooks/use-app-location.hook.ts":
/*!**************************************************!*\
  !*** ./src/state/hooks/use-app-location.hook.ts ***!
  \**************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useAppLocation = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const state_1 = __webpack_require__(/*! ./.. */ "./src/state/index.ts");
const useAppLocation = () => {
    return react_1.useContext(state_1.LocationContext);
};
exports.useAppLocation = useAppLocation;


/***/ }),

/***/ "./src/state/hooks/use-attachment-middleware.hook.ts":
/*!***********************************************************!*\
  !*** ./src/state/hooks/use-attachment-middleware.hook.ts ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useAttachmentMiddleware = void 0;
const _hooks_1 = __webpack_require__(/*! ../../hooks */ "./src/hooks/index.ts");
const _state_1 = __webpack_require__(/*! ./.. */ "./src/state/index.ts");
const react_1 = __webpack_require__(/*! react */ "react");
const use_focus_hook_1 = __webpack_require__(/*! ./use-focus.hook */ "./src/state/hooks/use-focus.hook.ts");
const use_middleware_hook_1 = __webpack_require__(/*! ./use-middleware.hook */ "./src/state/hooks/use-middleware.hook.ts");
const useAttachmentMiddleware = (props) => {
    const handleCommand = _hooks_1.useHandleCommand();
    const focus = use_focus_hook_1.useFocus();
    const localizeConfig = _state_1.useLocalizeConfig();
    const middleware = _hooks_1.useHookRef(use_middleware_hook_1.useMiddleware);
    return react_1.useMemo(() => middleware.current.attachment(Object.assign(Object.assign({}, props), { localizeConfig,
        handleCommand,
        focus })), [props, localizeConfig]);
};
exports.useAttachmentMiddleware = useAttachmentMiddleware;


/***/ }),

/***/ "./src/state/hooks/use-auth.hook.ts":
/*!******************************************!*\
  !*** ./src/state/hooks/use-auth.hook.ts ***!
  \******************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useAuth = void 0;
const _helpers_1 = __webpack_require__(/*! ../../helpers */ "./src/helpers/index.ts");
const react_1 = __webpack_require__(/*! react */ "react");
const hooks_1 = __webpack_require__(/*! ../../hooks */ "./src/hooks/index.ts");
const use_providers_hook_1 = __webpack_require__(/*! ./use-providers.hook */ "./src/state/hooks/use-providers.hook.ts");
const useAuth = () => {
    const providerRef = hooks_1.useHookRef(use_providers_hook_1.useProviders);
    const contextRef = react_1.useRef();
    const getServiceUser = react_1.useCallback((name, authContext) => {
        const provider = providerRef.current.auth.find(({ serviceUsers }) => ~serviceUsers.indexOf(name));
        if (!provider)
            _helpers_1.Logger.error(`Failed to find service user ${name}`, true);
        return provider.getServiceUser(name, authContext || contextRef.current);
    }, []);
    return react_1.useMemo(() => ({ getServiceUser }), []);
};
exports.useAuth = useAuth;


/***/ }),

/***/ "./src/state/hooks/use-bot-ready.hook.ts":
/*!***********************************************!*\
  !*** ./src/state/hooks/use-bot-ready.hook.ts ***!
  \***********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useBotReady = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const context_1 = __webpack_require__(/*! ../context */ "./src/state/context/index.ts");
const useBotReady = () => {
    var _a;
    return (_a = react_1.useContext(context_1.APIContext)) === null || _a === void 0 ? void 0 : _a.botReady;
};
exports.useBotReady = useBotReady;


/***/ }),

/***/ "./src/state/hooks/use-breakpoint.hook.ts":
/*!************************************************!*\
  !*** ./src/state/hooks/use-breakpoint.hook.ts ***!
  \************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useBreakpoint = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const context_1 = __webpack_require__(/*! ../context */ "./src/state/context/index.ts");
const useBreakpoint = () => {
    return react_1.useContext(context_1.BreakpointContext);
};
exports.useBreakpoint = useBreakpoint;


/***/ }),

/***/ "./src/state/hooks/use-chat-config.hook.ts":
/*!*************************************************!*\
  !*** ./src/state/hooks/use-chat-config.hook.ts ***!
  \*************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useChatConfig = void 0;
const context_1 = __webpack_require__(/*! ../context */ "./src/state/context/index.ts");
const react_1 = __webpack_require__(/*! react */ "react");
const useChatConfig = () => {
    return react_1.useContext(context_1.ChatBotContext).webChat;
};
exports.useChatConfig = useChatConfig;


/***/ }),

/***/ "./src/state/hooks/use-chat-scope.hook.ts":
/*!************************************************!*\
  !*** ./src/state/hooks/use-chat-scope.hook.ts ***!
  \************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useChatScope = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const context_1 = __webpack_require__(/*! ../context */ "./src/state/context/index.ts");
const useChatScope = () => {
    const ctx = react_1.useContext(context_1.ChatBotContext);
    return ctx.scope;
};
exports.useChatScope = useChatScope;


/***/ }),

/***/ "./src/state/hooks/use-chat-scopes.hook.ts":
/*!*************************************************!*\
  !*** ./src/state/hooks/use-chat-scopes.hook.ts ***!
  \*************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useChatScopes = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const context_1 = __webpack_require__(/*! ../context */ "./src/state/context/index.ts");
const useChatScopes = () => {
    const ctx = react_1.useContext(context_1.ChatBotContext);
    return ctx.scopes;
};
exports.useChatScopes = useChatScopes;


/***/ }),

/***/ "./src/state/hooks/use-chrome-state.hook.ts":
/*!**************************************************!*\
  !*** ./src/state/hooks/use-chrome-state.hook.ts ***!
  \**************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useChromeState = void 0;
const context_1 = __webpack_require__(/*! ../context */ "./src/state/context/index.ts");
const react_1 = __webpack_require__(/*! react */ "react");
const useChromeState = () => {
    const { chromeState, setChromeState } = react_1.useContext(context_1.AppContext);
    return react_1.useMemo(() => [chromeState, setChromeState], [chromeState, setChromeState]);
};
exports.useChromeState = useChromeState;


/***/ }),

/***/ "./src/state/hooks/use-content-providers.hook.ts":
/*!*******************************************************!*\
  !*** ./src/state/hooks/use-content-providers.hook.ts ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useContentProviders = void 0;
const use_providers_hook_1 = __webpack_require__(/*! ./use-providers.hook */ "./src/state/hooks/use-providers.hook.ts");
const useContentProviders = () => {
    return use_providers_hook_1.useProviders().content;
};
exports.useContentProviders = useContentProviders;


/***/ }),

/***/ "./src/state/hooks/use-directline.hook.ts":
/*!************************************************!*\
  !*** ./src/state/hooks/use-directline.hook.ts ***!
  \************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useDirectline = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const context_1 = __webpack_require__(/*! ../context */ "./src/state/context/index.ts");
const useDirectline = () => {
    return react_1.useContext(context_1.ChatBotContext).directlineContext;
};
exports.useDirectline = useDirectline;


/***/ }),

/***/ "./src/state/hooks/use-dismiss-notification.hook.ts":
/*!**********************************************************!*\
  !*** ./src/state/hooks/use-dismiss-notification.hook.ts ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useDismissNotification = void 0;
const context_1 = __webpack_require__(/*! ../context */ "./src/state/context/index.ts");
const react_1 = __webpack_require__(/*! react */ "react");
const useDismissNotification = () => {
    return react_1.useContext(context_1.NotificationContext).dismiss;
};
exports.useDismissNotification = useDismissNotification;


/***/ }),

/***/ "./src/state/hooks/use-dismiss-notifications.hook.ts":
/*!***********************************************************!*\
  !*** ./src/state/hooks/use-dismiss-notifications.hook.ts ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useDismissNotifications = void 0;
const context_1 = __webpack_require__(/*! ../context */ "./src/state/context/index.ts");
const react_1 = __webpack_require__(/*! react */ "react");
const useDismissNotifications = () => {
    return react_1.useContext(context_1.NotificationContext).dismissAll;
};
exports.useDismissNotifications = useDismissNotifications;


/***/ }),

/***/ "./src/state/hooks/use-fetch-middleware.hook.ts":
/*!******************************************************!*\
  !*** ./src/state/hooks/use-fetch-middleware.hook.ts ***!
  \******************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useFetchMiddleware = void 0;
const use_middleware_hook_1 = __webpack_require__(/*! ./use-middleware.hook */ "./src/state/hooks/use-middleware.hook.ts");
const useFetchMiddleware = () => {
    return use_middleware_hook_1.useMiddleware().fetch;
};
exports.useFetchMiddleware = useFetchMiddleware;


/***/ }),

/***/ "./src/state/hooks/use-focus-last-action.hook.ts":
/*!*******************************************************!*\
  !*** ./src/state/hooks/use-focus-last-action.hook.ts ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useFocusLastAction = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const context_1 = __webpack_require__(/*! ../context */ "./src/state/context/index.ts");
const useFocusLastAction = () => {
    return react_1.useContext(context_1.AppContext).focusLastAction;
};
exports.useFocusLastAction = useFocusLastAction;


/***/ }),

/***/ "./src/state/hooks/use-focus.hook.ts":
/*!*******************************************!*\
  !*** ./src/state/hooks/use-focus.hook.ts ***!
  \*******************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useFocus = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const context_1 = __webpack_require__(/*! ../context */ "./src/state/context/index.ts");
const useFocus = () => {
    return react_1.useContext(context_1.AppContext).focus;
};
exports.useFocus = useFocus;


/***/ }),

/***/ "./src/state/hooks/use-global-chat-scopes.hook.ts":
/*!********************************************************!*\
  !*** ./src/state/hooks/use-global-chat-scopes.hook.ts ***!
  \********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useGlobalChatScopes = void 0;
const context_1 = __webpack_require__(/*! ../context */ "./src/state/context/index.ts");
const react_1 = __webpack_require__(/*! react */ "react");
const useGlobalChatScopes = () => {
    return react_1.useContext(context_1.AppContext).chatScopes;
};
exports.useGlobalChatScopes = useGlobalChatScopes;


/***/ }),

/***/ "./src/state/hooks/use-grid-styles.hook.ts":
/*!*************************************************!*\
  !*** ./src/state/hooks/use-grid-styles.hook.ts ***!
  \*************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useGridStyles = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const context_1 = __webpack_require__(/*! ../context */ "./src/state/context/index.ts");
const useGridStyles = (root) => {
    const bp = react_1.useContext(context_1.BreakpointContext);
    return root ? bp.root.styles : bp.current.styles;
};
exports.useGridStyles = useGridStyles;


/***/ }),

/***/ "./src/state/hooks/use-host-config.hook.ts":
/*!*************************************************!*\
  !*** ./src/state/hooks/use-host-config.hook.ts ***!
  \*************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useHostConfig = void 0;
const context_1 = __webpack_require__(/*! ../context */ "./src/state/context/index.ts");
const react_1 = __webpack_require__(/*! react */ "react");
const useHostConfig = () => {
    return react_1.useContext(context_1.ChatBotContext).hostConfig;
};
exports.useHostConfig = useHostConfig;


/***/ }),

/***/ "./src/state/hooks/use-keywords.hook.ts":
/*!**********************************************!*\
  !*** ./src/state/hooks/use-keywords.hook.ts ***!
  \**********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useKeywords = void 0;
const _1 = __webpack_require__(/*! . */ "./src/state/hooks/index.ts");
//TODO move to managed central state
const stateConfig = { name: "k", channel: 'uri' };
const useKeywords = () => _1.useSharedState(stateConfig);
exports.useKeywords = useKeywords;


/***/ }),

/***/ "./src/state/hooks/use-known-uris.hook.ts":
/*!************************************************!*\
  !*** ./src/state/hooks/use-known-uris.hook.ts ***!
  \************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useKnownUris = void 0;
const context_1 = __webpack_require__(/*! ../context */ "./src/state/context/index.ts");
const react_1 = __webpack_require__(/*! react */ "react");
const useKnownUris = () => {
    return react_1.useContext(context_1.AppContext).knownUris;
};
exports.useKnownUris = useKnownUris;


/***/ }),

/***/ "./src/state/hooks/use-locale.hook.ts":
/*!********************************************!*\
  !*** ./src/state/hooks/use-locale.hook.ts ***!
  \********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useLocale = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const context_1 = __webpack_require__(/*! ../context */ "./src/state/context/index.ts");
const useLocale = () => {
    return react_1.useContext(context_1.LocalizeContext).locale;
};
exports.useLocale = useLocale;


/***/ }),

/***/ "./src/state/hooks/use-localise.hook.ts":
/*!**********************************************!*\
  !*** ./src/state/hooks/use-localise.hook.ts ***!
  \**********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useLocalize = void 0;
const use_localize_config_hook_1 = __webpack_require__(/*! ./use-localize-config.hook */ "./src/state/hooks/use-localize-config.hook.ts");
const useLocalize = (key) => {
    return use_localize_config_hook_1.useLocalizeConfig()[key];
};
exports.useLocalize = useLocalize;


/***/ }),

/***/ "./src/state/hooks/use-localize-config.hook.ts":
/*!*****************************************************!*\
  !*** ./src/state/hooks/use-localize-config.hook.ts ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useLocalizeConfig = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const context_1 = __webpack_require__(/*! ../context */ "./src/state/context/index.ts");
const useLocalizeConfig = () => {
    return react_1.useContext(context_1.LocalizeContext).config;
};
exports.useLocalizeConfig = useLocalizeConfig;


/***/ }),

/***/ "./src/state/hooks/use-middleware.hook.ts":
/*!************************************************!*\
  !*** ./src/state/hooks/use-middleware.hook.ts ***!
  \************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useMiddleware = void 0;
const context_1 = __webpack_require__(/*! ../context */ "./src/state/context/index.ts");
const react_1 = __webpack_require__(/*! react */ "react");
const useMiddleware = () => {
    return react_1.useContext(context_1.MiddlewareContext);
};
exports.useMiddleware = useMiddleware;


/***/ }),

/***/ "./src/state/hooks/use-next-notification.hook.ts":
/*!*******************************************************!*\
  !*** ./src/state/hooks/use-next-notification.hook.ts ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useNextNotification = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const use_notifications_hook_1 = __webpack_require__(/*! ./use-notifications.hook */ "./src/state/hooks/use-notifications.hook.ts");
const useNextNotification = () => {
    const notifications = use_notifications_hook_1.useNotifications();
    return react_1.useMemo(() => {
        return (notifications === null || notifications === void 0 ? void 0 : notifications.length) ? notifications[0]
            : null;
    }, [notifications]);
};
exports.useNextNotification = useNextNotification;


/***/ }),

/***/ "./src/state/hooks/use-notifications.hook.ts":
/*!***************************************************!*\
  !*** ./src/state/hooks/use-notifications.hook.ts ***!
  \***************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useNotifications = void 0;
const context_1 = __webpack_require__(/*! ../context */ "./src/state/context/index.ts");
const react_1 = __webpack_require__(/*! react */ "react");
const useNotifications = () => {
    return react_1.useContext(context_1.NotificationContext).notifications;
};
exports.useNotifications = useNotifications;


/***/ }),

/***/ "./src/state/hooks/use-page-state.hook.ts":
/*!************************************************!*\
  !*** ./src/state/hooks/use-page-state.hook.ts ***!
  \************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.usePageState = void 0;
const context_1 = __webpack_require__(/*! ../context */ "./src/state/context/index.ts");
const react_1 = __webpack_require__(/*! react */ "react");
const usePageState = () => {
    const { pageState, setPageState } = react_1.useContext(context_1.PageContext);
    return react_1.useMemo(() => [pageState, setPageState], [pageState, setPageState]);
};
exports.usePageState = usePageState;


/***/ }),

/***/ "./src/state/hooks/use-page.hook.ts":
/*!******************************************!*\
  !*** ./src/state/hooks/use-page.hook.ts ***!
  \******************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.usePage = void 0;
const context_1 = __webpack_require__(/*! ../context */ "./src/state/context/index.ts");
const react_1 = __webpack_require__(/*! react */ "react");
const usePage = () => {
    const { selectedPage, setSelectedPage } = react_1.useContext(context_1.PageContext);
    return react_1.useMemo(() => [selectedPage, setSelectedPage], [selectedPage, setSelectedPage]);
};
exports.usePage = usePage;


/***/ }),

/***/ "./src/state/hooks/use-panels.hook.ts":
/*!********************************************!*\
  !*** ./src/state/hooks/use-panels.hook.ts ***!
  \********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.usePanels = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const context_1 = __webpack_require__(/*! ../context */ "./src/state/context/index.ts");
const usePanels = () => {
    return react_1.useContext(context_1.PanelsContext);
};
exports.usePanels = usePanels;


/***/ }),

/***/ "./src/state/hooks/use-personality.hook.ts":
/*!*************************************************!*\
  !*** ./src/state/hooks/use-personality.hook.ts ***!
  \*************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.usePersonality = void 0;
const context_1 = __webpack_require__(/*! ../context */ "./src/state/context/index.ts");
const react_1 = __webpack_require__(/*! react */ "react");
const usePersonality = () => {
    const { personality, setPersonality } = react_1.useContext(context_1.PersonalityContext);
    return react_1.useMemo(() => [personality, setPersonality], [personality, setPersonality]);
};
exports.usePersonality = usePersonality;


/***/ }),

/***/ "./src/state/hooks/use-preference.hook.ts":
/*!************************************************!*\
  !*** ./src/state/hooks/use-preference.hook.ts ***!
  \************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useGetPreference = exports.usePreference = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = __webpack_require__(/*! react */ "react");
const context_1 = __webpack_require__(/*! ../context */ "./src/state/context/index.ts");
const usePreference = (key, parse, defaultValue, cacheLevel) => {
    const ctx = react_1.useContext(context_1.PreferenceContext);
    return react_1.useMemo(() => {
        const value = ctx === null || ctx === void 0 ? void 0 : ctx.get(key, parse, defaultValue);
        const set = (value) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
            return ctx === null || ctx === void 0 ? void 0 : ctx.set(key, value, cacheLevel);
        });
        return [value, set];
    }, [ctx, key, parse, defaultValue]);
};
exports.usePreference = usePreference;
const useGetPreference = () => {
    const ctx = react_1.useContext(context_1.PreferenceContext);
    return react_1.useCallback((key, parse, defaultValue) => {
        return ctx === null || ctx === void 0 ? void 0 : ctx.get(key, parse, defaultValue);
    }, [ctx]);
};
exports.useGetPreference = useGetPreference;


/***/ }),

/***/ "./src/state/hooks/use-preferences.hook.ts":
/*!*************************************************!*\
  !*** ./src/state/hooks/use-preferences.hook.ts ***!
  \*************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useGetPreferences = exports.usePreferences = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = __webpack_require__(/*! react */ "react");
const context_1 = __webpack_require__(/*! ../context */ "./src/state/context/index.ts");
const usePreferences = (key, parse, defaultValue, cacheLevel) => {
    const ctx = react_1.useContext(context_1.PreferenceContext);
    return react_1.useMemo(() => {
        const value = key.map((k, i) => ctx === null || ctx === void 0 ? void 0 : ctx.get(k, Array.isArray(parse) ? parse[i] : parse, Array.isArray(defaultValue) ? defaultValue[i] : defaultValue));
        const set = key.map((k, i) => ((value) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
            return ctx === null || ctx === void 0 ? void 0 : ctx.set(k, value, Array.isArray(cacheLevel) ? cacheLevel[i] : cacheLevel);
        })));
        return [value, set];
    }, [ctx, key, parse, defaultValue]);
};
exports.usePreferences = usePreferences;
const useGetPreferences = () => {
    const ctx = react_1.useContext(context_1.PreferenceContext);
    return react_1.useCallback((key, parse, defaultValue) => {
        return key.map((k, i) => ctx === null || ctx === void 0 ? void 0 : ctx.get(k, Array.isArray(parse) ? parse[i] : parse, Array.isArray(defaultValue) ? defaultValue[i] : defaultValue));
    }, [ctx]);
};
exports.useGetPreferences = useGetPreferences;


/***/ }),

/***/ "./src/state/hooks/use-profile.hook.ts":
/*!*********************************************!*\
  !*** ./src/state/hooks/use-profile.hook.ts ***!
  \*********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useSetProfile = exports.useProfile = void 0;
const _state_1 = __webpack_require__(/*! ./.. */ "./src/state/index.ts");
const stateConfig = {
    group: 'system',
    source: 'app',
    name: "$profile",
};
const useProfile = () => {
    return _state_1.useReadSharedState(stateConfig);
};
exports.useProfile = useProfile;
const useSetProfile = () => {
    return _state_1.useSetSharedState(stateConfig);
};
exports.useSetProfile = useSetProfile;


/***/ }),

/***/ "./src/state/hooks/use-providers.hook.ts":
/*!***********************************************!*\
  !*** ./src/state/hooks/use-providers.hook.ts ***!
  \***********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useProviders = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const context_1 = __webpack_require__(/*! ../context */ "./src/state/context/index.ts");
const useProviders = () => {
    return react_1.useContext(context_1.AppContext).providers;
};
exports.useProviders = useProviders;


/***/ }),

/***/ "./src/state/hooks/use-register-focus.hook.ts":
/*!****************************************************!*\
  !*** ./src/state/hooks/use-register-focus.hook.ts ***!
  \****************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useRegisterFocus = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const context_1 = __webpack_require__(/*! ../context */ "./src/state/context/index.ts");
const useRegisterFocus = () => {
    return react_1.useContext(context_1.AppContext).registerFocus;
};
exports.useRegisterFocus = useRegisterFocus;


/***/ }),

/***/ "./src/state/hooks/use-register-last-action.hook.ts":
/*!**********************************************************!*\
  !*** ./src/state/hooks/use-register-last-action.hook.ts ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useRegisterLastAction = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const context_1 = __webpack_require__(/*! ../context */ "./src/state/context/index.ts");
const useRegisterLastAction = () => {
    return react_1.useContext(context_1.AppContext).registerLastAction;
};
exports.useRegisterLastAction = useRegisterLastAction;


/***/ }),

/***/ "./src/state/hooks/use-remove-preference.hook.ts":
/*!*******************************************************!*\
  !*** ./src/state/hooks/use-remove-preference.hook.ts ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useRemovePreference = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const context_1 = __webpack_require__(/*! ../context */ "./src/state/context/index.ts");
const useRemovePreference = (prefKey) => {
    const ctx = react_1.useContext(context_1.PreferenceContext);
    return react_1.useCallback((key = prefKey) => {
        return ctx.remove(key);
    }, [ctx, prefKey]);
};
exports.useRemovePreference = useRemovePreference;


/***/ }),

/***/ "./src/state/hooks/use-render-middleware.hook.ts":
/*!*******************************************************!*\
  !*** ./src/state/hooks/use-render-middleware.hook.ts ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useRenderMiddleware = void 0;
const use_middleware_hook_1 = __webpack_require__(/*! ./use-middleware.hook */ "./src/state/hooks/use-middleware.hook.ts");
const useRenderMiddleware = () => {
    return use_middleware_hook_1.useMiddleware().render;
};
exports.useRenderMiddleware = useRenderMiddleware;


/***/ }),

/***/ "./src/state/hooks/use-reset-directline.hook.ts":
/*!******************************************************!*\
  !*** ./src/state/hooks/use-reset-directline.hook.ts ***!
  \******************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useResetDirectline = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const context_1 = __webpack_require__(/*! ../context */ "./src/state/context/index.ts");
const useResetDirectline = () => {
    const ctx = react_1.useContext(context_1.ChatBotContext);
    return ctx.reset;
};
exports.useResetDirectline = useResetDirectline;


/***/ }),

/***/ "./src/state/hooks/use-set-bot-ready.hook.ts":
/*!***************************************************!*\
  !*** ./src/state/hooks/use-set-bot-ready.hook.ts ***!
  \***************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useSetBotReady = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const context_1 = __webpack_require__(/*! ../context */ "./src/state/context/index.ts");
const useSetBotReady = () => {
    var _a;
    return (_a = react_1.useContext(context_1.APIContext)) === null || _a === void 0 ? void 0 : _a.setBotReady;
};
exports.useSetBotReady = useSetBotReady;


/***/ }),

/***/ "./src/state/hooks/use-set-chat-scope.hook.ts":
/*!****************************************************!*\
  !*** ./src/state/hooks/use-set-chat-scope.hook.ts ***!
  \****************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useSetChatScope = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const context_1 = __webpack_require__(/*! ../context */ "./src/state/context/index.ts");
const useSetChatScope = () => {
    const ctx = react_1.useContext(context_1.ChatBotContext);
    return ctx.setScope;
};
exports.useSetChatScope = useSetChatScope;


/***/ }),

/***/ "./src/state/hooks/use-set-chat-scopes.hook.ts":
/*!*****************************************************!*\
  !*** ./src/state/hooks/use-set-chat-scopes.hook.ts ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useSetChatScopes = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const context_1 = __webpack_require__(/*! ../context */ "./src/state/context/index.ts");
const useSetChatScopes = () => {
    const ctx = react_1.useContext(context_1.ChatBotContext);
    return ctx.setScopes;
};
exports.useSetChatScopes = useSetChatScopes;


/***/ }),

/***/ "./src/state/hooks/use-set-extended-api.hook.ts":
/*!******************************************************!*\
  !*** ./src/state/hooks/use-set-extended-api.hook.ts ***!
  \******************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useSetExtendedAPI = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const context_1 = __webpack_require__(/*! ../context */ "./src/state/context/index.ts");
const useSetExtendedAPI = () => {
    var _a;
    return (_a = react_1.useContext(context_1.APIContext)) === null || _a === void 0 ? void 0 : _a.setExtendedAPI;
};
exports.useSetExtendedAPI = useSetExtendedAPI;


/***/ }),

/***/ "./src/state/hooks/use-set-locale.hook.ts":
/*!************************************************!*\
  !*** ./src/state/hooks/use-set-locale.hook.ts ***!
  \************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useSetLocale = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const context_1 = __webpack_require__(/*! ../context */ "./src/state/context/index.ts");
const useSetLocale = () => {
    return react_1.useContext(context_1.LocalizeContext).setLocale;
};
exports.useSetLocale = useSetLocale;


/***/ }),

/***/ "./src/state/hooks/use-set-preference.hook.ts":
/*!****************************************************!*\
  !*** ./src/state/hooks/use-set-preference.hook.ts ***!
  \****************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useSetPreference = void 0;
const _hooks_1 = __webpack_require__(/*! ../../hooks */ "./src/hooks/index.ts");
const react_1 = __webpack_require__(/*! react */ "react");
const context_1 = __webpack_require__(/*! ../context */ "./src/state/context/index.ts");
const useSetPreference = (prefKey) => {
    const ctx = _hooks_1.useHookRef(react_1.useContext, context_1.PreferenceContext);
    return react_1.useCallback((value, key = prefKey) => {
        return ctx.current.set(key, value);
    }, [prefKey]);
};
exports.useSetPreference = useSetPreference;


/***/ }),

/***/ "./src/state/hooks/use-set-theme.hook.ts":
/*!***********************************************!*\
  !*** ./src/state/hooks/use-set-theme.hook.ts ***!
  \***********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useSetTheme = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const context_1 = __webpack_require__(/*! ../context */ "./src/state/context/index.ts");
const useSetTheme = () => {
    const ctx = react_1.useContext(context_1.ThemeContext);
    return ctx.setTheme;
};
exports.useSetTheme = useSetTheme;


/***/ }),

/***/ "./src/state/hooks/use-source-info.hook.ts":
/*!*************************************************!*\
  !*** ./src/state/hooks/use-source-info.hook.ts ***!
  \*************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useSourceInfo = void 0;
const context_1 = __webpack_require__(/*! ../context */ "./src/state/context/index.ts");
const react_1 = __webpack_require__(/*! react */ "react");
const useSourceInfo = () => {
    return react_1.useContext(context_1.AppContext).sourceInfo;
};
exports.useSourceInfo = useSourceInfo;


/***/ }),

/***/ "./src/state/hooks/use-splash.hook.ts":
/*!********************************************!*\
  !*** ./src/state/hooks/use-splash.hook.ts ***!
  \********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useSplash = void 0;
const usehooks_ts_1 = __webpack_require__(/*! usehooks-ts */ "./node_modules/usehooks-ts/dist/esm/index.js");
const react_1 = __webpack_require__(/*! react */ "react");
const useSplash = (sessionKey, cacheLocation, version) => {
    const [splashVisibility_local] = usehooks_ts_1.useLocalStorage(sessionKey, null);
    const [splashVisibility_session] = usehooks_ts_1.useSessionStorage(sessionKey, null);
    const getCache = react_1.useCallback(() => {
        let cacheStr = null;
        switch (cacheLocation) {
            case "local":
                cacheStr = splashVisibility_local;
                break;
            case "session":
                cacheStr = splashVisibility_session;
                break;
        }
        return cacheStr;
    }, [splashVisibility_local, splashVisibility_session, cacheLocation]);
    const shouldShowSplash = react_1.useCallback(() => {
        let accepted = false;
        const cacheStr = getCache();
        if (cacheStr) {
            try {
                let tncs = cacheStr;
                accepted =
                    tncs.version != null &&
                        tncs.version == version &&
                        tncs.date != null &&
                        tncs.accepted == true;
                return !accepted;
            }
            catch (ex) {
                console.log("Failed to parse acceptance record. " + cacheStr);
                return false;
            }
        }
        // show splash if no cache found
        return true;
    }, [splashVisibility_local, splashVisibility_session, cacheLocation]);
    return react_1.useMemo(() => {
        return { visible: shouldShowSplash() };
    }, []);
};
exports.useSplash = useSplash;


/***/ }),

/***/ "./src/state/hooks/use-theme.hook.ts":
/*!*******************************************!*\
  !*** ./src/state/hooks/use-theme.hook.ts ***!
  \*******************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useTheme = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const context_1 = __webpack_require__(/*! ../context */ "./src/state/context/index.ts");
const useTheme = () => {
    return react_1.useContext(context_1.ThemeContext).theme;
};
exports.useTheme = useTheme;


/***/ }),

/***/ "./src/state/hooks/use-themes.hook.ts":
/*!********************************************!*\
  !*** ./src/state/hooks/use-themes.hook.ts ***!
  \********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useThemes = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const context_1 = __webpack_require__(/*! ../context */ "./src/state/context/index.ts");
const useThemes = () => {
    return react_1.useContext(context_1.ThemeContext).themes;
};
exports.useThemes = useThemes;


/***/ }),

/***/ "./src/state/hooks/use-tpc-check.hook.ts":
/*!***********************************************!*\
  !*** ./src/state/hooks/use-tpc-check.hook.ts ***!
  \***********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useTPCCheck = void 0;
const _state_1 = __webpack_require__(/*! ./.. */ "./src/state/index.ts");
const react_1 = __webpack_require__(/*! react */ "react");
const useTPCCheck = () => {
    return react_1.useContext(_state_1.TPCCheckContext);
};
exports.useTPCCheck = useTPCCheck;


/***/ }),

/***/ "./src/state/hooks/use-transform-middleware.hook.ts":
/*!**********************************************************!*\
  !*** ./src/state/hooks/use-transform-middleware.hook.ts ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useTransformMiddleware = void 0;
const use_middleware_hook_1 = __webpack_require__(/*! ./use-middleware.hook */ "./src/state/hooks/use-middleware.hook.ts");
const useTransformMiddleware = () => {
    return use_middleware_hook_1.useMiddleware().transform;
};
exports.useTransformMiddleware = useTransformMiddleware;


/***/ }),

/***/ "./src/state/hooks/use-view-config.hook.ts":
/*!*************************************************!*\
  !*** ./src/state/hooks/use-view-config.hook.ts ***!
  \*************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useViewConfig = void 0;
const context_1 = __webpack_require__(/*! ../context */ "./src/state/context/index.ts");
const react_1 = __webpack_require__(/*! react */ "react");
const useViewConfig = () => {
    return react_1.useContext(context_1.AppContext).view;
};
exports.useViewConfig = useViewConfig;


/***/ }),

/***/ "./src/state/index.ts":
/*!****************************!*\
  !*** ./src/state/index.ts ***!
  \****************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./hooks */ "./src/state/hooks/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./context */ "./src/state/context/index.ts"), exports);


/***/ }),

/***/ "./src/styles/base-dock.config.ts":
/*!****************************************!*\
  !*** ./src/styles/base-dock.config.ts ***!
  \****************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.baseDockConfig = void 0;
exports.baseDockConfig = {
    mode: 'full',
    chat: {
        dockPositions: {
            preferred: 'right',
            options: ['left', 'right']
        },
        dockSizes: {
            sm: {
                preferred: 'full',
                full: 12,
                wide: 12,
                split: 12,
                narrow: 12,
                asside: 12
            },
            lg: {
                wide: 8,
                split: 6,
                narrow: 6,
                asside: 6
            },
            lgx: {
                wide: 7,
                narrow: 5,
                asside: 5
            },
            xl: {
                full: 8,
                wide: 8,
                narrow: 4,
                asside: 4
            },
            xlx: {
                narrow: 3,
                asside: 3
            }
        }
    },
    page: {
        dockPositions: {
            preferred: 'right',
            options: ['left', 'right']
        },
        dockSizes: {
            sm: {
                preferred: 'full',
                full: 12,
                wide: 12,
                split: 12,
                narrow: 12,
                asside: 12
            },
            lg: {
                wide: 8,
                split: 6,
                narrow: 6,
                asside: 6
            },
            lgx: {
                wide: 7,
                narrow: 5,
                asside: 7
            },
            xl: {
                full: 8,
                wide: 8,
                narrow: 4,
                asside: 8
            },
            xlx: {
                preferred: 'split'
            }
        }
    }
};


/***/ }),

/***/ "./src/styles/base-host-config.const.ts":
/*!**********************************************!*\
  !*** ./src/styles/base-host-config.const.ts ***!
  \**********************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.baseHostConfig = void 0;
exports.baseHostConfig = {
    "spacing": {
        "small": 3,
        "default": 8,
        "medium": 20,
        "large": 30,
        "extraLarge": 40,
        "padding": 10
    },
    "separator": {
        "lineThickness": 1,
        "lineColor": "#EEEEEE"
    },
    "supportsInteractivity": true,
    "fontTypes": {
        "default": {
            "fontFamily": "'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
            "fontSizes": {
                "small": 12,
                "default": 14,
                "medium": 17,
                "large": 21,
                "extraLarge": 26
            },
            "fontWeights": {
                "lighter": 200,
                "default": 400,
                "bolder": 600
            }
        },
        "monospace": {
            "fontFamily": "'Courier New', Courier, monospace",
            "fontSizes": {
                "small": 12,
                "default": 14,
                "medium": 17,
                "large": 21,
                "extraLarge": 26
            },
            "fontWeights": {
                "lighter": 200,
                "default": 400,
                "bolder": 600
            }
        }
    },
    "containerStyles": {
        "default": {
            "backgroundColor": "#FFFFFF",
            "foregroundColors": {
                "default": {
                    "default": "#000000",
                    "subtle": "#767676"
                },
                "accent": {
                    "default": "#0063B1",
                    "subtle": "#0063B1"
                },
                "attention": {
                    "default": "#FF0000",
                    "subtle": "#DDFF0000"
                },
                "good": {
                    "default": "#54a254",
                    "subtle": "#DD54a254"
                },
                "warning": {
                    "default": "#c3ab23",
                    "subtle": "#DDc3ab23"
                }
            }
        },
        "emphasis": {
            "backgroundColor": "#F0F0F0",
            "foregroundColors": {
                "default": {
                    "default": "#000000",
                    "subtle": "#767676"
                },
                "accent": {
                    "default": "#2E89FC",
                    "subtle": "#882E89FC"
                },
                "attention": {
                    "default": "#FF0000",
                    "subtle": "#DDFF0000"
                },
                "good": {
                    "default": "#54a254",
                    "subtle": "#DD54a254"
                },
                "warning": {
                    "default": "#c3ab23",
                    "subtle": "#DDc3ab23"
                }
            }
        },
        "accent": {
            "backgroundColor": "#C7DEF9",
            "foregroundColors": {
                "default": {
                    "default": "#333333",
                    "subtle": "#EE333333"
                },
                "dark": {
                    "default": "#000000",
                    "subtle": "#66000000"
                },
                "light": {
                    "default": "#FFFFFF",
                    "subtle": "#33000000"
                },
                "accent": {
                    "default": "#2E89FC",
                    "subtle": "#882E89FC"
                },
                "attention": {
                    "default": "#cc3300",
                    "subtle": "#DDcc3300"
                },
                "good": {
                    "default": "#54a254",
                    "subtle": "#DD54a254"
                },
                "warning": {
                    "default": "#e69500",
                    "subtle": "#DDe69500"
                }
            }
        },
        "good": {
            "backgroundColor": "#CCFFCC",
            "foregroundColors": {
                "default": {
                    "default": "#333333",
                    "subtle": "#EE333333"
                },
                "dark": {
                    "default": "#000000",
                    "subtle": "#66000000"
                },
                "light": {
                    "default": "#FFFFFF",
                    "subtle": "#33000000"
                },
                "accent": {
                    "default": "#2E89FC",
                    "subtle": "#882E89FC"
                },
                "attention": {
                    "default": "#cc3300",
                    "subtle": "#DDcc3300"
                },
                "good": {
                    "default": "#54a254",
                    "subtle": "#DD54a254"
                },
                "warning": {
                    "default": "#e69500",
                    "subtle": "#DDe69500"
                }
            }
        },
        "attention": {
            "backgroundColor": "#FFC5B2",
            "foregroundColors": {
                "default": {
                    "default": "#333333",
                    "subtle": "#EE333333"
                },
                "dark": {
                    "default": "#000000",
                    "subtle": "#66000000"
                },
                "light": {
                    "default": "#FFFFFF",
                    "subtle": "#33000000"
                },
                "accent": {
                    "default": "#2E89FC",
                    "subtle": "#882E89FC"
                },
                "attention": {
                    "default": "#cc3300",
                    "subtle": "#DDcc3300"
                },
                "good": {
                    "default": "#54a254",
                    "subtle": "#DD54a254"
                },
                "warning": {
                    "default": "#e69500",
                    "subtle": "#DDe69500"
                }
            }
        },
        "warning": {
            "backgroundColor": "#FFE2B2",
            "foregroundColors": {
                "default": {
                    "default": "#333333",
                    "subtle": "#EE333333"
                },
                "dark": {
                    "default": "#000000",
                    "subtle": "#66000000"
                },
                "light": {
                    "default": "#FFFFFF",
                    "subtle": "#33000000"
                },
                "accent": {
                    "default": "#2E89FC",
                    "subtle": "#882E89FC"
                },
                "attention": {
                    "default": "#cc3300",
                    "subtle": "#DDcc3300"
                },
                "good": {
                    "default": "#54a254",
                    "subtle": "#DD54a254"
                },
                "warning": {
                    "default": "#e69500",
                    "subtle": "#DDe69500"
                }
            }
        }
    },
    "imageSizes": {
        "small": 40,
        "medium": 80,
        "large": 160
    },
    "actions": {
        "maxActions": 100,
        "spacing": "default",
        "buttonSpacing": 8,
        "showCard": {
            "actionMode": "inline",
            "inlineTopMargin": 8
        },
        "actionsOrientation": "vertical",
        "actionAlignment": "stretch"
    },
    "adaptiveCard": {
        "allowCustomStyle": false
    },
    "imageSet": {
        "imageSize": "medium",
        "maxImageHeight": 100
    },
    "factSet": {
        "title": {
            "color": "default",
            "size": "default",
            "isSubtle": false,
            "weight": "bolder",
            "wrap": true,
            "maxWidth": 150
        },
        "value": {
            "color": "default",
            "size": "default",
            "isSubtle": false,
            "weight": "default",
            "wrap": true
        },
        "spacing": 8
    }
};


/***/ }),

/***/ "./src/styles/base-webchat-styles.const.ts":
/*!*************************************************!*\
  !*** ./src/styles/base-webchat-styles.const.ts ***!
  \*************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.baseWebChatStyles = void 0;
const default_webchat_styles_const_1 = __webpack_require__(/*! ./default-webchat-styles.const */ "./src/styles/default-webchat-styles.const.ts");
exports.baseWebChatStyles = Object.assign(Object.assign({}, default_webchat_styles_const_1.defaultStyleOptions), { backgroundColor: undefined, transcriptActivityVisualKeyboardIndicatorStyle: 'solid', transcriptActivityVisualKeyboardIndicatorWidth: 2, hideSendBox: true, botAvatarInitials: '', bubbleNubSize: 10, bubbleFromUserNubSize: 10 });


/***/ }),

/***/ "./src/styles/default-webchat-styles.const.ts":
/*!****************************************************!*\
  !*** ./src/styles/default-webchat-styles.const.ts ***!
  \****************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.defaultStyleOptions = void 0;
function fontFamily(fonts) {
    return fonts.map(font => `'${font}'`).join(', ');
}
const DEFAULT_ACCENT = '#0063B1';
const DEFAULT_SUBTLE = '#767676';
const PADDING_REGULAR = 10;
//refresh as needed.
exports.defaultStyleOptions = {
    // Basic styling
    accent: DEFAULT_ACCENT,
    backgroundColor: 'White',
    subtle: DEFAULT_SUBTLE,
    paddingRegular: PADDING_REGULAR,
    paddingWide: PADDING_REGULAR * 2,
    fontSizeSmall: '80%',
    monospaceFont: fontFamily(['Consolas', 'Courier New', 'monospace']),
    primaryFont: fontFamily(['Calibri', 'Helvetica Neue', 'Arial', 'sans-serif']),
    // Root
    rootHeight: '100%',
    rootWidth: '100%',
    rootZIndex: 0,
    transitionDuration: '0s',
    // Avatar
    avatarBorderRadius: '50%',
    avatarSize: 40,
    botAvatarBackgroundColor: undefined,
    botAvatarImage: undefined,
    botAvatarInitials: undefined,
    userAvatarBackgroundColor: undefined,
    userAvatarImage: undefined,
    userAvatarInitials: undefined,
    showAvatarInGroup: 'status',
    // Bubble
    // TODO: Should we make a bubbleFromBot*
    bubbleBackground: 'White',
    bubbleBorderColor: '#E6E6E6',
    bubbleBorderRadius: 2,
    bubbleBorderStyle: 'solid',
    bubbleBorderWidth: 1,
    bubbleFromUserBackground: 'White',
    bubbleFromUserBorderColor: '#E6E6E6',
    bubbleFromUserBorderRadius: 2,
    bubbleFromUserBorderStyle: 'solid',
    bubbleFromUserBorderWidth: 1,
    bubbleFromUserNubOffset: 0,
    bubbleFromUserNubSize: undefined,
    bubbleFromUserTextColor: 'Black',
    bubbleImageHeight: 240,
    bubbleMaxWidth: 480,
    bubbleMinHeight: 40,
    bubbleMinWidth: 250,
    bubbleNubOffset: 0,
    bubbleNubSize: undefined,
    bubbleTextColor: 'Black',
    messageActivityWordBreak: 'break-word',
    // Connectivity UI
    connectivityIconPadding: PADDING_REGULAR * 1.2,
    connectivityMarginLeftRight: PADDING_REGULAR * 1.4,
    connectivityMarginTopBottom: PADDING_REGULAR * 0.8,
    connectivityTextSize: '75%',
    failedConnectivity: '#C50F1F',
    slowConnectivity: '#EAA300',
    notificationText: '#5E5E5E',
    slowConnectionAfter: 15000,
    // Emoji
    emojiSet: true,
    // Live region - Accessibility
    internalLiveRegionFadeAfter: 1000,
    // Markdown
    markdownExternalLinkIconImage: 'url(data:image/svg+xml;base64,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)',
    markdownRespectCRLF: true,
    // Scroll behavior
    hideScrollToEndButton: undefined,
    autoScrollSnapOnActivity: false,
    autoScrollSnapOnActivityOffset: 0,
    autoScrollSnapOnPage: false,
    autoScrollSnapOnPageoffset: 0,
    // Send box
    hideSendBox: false,
    hideUploadButton: false,
    microphoneButtonColorOnDictate: '#F33',
    sendBoxBackground: 'White',
    sendBoxButtonColor: undefined,
    sendBoxButtonColorOnDisabled: '#CCC',
    sendBoxButtonColorOnFocus: '#333',
    sendBoxButtonColorOnHover: '#333',
    sendBoxDisabledTextColor: undefined,
    sendBoxHeight: 40,
    sendBoxMaxHeight: 200,
    sendBoxTextColor: 'Black',
    // TODO: We should deprecate this because there isn't an easy way to make the width of the send box narrower than the transcript
    sendBoxBorderBottom: undefined,
    sendBoxBorderLeft: undefined,
    sendBoxBorderRight: undefined,
    sendBoxBorderTop: 'solid 1px #E6E6E6',
    sendBoxPlaceholderColor: undefined,
    sendBoxTextWrap: false,
    sendBoxButtonAlignment: 'stretch',
    // Visually show spoken text
    showSpokenText: false,
    spinnerAnimationBackgroundImage: undefined,
    spinnerAnimationHeight: 16,
    spinnerAnimationWidth: 16,
    spinnerAnimationPadding: 12,
    // Suggested actions
    suggestedActionBackground: 'White',
    suggestedActionBorderColor: undefined,
    suggestedActionBorderRadius: 0,
    suggestedActionBorderStyle: 'solid',
    suggestedActionBorderWidth: 2,
    suggestedActionDisabledBackground: undefined,
    suggestedActionDisabledBorderColor: '#E6E6E6',
    suggestedActionDisabledBorderStyle: 'solid',
    suggestedActionDisabledBorderWidth: 2,
    suggestedActionDisabledTextColor: undefined,
    suggestedActionHeight: 40,
    suggestedActionImageHeight: 20,
    suggestedActionLayout: 'carousel',
    suggestedActionTextColor: undefined,
    // Suggested actions carousel layout
    suggestedActionsCarouselFlipperCursor: undefined,
    suggestedActionsCarouselFlipperBoxWidth: 40,
    suggestedActionsCarouselFlipperSize: 20,
    // Suggested actions flow layout
    suggestedActionsFlowMaxHeight: undefined,
    // Suggested actions stacked layout
    suggestedActionsStackedHeight: undefined,
    suggestedActionsStackedOverflow: undefined,
    suggestedActionsStackedLayoutButtonMaxHeight: undefined,
    suggestedActionsStackedLayoutButtonTextWrap: false,
    // Timestamp
    groupTimestamp: true,
    sendTimeout: 20000,
    sendTimeoutForAttachments: 120000,
    timestampColor: undefined,
    timestampFormat: 'relative',
    // Transcript overlay buttons
    scrollToEndButtonBehavior: 'unread',
    scrollToEndButtonFontSize: '85%',
    newMessagesButtonFontSize: undefined,
    transcriptOverlayButtonBackground: 'rgba(0, 0, 0, .6)',
    transcriptOverlayButtonBackgroundOnDisabled: 'rgba(0, 0, 0, .6)',
    transcriptOverlayButtonBackgroundOnFocus: 'rgba(0, 0, 0, .8)',
    transcriptOverlayButtonBackgroundOnHover: 'rgba(0, 0, 0, .8)',
    transcriptOverlayButtonColor: 'White',
    transcriptOverlayButtonColorOnDisabled: 'White',
    transcriptOverlayButtonColorOnFocus: undefined,
    transcriptOverlayButtonColorOnHover: undefined,
    // Toast UI
    notificationDebounceTimeout: 400,
    hideToaster: false,
    toasterHeight: 32,
    toasterMaxHeight: 32 * 5,
    toasterSingularMaxHeight: 50,
    toastFontSize: '87.5%',
    toastIconWidth: 36,
    toastSeparatorColor: '#E8EAEC',
    toastTextPadding: 6,
    toastErrorBackgroundColor: '#FDE7E9',
    toastErrorColor: '#A80000',
    toastInfoBackgroundColor: '#CEF1FF',
    toastInfoColor: '#105E7D',
    toastSuccessBackgroundColor: '#DFF6DD',
    toastSuccessColor: '#107C10',
    toastWarnBackgroundColor: '#FFF4CE',
    toastWarnColor: '#3B3A39',
    // Transcript
    transcriptTerminatorBackgroundColor: '#595959',
    transcriptTerminatorBorderRadius: 5,
    transcriptTerminatorColor: 'White',
    transcriptTerminatorFontSize: 12,
    transcriptActivityVisualKeyboardIndicatorColor: DEFAULT_SUBTLE,
    transcriptActivityVisualKeyboardIndicatorStyle: 'dashed',
    transcriptActivityVisualKeyboardIndicatorWidth: 1,
    transcriptVisualKeyboardIndicatorColor: 'Black',
    transcriptVisualKeyboardIndicatorStyle: 'solid',
    transcriptVisualKeyboardIndicatorWidth: 2,
    // Typing animation
    typingAnimationBackgroundImage: undefined,
    typingAnimationDuration: 5000,
    typingAnimationHeight: 20,
    typingAnimationWidth: 64,
    // Upload thumbnail
    // TODO: [P0] #3322 This is only supported in HTML.
    enableUploadThumbnail: true,
    uploadThumbnailContentType: 'image/jpeg',
    uploadThumbnailHeight: 360,
    uploadThumbnailQuality: 0.6,
    uploadThumbnailWidth: 720,
    // Video
    videoHeight: 270 // based on bubbleMaxWidth: 480 / 16 * 9 = 270
};


/***/ }),

/***/ "./src/styles/helpers/apply-item-mapping.fn.ts":
/*!*****************************************************!*\
  !*** ./src/styles/helpers/apply-item-mapping.fn.ts ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.applyItemMapping = void 0;
const applyItemMapping = (obj, mappings, items) => {
    return Object.keys(mappings).reduce((accum, k) => {
        var _a;
        const mapping = mappings[k];
        if (typeof mapping === 'string')
            accum[k] = items[mapping];
        else
            accum[k] = exports.applyItemMapping((_a = accum[k]) !== null && _a !== void 0 ? _a : {}, mapping, items);
        return accum;
    }, obj);
};
exports.applyItemMapping = applyItemMapping;


/***/ }),

/***/ "./src/styles/helpers/index.ts":
/*!*************************************!*\
  !*** ./src/styles/helpers/index.ts ***!
  \*************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.reduceStyleProp = exports.responsiveColumnWidths = exports.responsiveBreakPoints = exports.mergeWebchatStyleset = exports.mergeWebchatStyles = exports.mergeHostConfigStyles = exports.mergeFluentTheme = exports.mergeTheme = exports.themeStyle = void 0;
var theme_style_helper_1 = __webpack_require__(/*! ./theme-style.helper */ "./src/styles/helpers/theme-style.helper.ts");
Object.defineProperty(exports, "themeStyle", ({ enumerable: true, get: function () { return theme_style_helper_1.themeStyle; } }));
var merge_theme_fn_1 = __webpack_require__(/*! ./merge-theme.fn */ "./src/styles/helpers/merge-theme.fn.ts");
Object.defineProperty(exports, "mergeTheme", ({ enumerable: true, get: function () { return merge_theme_fn_1.mergeTheme; } }));
var merge_fluent_theme_fn_1 = __webpack_require__(/*! ./merge-fluent-theme.fn */ "./src/styles/helpers/merge-fluent-theme.fn.ts");
Object.defineProperty(exports, "mergeFluentTheme", ({ enumerable: true, get: function () { return merge_fluent_theme_fn_1.mergeFluentTheme; } }));
var merge_host_config_styles_fn_1 = __webpack_require__(/*! ./merge-host-config-styles.fn */ "./src/styles/helpers/merge-host-config-styles.fn.ts");
Object.defineProperty(exports, "mergeHostConfigStyles", ({ enumerable: true, get: function () { return merge_host_config_styles_fn_1.mergeHostConfigStyles; } }));
var merge_webchat_styles_fn_1 = __webpack_require__(/*! ./merge-webchat-styles.fn */ "./src/styles/helpers/merge-webchat-styles.fn.ts");
Object.defineProperty(exports, "mergeWebchatStyles", ({ enumerable: true, get: function () { return merge_webchat_styles_fn_1.mergeWebchatStyles; } }));
var merge_webchat_styleset_fn_1 = __webpack_require__(/*! ./merge-webchat-styleset.fn */ "./src/styles/helpers/merge-webchat-styleset.fn.ts");
Object.defineProperty(exports, "mergeWebchatStyleset", ({ enumerable: true, get: function () { return merge_webchat_styleset_fn_1.mergeWebchatStyleset; } }));
var responsive_const_1 = __webpack_require__(/*! ./responsive.const */ "./src/styles/helpers/responsive.const.ts");
Object.defineProperty(exports, "responsiveBreakPoints", ({ enumerable: true, get: function () { return responsive_const_1.responsiveBreakPoints; } }));
Object.defineProperty(exports, "responsiveColumnWidths", ({ enumerable: true, get: function () { return responsive_const_1.responsiveColumnWidths; } }));
var reduce_style_prop_1 = __webpack_require__(/*! ./reduce-style-prop */ "./src/styles/helpers/reduce-style-prop.ts");
Object.defineProperty(exports, "reduceStyleProp", ({ enumerable: true, get: function () { return reduce_style_prop_1.reduceStyleProp; } }));


/***/ }),

/***/ "./src/styles/helpers/merge-fluent-theme.fn.ts":
/*!*****************************************************!*\
  !*** ./src/styles/helpers/merge-fluent-theme.fn.ts ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.mergeFluentTheme = void 0;
const mergeFluentTheme = ({ palette, fonts, fluentStyles, fluentMapping }) => {
    return {
        palette: Object.keys(fluentMapping).reduce((p, key) => {
            p[key] = palette[fluentMapping[key]];
            return p;
        }, {}),
        fonts,
        components: fluentStyles
    };
};
exports.mergeFluentTheme = mergeFluentTheme;


/***/ }),

/***/ "./src/styles/helpers/merge-host-config-styles.fn.ts":
/*!***********************************************************!*\
  !*** ./src/styles/helpers/merge-host-config-styles.fn.ts ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.mergeHostConfigStyles = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const AdaptiveCards = tslib_1.__importStar(__webpack_require__(/*! adaptivecards */ "adaptivecards"));
const apply_item_mapping_fn_1 = __webpack_require__(/*! ./apply-item-mapping.fn */ "./src/styles/helpers/apply-item-mapping.fn.ts");
const base_host_config_const_1 = __webpack_require__(/*! ../base-host-config.const */ "./src/styles/base-host-config.const.ts");
const mergeHostConfigStyles = (adaptiveCardHostConfig, { acMapping, palette }) => {
    const hostConfig = apply_item_mapping_fn_1.applyItemMapping(Object.assign(Object.assign({}, base_host_config_const_1.baseHostConfig), (adaptiveCardHostConfig !== null && adaptiveCardHostConfig !== void 0 ? adaptiveCardHostConfig : {})), acMapping, palette);
    return new AdaptiveCards.HostConfig(hostConfig);
};
exports.mergeHostConfigStyles = mergeHostConfigStyles;


/***/ }),

/***/ "./src/styles/helpers/merge-theme.fn.ts":
/*!**********************************************!*\
  !*** ./src/styles/helpers/merge-theme.fn.ts ***!
  \**********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.mergeTheme = void 0;
const _models_1 = __webpack_require__(/*! ../../models */ "./src/models/index.ts");
const mergeTheme = ({ $id, name, description, definition: { type, palette, icon, image, styles, props, fonts, fluentStyles, fluentMapping, acMapping, webChatMapping, spacing, sizes } }, base) => {
    var _a, _b, _c, _d;
    return {
        $id,
        $schema: _models_1.IThemeSchema,
        name,
        description,
        definition: {
            type,
            spacing: Object.assign(Object.assign({}, base.definition.spacing), spacing),
            sizes: Object.assign(Object.assign({}, base.definition.sizes), sizes),
            webChatMapping: {
                palette: Object.assign(Object.assign({}, base.definition.webChatMapping.palette), ((_a = webChatMapping === null || webChatMapping === void 0 ? void 0 : webChatMapping.palette) !== null && _a !== void 0 ? _a : {})),
                images: Object.assign(Object.assign({}, base.definition.webChatMapping.images), ((_b = webChatMapping === null || webChatMapping === void 0 ? void 0 : webChatMapping.images) !== null && _b !== void 0 ? _b : {})),
                sizes: Object.assign(Object.assign({}, base.definition.webChatMapping.sizes), ((_c = webChatMapping === null || webChatMapping === void 0 ? void 0 : webChatMapping.sizes) !== null && _c !== void 0 ? _c : {})),
                spacing: Object.assign(Object.assign({}, base.definition.webChatMapping.spacing), ((_d = webChatMapping === null || webChatMapping === void 0 ? void 0 : webChatMapping.spacing) !== null && _d !== void 0 ? _d : {})),
            },
            acMapping: Object.assign(Object.assign({}, base.definition.acMapping), acMapping),
            fonts: Object.assign(Object.assign({}, base.definition.fonts), fonts),
            palette: Object.assign(Object.assign({}, base.definition.palette), palette),
            icon: Object.assign(Object.assign({}, base.definition.icon), icon),
            image: Object.assign(Object.assign({}, base.definition.image), image),
            styles: Object.assign(Object.assign({}, base.definition.styles), styles),
            props: Object.assign(Object.assign({}, base.definition.props), props),
            fluentMapping: Object.assign(Object.assign({}, base.definition.fluentMapping), fluentMapping),
            fluentStyles: Object.assign(Object.assign({}, base.definition.fluentStyles), fluentStyles),
        }
    };
};
exports.mergeTheme = mergeTheme;


/***/ }),

/***/ "./src/styles/helpers/merge-webchat-styles.fn.ts":
/*!*******************************************************!*\
  !*** ./src/styles/helpers/merge-webchat-styles.fn.ts ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.mergeWebchatStyles = void 0;
const apply_item_mapping_fn_1 = __webpack_require__(/*! ./apply-item-mapping.fn */ "./src/styles/helpers/apply-item-mapping.fn.ts");
const base_webchat_styles_const_1 = __webpack_require__(/*! ../base-webchat-styles.const */ "./src/styles/base-webchat-styles.const.ts");
//TODO refine this
const mergeWebchatStyles = (webChatStyles, { webChatMapping, palette, image, sizes, spacing }) => {
    let styles = Object.assign(Object.assign({}, base_webchat_styles_const_1.baseWebChatStyles), (webChatStyles !== null && webChatStyles !== void 0 ? webChatStyles : {}));
    apply_item_mapping_fn_1.applyItemMapping(styles, webChatMapping.palette, palette);
    apply_item_mapping_fn_1.applyItemMapping(styles, webChatMapping.images, image);
    apply_item_mapping_fn_1.applyItemMapping(styles, webChatMapping.spacing, spacing);
    apply_item_mapping_fn_1.applyItemMapping(styles, webChatMapping.sizes, sizes);
    return styles;
};
exports.mergeWebchatStyles = mergeWebchatStyles;


/***/ }),

/***/ "./src/styles/helpers/merge-webchat-styleset.fn.ts":
/*!*********************************************************!*\
  !*** ./src/styles/helpers/merge-webchat-styleset.fn.ts ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.mergeWebchatStyleset = void 0;
const botframework_webchat_1 = __webpack_require__(/*! botframework-webchat */ "botframework-webchat");
const hooks_1 = __webpack_require__(/*! ../hooks */ "./src/styles/hooks/index.ts");
const mergeWebchatStyleset = (styleSet, webChatStyles, theme) => {
    const adaptiveCardRenderer = hooks_1.createAdaptiveCardStyleSet(theme);
    const mainStyleSet = botframework_webchat_1.createStyleSet(webChatStyles);
    return Object.assign(Object.assign(Object.assign({}, mainStyleSet), { adaptiveCardRenderer }), (styleSet !== null && styleSet !== void 0 ? styleSet : {}));
};
exports.mergeWebchatStyleset = mergeWebchatStyleset;


/***/ }),

/***/ "./src/styles/helpers/reduce-style-prop.ts":
/*!*************************************************!*\
  !*** ./src/styles/helpers/reduce-style-prop.ts ***!
  \*************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.reduceStyleProp = void 0;
const responsive_const_1 = __webpack_require__(/*! ./responsive.const */ "./src/styles/helpers/responsive.const.ts");
const reduceStyleProp = (breakpoint, config) => {
    return config
        ? responsive_const_1.responsiveBreakPoints
            .slice(0, breakpoint.size + 1)
            .reduce((value, bp) => {
            return Object.assign(Object.assign({}, value), config[bp.name]);
        }, {})
        : undefined;
};
exports.reduceStyleProp = reduceStyleProp;


/***/ }),

/***/ "./src/styles/helpers/responsive.const.ts":
/*!************************************************!*\
  !*** ./src/styles/helpers/responsive.const.ts ***!
  \************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.responsiveColumnWidths = exports.responsiveBreakPoints = void 0;
const _models_1 = __webpack_require__(/*! ../../models */ "./src/models/index.ts");
exports.responsiveBreakPoints = [
    { size: _models_1.Breakpoints.xs, name: _models_1.BreakpointNames.xs, width: 0 },
    { size: _models_1.Breakpoints.sm, name: _models_1.BreakpointNames.sm, width: 320 },
    { size: _models_1.Breakpoints.md, name: _models_1.BreakpointNames.md, width: 480 },
    { size: _models_1.Breakpoints.lg, name: _models_1.BreakpointNames.lg, width: 640 },
    { size: _models_1.Breakpoints.lgx, name: _models_1.BreakpointNames.lgx, width: 832 },
    { size: _models_1.Breakpoints.xl, name: _models_1.BreakpointNames.xl, width: 1024 },
    { size: _models_1.Breakpoints.xlx, name: _models_1.BreakpointNames.xlx, width: 1195 },
    { size: _models_1.Breakpoints.xxl, name: _models_1.BreakpointNames.xxl, width: 1366 },
    { size: _models_1.Breakpoints.xxxl, name: _models_1.BreakpointNames.xxxl, width: 1920 }
];
exports.responsiveColumnWidths = [
    "0%",
    "8.333333333333332%",
    "16.666666666666664%",
    "25%",
    "33.33333333333333%",
    "41.66666666666667%",
    "50%",
    "58.333333333333336%",
    "66.66666666666666%",
    "75%",
    "83.33333333333334%",
    "91.66666666666666%",
    "100%"
];


/***/ }),

/***/ "./src/styles/helpers/theme-style.helper.ts":
/*!**************************************************!*\
  !*** ./src/styles/helpers/theme-style.helper.ts ***!
  \**************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.themeStyle = void 0;
const themeStyle = (style, props) => typeof style === 'function'
    ? style(props)
    : style !== null && style !== void 0 ? style : {};
exports.themeStyle = themeStyle;


/***/ }),

/***/ "./src/styles/hooks/adaptive-card.styles.ts":
/*!**************************************************!*\
  !*** ./src/styles/hooks/adaptive-card.styles.ts ***!
  \**************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createAdaptiveCardStyleSet = exports.createUseAdaptiveCardStyles = void 0;
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
//TODO review, is this needed?
const adaptiveCardStyleSet = ({ fonts, palette, spacing }, prefix = false) => {
    const pfx = prefix ? "& " : "";
    return {
        [`${pfx}.ac-textBlock ul`]: {
            listStyleType: "disc",
            padding: "0.5rem 2rem",
        },
        [`${pfx}.ac-textBlock h1`]: {
            marginTop: "0px",
            width: "100%",
            fontFamily: "inherit",
            fontSize: "1.3em",
            textTransform: "unset",
            fontWeight: 600,
            padding: "0px 0px 5px 0px",
        },
        [`${pfx}.ac-textBlock h2`]: {
            marginTop: "0px",
            width: "100%",
            fontFamily: "inherit",
            fontSize: "1.1em",
            textTransform: "unset",
            fontWeight: 600,
            padding: "0px 0px 5px 0px",
        },
        [`${pfx}.ac-input, ${pfx}.ac-inlineActionButton, ${pfx}.ac-quickActionButton`]: Object.assign(Object.assign({}, fonts.normal), { padding: spacing.smallPlus }),
        [`${pfx}.ac-multichoiceInput`]: {
            padding: spacing.mediumPlus,
        },
        [`${pfx}.ac-pushButton`]: Object.assign(Object.assign({}, fonts.normal), { appearance: "none", borderRadius: spacing.small, lineHeight: spacing.xLarge, padding: spacing.smallPlus, transitionDuration: "300ms", transitionProperty: "color, background-color", transitionTimingFunction: "ease-in", backgroundColor: palette.primary, color: palette.primaryOn, border: "none" }),
        [`${pfx}.ac-pushButton:hover`]: {
            backgroundColor: palette.primaryPlus2,
            color: palette.primaryPlus2On,
        },
        [`${pfx}.ac-pushButton.style-destructive`]: {
            backgroundColor: palette.hazard,
            color: palette.hazardOn,
        },
        [`${pfx}.ac-pushButton.style-destructive:hover, ${pfx}.ac-pushButton.style-destructive:active`]: {
            backgroundColor: palette.hazardVar,
            color: palette.hazardVarOn,
        },
        [`${pfx}.ac-pushButton.style-positive`]: {
            backgroundColor: palette.ok,
            color: palette.okOn,
        },
        [`${pfx}.ac-pushButton.style-positive:hover, ${pfx}.ac-pushButton.style-positive:active`]: {
            backgroundColor: palette.okVar,
            color: palette.okVarOn,
        },
        [`${pfx}input, ${pfx}select, ${pfx}textarea`]: {
            borderRadius: spacing.small,
            borderColor: palette.neutralPlus3,
            borderStyle: "solid",
            borderWidth: 1,
            backgroundColor: palette.neutralEmpty,
            color: palette.neutralEmptyOn,
            [`${pfx}[aria-disabled="true"]`]: {
                backgroundColor: palette.neutralMinus4,
                borderColor: palette.neutralMinus2,
                color: palette.neutralPlus2,
            },
        },
        [`${pfx}.ac-pushButton[aria-disabled="true"]`]: {
            backgroundColor: palette.neutralMinus4,
            color: palette.neutralPlus2,
        },
    };
};
const createUseAdaptiveCardStyles = () => {
    const styles = (theme) => ({
        adaptiveCard: {
            "@global": adaptiveCardStyleSet(theme),
        },
    });
    return react_jss_1.createUseStyles(styles);
};
exports.createUseAdaptiveCardStyles = createUseAdaptiveCardStyles;
const createAdaptiveCardStyleSet = (theme) => ({
    "&.webchat__adaptive-card-renderer": adaptiveCardStyleSet(theme, true),
});
exports.createAdaptiveCardStyleSet = createAdaptiveCardStyleSet;


/***/ }),

/***/ "./src/styles/hooks/button.styles.ts":
/*!*******************************************!*\
  !*** ./src/styles/hooks/button.styles.ts ***!
  \*******************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useButtonStyles = void 0;
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
exports.useButtonStyles = react_jss_1.createUseStyles(({ palette, spacing, sizes, fonts }) => ({
    medium: {
        cursor: "pointer",
        display: "block",
        width: sizes.medium,
        flex: `0 0 ${sizes.medium}`,
        height: sizes.medium,
        boxSizing: "border-box",
        border: "0",
        padding: "0",
        borderRadius: spacing.small,
        transition: "background-color 300ms ease-in",
        backgroundColor: "rgba(0,0,0,0)",
        color: palette.neutralEmptyOn,
        fontSize: fonts.superLarge.fontSize,
        "&:focus": {
            outline: "none"
        },
        "&:hover": {
            color: palette.primary
        }
    },
    large: {
        cursor: "pointer",
        display: "block",
        width: sizes.large,
        flex: `0 0 ${sizes.large}`,
        height: sizes.large,
        boxSizing: "border-box",
        border: "0",
        padding: "0",
        borderRadius: spacing.small,
        transition: "background-color 300ms ease-in",
        backgroundColor: "rgba(0,0,0,0)",
        color: palette.neutralEmptyOn,
        fontSize: fonts.superLarge.fontSize,
        "&:focus": {
            outline: "none"
        },
        "&:hover": {
            color: palette.primary
        }
    }
}));


/***/ }),

/***/ "./src/styles/hooks/focus.styles.ts":
/*!******************************************!*\
  !*** ./src/styles/hooks/focus.styles.ts ***!
  \******************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useFocusStyles = void 0;
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
exports.useFocusStyles = react_jss_1.createUseStyles(({ palette, spacing }) => ({
    focus: ({ position } = { position: null }) => ({
        position: position ? position : "relative",
        ['&:focus-within']: {
            ["&:after"]: {
                content: '""',
                pointerEvents: "none",
                position: "absolute",
                inset: spacing.xSmall,
                borderRadius: spacing.small,
                outline: `${palette.neutralMinus5On} solid ${spacing.xSmall}`,
                border: `${palette.neutralEmpty} solid ${spacing.tiny}`,
                zIndex: 1
            }
        },
        ['&:focus']: {
            ["&:after"]: {
                content: '""',
                position: "absolute",
                inset: spacing.xSmall,
                borderRadius: spacing.small,
                outline: `${palette.neutralMinus5On} solid ${spacing.xSmall}`,
                border: `${palette.neutralEmpty} solid ${spacing.tiny}`,
                zIndex: 1
            }
        },
    })
}));


/***/ }),

/***/ "./src/styles/hooks/grid.styles.ts":
/*!*****************************************!*\
  !*** ./src/styles/hooks/grid.styles.ts ***!
  \*****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCreateGridStyles = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const styles_1 = __webpack_require__(/*! ./.. */ "./src/styles/index.ts");
const themes_1 = __webpack_require__(/*! ../themes */ "./src/styles/themes/index.ts");
const gridDefinition = {
    cols: {
        size: [
            { width: "100%", flex: "0 0 0" },
            { width: "100%", flex: "1 0 8.333333333333332%" },
            { width: "100%", flex: "1 0 16.666666666666664%" },
            { width: "100%", flex: "1 0 25%" },
            { width: "100%", flex: "1 0 33.33333333333333%" },
            { width: "100%", flex: "1 0 41.66666666666667%" },
            { width: "100%", flex: "1 0 50%" },
            { width: "100%", flex: "1 0 58.333333333333336%" },
            { width: "100%", flex: "1 0 66.66666666666666%" },
            { width: "100%", flex: "1 0 75%" },
            { width: "100%", flex: "1 0 83.33333333333334%" },
            { width: "100%", flex: "1 0 91.66666666666666%" },
            { width: "100%", flex: "1 0 100%" },
        ],
        space: [
            { marginLeft: "0" },
            { marginLeft: "8.333333333333332%" },
            { marginLeft: "16.666666666666664%" },
            { marginLeft: "25%" },
            { marginLeft: "33.33333333333333%" },
            { marginLeft: "41.66666666666667%" },
            { marginLeft: "50%" },
            { marginLeft: "58.333333333333336%" },
            { marginLeft: "66.66666666666666%" },
            { marginLeft: "75%" },
            { marginLeft: "83.33333333333334%" },
            { marginLeft: "91.66666666666666%" },
            { marginLeft: "100%" }
        ],
        min: [
            {
                minWidth: "0"
            },
            {
                minWidth: "8.333333333333332%"
            },
            {
                minWidth: "16.666666666666664%"
            },
            {
                minWidth: "25%"
            },
            {
                minWidth: "33.33333333333333%"
            },
            {
                minWidth: "41.66666666666667%"
            },
            {
                minWidth: "50%"
            },
            {
                minWidth: "58.333333333333336%"
            },
            {
                minWidth: "66.66666666666666%"
            },
            {
                minWidth: "75%"
            },
            {
                minWidth: "83.33333333333334%"
            },
            {
                minWidth: "91.66666666666666%"
            },
            {
                minWidth: "100%"
            },
        ],
        max: [
            {
                maxWidth: '0'
            },
            {
                maxWidth: '8.333333333333332%'
            },
            {
                maxWidth: '16.666666666666664%'
            },
            {
                maxWidth: '25%'
            },
            {
                maxWidth: '33.33333333333333%'
            },
            {
                maxWidth: '41.66666666666667%'
            },
            {
                maxWidth: '50%'
            },
            {
                maxWidth: '58.333333333333336%'
            },
            {
                maxWidth: '66.66666666666666%'
            },
            {
                maxWidth: '75%'
            },
            {
                maxWidth: '83.33333333333334%'
            },
            {
                maxWidth: '91.66666666666666%'
            },
            {
                maxWidth: '100%'
            },
        ],
        scroll: {
            overflowY: "overlay",
            maxHeight: "100%"
        },
        clip: {
            overflowX: "clip",
        },
        stretch: {
            flex: "1 1"
        },
        fill: {
            height: "100%"
        },
        wrap: {
            none: {
                flexWrap: "nowrap"
            },
            wrap: {
                flexWrap: "wrap"
            },
            wrapfill: {
                flexWrap: "wrap",
                maxWidth: "none"
            }
        }
    },
    rows: {
        size: [
            { height: "100%", flex: "0 0 0" },
            { height: "100%", flex: "1 0 8.333333333333332%" },
            { height: "100%", flex: "1 0 16.666666666666664%" },
            { height: "100%", flex: "1 0 25%" },
            { height: "100%", flex: "1 0 33.33333333333333%" },
            { height: "100%", flex: "1 0 41.66666666666667%" },
            { height: "100%", flex: "1 0 50%" },
            { height: "100%", flex: "1 0 58.333333333333336%" },
            { height: "100%", flex: "1 0 66.66666666666666%" },
            { height: "100%", flex: "1 0 75%" },
            { height: "100%", flex: "1 0 83.33333333333334%" },
            { height: "100%", flex: "1 0 91.66666666666666%" },
            { height: "100%", flex: "1 0 100%" },
        ],
        space: [
            { marginTop: "0" },
            { marginTop: "8.333333333333332%" },
            { marginTop: "16.666666666666664%" },
            { marginTop: "25%" },
            { marginTop: "33.33333333333333%" },
            { marginTop: "41.66666666666667%" },
            { marginTop: "50%" },
            { marginTop: "58.333333333333336%" },
            { marginTop: "66.66666666666666%" },
            { marginTop: "75%" },
            { marginTop: "83.33333333333334%" },
            { marginTop: "91.66666666666666%" },
            { marginTop: "100%" }
        ],
        min: [
            {
                minHeight: "0"
            },
            {
                minHeight: "8.333333333333332%"
            },
            {
                minHeight: "16.666666666666664%"
            },
            {
                minHeight: "25%"
            },
            {
                minHeight: "33.33333333333333%"
            },
            {
                minHeight: "41.66666666666667%"
            },
            {
                minHeight: "50%"
            },
            {
                minHeight: "58.333333333333336%"
            },
            {
                minHeight: "66.66666666666666%"
            },
            {
                minHeight: "75%"
            },
            {
                minHeight: "83.33333333333334%"
            },
            {
                minHeight: "91.66666666666666%"
            },
            {
                minHeight: "100%"
            },
        ],
        max: [
            {
                maxHeight: '0'
            },
            {
                maxHeight: '8.333333333333332%'
            },
            {
                maxHeight: '16.666666666666664%'
            },
            {
                maxHeight: '25%'
            },
            {
                maxHeight: '33.33333333333333%'
            },
            {
                maxHeight: '41.66666666666667%'
            },
            {
                maxHeight: '50%'
            },
            {
                maxHeight: '58.333333333333336%'
            },
            {
                maxHeight: '66.66666666666666%'
            },
            {
                maxHeight: '75%'
            },
            {
                maxHeight: '83.33333333333334%'
            },
            {
                maxHeight: '91.66666666666666%'
            },
            {
                maxHeight: '100%'
            },
        ],
        scroll: {
            overflowY: "overlay",
            maxHeight: "100%"
        },
        clip: {
            overflowY: "clip",
        },
        stretch: {
            flex: "1 1"
        },
        fill: {
            width: "100%",
        },
        wrap: {
            none: {
                flexWrap: "nowrap"
            },
            wrap: {
                flexWrap: "wrap"
            },
            wrapfill: {
                flexWrap: "wrap",
                maxHeight: "none"
            }
        }
    },
    order: [
        { order: "0" },
        { order: "1" },
        { order: "2" },
        { order: "3" },
        { order: "4" },
        { order: "5" },
        { order: "6" },
        { order: "7" },
        { order: "8" },
        { order: "9" },
        { order: "10" },
        { order: "11" },
        { order: "12" }
    ],
    align: {
        start: {
            alignContent: 'start'
        },
        end: {
            alignContent: 'end'
        }
    },
    visibility: {
        vanish: { display: "contents" },
        show: { display: "flex" },
        hide: { display: "none" },
    },
};
const buildStyles = (currentTheme) => {
    const { spacing } = currentTheme.hasOwnProperty('spacing')
        ? currentTheme
        : themes_1.baseTheme.definition;
    const styles = {
        grid: {
            boxSizing: "border-box",
            padding: "0",
            margin: "0",
            width: "100%",
            height: "100%",
            display: "flex",
            overflow: "hidden",
            flexDirection: "column",
            position: "relative",
            "&$overflow": {
                overflow: "visible",
            },
            "&$padR": {
                paddingRight: spacing.medium
            },
            "&$padB": {
                marginBottom: spacing.medium
            },
            "&$row": {
                flexDirection: "row",
                height: "100%",
            }
        },
        row: {
            boxSizing: "border-box",
            padding: "0",
            margin: "0",
            width: "100%",
            flex: "0 0",
            display: "flex",
            height: "auto",
            flexWrap: "wrap",
            "&$padT": {
                marginTop: spacing.medium
            },
            "&$padB": {
                marginBottom: spacing.medium
            }
        },
        col: {
            boxSizing: "border-box",
            margin: "0",
            padding: "0",
            display: "flex",
            flexDirection: "column",
            "&$padL": {
                paddingLeft: spacing.medium
            },
            "&$padR": {
                paddingRight: spacing.medium
            }
        },
        bpxs: {},
        bpsm: {},
        bpmd: {},
        bplg: {},
        bplgx: {},
        bpxl: {},
        bpxlx: {},
        bpxxl: {},
        bpxxxl: {},
        padT: {},
        padR: {},
        padB: {},
        padL: {},
        overflow: {},
    };
    styles_1.responsiveBreakPoints.forEach(({ name }, bpIdx) => {
        const applyItems = (itemDefs) => {
            const itemStyles = {};
            if (itemDefs) {
                itemDefs.size.forEach((item, idx) => {
                    itemStyles[`&$${name}${idx}`] = item;
                });
                itemDefs.space.forEach((item, idx) => {
                    itemStyles[`&$${name}space${idx}`] = item;
                });
                itemDefs.min.forEach((item, idx) => {
                    itemStyles[`&$${name}min${idx}`] = item;
                });
                itemDefs.max.forEach((item, idx) => {
                    itemStyles[`&$${name}max${idx}`] = item;
                });
                itemStyles[`&$${name}stretch`] = itemDefs.stretch;
                itemStyles[`&$${name}fill`] = itemDefs.fill;
                itemStyles[`&$${name}clip`] = itemDefs.clip;
                itemStyles[`&$${name}scroll`] = itemDefs.scroll;
                itemStyles[`&$${name}wrap`] = itemDefs.wrap.wrap;
                itemStyles[`&$${name}wrapfill`] = itemDefs.wrap.wrapfill;
                itemStyles[`&$${name}nowrap`] = itemDefs.wrap.none;
            }
            gridDefinition.order.forEach((item, idx) => {
                itemStyles[`&$${name}order${idx}`] = item;
            });
            itemStyles[`&$${name}start`] = gridDefinition.align.start;
            itemStyles[`&$${name}end`] = gridDefinition.align.end;
            itemStyles[`&$${name}show`] = gridDefinition.visibility.show;
            itemStyles[`&$${name}hide`] = gridDefinition.visibility.hide;
            itemStyles[`&$${name}vanish`] = gridDefinition.visibility.vanish;
            return itemStyles;
        };
        const idx = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
        idx.forEach(item => {
            styles[`${name}${item}`] = {};
            styles[`${name}space${item}`] = {};
            styles[`${name}min${item}`] = {};
            styles[`${name}max${item}`] = {};
            styles[`${name}order${item}`] = {};
        });
        styles[`${name}show`] = {};
        styles[`${name}hide`] = {};
        styles[`${name}vanish`] = {};
        styles[`${name}stretch`] = {};
        styles[`${name}fill`] = {};
        styles[`${name}clip`] = {};
        styles[`${name}scroll`] = {};
        styles[`${name}start`] = {};
        styles[`${name}end`] = {};
        styles[`${name}nowrap`] = {};
        styles[`${name}wrap`] = {};
        styles[`${name}wrapfill`] = {};
        styles[`bp${name}`]['& $col'] = applyItems(gridDefinition.cols);
        styles[`bp${name}`]['& $row'] = applyItems(gridDefinition.rows);
        styles[`bp${name}`]['& $grid'] = applyItems(gridDefinition.rows);
        return styles;
    });
    return styles;
};
const useCreateGridStyles = (name) => {
    const useStyles = react_1.useMemo(() => react_jss_1.createUseStyles(buildStyles, { name }), []);
    return useStyles();
};
exports.useCreateGridStyles = useCreateGridStyles;


/***/ }),

/***/ "./src/styles/hooks/index.ts":
/*!***********************************!*\
  !*** ./src/styles/hooks/index.ts ***!
  \***********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useFluentStylesWithProps = exports.useFluentStyles = exports.useThemeStyleProps = exports.useStyleProps = exports.useResponsiveProps = exports.createAdaptiveCardStyleSet = exports.createUseAdaptiveCardStyles = exports.useFocusStyles = exports.usePanelStyles = exports.useCreateGridStyles = exports.useButtonStyles = void 0;
var button_styles_1 = __webpack_require__(/*! ./button.styles */ "./src/styles/hooks/button.styles.ts");
Object.defineProperty(exports, "useButtonStyles", ({ enumerable: true, get: function () { return button_styles_1.useButtonStyles; } }));
var grid_styles_1 = __webpack_require__(/*! ./grid.styles */ "./src/styles/hooks/grid.styles.ts");
Object.defineProperty(exports, "useCreateGridStyles", ({ enumerable: true, get: function () { return grid_styles_1.useCreateGridStyles; } }));
var panel_styles_1 = __webpack_require__(/*! ./panel.styles */ "./src/styles/hooks/panel.styles.ts");
Object.defineProperty(exports, "usePanelStyles", ({ enumerable: true, get: function () { return panel_styles_1.usePanelStyles; } }));
var focus_styles_1 = __webpack_require__(/*! ./focus.styles */ "./src/styles/hooks/focus.styles.ts");
Object.defineProperty(exports, "useFocusStyles", ({ enumerable: true, get: function () { return focus_styles_1.useFocusStyles; } }));
var adaptive_card_styles_1 = __webpack_require__(/*! ./adaptive-card.styles */ "./src/styles/hooks/adaptive-card.styles.ts");
Object.defineProperty(exports, "createUseAdaptiveCardStyles", ({ enumerable: true, get: function () { return adaptive_card_styles_1.createUseAdaptiveCardStyles; } }));
Object.defineProperty(exports, "createAdaptiveCardStyleSet", ({ enumerable: true, get: function () { return adaptive_card_styles_1.createAdaptiveCardStyleSet; } }));
var use_responsive_props_hook_1 = __webpack_require__(/*! ./use-responsive-props.hook */ "./src/styles/hooks/use-responsive-props.hook.ts");
Object.defineProperty(exports, "useResponsiveProps", ({ enumerable: true, get: function () { return use_responsive_props_hook_1.useResponsiveProps; } }));
var use_style_props_hook_1 = __webpack_require__(/*! ./use-style-props.hook */ "./src/styles/hooks/use-style-props.hook.ts");
Object.defineProperty(exports, "useStyleProps", ({ enumerable: true, get: function () { return use_style_props_hook_1.useStyleProps; } }));
Object.defineProperty(exports, "useThemeStyleProps", ({ enumerable: true, get: function () { return use_style_props_hook_1.useThemeStyleProps; } }));
var use_fluent_styles_1 = __webpack_require__(/*! ./use-fluent-styles */ "./src/styles/hooks/use-fluent-styles.ts");
Object.defineProperty(exports, "useFluentStyles", ({ enumerable: true, get: function () { return use_fluent_styles_1.useFluentStyles; } }));
Object.defineProperty(exports, "useFluentStylesWithProps", ({ enumerable: true, get: function () { return use_fluent_styles_1.useFluentStylesWithProps; } }));


/***/ }),

/***/ "./src/styles/hooks/panel.styles.ts":
/*!******************************************!*\
  !*** ./src/styles/hooks/panel.styles.ts ***!
  \******************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.usePanelStyles = void 0;
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const panelStyles = ({ palette, fonts, type, spacing, sizes, }) => ({
    panel: Object.assign(Object.assign({ width: "100%", height: "100%", position: "relative", overflow: "hidden", overscrollBehavior: "auto" }, fonts.normal), { "& *": {
            overscrollBehavior: "auto",
        }, "& *::-webkit-scrollbar-track": {
            borderRadius: spacing.small,
            background: "transparent",
            border: "0",
        }, "& *::-webkit-scrollbar": {
            width: spacing.medium,
            height: spacing.medium,
            border: "0",
        }, "& *:hover::-webkit-scrollbar": {
            width: spacing.medium,
            height: spacing.medium,
        }, "& *::-webkit-scrollbar-thumb": {
            background: palette.neutral,
            borderRadius: spacing.xSmall,
            border: "0",
        } }),
    fill: {},
    body: {
        position: "relative",
        boxSizing: "border-box",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        "&$fill": {
            padding: "0",
        },
    },
    main: {
        flex: "1 1",
        margin: 0,
        height: "0px",
        overflowY: "overlay",
    },
    routes: {
        width: "100%",
        flex: "1 1 100%",
    },
    header: {
        position: "relative",
        boxSizing: "border-box",
        display: "flex",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundColor: palette.neutralEmpty,
        color: palette.neutralEmptyOn,
        borderBottom: `${spacing.xSmall} solid ${type == "dark" ? palette.neutralMinus5 : palette.neutralMinus3}`,
    },
    small: {},
    title: Object.assign(Object.assign({}, fonts.superLarge), { color: palette.primaryPlus1, margin: `${spacing.normal} ${spacing.medium} -${spacing.normal} ${spacing.medium}`, boxSizing: "border-box", lineHeight: sizes.normal, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", ["&$small"]: Object.assign(Object.assign({}, fonts.xLargePlus), { marginTop: spacing.smallPlus }) }),
    logo: {
        padding: `${spacing.smallPlus} 0 ${spacing.smallPlus} ${spacing.smallPlus}`,
        height: "100%",
    },
    description: Object.assign(Object.assign({}, fonts.normal), { margin: `${spacing.normal} ${spacing.medium} ${spacing.medium} ${spacing.medium}`, boxSizing: "border-box", lineHeight: sizes.small, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }),
});
exports.usePanelStyles = react_jss_1.createUseStyles(panelStyles);


/***/ }),

/***/ "./src/styles/hooks/use-fluent-styles.ts":
/*!***********************************************!*\
  !*** ./src/styles/hooks/use-fluent-styles.ts ***!
  \***********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useFluentStylesWithProps = exports.useFluentStyles = void 0;
const _styles_1 = __webpack_require__(/*! ./.. */ "./src/styles/index.ts");
const react_1 = __webpack_require__(/*! react */ "react");
const useFluentStyles = (styles, props) => react_1.useMemo(() => styles(props), [props]);
exports.useFluentStyles = useFluentStyles;
const useFluentStylesWithProps = (styles, config, responsive, level) => {
    const props = _styles_1.useThemeStyleProps(config, responsive, level);
    return react_1.useMemo(() => styles(props), [props]);
};
exports.useFluentStylesWithProps = useFluentStylesWithProps;


/***/ }),

/***/ "./src/styles/hooks/use-responsive-props.hook.ts":
/*!*******************************************************!*\
  !*** ./src/styles/hooks/use-responsive-props.hook.ts ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useResponsiveProps = void 0;
const _state_1 = __webpack_require__(/*! ../../state */ "./src/state/index.ts");
const helpers_1 = __webpack_require__(/*! ../helpers */ "./src/styles/helpers/index.ts");
const react_1 = __webpack_require__(/*! react */ "react");
const useResponsiveProps = (props, level) => {
    const context = _state_1.useBreakpoint();
    const breakpoint = level == 'root' ? context.root : context.current;
    return react_1.useMemo(() => helpers_1.reduceStyleProp(breakpoint, props), [breakpoint.name, props]);
};
exports.useResponsiveProps = useResponsiveProps;


/***/ }),

/***/ "./src/styles/hooks/use-style-props.hook.ts":
/*!**************************************************!*\
  !*** ./src/styles/hooks/use-style-props.hook.ts ***!
  \**************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useThemeStyleProps = exports.useStyleProps = void 0;
const _state_1 = __webpack_require__(/*! ../../state */ "./src/state/index.ts");
const helpers_1 = __webpack_require__(/*! ../helpers */ "./src/styles/helpers/index.ts");
const react_1 = __webpack_require__(/*! react */ "react");
const useStyleProps = (config, responsiveProps, level) => {
    const context = _state_1.useBreakpoint();
    const breakpoint = level == 'root' ? context.root : context.current;
    return react_1.useMemo(() => {
        const responsive = helpers_1.reduceStyleProp(breakpoint, responsiveProps);
        return {
            config,
            responsive,
            breakpoint
        };
    }, [breakpoint.name, config, responsiveProps]);
};
exports.useStyleProps = useStyleProps;
const useThemeStyleProps = (config, responsiveProps, level) => {
    const { definition: theme } = _state_1.useTheme();
    const context = _state_1.useBreakpoint();
    const breakpoint = level == 'root' ? context.root : context.current;
    return react_1.useMemo(() => {
        const responsive = helpers_1.reduceStyleProp(breakpoint, responsiveProps);
        return {
            theme,
            config,
            responsive,
            breakpoint
        };
    }, [breakpoint.name, config, responsiveProps, theme]);
};
exports.useThemeStyleProps = useThemeStyleProps;


/***/ }),

/***/ "./src/styles/index.ts":
/*!*****************************!*\
  !*** ./src/styles/index.ts ***!
  \*****************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.baseDockConfig = exports.baseWebChatStyles = exports.baseHostConfig = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
var base_host_config_const_1 = __webpack_require__(/*! ./base-host-config.const */ "./src/styles/base-host-config.const.ts");
Object.defineProperty(exports, "baseHostConfig", ({ enumerable: true, get: function () { return base_host_config_const_1.baseHostConfig; } }));
var base_webchat_styles_const_1 = __webpack_require__(/*! ./base-webchat-styles.const */ "./src/styles/base-webchat-styles.const.ts");
Object.defineProperty(exports, "baseWebChatStyles", ({ enumerable: true, get: function () { return base_webchat_styles_const_1.baseWebChatStyles; } }));
var base_dock_config_1 = __webpack_require__(/*! ./base-dock.config */ "./src/styles/base-dock.config.ts");
Object.defineProperty(exports, "baseDockConfig", ({ enumerable: true, get: function () { return base_dock_config_1.baseDockConfig; } }));
tslib_1.__exportStar(__webpack_require__(/*! ./hooks */ "./src/styles/hooks/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./themes */ "./src/styles/themes/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./helpers */ "./src/styles/helpers/index.ts"), exports);


/***/ }),

/***/ "./src/styles/themes/base.theme.ts":
/*!*****************************************!*\
  !*** ./src/styles/themes/base.theme.ts ***!
  \*****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.baseTheme = exports.baseFont = void 0;
const _models_1 = __webpack_require__(/*! ../../models */ "./src/models/index.ts");
exports.baseFont = {
    fontWeight: "400",
    fontStyle: "normal",
    fontFamily: '"Segoe UI", Tahoma, Geneva, Verdana, sans-serif',
};
exports.baseTheme = {
    $id: "base",
    $schema: _models_1.IThemeSchema,
    name: "Base Theme",
    description: "Applies default colour scheme to the SmartHub",
    definition: {
        type: "light",
        spacing: {
            large: "18px",
            medium: "12px",
            mediumPlus: "15px",
            mega: "48px",
            normal: "8px",
            small: "3px",
            smallPlus: "6px",
            superLarge: "36px",
            tiny: "1px",
            xLarge: "20px",
            xLargePlus: "22px",
            xSmall: "2px",
            xxLarge: "24px",
            xxLargePlus: "30px",
        },
        sizes: {
            large: "50px",
            medium: "40px",
            mediumPlus: "44px",
            mediumEm: "48px",
            mega: "100px",
            normal: "32px",
            normalPlus: "36px",
            small: "20px",
            smallPlus: "24px",
            superLarge: "62px",
            tiny: "12px",
            xLarge: "54px",
            xLargePlus: "60px",
            xSmall: "16px",
            xxLarge: "64px",
            xxLargePlus: "72px",
        },
        fonts: {
            normal: Object.assign(Object.assign({}, exports.baseFont), { fontStyle: "normal", fontWeight: "normal", fontSize: "14px" }),
            normalEm: Object.assign(Object.assign({}, exports.baseFont), { fontSize: "14px", fontStyle: "italic" }),
            normalPlus: Object.assign(Object.assign({}, exports.baseFont), { fontSize: "14px", fontWeight: "600" }),
            tiny: Object.assign(Object.assign({}, exports.baseFont), { fontSize: "10px" }),
            xSmall: Object.assign(Object.assign({}, exports.baseFont), { fontSize: "11px" }),
            small: Object.assign(Object.assign({}, exports.baseFont), { fontSize: "12px" }),
            smallPlus: Object.assign(Object.assign({}, exports.baseFont), { fontSize: "13px", fontWeight: "600" }),
            medium: Object.assign(Object.assign({}, exports.baseFont), { fontSize: "15px" }),
            mediumEm: Object.assign(Object.assign({}, exports.baseFont), { fontSize: "15px", fontStyle: "italic" }),
            mediumPlus: Object.assign(Object.assign({}, exports.baseFont), { fontSize: "15px", fontWeight: "600" }),
            large: Object.assign(Object.assign({}, exports.baseFont), { fontSize: "16px" }),
            xLarge: Object.assign(Object.assign({}, exports.baseFont), { fontSize: "18px" }),
            xLargePlus: Object.assign(Object.assign({}, exports.baseFont), { fontSize: "18px", fontWeight: "600" }),
            xxLarge: Object.assign(Object.assign({}, exports.baseFont), { fontSize: "20px" }),
            xxLargePlus: Object.assign(Object.assign({}, exports.baseFont), { fontSize: "20px", fontWeight: "600" }),
            superLarge: Object.assign(Object.assign({}, exports.baseFont), { fontWeight: 300, fontSize: "24px" }),
            mega: Object.assign(Object.assign({}, exports.baseFont), { fontSize: "30px", fontWeight: "600" }),
        },
        fluentMapping: {
            themeDarker: _models_1.PaletteKeys.primaryFull,
            themeDark: _models_1.PaletteKeys.primaryPlus2,
            themeDarkAlt: _models_1.PaletteKeys.primaryPlus1,
            themePrimary: _models_1.PaletteKeys.primary,
            themeSecondary: _models_1.PaletteKeys.primaryMinus1,
            themeTertiary: _models_1.PaletteKeys.primaryMinus2,
            themeLight: _models_1.PaletteKeys.primaryMinus3,
            themeLighter: _models_1.PaletteKeys.primaryMinus4,
            themeLighterAlt: _models_1.PaletteKeys.primaryEmpty,
            black: _models_1.PaletteKeys.neutralFull,
            neutralDark: _models_1.PaletteKeys.neutralPlus5,
            neutralPrimary: _models_1.PaletteKeys.neutralPlus4,
            neutralPrimaryAlt: _models_1.PaletteKeys.neutralPlus3,
            neutralSecondary: _models_1.PaletteKeys.neutralPlus2,
            neutralTertiary: _models_1.PaletteKeys.neutralPlus1,
            neutralTertiaryAlt: _models_1.PaletteKeys.neutral,
            neutralQuaternary: _models_1.PaletteKeys.neutralMinus1,
            neutralQuaternaryAlt: _models_1.PaletteKeys.neutralMinus2,
            neutralLight: _models_1.PaletteKeys.neutralMinus3,
            neutralLighter: _models_1.PaletteKeys.neutralMinus4,
            neutralLighterAlt: _models_1.PaletteKeys.neutralMinus5,
            white: _models_1.PaletteKeys.neutralEmpty,
        },
        acMapping: {
            separator: {
                lineColor: _models_1.PaletteKeys.neutralEmptyOn,
            },
            containerStyles: {
                accent: {
                    backgroundColor: _models_1.PaletteKeys.primary,
                    foregroundColors: {
                        accent: {
                            default: _models_1.PaletteKeys.primaryOn,
                            subtle: _models_1.PaletteKeys.primaryFullOn,
                        },
                        default: {
                            default: _models_1.PaletteKeys.primaryOn,
                            subtle: _models_1.PaletteKeys.primaryFullOn,
                        },
                        dark: {
                            default: _models_1.PaletteKeys.neutralMinus5On,
                            subtle: _models_1.PaletteKeys.neutralEmptyOn,
                        },
                        light: {
                            default: _models_1.PaletteKeys.neutralPlus5On,
                            subtle: _models_1.PaletteKeys.neutralFullOn,
                        },
                        emphasis: {
                            default: _models_1.PaletteKeys.primaryOn,
                            subtle: _models_1.PaletteKeys.primaryFullOn,
                        },
                        good: {
                            default: _models_1.PaletteKeys.primaryOn,
                            subtle: _models_1.PaletteKeys.primaryFullOn,
                        },
                        attention: {
                            default: _models_1.PaletteKeys.primaryOn,
                            subtle: _models_1.PaletteKeys.primaryFullOn,
                        },
                        warning: {
                            default: _models_1.PaletteKeys.primaryOn,
                            subtle: _models_1.PaletteKeys.primaryFullOn,
                        },
                    },
                },
                attention: {
                    backgroundColor: _models_1.PaletteKeys.hazard,
                    foregroundColors: {
                        accent: {
                            default: _models_1.PaletteKeys.hazardOn,
                            subtle: _models_1.PaletteKeys.hazardOn,
                        },
                        default: {
                            default: _models_1.PaletteKeys.hazardOn,
                            subtle: _models_1.PaletteKeys.hazardOn,
                        },
                        dark: {
                            default: _models_1.PaletteKeys.neutralMinus5On,
                            subtle: _models_1.PaletteKeys.neutralEmptyOn,
                        },
                        light: {
                            default: _models_1.PaletteKeys.neutralPlus5On,
                            subtle: _models_1.PaletteKeys.neutralFullOn,
                        },
                        emphasis: {
                            default: _models_1.PaletteKeys.hazardOn,
                            subtle: _models_1.PaletteKeys.hazardOn,
                        },
                        good: {
                            default: _models_1.PaletteKeys.hazardOn,
                            subtle: _models_1.PaletteKeys.hazardOn,
                        },
                        attention: {
                            default: _models_1.PaletteKeys.hazardOn,
                            subtle: _models_1.PaletteKeys.hazardOn,
                        },
                        warning: {
                            default: _models_1.PaletteKeys.hazardOn,
                            subtle: _models_1.PaletteKeys.hazardOn,
                        },
                    },
                },
                warning: {
                    backgroundColor: _models_1.PaletteKeys.warn,
                    foregroundColors: {
                        accent: {
                            default: _models_1.PaletteKeys.warnOn,
                            subtle: _models_1.PaletteKeys.warnOn,
                        },
                        default: {
                            default: _models_1.PaletteKeys.warnOn,
                            subtle: _models_1.PaletteKeys.warnOn,
                        },
                        dark: {
                            default: _models_1.PaletteKeys.neutralMinus5On,
                            subtle: _models_1.PaletteKeys.neutralEmptyOn,
                        },
                        light: {
                            default: _models_1.PaletteKeys.neutralPlus5On,
                            subtle: _models_1.PaletteKeys.neutralFullOn,
                        },
                        emphasis: {
                            default: _models_1.PaletteKeys.warnOn,
                            subtle: _models_1.PaletteKeys.warnOn,
                        },
                        good: {
                            default: _models_1.PaletteKeys.warnOn,
                            subtle: _models_1.PaletteKeys.warnOn,
                        },
                        attention: {
                            default: _models_1.PaletteKeys.warnOn,
                            subtle: _models_1.PaletteKeys.warnOn,
                        },
                        warning: {
                            default: _models_1.PaletteKeys.warnOn,
                            subtle: _models_1.PaletteKeys.warnOn,
                        },
                    },
                },
                good: {
                    backgroundColor: _models_1.PaletteKeys.success,
                    foregroundColors: {
                        accent: {
                            default: _models_1.PaletteKeys.successOn,
                            subtle: _models_1.PaletteKeys.successOn,
                        },
                        default: {
                            default: _models_1.PaletteKeys.successOn,
                            subtle: _models_1.PaletteKeys.successOn,
                        },
                        dark: {
                            default: _models_1.PaletteKeys.neutralMinus5On,
                            subtle: _models_1.PaletteKeys.neutralEmptyOn,
                        },
                        light: {
                            default: _models_1.PaletteKeys.neutralPlus5On,
                            subtle: _models_1.PaletteKeys.neutralFullOn,
                        },
                        emphasis: {
                            default: _models_1.PaletteKeys.successOn,
                            subtle: _models_1.PaletteKeys.successOn,
                        },
                        good: {
                            default: _models_1.PaletteKeys.successOn,
                            subtle: _models_1.PaletteKeys.successOn,
                        },
                        attention: {
                            default: _models_1.PaletteKeys.successOn,
                            subtle: _models_1.PaletteKeys.successOn,
                        },
                        warning: {
                            default: _models_1.PaletteKeys.successOn,
                            subtle: _models_1.PaletteKeys.successOn,
                        },
                    },
                },
                emphasis: {
                    backgroundColor: _models_1.PaletteKeys.neutralMinus4,
                    foregroundColors: {
                        accent: {
                            default: _models_1.PaletteKeys.primaryPlus2,
                            subtle: _models_1.PaletteKeys.primary,
                        },
                        default: {
                            default: _models_1.PaletteKeys.neutralMinus3On,
                            subtle: _models_1.PaletteKeys.neutralMinus4On,
                        },
                        dark: {
                            default: _models_1.PaletteKeys.neutralMinus5On,
                            subtle: _models_1.PaletteKeys.neutralEmptyOn,
                        },
                        light: {
                            default: _models_1.PaletteKeys.neutralPlus5On,
                            subtle: _models_1.PaletteKeys.neutralFullOn,
                        },
                        emphasis: {
                            default: _models_1.PaletteKeys.neutralEmptyOn,
                            subtle: _models_1.PaletteKeys.neutralEmptyOn,
                        },
                        good: {
                            default: _models_1.PaletteKeys.successPlus1,
                            subtle: _models_1.PaletteKeys.success,
                        },
                        attention: {
                            default: _models_1.PaletteKeys.hazardPlus1,
                            subtle: _models_1.PaletteKeys.hazard,
                        },
                        warning: {
                            default: _models_1.PaletteKeys.warnPlus1,
                            subtle: _models_1.PaletteKeys.hazard,
                        },
                    },
                },
                default: {
                    backgroundColor: _models_1.PaletteKeys.neutralEmpty,
                    foregroundColors: {
                        accent: {
                            default: _models_1.PaletteKeys.primaryPlus2,
                            subtle: _models_1.PaletteKeys.primary,
                        },
                        default: {
                            default: _models_1.PaletteKeys.neutralMinus5On,
                            subtle: _models_1.PaletteKeys.neutralEmptyOn,
                        },
                        dark: {
                            default: _models_1.PaletteKeys.neutralMinus5On,
                            subtle: _models_1.PaletteKeys.neutralEmptyOn,
                        },
                        light: {
                            default: _models_1.PaletteKeys.neutralPlus5On,
                            subtle: _models_1.PaletteKeys.neutralFullOn,
                        },
                        emphasis: {
                            default: _models_1.PaletteKeys.neutralEmptyOn,
                            subtle: _models_1.PaletteKeys.neutralEmptyOn,
                        },
                        good: {
                            default: _models_1.PaletteKeys.successPlus1,
                            subtle: _models_1.PaletteKeys.success,
                        },
                        attention: {
                            default: _models_1.PaletteKeys.hazardPlus1,
                            subtle: _models_1.PaletteKeys.hazard,
                        },
                        warning: {
                            default: _models_1.PaletteKeys.warnPlus1,
                            subtle: _models_1.PaletteKeys.hazard,
                        },
                    },
                },
                dark: {
                    backgroundColor: _models_1.PaletteKeys.neutralEmpty,
                    foregroundColors: {
                        accent: {
                            default: _models_1.PaletteKeys.primaryPlus2,
                            subtle: _models_1.PaletteKeys.primary,
                        },
                        default: {
                            default: _models_1.PaletteKeys.neutralMinus5On,
                            subtle: _models_1.PaletteKeys.neutralEmptyOn,
                        },
                        dark: {
                            default: _models_1.PaletteKeys.neutralMinus5On,
                            subtle: _models_1.PaletteKeys.neutralEmptyOn,
                        },
                        light: {
                            default: _models_1.PaletteKeys.neutralPlus5On,
                            subtle: _models_1.PaletteKeys.neutralFullOn,
                        },
                        emphasis: {
                            default: _models_1.PaletteKeys.neutralEmptyOn,
                            subtle: _models_1.PaletteKeys.neutralEmptyOn,
                        },
                        good: {
                            default: _models_1.PaletteKeys.successPlus1,
                            subtle: _models_1.PaletteKeys.success,
                        },
                        attention: {
                            default: _models_1.PaletteKeys.hazardPlus1,
                            subtle: _models_1.PaletteKeys.hazard,
                        },
                        warning: {
                            default: _models_1.PaletteKeys.warnPlus1,
                            subtle: _models_1.PaletteKeys.hazard,
                        },
                    },
                },
                light: {
                    backgroundColor: _models_1.PaletteKeys.neutralEmpty,
                    foregroundColors: {
                        accent: {
                            default: _models_1.PaletteKeys.primaryPlus2,
                            subtle: _models_1.PaletteKeys.primary,
                        },
                        default: {
                            default: _models_1.PaletteKeys.neutralMinus5On,
                            subtle: _models_1.PaletteKeys.neutralEmptyOn,
                        },
                        dark: {
                            default: _models_1.PaletteKeys.neutralMinus5On,
                            subtle: _models_1.PaletteKeys.neutralEmptyOn,
                        },
                        light: {
                            default: _models_1.PaletteKeys.neutralPlus5On,
                            subtle: _models_1.PaletteKeys.neutralFullOn,
                        },
                        emphasis: {
                            default: _models_1.PaletteKeys.neutralEmptyOn,
                            subtle: _models_1.PaletteKeys.neutralEmptyOn,
                        },
                        good: {
                            default: _models_1.PaletteKeys.successPlus1,
                            subtle: _models_1.PaletteKeys.success,
                        },
                        attention: {
                            default: _models_1.PaletteKeys.hazardPlus1,
                            subtle: _models_1.PaletteKeys.hazard,
                        },
                        warning: {
                            default: _models_1.PaletteKeys.warnPlus1,
                            subtle: _models_1.PaletteKeys.hazard,
                        },
                    },
                },
            },
        },
        webChatMapping: {
            palette: {
                accent: _models_1.PaletteKeys.primary,
                activeActivityOutlineColor: _models_1.PaletteKeys.neutralMinus3,
                cardEmphasisBackgroundColor: _models_1.PaletteKeys.primaryMinus4,
                backgroundColor: _models_1.PaletteKeys.neutralMinus3,
                subtle: _models_1.PaletteKeys.primaryMinus2,
                bubbleBackground: _models_1.PaletteKeys.neutralEmpty,
                bubbleBorderColor: _models_1.PaletteKeys.neutralEmpty,
                bubbleFromUserBackground: _models_1.PaletteKeys.primary,
                bubbleFromUserBorderColor: _models_1.PaletteKeys.primary,
                bubbleFromUserTextColor: _models_1.PaletteKeys.primaryOn,
                bubbleTextColor: _models_1.PaletteKeys.neutralEmptyOn,
                transcriptActivityVisualKeyboardIndicatorColor: _models_1.PaletteKeys.neutralEmptyOn,
                timestampColor: _models_1.PaletteKeys.neutralEmptyOn,
                botAvatarBackgroundColor: _models_1.PaletteKeys.clear,
            },
            images: {
                botAvatarImage: _models_1.ImageKeys.botAvatar,
            },
            sizes: {},
            spacing: {},
        },
        palette: {
            clear: "rgba(0,0,0,0)",
            warnPlus2: "#c27400",
            warnPlus2On: "#fff",
            warnPlus1: "#e68a00",
            warnPlus1On: "#fff",
            warn: "#FF9900",
            warnOn: "#fff",
            warnMinus1: "#ffc266",
            warnMinus1On: "#000",
            warnMinus2: "#ffe0b3",
            warnMinus2On: "#000",
            successPlus2: "#005e23",
            successPlus2On: "#fff",
            successPlus1: "#00802f",
            successPlus1On: "#fff",
            success: "#00a83d",
            successOn: "#fff",
            successMinus1: "#51cb7e",
            successMinus1On: "#fff",
            successMinus2: "#a0e5b9",
            successMinus2On: "#000",
            hazardPlus2: "#862b43",
            hazardPlus2On: "#fff",
            hazardPlus1: "#9e334f",
            hazardPlus1On: "#fff",
            hazard: "#b03959",
            hazardOn: "#fff",
            hazardMinus1: "#d07b91",
            hazardMinus1On: "#fff",
            hazardMinus2: "#e7b8c5",
            hazardMinus2On: "#000",
            notifyPlus2: "#26706f",
            notifyPlus2On: "#fff",
            notifyPlus1: "#2d8584",
            notifyPlus1On: "#fff",
            notify: "#339594",
            notifyOn: "#fff",
            notifyMinus1: "#43a19f",
            notifyMinus1On: "#fff",
            notifyMinus2: "#73bfbd",
            notifyMinus2On: "#fff",
        },
        icon: {},
        image: {
            launchButtonLeft: "data:image/png;base64,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",
            launchButtonRight: "data:image/png;base64,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",
            chatHead: "data:image/png;base64,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",
            botAvatar: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAjCAYAAACD1LrRAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAABFcAAARXAf1SabcAAAAYdEVYdFNvZnR3YXJlAHBhaW50Lm5ldCA0LjEuMWMqnEsAAAKASURBVFhHxZVLa1NRFIVbEB34LxQVxIkd2IEKiqCtjzSPmgeCmYsPEOorEFCsoJMEBcGhgtI/oG0MagwE0WBA6gMzU1KIYB6Dpgkkuce1z91X7yFHNG1yuuAb3LX3WSunNyUjQoh1QWuaQGuaQGuaYNWq1+uXCH40p2q1egIc50dzQukxgh/NqVKpTKD4KD8OV/hSbKjVajfAN2ABAb6TRzNeW5sQtAOcB3fBA6Lb7T5pt9tZHTRz9vjMObCd4/4tLFPhAhiUnoFtHK8XFg6COm0PWDVwgGtUYUA3HUapIyrvvTnM53LMarVaXxKJRD4SiSx7vV7RD+FweDmZTL5DxleOczTPdbZg7LJ9W41GYzEYDK7oQvshFAo1ms3mR451tFOWlsvlzfhG3mJTKhaLfXIHTAWmxcSFq8ITiijBbjzBiNyZmj6p+PF4fJFjpdA1S50j+B981el0suwLy7Iq7oPEvkcvxO73K2J8oaj4bsaffpY7ex+/Vnyfz4dIq8rxgrrQ+ZKKf2CQY58GS+6DhBM69rYuvP6AMpP4fGLsTUXu7Jnv/XC45RLH08Vy6CzTr8whDObYJ3Wi0ahy68kzF8X+h2lx+PJNJdDNkZnrcmfy7IziI+snMrt2tLzYHHXK94xnj23byufzGffhtVAoFDIc6+jPLxoeNoHffw6om0qlMn6/v6ML+x8CgUA7nU5TqWVHSpXARq61BeO0HLlE77tUKuWKxWK2H+iM+726dIrrVGFw354PRfe4plcYjoJroEWbAxJlXQGjXPN3YWkruAM+gNV8CDpDZ2+DLRyrCoN1QWuaQGuaQGuaQGuaQGuaQGuaQGuaQGuaQGsOHzHyC5M/O704HE0hAAAAAElFTkSuQmCC",
            chatPoweredBy: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABBoAAAGDCAMAAACyU4NBAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAGhUExURQAAACCfn0BAQDCfr0BAQCufqkBAQCifp0BAQC2fpkBAQCufqkBAQEBAQCyfp0BAQCucqkBAQCmcqUBAQCucqEBAQCudp0BAQCuXoj1HR0BAQCqYpEBAQCyapT5GRkBAQCyWoD1MTiuapTF7hDtSVCyXoUBAQDtRUkBAQC2Yoz5LTTxQUkBAQC6TnjpVVztaWyybpS6WoEBAQD1PUS2XoTpTVEBAQDhmaS2SmzpcX0BAQDlkZ0BAQDRyeC6WoDpZXC2TnTleYC6SnDliZEBAQC2Vnzhkai6UnkBAQC6VnjpfYkBAQC6TnDdlai6VnUBAQDdrcC2WoDhjaC2Wny2UnjdqbkBAQDVscjhmajZobS2YokBAQC2XoTZnbC2VnzZucyyXoi6Ol0BAQDGEjCyYoy2ZpDZscS2Yoi+MlDVyeUBAQDCMlDCOlyyZpDZxeDR0eiubpTZxd0BAQCuapTN2fCycqDR2fCycpzJ+hjN7gyyZoy6TnSueqSyYoiybpi2Vny6SnC+MlTCHjzCJkjJ+hTKBiDN7gjZvdThjZz9DQ0BAQLMGn30AAAB8dFJOUwAICBAQGBggICgoMDA4QEBISFBQWFhgYGVlaG1wdHR4eXl8fH2AgIWHiIiMj5CQlJaWl5qdnZ+gpKSnq6+wsbG0tLe3t7q6vb/Dw8fIyM7P0tPT1dfX19na3N7f4eHk5Ofn5+ns7e3v7+/v8fHz8/T39/f4+Pv7/Pz8/v52NGmgAAAACXBIWXMAABcRAAAXEQHKJvM/AAAlkElEQVR4Xu3d+YPb2lnG8el0mIY0qRvCJRCmhNWEErYAFxoCBTrAlABha1gGKAz7sHYKtMC9be8tZfFfjSy9trU873uOZNluou/nl5trHXtmrKNHZ5N0BAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADmK+WLk6PTo6X1yf36k2HD+9WpwfV/8GMDUXFgyF2dHd5X9eVhseVy8BmKSHFxcX10UeXFycnxzNFosby4Pj4h9EAzBpRcuhyoAiGp4tFm8v//lgsVi/DGCS6tEwf7G4Xo4wvFhczt/AaDiZzc7m8+dFU6nwbD6f379lW/CmOpk9fFzt8IuLt+fzB7MZ+zxXIxrOFou3jo5uF/9646Lh3uOXy15Sy83F4wc29Io3zd35Rdkzbnn15D4j7Dka0XC6WJyXg5C33qhouP2o+Ct9rx6lzyRvW9kEG8aNhb/M2txKR37+Hdd/n1iZyEf/7H3P/9qvUXNZnHnPl2feU3u7UNSi0VzYZw5x/OD5tX2Mcn6WPiEEuzysL5t5v46cQ6qcDnCofbq7b7wRDUfni5vTo6uiyBsUDXee2x8eOH+QOJFkRsMi43xUDfIm5UTDP1sOCF9+YGUi32KFhf+xX0O7mDu14+sjGm4/jXKhcnnfCnsOFA3B2xdqn+4rGh4sFmf3lr/CGxMNOcGwdP0oPKpzoyHjS8vclxnR8BE7jKVPWqHI4GgoXD25bZ9S9/UQDbMX9gEJL+OddaBoUP3elXKSoGVf0VCc0V48W9wcvynRkBsMS+FpJDcaMg7o6LRQk/FJP2aHsfQ5KxTZJhoKz7vhcPhouNVjl6+W+EmHiYZbVlS6tkJ1+4qGo2fL1Q1FOL0Z0ZB5FK6cq/NgJTcazq18IDot1GREw5/aYSy9f9dKBbaMhsXiabv3e+hoOH6c111beeaPmxwmGh5aUU3s071FQ9GbKF94E6LhpMf5wzyyt3bkRoPK9aYTK5mSjoYP2VHs+LgVC2wdDYurt+yjzIGj4XZm7m5cug2Hw0TDuRXVRKXYWzQcXxXfVvF/b0A03H5lf3AfT+3NbbnRsEiOfN+3ginpaPiYHcWO37dige2joWgnNRoOh42Gt9Kjjx3XXuvqINGQGKN+YcVq9hANd6va+LT6z+sfDfcHVJOCc1VZdjQ8tDe4nljBlHQ0/JYdxY6M6csxomHxqn6gHDQairo7wM09e3vLQaIhdeLo7tPdfeO3ZqvUnM2WP/d4NlseHCez1zwZgh0Ueyl7n9nRoAaRG3KbvMlo+OAX7Ch2ZExfjhINjfPuIaMhex+16S/qINGQ+hu6v+ph22mvoXg0J3SpzrbZ1W7ZG4vkDjWko+Gb7SB2pacvx4mGxc0mGw5XUY/7jyytySGmg0RD0Z8Pdc88REM/s37j1E1qliH/jBQsFVzKHWpIR0OwFLKSnr4cKRoW1+tj5WAV9Tgev0toDaaWDhEN0VLIUneYm2jo5dawcYYVcVTmR0NikV12fzgZDcFSyEp6+nKsaNi0tA5WUfN3kHItAv0Q0ZDuBnf2KdHQx/GQuYm67uGdX/Oe2Dscl1YsKRUN4VLISnL6crRoWLe0DlVRt+hAlsTPOkQ0pAeiOtWCaOhji15nZdNAXsmPBjG/VBMudmtIRUO4FLKSnL4cLxpW42MHqqh3t+lAlrrDDQeIhoza0aleREMPZ/aHbqGzA/Kj4Sa8FuOBlUpLRUO4FLKSnL4cMRqsSX6YinqS3RZz3XQWpBwgGnLaPu19SjTkW67a2lq7S5EfDfH+z/+cRDQklkKWktOXI0bD4nn5iYepqM/sHdt41Y70A0RDzlBqe58SDflGaDR0b7zQIxrcxdZL+ae3RDQklkJWUtOXY0ZDtQ70IBW1XN2/tfYg0f6jIety/fb0JdGQ7XSMRsNicWYfZ3pEQ3X61PKHGlLRkFgKWUlNX44aDeXffYiKerx9d2LppjVLsf9oyJrYbk9fEg3ZchciJ1w125c9oiG6wip/qCERDamlkJXU9OWo0VA2Gw5RUctHI4wg/2ywo2jIq2StfUo05DrdeqzaNCtKj2hY+Jd29+kUx9GQXApZSUxfRtHworrXailvMnh5adoBKuqdsfZ4/tlgR9GQ195tVQyiIVei0XB+Vh64J7Oz8N6Bhavy41Z0PdHT0MHgX/dnuo3hOBqSSyErienLKBra1f/uo9Qg2fJu5AeoqMmp6usnD5aXB92dnSUirjn2vPdoSC6FrLRmz4iGXGG/8+36Pj0+i/uojf2o64nOIf8KqztWYuPGbUfE0ZBcCllJTF/2iYalR/EJ+q1DVNTud9p0dVb7Du6Ei1GbY897j4bgjQ3NfUo0ZIrG+a47eybspTZu3aDryVv23yb/ttLdyZMLtwKG0ZCxFLKUmL7sGw1Hd8Pz7nlx7FkXpMOKCNdWoiOxrtQkGg3tnL4XNRYb3fi9R0PuNbnNfbr/b/w1FSwauRI7dBZUlEbXU9eT2/os6p6qu9V4PiwaMpZCVuLpy97RcHQc3ZI1Wu1lRYTtTlWJRkN3Jvk0OAIbk0v7jobs2avkdf8VKy282f0Gj38O6S53W7oTZEP9Fh+6ntzSB4p7hVX3h82GRUPGUshKPH3ZPxriK9eCqm8lhO0qaji2dKOuqDwN+pH1+ct9R0P2ZSDpmwyWrLQwzWjwK25ramolGN+up7MTDbpiPrY3tYmhhuNB0ZCzFLIST18OiIZw8j34na2EsFVFjZe+6n0eXHBRb6vvOxryrypPTEkbKyxMMhr8MZnOOtgVf6lBvXnpRIM+TryvXgw1+BUwigaxFPLv7L9t4fTlkGiIDpmgzlkJYauKqkd7jPfJ/i5Pnw1Ku4gGsRTyhZNhYYNyzQoLk4wGf7f492zUcwRXjxv734kG3T/0+tzdkaH5sGgQSyF/yv7bFk5fDoqGoHd/Y0UEKyFsVVGjU+2Ve1cdd7ihfo+uPUeDOMvMnaHE+OLeFSssTDIa/N3pVpOjE9Emfda+lagTDc5cqb6ttDgvzAZFg1gK+ZXZX9u/WsLpy0HREI2k+2+yAsI2FfXUPkNSAw0Vv1NU23N7jgbx42beR8VT0sbKCpOMBvckEt2ysd3Of/WwmyNeNOhhT93H7fZ2iubFkGgQSyG/dvyL9q+WcPpyWDQE1685N2cuWAFhm4r6yD5D8eeQg3Sr7bk9R4M4QR17/eN4StpYWWGS0eDu8qieNIayrp/KQR4vGvRhoq+w6taZomU4JBrEUsjPHn2r/avtF+xNyrBoOPGH8Zyx3oIVELapqMHkfXgnPneIorbn9hsNYinkS/dSzKzpSysrTDIa3HmpsHu2Ob4vvCdme9GgF7c2F1mvdOvxk2HRIJZCfsKdtYimL4dFQ9Cj8J7w07einswczetTottzh7f2dtOtNjG432gQ7ypqhxN9WdOXVlaYZDTY394VVhS7JKs18tjgRYOT6+qDRNHixDYgGsRSyHeLT3IGG74aTHUNjAZ/8Yh/OrMCgqqo7kxT8wdEF7J6M8gVt+e5GWzYbzSIuC32qfdZOdOXVlSYYjQEZ5FgoV5VUTojjw1eNDi5rjqDorqfDIoGsRTya8UnOYMN0fTlwGjwL0TwnwZsBYQtoiG6kDU+etz1RZsu0V6jQU11FfvU+x6CJuWaFRWmGA237W8X/OHqwltq5LHBjQa96EktRu9WmeUAyIBoEEsh/7Z42Rts+IPqXcrAaPAH//xKZwWE4dFwHKzMTLS53VXJz6zAnqNBRNWyoesNNuRMX1pRYYrR4NYob2QwmxsNeh5MjXp2m4zLAOkfDWpQ4VPO60vB9OXAaPDXGe03GqLrJ1L72xsv2Rx0e40G0cEp/1RvnDVj+tJKClOMhuiK96Cfl8GNBmdmvbvrRGdnOYbePxrEUsgvfdtygzPY8K4/1TUwGvwE3m80BLOowVxJxeuLbEaQ9xkNqnVQ7jbvwzKmL62kMMVoiC5ee5URtD43GpxJke7AhWheLH+j/tEglkK+X9ZVb7DBn74cGA3+iqH9RkNw8DqrzjbcTtG6muwzGtQ3Wv4Q74tofA+alRSIhpaX22SDHw369NM9sLuDEmWvo3c0qLtC/lO55dvt/9r86cuB0eBPDOw3GqKbR4TDzgU33taZss9oED+rar54gw0Z05dWUphiNARfR+Fl3hVrkh8NulXb/fb1UEP/aFB3hfz1csuH7f/a/OnLgdHgN+Q3g3htVkAYHA3RqoZXVsbljlivV0rtMxrEUkgbLPEGG9J12QoKk4yG6GYChcepc4nLjwY9FtZJdWeooX80qLtCfle1ybsrnDt9OTAa/Jtj+e1cKyAMjga3UCE96uycjjeDFHuMBjVGZr+H92luf3PNCgqTjAYvY1cus1afC340OE2+dl9XNGDL+dLe0SCO//fsh33a/r/Nnb4cGA1fJ0ueolHIeMHTkrdwdj3vvMdoUG+xfep9E+npSysoTDIawnv+lAaGgx8NThy1R8i7y4SqBZp9o0HdFfJfbJv3RCt3+nJgNPhtM//JXVZAGBwN0c5O72XvTnbr9sYeo0HMpK6and5gQ3r60soJk4yG8M4e5vLhgG5FEA26hrZ73d2TVFXL+0aDuivkb9o2b7DBnb4cFg3BYO+6o95hBYTB0RDdq8Ht1a95Dcz1kpT9RYP6QtfrSr3fMxl+Vk6YZDQEyyFrrp+E+1YJokGPdbcu2hB7v9q3faNB3RXyh22bO9jgTV8Oi4agIe8/nccKCIOjIZqgSO9g74tf345mf9GgVm2vd7/3cfVvQrJywiSjwb/0siW+YqIriAZnoLxZfcR8X1WgZzSoJY9fWdc4b7DBm74cFg3eQsKClRCsgDA4GuwlyYoEOo29y4uL8/l8foAZCtX8WRf1vork9KWVE6YZDfnPP7x8lLhsoiGIBieOmm3r7vutWdEzGtRwwr+vO0jeYIM3fTkoGoLlycGUoZUQhkZD1EIML7StLI/gi4uLp/P52Ww2E33MvUWDGk7Y3EPQHWxITV9aMWGa0ZD5cLBKj6ZDFA16W/MKK2+ooW80qAdk/55t8wcbvOnLQdEQdPGDRq6VEIZGg1umkFzWkGFv0aB6pLUvxWukOT3ONSsmTDMasnsUlcvgFg0NUTTovvd6OGvJHWroGQ3yAdmfsI2Fz9tLbc705ZBoiB6XEFzeaiWEodEQ3axhjMq/t2hQP6h2YvEmYlLTl1ZMmGg0RJPd0nl4ufZKFA1OC7veRnWHGnpGg1oKubyNy8qv2WttzvTlgGgIn0sdTKhZCWFoNER7esvrbEtBNNSfIt4RnJx0NKhHadT2qbukOzF9aaWEiUZD/MwS6bL+wFRHFA3Owrp6PeheaLHqDfeLBrUUcnkbl5XvtNfa3tX51z8awkdGRucxKyIMjYbg7Bz1bLIF0TCUjAbZB67tU3c9eOKcZqWEiUZD/2ZD4fqpc45cC6NBTz3Xj+3uAbWqvP2iQc1Ofta2LbmDDXr6sm80HEd3cHZ+ZWNFhKHREB260W+Sa1/RoCKu0Rv1BhsS+WelhKlGw4Bmw1Lj+fpdYTToaZFao1Z0OVarJXtFg3xA9s/YxpI32PCPtr2pXzQcn8Vf7U005WNlhKHR4C/Xfr2iQR35jTFsb7BB35x4zUoJU42GrBWRShgOYTTo3mBt4lm0ZFbXWPSKhp+w47auuo3LijfY8NX2NR2l7Gg4ns0epa5PiTv4VkYYGg3R7+Mv2M63p2iQa0sbSx3dwQa5T9eskDDZaAhvJhp64o85hNHg9AY3e657glvnRq9o+As7buuq27iseIMNevoyigb7NXoIa6qVEYZGQzQXlVxFnGFP0SBnfBr71B1siNtGVkiYbjScDutSFK7dJ2OG0eDU0s2HdYca0hfxiP3+jXbYNizvGLshuxxLn7ECDaNGQzyZZoWEiUeDWibSWrHlDTbEh7gVEqYbDUf37CsY4IXTX46jQW9dV+NgqKFXNHy3HbYNv2wbKx/4V3u5TU5fjhoN8eo8KyTsIhr8y7zy7Sca5GLH2l+55F5iGs6sWRlhwtEQLstJuNYrJONo0D9vnf3BUEOvaFBLIVe3cVmRZQpy+nLMaGiu/uywUsIuokGO9/W0n2iQAwmtK/rdwYZw+tLKCFOOBj9nM8i7gMTR4Cx6WoV6d8BsM0TZIxo+aEdtw+o2Lis/YK93qOnLEaPhMnGluxUTVEW9Y8uHOmrji1G38fWJBvlTWvvUHWxotS6arIww6WjYar++nX2tzXq0SC8EsmataDNuBvN7RIM8kFe3cVlxBxvU9OWI0ZC6HMWKCUMrqr1den2iQQVc56JKb7AhnL60MsK0o2GrdsN5NxsS0aAn0qyNLVrHmxZjj2j4JTtqG6o7xm64gw1q+nK8aEjOFlo5YdLRIJdCdmaB3cocTQpZEWHi0TBoVeRK99GNiWjQi3ZtzF5s3OzS/Gj4gLxRy/fa1jVvsEFNX44WDf4TslesoDDpaJCr5do3D/QHG8SA1JoVEaYeDUf3Bs9hijG1RDTofWcX3UdDDT2iQXYVNrdxWXEHG8T05VjR4D8Fd81KCpOOBnmnqk4xd7Ah+u6siDD5aDg62WLntsd+E9Hg7LtyH4uhhtq+yY8GtRSydhuXFXewQUxfjhQNzxNDkEtWVBhaUaMLvV6XaJBLITe3cVnzBhvGu9Z1au5HE1yhm9ZdDhPR4NynsGwZiqGG2mGfHw1/aQdtQ7cp4A42iOnLcaIhMW1ZsbLC0Ir6Jkxeyl6v+ELcwYZg+tJKCERD4fgsOrdEWl9fKhr09nI8SQw11KpIdjTIpZDv/IhtrXEHG7rTl2NEw03eykMrLUw5GuTwdeekEAw2BNOXVkIgGkon84Hh0FwznYoGveipHFPoNgbrLcbsaPg+O2Yb3hVzhu5gQ3f6coRoeJF+wlrJigsTjoYTeacPsU/dwYZg+tJKCESDOTkb1K24biyZTkWDs+ipKCD2an3XZEfD79gx21C/jcuKO9jQnb7cOhpusi9xtDcIE44GfZGwGj9wBxv86UsrIBANGw+8RxVFGl3oVDQ4g2JFY1u0BetHfW40yKWQjdu4rLiDDd3py22j4ZX/3Ik2e4cwtKJG+/Q1ubxK/oiXtrHBHWwQvQ9jBQSioe7O2/oubYHGnUmS0aDvs1x0BcVOrdeQ3GjQR3HtjrEb7mBDZ8xy22gIb97SZO8QhlbU6OFVr0k0yPOJHNV1Bxv8b88KCERD08nD6GlHSn0fJaNBL3oqzgDxUEN2NPyKHbINX5JXGLqDDZ3py607FPm3TLE3CEMranTodhYNDbD7aNAXkcl96g42+NOXtl0gGjruvt1rSDI9WliLBudC8JPEUENuNOilkO/Ls/ZHbWtHZ/py62hI3IOsxt4gDK2o0dOI/GZ2vt1Hg/4LdEvMHWxwpy9tu0A0CMdvRc3Qttq3nowGJ9bvJ4YacqNBjy02b+OyooclltrTl1tHQ/6NEay8MLSiRrew3XE01PZ7l24/llrRIJuxzoO33MEGd/rStgtEg3b6KLtjUXvadTIanFifdx+e35ycyowGuRTynU/Z1pY/tM0d7enLKBoaz1pwv7KMJdIVKy8MrajRI2rCq5Uz7Twa5FJI71d3BxvchpttF4gG193MMcnrTY8iHQ26hHpgSaN3mBkNcinkO407xm78qG3uaE9fRtHQqP66Fi/lzlFYcWFoRY3u5VUL9cF2Hg36AkBnBNUfbPCmL22zQDQETh5mrXXYnN/T0aBPYiKDmpNTedGgl0K+92AmfY9t72pNX2ZHgz9TmLVKumDFhaEV1VlKUhqj8u88GvSV/M4+nbkV1us82WaBaIg9yAiHzQ2f0tEQ1dSG5sGUFw1yKeQArenL/GhwO/a1llXIigtDK+qxvV9JPQ8yx66jQS+F7M/7/myzQDSkPEzOV6RuxtSoIrmzH82Ru7xokEshB2hNX+ZHg9+jyJwntNLC4IoaZHvGQ/RvLZ+d768l3H00DH1eSoczfWlbBaIh6USMETZsalhGNOTOfTT3ZFY0+HMOPbWmL/OjwWn9Fpr9I5eVFgZX1OgLtyKBdQfw6uLi4tl8Pn9YREX9j951NASf348zfWlbBaIhQ/h018L6MM6IhqBK1LUOpaxoCA7hnprTlz2iwb9Jd7MD7bHCwuCKGgV7ePCW3GURq2bQrqOh1xqbiDOnYVsFoiHHnXgHrS8rzIgG9wbpTa1xu6xokEshB2lOX/aIhlP7tbo6dzKUrLAwuKJGt/hLXw/qPuNs1eHbcTRkVpcMzvSlbRWIhix3w8Gg9b7MiAZ/eqmhtUgoJxr0UshBmtOXPaLB71HkXUhhhYXBFTWavXTXCK65ywtX07E7joZoMWdPesTENgpEQ57wufDr4zgjGvzK1tAaNMqJBvcy6wEa05d9osHvUdTbNy4rKwyuqFEWy4eJNLjNxdWUy46joe8VPQG9A2yjQDQs3U6e0sKH7q/Xn+REQ2pQs9QetcuJBr0UcpjG9GWfaPB7FFc585dWVhheUYOjK9nLcadc1s3z3UaDP+XTn/4GbaNANBzff3qZcUqLuqy9oiFaubvWvi17TjTopZDDNKYv+0SD36PIupDCigrDK2rwSPRXVsTl7qz1r7PbaNjmWQgdcvrStgkTj4bbZ9XcVnrxi3867BkNt+3VUHsdbEY06KWQAzWmL3tFg9+jyFlgZEWF4RU1Orzk0VLjfu/r7N5tNPhBO4AcWbFtwpSj4d6TTVszPUgWjBGsV0rnREPWdFS7VmVEw1hLISv16cte0RBEaLRyyFhJYXhFlY9+MqmWjLtean0Lip1Gw1hLISty+tK2CVONhlsPnze+dudylZrnVlJY1/msaAg+aKWzTC8jGsZaClmpT1/2ioZgiVH64VU7qajyAfQmcW2H39Vfn4F3Gg2jLYUsyelL2yZMMhrqzQWTvmw4pw5kRUNQKVY6+Z6OhtGWQlbq05f9osEfS7lJNd93VFGD9ZCJRZp+7yhxNihtHw3Bhw+hmm22SZhcNLSbCyvJy4aD3WQlMqMhYxVLpw2Tjobg+B2kNn3ZLxqCRnD6QgorKGxRUaOB3/Dw9a8k3ZyAdxoNoy2FrGyamBu2SZhYNJy6M1nJy4b9c0+qnrSqSMaip06lSkfDeEshK7Xpy37REHxRyQmB3VTUaAQ5vG2l35/YNOt2GQ3jLYWsqO/QNglTazW454HkZcP+Xcs3NT4rGtKLnrpXBCajYcSlkJX/2rT+e0ZDcJIWj1VpsnLCNhU1uOF82KPwD9/N8OUuo2HEpZAV0aOzLcLUosFf1ZhoNgTt5M13mBcN7g38VrpDycloGHMpZKk2fdkzGoJvKrnEyMoJ21TUaClrMEfhL3Or3Sp4l9Ew4lLIipi+tC3C1KLBbyPexHNrwblwEyp50RD1fUvd6ZJkNIy5FLKyuaNkz2iIhv3Co6VgxYRtKmrUowhWW/gLImoRt8NoGHMpZEVMX9oWYWrREDQu4yU5QS9gM2yUFw3JXd6tU8loGHMpZGUzfdk3GrJSVLNiwlYVNQir1lNLa0791k8tu3cYDaMuhSyJ6UvbIkwuGoLvO6q3/jRWv9vGlhIDz+XjcZtS0TDqUsjKe+tWVN9oCHoUqQsprJigKqo7TNc+O0brA268uangoK8tkNthNIy6FLLSbRnbBmFy0RA1Lv3JtVvB1VW9bjZfSix6Ej3yVDQ4SyH/829S/t5KCj9YfXT/aIiuWkgsLbNSwlbREF4c90LHVRAn9fbl7qLBSdib6sb+Ef/Us2pkbtgGYXLREGaxV3FvRTePTbYuO1UkvMJbJlQqGpylkL9dbY183op2racve0dDcFSFMwI7i4Z45Ff0wIvP9ps+jR20u2hwvsWMI9b/a7tvtg3C9KLBfYrH0lN5Brkd3la6NiOUGQ2J+WoxHpqIBm8p5I+XW0O/YUW7vrj6w3pHQ7Q0OR7stULCdtEQjBsUzruTetF9vRq9ot1Fg/PJyQU4URXvLki1DcL0oiFeVvBCVN1HYb1Kty47VSS6AbocakhFg3PwfiXjOugfsrJd767e3Tsaoh6FPEWvWSFhu2hITBi/av8Z4S5vtOp2Fw1OOGXs02Ccu/Nue12YYDSEzYbiFLIaBaocpx6dnW5ddqtImE5q8j8RDc5SyM4zr4VgQcRq+rJ/NAQ9ivhGcFZI2DIa4mbD4ubt+mDkvWCNVHsodWfR4P1xGfs0uMF+55ux14UJRkNyNeLVs4ezsqbcmc2fp5axZ7Quu1UkPIepwdA4GrylkH9cvjf2gS9Y4a7VY3T7R0PUo1B/3pqVEbaMhvQ6s4uz2fIusndmj8PuY/sP2Fk0OEshE4M1Ff+X6iy0tdeFKUZDotnQT6OFlhsN4aIn1RuPo8E78/9k+d6E37XCXavpy/7REPUo5KXBK1ZG2DYaEs2GfK35151Fg9NYzRhqCOtXu3bZy8IUoyF9EUO+ZojnRkO06EkNNSSiwVkK+WV5W582f7Dhne+vSgyIhmghQdRZtiLCttGQmhbK1mr17CoavCqStU+D+tW+nsxeFiYZDSM2G5pPMsiNhqNgnl1eZxBHg7MU8mth3VwJBhts+nJANBwH/bDo1hhWRNg6Go7HOSG0F23tKhq8pXlZ+zQYbGh/j/ayMMloyLnRUp7WcZwdDcEvIPviYTR4SyH/qnpvQnAPGJu+HBAN0RET3RrDSghbR0N4I7h8VWt/Y1fR4Cy/yXhM55L/W7WnL+1lYZrRcBqtjuuhvcg2OxqC5drtulcKo8G7K+Qnq/em/JEV77LpyyHRED0YJuguWwlh+2jIu81/QtlKq9tRNHiLzfVf1hEMNrT6c/aqMM1o8CtVP+0zfHY0+D+/dr1vTRgNzlLIdxOLkleCizar6csh0RD1KIJbY1gJYYRoONn+Iufub7GjaPAGazL3aTDY0Ppu7FVhotGQnsvK0Tn9ZUeDP7und0gUDV6P4GtBw73um6y8UE1fDomG6JDxL3bcbTQc3U7NRKdcdRdl7CgavI/N3KfBFXytLom9Kkw1GsYYlOoOGGZHgz9J0mmxlqJo8I7cz9l7U4LBhmr6clA0RD0Kf27eCghjRMPW48+is7ejaHAObTl9peTc/7xkLwpTjYbtzyDqir38aHBbLaL2FaJo8O4K+av23qQ/sTcI5fTloGiIehTOH1mw7cIo0RAdkBlUbO8mGry/TE5fKcFgVnP60l4UJhsNqQfjJ12KFav50eD1JfVQQxQN3lLIL32HvTfpp+0dQjl9OSgaomPGr+G2XRgnGsLfKkXOuu4mGry7QoZLSevu2BuE5jdpLwrTjYYts+Fa7fj8aPDGiZz9EUSDty7hfbWqUgoO/XL6clg0RD0K90IK2y6MFA1bZMN5vwHiraLBGzDN3qfBYENz+tJeFCYcDVtlwwu53/OjwVv0pIcaomjwJhhyhxqOjj5k7xDK6cth0RDePsX5M/cQDYOzQSfDbqLBO3FkDzWEgw2N6Ut7TZhyNMR3aAk96VNPZBVxdp3TCw+iwbsrZMZtXFaCG0supy+HRUO4jKC9pnDFNgujRcPAW7g/c37jnUSDN1LQ42gNBhsa3469Jkw6Go5uhVffuq69ywB6RIPedc5QQxAN7l0ha4+fSvk5e4uwnL4cGA3ugbvkfIO2VRgvGo7uDWgtup38nUSDdycyr7ElBIMNjelLe02YdjSkbtOi6c7EUo9o0Mt2vbta+9HgLYV8z50F6AqO/eX05cBoiC4U8eqdbRVGjIaj075nhGv/y9xFNLj33e2xT6N7E9dHLOwlYerRcHS7bzW5eeyc2Qs9okEvevLWEPvR4D0g+9/837IjGGxYTl8OjYZwYbIeULONwpjRUByYvc4Iz4Lbz+wiGnpOX2nBDfbr05f2kjD5aCia9n3al9ePo7sU9YgG/UCMfj2VwsftGO3oMdRwdPQP9ibhM8OjIexR6Cfq20Zh3Gg4Og3uKNFyFT6ObxfR4H1mr4M1+AH1z7GXBKKhqCaPc6+2unokFjPU9IkGuejJ+3i3Av6sHaMdGXeM3fi0vUn44sngaAh7FPqJ+rZRGDkaih5d3mMers7iU/UuosE7V2XdxmUlCOb6d28vCURD6a3o+UYrlw9SDbo+0aAW7boriN0K+Od2jLbl3DF242P2LuHd+8OjIexRyIE92yaMHg1FX/Jpsr14mQiGnUSDu6nXPo1uwlf7IHtFIBrMrcfhdXk354+ad22R+kSDmrt2TwteBfy//7BjtC3njrEbH7Z3KZ8aHg1hj0I+Ud+2CTuIhuLwefA8OICunw7e5aWh0eCOfvXap9EDV2rfj70iEA0bJ/fm8uvMi4U31zd8xPUhK/Iamz1WO/36/FGf6QBMwN2z+Xz+vHpA2LPin7PyPsN4o92aPXpa7fKl+dksPOEDAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAc2NHR/wN0vT9/PxruRQAAAABJRU5ErkJggg==",
        },
        styles: {},
    },
};


/***/ }),

/***/ "./src/styles/themes/default-dark.theme.ts":
/*!*************************************************!*\
  !*** ./src/styles/themes/default-dark.theme.ts ***!
  \*************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.defaultDarkTheme = void 0;
const helpers_1 = __webpack_require__(/*! ../helpers */ "./src/styles/helpers/index.ts");
const _models_1 = __webpack_require__(/*! ../../models */ "./src/models/index.ts");
const base_theme_1 = __webpack_require__(/*! ./base.theme */ "./src/styles/themes/base.theme.ts");
exports.defaultDarkTheme = helpers_1.mergeTheme({
    $id: "dark",
    $schema: _models_1.IThemeSchema,
    name: "Default Dark Theme",
    description: "Applies default colour scheme to the SmartHub",
    definition: {
        type: 'dark',
        palette: {
            primaryNavText: '#fff',
            primaryNavBackground: "#3a3a3a",
            neutralFull: "#fff",
            neutralFullOn: "#222",
            neutralPlus5: "#fefeff",
            neutralPlus5On: "#222",
            neutralPlus4: "#ddd",
            neutralPlus4On: "#111",
            neutralPlus3: "#ccc",
            neutralPlus3On: "#fff",
            neutralPlus2: "#9e9e9e",
            neutralPlus2On: "#fff",
            neutralPlus1: "#8f8f8f",
            neutralPlus1On: "#fff",
            neutral: "#5A5A5A",
            neutralOn: "#fff",
            neutralMinus1: "#4A4A4A",
            neutralMinus1On: "#fff",
            neutralMinus2: "#3a3a3a",
            neutralMinus2On: "#fff",
            neutralMinus3: "#272626",
            neutralMinus3On: "#fff",
            neutralMinus4: "#252525",
            neutralMinus4On: "#ddd",
            neutralMinus5: "#242424",
            neutralMinus5On: "#ddd",
            neutralEmpty: "#2D2D2D",
            neutralEmptyOn: "#ccc",
            primaryFull: "#d2ecec",
            primaryFullOn: "#44",
            primaryPlus2: "#c3e6e5",
            primaryPlus2On: "#44",
            primaryPlus1: "#b9e1e0",
            primaryPlus1On: "#333",
            primary: "#b3dfde",
            primaryOn: "#222",
            primaryMinus1: "#9cc3c3",
            primaryMinus1On: "#111",
            primaryMinus2: "#6a8585",
            primaryMinus2On: "#fff",
            primaryMinus3: "#354342",
            primaryMinus3On: "#fff",
            primaryMinus4: "#1c2323",
            primaryMinus4On: "#fff",
            primaryEmpty: "#070909",
            primaryEmptyOn: "#fff",
            filmPlus1: "#000000A6",
            filmPlus1On: "#fff",
            film: "#33959499",
            filmOn: "#fff",
            filmVar: "#73bfbd99",
            filmVarOn: "#222",
            filmMinus1: "#00000077",
            filmMinus1On: "#fff",
            neutalFilm: "#33333399",
            neutalFilmOn: "#fff",
            neutalFilmMinus1: "#00000099",
            neutalFilmMinus1On: "#ffffff",
            neutalFilmMinus2: "#000000cc",
            neutalFilmMinus2On: "#ffffff",
        }
    }
}, base_theme_1.baseTheme);


/***/ }),

/***/ "./src/styles/themes/default-light.theme.ts":
/*!**************************************************!*\
  !*** ./src/styles/themes/default-light.theme.ts ***!
  \**************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.defaultLightTheme = void 0;
const helpers_1 = __webpack_require__(/*! ../helpers */ "./src/styles/helpers/index.ts");
const _models_1 = __webpack_require__(/*! ../../models */ "./src/models/index.ts");
const base_theme_1 = __webpack_require__(/*! ./base.theme */ "./src/styles/themes/base.theme.ts");
exports.defaultLightTheme = helpers_1.mergeTheme({
    $id: "light",
    $schema: _models_1.IThemeSchema,
    name: "Default Light Theme",
    description: "Applies default colour scheme to the SmartHub",
    definition: {
        type: "light",
        palette: {
            primaryNavText: "#fff",
            primaryNavBackground: "#525659",
            neutralFull: "#222",
            neutralFullOn: "#fff",
            neutralPlus5: "#201f1e",
            neutralPlus5On: "#fff",
            neutralPlus4: "#323130",
            neutralPlus4On: "#fff",
            neutralPlus3: "#3b3a39",
            neutralPlus3On: "#fff",
            neutralPlus2: "#525659",
            neutralPlus2On: "#fff",
            neutralPlus1: "#a19f9d",
            neutralPlus1On: "#000",
            neutral: "#c8c8c8",
            neutralOn: "#111",
            neutralMinus1: "#d0d0d0",
            neutralMinus1On: "#222",
            neutralMinus2: "#dadada",
            neutralMinus2On: "#333",
            neutralMinus3: "#eaeaea",
            neutralMinus3On: "#444",
            neutralMinus4: "#f4f4f4",
            neutralMinus4On: "#444",
            neutralMinus5: "#f8f8f8",
            neutralMinus5On: "#444",
            neutralEmpty: "#fff",
            neutralEmptyOn: "#222",
            primaryFull: "#153f3e",
            primaryFullOn: "#eee",
            primaryPlus2: "#1d5554",
            primaryPlus2On: "#fff",
            primaryPlus1: "#226564",
            primaryPlus1On: "#fff",
            primary: "#26706f",
            primaryOn: "#fff",
            primaryMinus1: "#368180",
            primaryMinus1On: "#fff",
            primaryMinus2: "#339594",
            primaryMinus2On: "#fff",
            primaryMinus3: "#66a9a8",
            primaryMinus3On: "#333",
            primaryMinus4: "#aad4d3",
            primaryMinus4On: "#444",
            primaryEmpty: "#d0e8e8",
            primaryEmptyOn: "#444",
            filmPlus1: "#000000A6",
            filmPlus1On: "#fff",
            film: "#33959499",
            filmOn: "#fff",
            filmVar: "#73bfbd99",
            filmVarOn: "#222",
            filmMinus1: "#00000077",
            filmMinus1On: "#fff",
            neutalFilm: "#33333399",
            neutalFilmOn: "#fff",
            neutalFilmMinus1: "#ffffff99",
            neutalFilmMinus1On: "#000",
            neutalFilmMinus2: "#ffffffcc",
            neutalFilmMinus2On: "#000",
        },
    },
}, base_theme_1.baseTheme);


/***/ }),

/***/ "./src/styles/themes/index.ts":
/*!************************************!*\
  !*** ./src/styles/themes/index.ts ***!
  \************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.baseTheme = exports.defaultDarkTheme = exports.defaultLightTheme = void 0;
var default_light_theme_1 = __webpack_require__(/*! ./default-light.theme */ "./src/styles/themes/default-light.theme.ts");
Object.defineProperty(exports, "defaultLightTheme", ({ enumerable: true, get: function () { return default_light_theme_1.defaultLightTheme; } }));
var default_dark_theme_1 = __webpack_require__(/*! ./default-dark.theme */ "./src/styles/themes/default-dark.theme.ts");
Object.defineProperty(exports, "defaultDarkTheme", ({ enumerable: true, get: function () { return default_dark_theme_1.defaultDarkTheme; } }));
var base_theme_1 = __webpack_require__(/*! ./base.theme */ "./src/styles/themes/base.theme.ts");
Object.defineProperty(exports, "baseTheme", ({ enumerable: true, get: function () { return base_theme_1.baseTheme; } }));


/***/ }),

/***/ "./src/transform/add-expressions.helper.ts":
/*!*************************************************!*\
  !*** ./src/transform/add-expressions.helper.ts ***!
  \*************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.addExpressionFunction = void 0;
const adaptive_expressions_1 = __webpack_require__(/*! adaptive-expressions */ "adaptive-expressions");
const addExpressionFunction = (ref) => {
    const functions = Array.isArray(ref)
        ? ref
        : [ref];
    functions.forEach(({ name, fn }) => adaptive_expressions_1.Expression.functions.add(name, fn));
};
exports.addExpressionFunction = addExpressionFunction;


/***/ }),

/***/ "./src/transform/aes/defaultValue.fn.ts":
/*!**********************************************!*\
  !*** ./src/transform/aes/defaultValue.fn.ts ***!
  \**********************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.defaultValue = exports.isExpr = void 0;
const expressionRgx = /^\${[^\{\}\$]*}$/;
const isExpr = (val) => typeof val === 'string' && expressionRgx.test(val);
exports.isExpr = isExpr;
const defaultValue = ([value, defaultValue]) => {
    return value == null || exports.isExpr(value)
        ? defaultValue === undefined
            ? ''
            : defaultValue
        : value;
};
exports.defaultValue = defaultValue;


/***/ }),

/***/ "./src/transform/aes/endOf.fn.ts":
/*!***************************************!*\
  !*** ./src/transform/aes/endOf.fn.ts ***!
  \***************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.endOf = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const dayjs_1 = tslib_1.__importDefault(__webpack_require__(/*! dayjs */ "dayjs"));
const isoWeek_1 = tslib_1.__importDefault(__webpack_require__(/*! dayjs/plugin/isoWeek */ "dayjs/plugin/isoWeek"));
const _1 = __webpack_require__(/*! . */ "./src/transform/aes/index.ts");
const helpers_1 = __webpack_require__(/*! ../../helpers */ "./src/helpers/index.ts");
const verifyTimeStamp_fn_1 = __webpack_require__(/*! ./verifyTimeStamp.fn */ "./src/transform/aes/verifyTimeStamp.fn.ts");
dayjs_1.default.extend(isoWeek_1.default);
const endOf = ([unit, format, date]) => {
    try {
        date = verifyTimeStamp_fn_1.verifyTimestamp(date);
        return dayjs_1.default(date)
            .endOf(unit)
            .local()
            .format(format !== null && format !== void 0 ? format : _1.defaultDateTimeFormat);
    }
    catch (ex) {
        helpers_1.Logger.error(`Failed to get end of for date ${ex.message}`, true, {
            date,
            ex
        });
    }
    return date === null || date === void 0 ? void 0 : date.toString();
};
exports.endOf = endOf;


/***/ }),

/***/ "./src/transform/aes/formatDateTime.fn.ts":
/*!************************************************!*\
  !*** ./src/transform/aes/formatDateTime.fn.ts ***!
  \************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.formatDateTime = exports.defaultDateTimeFormat = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const dayjs_1 = tslib_1.__importDefault(__webpack_require__(/*! dayjs */ "dayjs"));
const advancedFormat_1 = tslib_1.__importDefault(__webpack_require__(/*! dayjs/plugin/advancedFormat */ "dayjs/plugin/advancedFormat"));
const utc_1 = tslib_1.__importDefault(__webpack_require__(/*! dayjs/plugin/utc */ "dayjs/plugin/utc"));
const logger_module_1 = __webpack_require__(/*! ../../helpers/logger.module */ "./src/helpers/logger.module.ts");
const verifyTimeStamp_fn_1 = __webpack_require__(/*! ./verifyTimeStamp.fn */ "./src/transform/aes/verifyTimeStamp.fn.ts");
dayjs_1.default.extend(advancedFormat_1.default);
dayjs_1.default.extend(utc_1.default);
exports.defaultDateTimeFormat = "YYYY-MM-DDTHH:mm:ss.SSS[Z]";
const formatDateTime = ([date, format]) => {
    try {
        date = verifyTimeStamp_fn_1.verifyTimestamp(date);
        return dayjs_1.default(date)
            .local()
            .format(format !== null && format !== void 0 ? format : exports.defaultDateTimeFormat);
    }
    catch (ex) {
        logger_module_1.Logger.error(`Failed to transform date ${ex.message}`, false, {
            date,
            ex
        });
    }
    return date === null || date === void 0 ? void 0 : date.toString();
};
exports.formatDateTime = formatDateTime;


/***/ }),

/***/ "./src/transform/aes/fromNow.fn.ts":
/*!*****************************************!*\
  !*** ./src/transform/aes/fromNow.fn.ts ***!
  \*****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fromNow = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const dayjs_1 = tslib_1.__importDefault(__webpack_require__(/*! dayjs */ "dayjs"));
const utc_1 = tslib_1.__importDefault(__webpack_require__(/*! dayjs/plugin/utc */ "dayjs/plugin/utc"));
const relativeTime_1 = tslib_1.__importDefault(__webpack_require__(/*! dayjs/plugin/relativeTime */ "dayjs/plugin/relativeTime"));
const logger_module_1 = __webpack_require__(/*! ../../helpers/logger.module */ "./src/helpers/logger.module.ts");
const verifyTimeStamp_fn_1 = __webpack_require__(/*! ./verifyTimeStamp.fn */ "./src/transform/aes/verifyTimeStamp.fn.ts");
dayjs_1.default.extend(utc_1.default);
dayjs_1.default.extend(relativeTime_1.default);
const fromNow = ([date]) => {
    try {
        date = verifyTimeStamp_fn_1.verifyTimestamp(date);
        return dayjs_1.default(date)
            .local()
            .fromNow();
    }
    catch (ex) {
        logger_module_1.Logger.error(`Failed to get from now for date ${ex.message}`, true, {
            date,
            ex
        });
    }
    return date === null || date === void 0 ? void 0 : date.toString();
};
exports.fromNow = fromNow;


/***/ }),

/***/ "./src/transform/aes/groupCount.fn.ts":
/*!********************************************!*\
  !*** ./src/transform/aes/groupCount.fn.ts ***!
  \********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.groupCount = void 0;
const helpers_1 = __webpack_require__(/*! ../../helpers */ "./src/helpers/index.ts");
const groupCount = ([array, field]) => {
    try {
        return array === null || array === void 0 ? void 0 : array.reduce((groups, item) => {
            const value = item[field];
            if (value) {
                const key = value.replace(/ /g, '').toLocaleLowerCase();
                const { count } = groups[key] || { count: 0 };
                return Object.assign(Object.assign({}, groups), { [key]: {
                        value,
                        count: count + 1
                    } });
            }
            return groups;
        }, {});
    }
    catch (ex) {
        helpers_1.Logger.error(`Failed to groupCount ${ex.message}`, true, {
            ex
        });
    }
    return {};
};
exports.groupCount = groupCount;


/***/ }),

/***/ "./src/transform/aes/index.ts":
/*!************************************!*\
  !*** ./src/transform/aes/index.ts ***!
  \************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./fromNow.fn */ "./src/transform/aes/fromNow.fn.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./formatDateTime.fn */ "./src/transform/aes/formatDateTime.fn.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./timeDifference.fn */ "./src/transform/aes/timeDifference.fn.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./startOf.fn */ "./src/transform/aes/startOf.fn.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./endOf.fn */ "./src/transform/aes/endOf.fn.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./groupCount.fn */ "./src/transform/aes/groupCount.fn.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./joinMerge.fn */ "./src/transform/aes/joinMerge.fn.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./joinWrap.fn */ "./src/transform/aes/joinWrap.fn.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./defaultValue.fn */ "./src/transform/aes/defaultValue.fn.ts"), exports);


/***/ }),

/***/ "./src/transform/aes/joinMerge.fn.ts":
/*!*******************************************!*\
  !*** ./src/transform/aes/joinMerge.fn.ts ***!
  \*******************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.joinMerge = void 0;
const helpers_1 = __webpack_require__(/*! ../../helpers */ "./src/helpers/index.ts");
const joinMerge = ([keyArrayOrItem, valueArrayOrItem, sep]) => {
    try {
        if (!keyArrayOrItem || !valueArrayOrItem)
            return [];
        const keys = Array.isArray(keyArrayOrItem)
            ? keyArrayOrItem
            : [keyArrayOrItem];
        const values = Array.isArray(valueArrayOrItem)
            ? valueArrayOrItem
            : [valueArrayOrItem];
        return keys.reduce((items, key, idx) => {
            const val = values.length > idx
                ? values[idx]
                : null;
            return val
                ? [
                    ...items,
                    `${key}${sep}${val}`
                ]
                : items;
        }, []);
    }
    catch (ex) {
        helpers_1.Logger.error(`Failed to joinWrap ${ex.message}`, true, {
            ex
        });
    }
    return [];
};
exports.joinMerge = joinMerge;


/***/ }),

/***/ "./src/transform/aes/joinWrap.fn.ts":
/*!******************************************!*\
  !*** ./src/transform/aes/joinWrap.fn.ts ***!
  \******************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.joinWrap = void 0;
const helpers_1 = __webpack_require__(/*! ../../helpers */ "./src/helpers/index.ts");
const joinWrap = ([arrayOrItem, prefix, sep, suffix]) => {
    try {
        if (Array.isArray(arrayOrItem)) {
            return arrayOrItem.length > 0
                ? arrayOrItem.length > 1
                    ? `${prefix}${arrayOrItem.join(sep)}${suffix}`
                    : arrayOrItem[0]
                : '';
        }
        return arrayOrItem || '';
    }
    catch (ex) {
        helpers_1.Logger.error(`Failed to joinWrap ${ex.message}`, true, {
            ex
        });
    }
    return '';
};
exports.joinWrap = joinWrap;


/***/ }),

/***/ "./src/transform/aes/startOf.fn.ts":
/*!*****************************************!*\
  !*** ./src/transform/aes/startOf.fn.ts ***!
  \*****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.startOf = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const dayjs_1 = tslib_1.__importDefault(__webpack_require__(/*! dayjs */ "dayjs"));
const isoWeek_1 = tslib_1.__importDefault(__webpack_require__(/*! dayjs/plugin/isoWeek */ "dayjs/plugin/isoWeek"));
const _1 = __webpack_require__(/*! . */ "./src/transform/aes/index.ts");
const helpers_1 = __webpack_require__(/*! ../../helpers */ "./src/helpers/index.ts");
const verifyTimeStamp_fn_1 = __webpack_require__(/*! ./verifyTimeStamp.fn */ "./src/transform/aes/verifyTimeStamp.fn.ts");
dayjs_1.default.extend(isoWeek_1.default);
const startOf = ([unit, format, date]) => {
    try {
        date = verifyTimeStamp_fn_1.verifyTimestamp(date);
        return dayjs_1.default(date)
            .startOf(unit)
            .local()
            .format(format !== null && format !== void 0 ? format : _1.defaultDateTimeFormat);
    }
    catch (ex) {
        helpers_1.Logger.error(`Failed to get start of for date ${ex.message}`, true, {
            date,
            ex
        });
    }
    return date === null || date === void 0 ? void 0 : date.toString();
};
exports.startOf = startOf;


/***/ }),

/***/ "./src/transform/aes/timeDifference.fn.ts":
/*!************************************************!*\
  !*** ./src/transform/aes/timeDifference.fn.ts ***!
  \************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.timeDifference = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const dayjs_1 = tslib_1.__importDefault(__webpack_require__(/*! dayjs */ "dayjs"));
const duration_1 = tslib_1.__importDefault(__webpack_require__(/*! dayjs/plugin/duration */ "dayjs/plugin/duration"));
dayjs_1.default.extend(duration_1.default);
const timeDifference = (startDateTime, endDateTime) => {
    const duration = dayjs_1.default(endDateTime).diff(dayjs_1.default(startDateTime));
    const hourDuration = Math.trunc(dayjs_1.default.duration(duration).asHours());
    const minDuration = dayjs_1.default.duration(duration).minutes();
    const hDuration = hourDuration != 0 ? `${hourDuration}hr ` : '';
    const mDuration = minDuration != 0 ? `${minDuration}mins` : '';
    return hDuration + mDuration;
};
exports.timeDifference = timeDifference;


/***/ }),

/***/ "./src/transform/aes/verifyTimeStamp.fn.ts":
/*!*************************************************!*\
  !*** ./src/transform/aes/verifyTimeStamp.fn.ts ***!
  \*************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.verifyTimestamp = void 0;
const verifyTimestamp = (date) => {
    if (date == null || date == '')
        date = new Date().toISOString();
    else if (typeof date === 'string') {
        const testDate = new Date(date);
        if (Number.isNaN(testDate === null || testDate === void 0 ? void 0 : testDate.getTime()))
            throw new Error(`${testDate === null || testDate === void 0 ? void 0 : testDate.toString()} is not a valid datetime string.`);
    }
    else
        date = date.toISOString();
    if (!date.endsWith('Z')) {
        try {
            return new Date(`${date}Z`).toISOString();
        }
        catch (_a) {
            //ignore
        }
    }
    return new Date(date).toISOString();
};
exports.verifyTimestamp = verifyTimestamp;


/***/ }),

/***/ "./src/transform/index.ts":
/*!********************************!*\
  !*** ./src/transform/index.ts ***!
  \********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const load_expressions_helper_1 = __webpack_require__(/*! ./load-expressions.helper */ "./src/transform/load-expressions.helper.ts");
load_expressions_helper_1.loadExpressions();
tslib_1.__exportStar(__webpack_require__(/*! ./aes */ "./src/transform/aes/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./transformData.helper */ "./src/transform/transformData.helper.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./replaceExpression.helper */ "./src/transform/replaceExpression.helper.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./add-expressions.helper */ "./src/transform/add-expressions.helper.ts"), exports);


/***/ }),

/***/ "./src/transform/load-expressions.helper.ts":
/*!**************************************************!*\
  !*** ./src/transform/load-expressions.helper.ts ***!
  \**************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.loadExpressions = void 0;
const adaptive_expressions_1 = __webpack_require__(/*! adaptive-expressions */ "adaptive-expressions");
const aes_1 = __webpack_require__(/*! ./aes */ "./src/transform/aes/index.ts");
const loadExpressions = () => {
    adaptive_expressions_1.Expression.functions.add("smarthub.formatDateTime", aes_1.formatDateTime);
    adaptive_expressions_1.Expression.functions.add("smarthub.fromNow", aes_1.fromNow);
    adaptive_expressions_1.Expression.functions.add("smarthub.startOf", aes_1.startOf);
    adaptive_expressions_1.Expression.functions.add("smarthub.endOf", aes_1.endOf);
    adaptive_expressions_1.Expression.functions.add("smarthub.joinMerge", aes_1.joinMerge);
    adaptive_expressions_1.Expression.functions.add("smarthub.joinWrap", aes_1.joinWrap);
    adaptive_expressions_1.Expression.functions.add("smarthub.val", aes_1.defaultValue);
    adaptive_expressions_1.Expression.functions.add("smarthub.groupCount", aes_1.groupCount);
};
exports.loadExpressions = loadExpressions;


/***/ }),

/***/ "./src/transform/parse-interpolated-string.helper.ts":
/*!***********************************************************!*\
  !*** ./src/transform/parse-interpolated-string.helper.ts ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.parseInterpolatedString = void 0;
const adaptive_expressions_1 = __webpack_require__(/*! adaptive-expressions */ "adaptive-expressions");
const parseInterpolatedString = (interpolatedString) => {
    let lookup = (type) => {
        let standardFunction = adaptive_expressions_1.Expression.functions.get(type);
        if (standardFunction) {
            return standardFunction;
        }
        else {
            return new adaptive_expressions_1.ExpressionEvaluator(type, (expression, state, options) => {
                throw new Error("Unknown function " + type);
            }, adaptive_expressions_1.ReturnType.String);
        }
    };
    // If there is at least one expression start marker, let's attempt to convert into an expression
    if (interpolatedString.indexOf("${") >= 0) {
        let parsedExpression = adaptive_expressions_1.Expression.parse("`" + interpolatedString + "`", lookup);
        if (parsedExpression.type === "concat") {
            if (parsedExpression.children.length === 1 &&
                !(parsedExpression.children[0] instanceof adaptive_expressions_1.Constant)) {
                // The concat contains a single child that isn't a constant, thus the original
                // string was a single expression. When evaluated, we want it to produce the type
                // of that single expression
                return parsedExpression.children[0];
            }
            else if (parsedExpression.children.length === 2) {
                let firstChild = parsedExpression.children[0];
                if (firstChild instanceof adaptive_expressions_1.Constant &&
                    firstChild.value === "" &&
                    !(parsedExpression.children[1] instanceof adaptive_expressions_1.Constant)) {
                    // The concat contains 2 children, and the first one is an empty string constant and the second isn't a constant.
                    // From version 4.10.3, AEL always inserts an empty string constant in all concat expression. Thus the original
                    // string was a single expression in this case as well. When evaluated, we want it to produce the type
                    // of that single expression.
                    return parsedExpression.children[1];
                }
            }
            // Otherwise, we want the expression to produce a string
            return parsedExpression;
        }
    }
    // If the original string didn't contain any expression, return i as is
    return interpolatedString;
};
exports.parseInterpolatedString = parseInterpolatedString;


/***/ }),

/***/ "./src/transform/replaceExpression.helper.ts":
/*!***************************************************!*\
  !*** ./src/transform/replaceExpression.helper.ts ***!
  \***************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.replaceExpression = void 0;
const template_class_1 = __webpack_require__(/*! ./template.class */ "./src/transform/template.class.ts");
const replaceExpression = (text, expressionVal) => {
    const exprText = template_class_1.Template.parseInterpolatedString(text);
    const replacedText = template_class_1.Template.tryEvaluateExpression(exprText, { $root: expressionVal }, false);
    return (replacedText === null || replacedText === void 0 ? void 0 : replacedText.value) ? replacedText.value : replacedText.error;
};
exports.replaceExpression = replaceExpression;


/***/ }),

/***/ "./src/transform/template.class.ts":
/*!*****************************************!*\
  !*** ./src/transform/template.class.ts ***!
  \*****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Template = void 0;
const template_engine_1 = __webpack_require__(/*! adaptivecards-templating/lib/template-engine */ "adaptivecards-templating/lib/template-engine");
Object.defineProperty(exports, "Template", ({ enumerable: true, get: function () { return template_engine_1.Template; } }));
const parse_interpolated_string_helper_1 = __webpack_require__(/*! ./parse-interpolated-string.helper */ "./src/transform/parse-interpolated-string.helper.ts");
template_engine_1.Template.parseInterpolatedString = parse_interpolated_string_helper_1.parseInterpolatedString;
template_engine_1.GlobalSettings.getUndefinedFieldValueSubstitutionString = (path) => { return ''; };


/***/ }),

/***/ "./src/transform/transformData.helper.ts":
/*!***********************************************!*\
  !*** ./src/transform/transformData.helper.ts ***!
  \***********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.transformData = void 0;
const template_class_1 = __webpack_require__(/*! ./template.class */ "./src/transform/template.class.ts");
const transformData = (template, data, cache, propName = 'template') => {
    const instance = cache
        ? cache[propName] || (cache[propName] = new template_class_1.Template(template))
        : new template_class_1.Template(template);
    const output = instance.expand({
        $root: data
    });
    return (output === null || output === void 0 ? void 0 : output.$return) || output;
};
exports.transformData = transformData;


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/index.js":
/*!****************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/index.js ***!
  \****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useBoolean": () => (/* reexport safe */ _useBoolean_useBoolean__WEBPACK_IMPORTED_MODULE_0__["default"]),
/* harmony export */   "useClickAnyWhere": () => (/* reexport safe */ _useClickAnyWhere_useClickAnyWhere__WEBPACK_IMPORTED_MODULE_1__["default"]),
/* harmony export */   "useCopyToClipboard": () => (/* reexport safe */ _useCopyToClipboard_useCopyToClipboard__WEBPACK_IMPORTED_MODULE_2__["default"]),
/* harmony export */   "useCountdown": () => (/* reexport safe */ _useCountdown_useCountdown__WEBPACK_IMPORTED_MODULE_3__["default"]),
/* harmony export */   "useCounter": () => (/* reexport safe */ _useCounter_useCounter__WEBPACK_IMPORTED_MODULE_4__["default"]),
/* harmony export */   "useDarkMode": () => (/* reexport safe */ _useDarkMode_useDarkMode__WEBPACK_IMPORTED_MODULE_5__["default"]),
/* harmony export */   "useDebounce": () => (/* reexport safe */ _useDebounce_useDebounce__WEBPACK_IMPORTED_MODULE_6__["default"]),
/* harmony export */   "useDocumentTitle": () => (/* reexport safe */ _useDocumentTitle_useDocumentTitle__WEBPACK_IMPORTED_MODULE_7__["default"]),
/* harmony export */   "useEffectOnce": () => (/* reexport safe */ _useEffectOnce_useEffectOnce__WEBPACK_IMPORTED_MODULE_8__["default"]),
/* harmony export */   "useElementSize": () => (/* reexport safe */ _useElementSize_useElementSize__WEBPACK_IMPORTED_MODULE_9__["default"]),
/* harmony export */   "useEventCallback": () => (/* reexport safe */ _useEventCallback_useEventCallback__WEBPACK_IMPORTED_MODULE_10__["default"]),
/* harmony export */   "useEventListener": () => (/* reexport safe */ _useEventListener_useEventListener__WEBPACK_IMPORTED_MODULE_11__["default"]),
/* harmony export */   "useFetch": () => (/* reexport safe */ _useFetch_useFetch__WEBPACK_IMPORTED_MODULE_12__["default"]),
/* harmony export */   "useHover": () => (/* reexport safe */ _useHover_useHover__WEBPACK_IMPORTED_MODULE_13__["default"]),
/* harmony export */   "useImageOnLoad": () => (/* reexport safe */ _useImageOnLoad_useImageOnLoad__WEBPACK_IMPORTED_MODULE_14__["default"]),
/* harmony export */   "useIntersectionObserver": () => (/* reexport safe */ _useIntersectionObserver_useIntersectionObserver__WEBPACK_IMPORTED_MODULE_15__["default"]),
/* harmony export */   "useInterval": () => (/* reexport safe */ _useInterval_useInterval__WEBPACK_IMPORTED_MODULE_16__["default"]),
/* harmony export */   "useIsClient": () => (/* reexport safe */ _useIsClient_useIsClient__WEBPACK_IMPORTED_MODULE_17__["default"]),
/* harmony export */   "useIsFirstRender": () => (/* reexport safe */ _useIsFirstRender_useIsFirstRender__WEBPACK_IMPORTED_MODULE_18__["default"]),
/* harmony export */   "useIsMounted": () => (/* reexport safe */ _useIsMounted_useIsMounted__WEBPACK_IMPORTED_MODULE_19__["default"]),
/* harmony export */   "useIsomorphicLayoutEffect": () => (/* reexport safe */ _useIsomorphicLayoutEffect_useIsomorphicLayoutEffect__WEBPACK_IMPORTED_MODULE_20__["default"]),
/* harmony export */   "useLocalStorage": () => (/* reexport safe */ _useLocalStorage_useLocalStorage__WEBPACK_IMPORTED_MODULE_21__["default"]),
/* harmony export */   "useLockedBody": () => (/* reexport safe */ _useLockedBody_useLockedBody__WEBPACK_IMPORTED_MODULE_22__["default"]),
/* harmony export */   "useMap": () => (/* reexport safe */ _useMap_useMap__WEBPACK_IMPORTED_MODULE_23__["default"]),
/* harmony export */   "useMediaQuery": () => (/* reexport safe */ _useMediaQuery_useMediaQuery__WEBPACK_IMPORTED_MODULE_24__["default"]),
/* harmony export */   "useOnClickOutside": () => (/* reexport safe */ _useOnClickOutside_useOnClickOutside__WEBPACK_IMPORTED_MODULE_25__["default"]),
/* harmony export */   "useReadLocalStorage": () => (/* reexport safe */ _useReadLocalStorage_useReadLocalStorage__WEBPACK_IMPORTED_MODULE_26__["default"]),
/* harmony export */   "useScreen": () => (/* reexport safe */ _useScreen_useScreen__WEBPACK_IMPORTED_MODULE_27__["default"]),
/* harmony export */   "useScript": () => (/* reexport safe */ _useScript_useScript__WEBPACK_IMPORTED_MODULE_28__["default"]),
/* harmony export */   "useSessionStorage": () => (/* reexport safe */ _useSessionStorage_useSessionStorage__WEBPACK_IMPORTED_MODULE_29__["default"]),
/* harmony export */   "useSsr": () => (/* reexport safe */ _useSsr_useSsr__WEBPACK_IMPORTED_MODULE_30__["default"]),
/* harmony export */   "useStep": () => (/* reexport safe */ _useStep_useStep__WEBPACK_IMPORTED_MODULE_31__["default"]),
/* harmony export */   "useTernaryDarkMode": () => (/* reexport safe */ _useTernaryDarkMode_useTernaryDarkMode__WEBPACK_IMPORTED_MODULE_32__["default"]),
/* harmony export */   "useTimeout": () => (/* reexport safe */ _useTimeout_useTimeout__WEBPACK_IMPORTED_MODULE_33__["default"]),
/* harmony export */   "useToggle": () => (/* reexport safe */ _useToggle_useToggle__WEBPACK_IMPORTED_MODULE_34__["default"]),
/* harmony export */   "useUpdateEffect": () => (/* reexport safe */ _useUpdateEffect_useUpdateEffect__WEBPACK_IMPORTED_MODULE_35__["default"]),
/* harmony export */   "useWindowSize": () => (/* reexport safe */ _useWindowSize_useWindowSize__WEBPACK_IMPORTED_MODULE_36__["default"])
/* harmony export */ });
/* harmony import */ var _useBoolean_useBoolean__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./useBoolean/useBoolean */ "./node_modules/usehooks-ts/dist/esm/useBoolean/useBoolean.js");
/* harmony import */ var _useClickAnyWhere_useClickAnyWhere__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./useClickAnyWhere/useClickAnyWhere */ "./node_modules/usehooks-ts/dist/esm/useClickAnyWhere/useClickAnyWhere.js");
/* harmony import */ var _useCopyToClipboard_useCopyToClipboard__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./useCopyToClipboard/useCopyToClipboard */ "./node_modules/usehooks-ts/dist/esm/useCopyToClipboard/useCopyToClipboard.js");
/* harmony import */ var _useCountdown_useCountdown__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./useCountdown/useCountdown */ "./node_modules/usehooks-ts/dist/esm/useCountdown/useCountdown.js");
/* harmony import */ var _useCounter_useCounter__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./useCounter/useCounter */ "./node_modules/usehooks-ts/dist/esm/useCounter/useCounter.js");
/* harmony import */ var _useDarkMode_useDarkMode__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./useDarkMode/useDarkMode */ "./node_modules/usehooks-ts/dist/esm/useDarkMode/useDarkMode.js");
/* harmony import */ var _useDebounce_useDebounce__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./useDebounce/useDebounce */ "./node_modules/usehooks-ts/dist/esm/useDebounce/useDebounce.js");
/* harmony import */ var _useDocumentTitle_useDocumentTitle__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./useDocumentTitle/useDocumentTitle */ "./node_modules/usehooks-ts/dist/esm/useDocumentTitle/useDocumentTitle.js");
/* harmony import */ var _useEffectOnce_useEffectOnce__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./useEffectOnce/useEffectOnce */ "./node_modules/usehooks-ts/dist/esm/useEffectOnce/useEffectOnce.js");
/* harmony import */ var _useElementSize_useElementSize__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./useElementSize/useElementSize */ "./node_modules/usehooks-ts/dist/esm/useElementSize/useElementSize.js");
/* harmony import */ var _useEventCallback_useEventCallback__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./useEventCallback/useEventCallback */ "./node_modules/usehooks-ts/dist/esm/useEventCallback/useEventCallback.js");
/* harmony import */ var _useEventListener_useEventListener__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./useEventListener/useEventListener */ "./node_modules/usehooks-ts/dist/esm/useEventListener/useEventListener.js");
/* harmony import */ var _useFetch_useFetch__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./useFetch/useFetch */ "./node_modules/usehooks-ts/dist/esm/useFetch/useFetch.js");
/* harmony import */ var _useHover_useHover__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./useHover/useHover */ "./node_modules/usehooks-ts/dist/esm/useHover/useHover.js");
/* harmony import */ var _useImageOnLoad_useImageOnLoad__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./useImageOnLoad/useImageOnLoad */ "./node_modules/usehooks-ts/dist/esm/useImageOnLoad/useImageOnLoad.js");
/* harmony import */ var _useIntersectionObserver_useIntersectionObserver__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./useIntersectionObserver/useIntersectionObserver */ "./node_modules/usehooks-ts/dist/esm/useIntersectionObserver/useIntersectionObserver.js");
/* harmony import */ var _useInterval_useInterval__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./useInterval/useInterval */ "./node_modules/usehooks-ts/dist/esm/useInterval/useInterval.js");
/* harmony import */ var _useIsClient_useIsClient__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./useIsClient/useIsClient */ "./node_modules/usehooks-ts/dist/esm/useIsClient/useIsClient.js");
/* harmony import */ var _useIsFirstRender_useIsFirstRender__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./useIsFirstRender/useIsFirstRender */ "./node_modules/usehooks-ts/dist/esm/useIsFirstRender/useIsFirstRender.js");
/* harmony import */ var _useIsMounted_useIsMounted__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./useIsMounted/useIsMounted */ "./node_modules/usehooks-ts/dist/esm/useIsMounted/useIsMounted.js");
/* harmony import */ var _useIsomorphicLayoutEffect_useIsomorphicLayoutEffect__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./useIsomorphicLayoutEffect/useIsomorphicLayoutEffect */ "./node_modules/usehooks-ts/dist/esm/useIsomorphicLayoutEffect/useIsomorphicLayoutEffect.js");
/* harmony import */ var _useLocalStorage_useLocalStorage__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./useLocalStorage/useLocalStorage */ "./node_modules/usehooks-ts/dist/esm/useLocalStorage/useLocalStorage.js");
/* harmony import */ var _useLockedBody_useLockedBody__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./useLockedBody/useLockedBody */ "./node_modules/usehooks-ts/dist/esm/useLockedBody/useLockedBody.js");
/* harmony import */ var _useMap_useMap__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./useMap/useMap */ "./node_modules/usehooks-ts/dist/esm/useMap/useMap.js");
/* harmony import */ var _useMediaQuery_useMediaQuery__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./useMediaQuery/useMediaQuery */ "./node_modules/usehooks-ts/dist/esm/useMediaQuery/useMediaQuery.js");
/* harmony import */ var _useOnClickOutside_useOnClickOutside__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ./useOnClickOutside/useOnClickOutside */ "./node_modules/usehooks-ts/dist/esm/useOnClickOutside/useOnClickOutside.js");
/* harmony import */ var _useReadLocalStorage_useReadLocalStorage__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ./useReadLocalStorage/useReadLocalStorage */ "./node_modules/usehooks-ts/dist/esm/useReadLocalStorage/useReadLocalStorage.js");
/* harmony import */ var _useScreen_useScreen__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ./useScreen/useScreen */ "./node_modules/usehooks-ts/dist/esm/useScreen/useScreen.js");
/* harmony import */ var _useScript_useScript__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ./useScript/useScript */ "./node_modules/usehooks-ts/dist/esm/useScript/useScript.js");
/* harmony import */ var _useSessionStorage_useSessionStorage__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ./useSessionStorage/useSessionStorage */ "./node_modules/usehooks-ts/dist/esm/useSessionStorage/useSessionStorage.js");
/* harmony import */ var _useSsr_useSsr__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ./useSsr/useSsr */ "./node_modules/usehooks-ts/dist/esm/useSsr/useSsr.js");
/* harmony import */ var _useStep_useStep__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ./useStep/useStep */ "./node_modules/usehooks-ts/dist/esm/useStep/useStep.js");
/* harmony import */ var _useTernaryDarkMode_useTernaryDarkMode__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ./useTernaryDarkMode/useTernaryDarkMode */ "./node_modules/usehooks-ts/dist/esm/useTernaryDarkMode/useTernaryDarkMode.js");
/* harmony import */ var _useTimeout_useTimeout__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ./useTimeout/useTimeout */ "./node_modules/usehooks-ts/dist/esm/useTimeout/useTimeout.js");
/* harmony import */ var _useToggle_useToggle__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! ./useToggle/useToggle */ "./node_modules/usehooks-ts/dist/esm/useToggle/useToggle.js");
/* harmony import */ var _useUpdateEffect_useUpdateEffect__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! ./useUpdateEffect/useUpdateEffect */ "./node_modules/usehooks-ts/dist/esm/useUpdateEffect/useUpdateEffect.js");
/* harmony import */ var _useWindowSize_useWindowSize__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! ./useWindowSize/useWindowSize */ "./node_modules/usehooks-ts/dist/esm/useWindowSize/useWindowSize.js");












































































/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useBoolean/useBoolean.js":
/*!********************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useBoolean/useBoolean.js ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

function useBoolean(defaultValue) {
    const [value, setValue] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!!defaultValue);
    const setTrue = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => setValue(true), []);
    const setFalse = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => setValue(false), []);
    const toggle = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => setValue(x => !x), []);
    return { value, setValue, setTrue, setFalse, toggle };
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useBoolean);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useClickAnyWhere/useClickAnyWhere.js":
/*!********************************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useClickAnyWhere/useClickAnyWhere.js ***!
  \********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! .. */ "./node_modules/usehooks-ts/dist/esm/index.js");

function useClickAnyWhere(handler) {
    (0,___WEBPACK_IMPORTED_MODULE_0__.useEventListener)('click', event => {
        handler(event);
    });
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useClickAnyWhere);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useCopyToClipboard/useCopyToClipboard.js":
/*!************************************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useCopyToClipboard/useCopyToClipboard.js ***!
  \************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};

function useCopyToClipboard() {
    const [copiedText, setCopiedText] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
    const copy = (text) => __awaiter(this, void 0, void 0, function* () {
        if (!(navigator === null || navigator === void 0 ? void 0 : navigator.clipboard)) {
            console.warn('Clipboard not supported');
            return false;
        }
        try {
            yield navigator.clipboard.writeText(text);
            setCopiedText(text);
            return true;
        }
        catch (error) {
            console.warn('Copy failed', error);
            setCopiedText(null);
            return false;
        }
    });
    return [copiedText, copy];
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useCopyToClipboard);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useCountdown/useCountdown.js":
/*!************************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useCountdown/useCountdown.js ***!
  \************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! .. */ "./node_modules/usehooks-ts/dist/esm/index.js");


function useCountdown(countdownOption) {
    let isDeprecated = false;
    let countStart, intervalMs, isIncrement, countStop;
    if ('seconds' in countdownOption) {
        console.warn('[useCountdown:DEPRECATED] new interface is already available (see https://usehooks-ts.com/react-hook/use-countdown), the old version will retire on usehooks-ts@3.');
        isDeprecated = true;
        countStart = countdownOption.seconds;
        intervalMs = countdownOption.interval;
        isIncrement = countdownOption.isIncrement;
    }
    else {
        ;
        ({ countStart, intervalMs, isIncrement, countStop } = countdownOption);
    }
    intervalMs = intervalMs !== null && intervalMs !== void 0 ? intervalMs : 1000;
    isIncrement = isIncrement !== null && isIncrement !== void 0 ? isIncrement : false;
    countStop = countStop !== null && countStop !== void 0 ? countStop : 0;
    const { count, increment, decrement, reset: resetCounter, } = (0,___WEBPACK_IMPORTED_MODULE_1__.useCounter)(countStart);
    const { value: isCountdownRunning, setTrue: startCountdown, setFalse: stopCountdown, } = (0,___WEBPACK_IMPORTED_MODULE_1__.useBoolean)(false);
    const resetCountdown = () => {
        stopCountdown();
        resetCounter();
    };
    const countdownCallback = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
        if (count === countStop) {
            stopCountdown();
            return;
        }
        if (isIncrement) {
            increment();
        }
        else {
            decrement();
        }
    }, [count, countStop, decrement, increment, isIncrement, stopCountdown]);
    (0,___WEBPACK_IMPORTED_MODULE_1__.useInterval)(countdownCallback, isCountdownRunning ? intervalMs : null);
    return isDeprecated
        ? [
            count,
            {
                start: startCountdown,
                stop: stopCountdown,
                reset: resetCountdown,
            },
        ]
        : [
            count,
            {
                startCountdown,
                stopCountdown,
                resetCountdown,
            },
        ];
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useCountdown);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useCounter/useCounter.js":
/*!********************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useCounter/useCounter.js ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

function useCounter(initialValue) {
    const [count, setCount] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initialValue || 0);
    const increment = () => setCount(x => x + 1);
    const decrement = () => setCount(x => x - 1);
    const reset = () => setCount(initialValue || 0);
    return {
        count,
        increment,
        decrement,
        reset,
        setCount,
    };
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useCounter);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useDarkMode/useDarkMode.js":
/*!**********************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useDarkMode/useDarkMode.js ***!
  \**********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! .. */ "./node_modules/usehooks-ts/dist/esm/index.js");

const COLOR_SCHEME_QUERY = '(prefers-color-scheme: dark)';
function useDarkMode(defaultValue) {
    var _a;
    const isDarkOS = (0,___WEBPACK_IMPORTED_MODULE_0__.useMediaQuery)(COLOR_SCHEME_QUERY);
    const [isDarkMode, setDarkMode] = (0,___WEBPACK_IMPORTED_MODULE_0__.useLocalStorage)('usehooks-ts-dark-mode', (_a = defaultValue !== null && defaultValue !== void 0 ? defaultValue : isDarkOS) !== null && _a !== void 0 ? _a : false);
    (0,___WEBPACK_IMPORTED_MODULE_0__.useUpdateEffect)(() => {
        setDarkMode(isDarkOS);
    }, [isDarkOS]);
    return {
        isDarkMode,
        toggle: () => setDarkMode(prev => !prev),
        enable: () => setDarkMode(true),
        disable: () => setDarkMode(false),
    };
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useDarkMode);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useDebounce/useDebounce.js":
/*!**********************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useDebounce/useDebounce.js ***!
  \**********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

function useDebounce(value, delay) {
    const [debouncedValue, setDebouncedValue] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(value);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        const timer = setTimeout(() => setDebouncedValue(value), delay || 500);
        return () => {
            clearTimeout(timer);
        };
    }, [value, delay]);
    return debouncedValue;
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useDebounce);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useDocumentTitle/useDocumentTitle.js":
/*!********************************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useDocumentTitle/useDocumentTitle.js ***!
  \********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! .. */ "./node_modules/usehooks-ts/dist/esm/index.js");

function useDocumentTitle(title) {
    (0,___WEBPACK_IMPORTED_MODULE_0__.useIsomorphicLayoutEffect)(() => {
        window.document.title = title;
    }, [title]);
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useDocumentTitle);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useEffectOnce/useEffectOnce.js":
/*!**************************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useEffectOnce/useEffectOnce.js ***!
  \**************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

function useEffectOnce(effect) {
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(effect, []);
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useEffectOnce);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useElementSize/useElementSize.js":
/*!****************************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useElementSize/useElementSize.js ***!
  \****************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! .. */ "./node_modules/usehooks-ts/dist/esm/index.js");


function useElementSize() {
    const [ref, setRef] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
    const [size, setSize] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        width: 0,
        height: 0,
    });
    const handleSize = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
        setSize({
            width: (ref === null || ref === void 0 ? void 0 : ref.offsetWidth) || 0,
            height: (ref === null || ref === void 0 ? void 0 : ref.offsetHeight) || 0,
        });
    }, [ref === null || ref === void 0 ? void 0 : ref.offsetHeight, ref === null || ref === void 0 ? void 0 : ref.offsetWidth]);
    (0,___WEBPACK_IMPORTED_MODULE_1__.useEventListener)('resize', handleSize);
    (0,___WEBPACK_IMPORTED_MODULE_1__.useIsomorphicLayoutEffect)(() => {
        handleSize();
    }, [ref === null || ref === void 0 ? void 0 : ref.offsetHeight, ref === null || ref === void 0 ? void 0 : ref.offsetWidth]);
    return [setRef, size];
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useElementSize);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useEventCallback/useEventCallback.js":
/*!********************************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useEventCallback/useEventCallback.js ***!
  \********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ useEventCallback)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! .. */ "./node_modules/usehooks-ts/dist/esm/index.js");


function useEventCallback(fn) {
    const ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(() => {
        throw new Error('Cannot call an event handler while rendering.');
    });
    (0,___WEBPACK_IMPORTED_MODULE_1__.useIsomorphicLayoutEffect)(() => {
        ref.current = fn;
    }, [fn]);
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((...args) => ref.current(...args), [ref]);
}


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useEventListener/useEventListener.js":
/*!********************************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useEventListener/useEventListener.js ***!
  \********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! .. */ "./node_modules/usehooks-ts/dist/esm/index.js");


function useEventListener(eventName, handler, element, options) {
    const savedHandler = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(handler);
    (0,___WEBPACK_IMPORTED_MODULE_1__.useIsomorphicLayoutEffect)(() => {
        savedHandler.current = handler;
    }, [handler]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        var _a;
        const targetElement = (_a = element === null || element === void 0 ? void 0 : element.current) !== null && _a !== void 0 ? _a : window;
        if (!(targetElement && targetElement.addEventListener))
            return;
        const listener = event => savedHandler.current(event);
        targetElement.addEventListener(eventName, listener, options);
        return () => {
            targetElement.removeEventListener(eventName, listener, options);
        };
    }, [eventName, element, options]);
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useEventListener);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useFetch/useFetch.js":
/*!****************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useFetch/useFetch.js ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};

function useFetch(url, options) {
    const cache = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({});
    const cancelRequest = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    const initialState = {
        error: undefined,
        data: undefined,
    };
    const fetchReducer = (state, action) => {
        switch (action.type) {
            case 'loading':
                return Object.assign({}, initialState);
            case 'fetched':
                return Object.assign(Object.assign({}, initialState), { data: action.payload });
            case 'error':
                return Object.assign(Object.assign({}, initialState), { error: action.payload });
            default:
                return state;
        }
    };
    const [state, dispatch] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)(fetchReducer, initialState);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        if (!url)
            return;
        cancelRequest.current = false;
        const fetchData = () => __awaiter(this, void 0, void 0, function* () {
            dispatch({ type: 'loading' });
            if (cache.current[url]) {
                dispatch({ type: 'fetched', payload: cache.current[url] });
                return;
            }
            try {
                const response = yield fetch(url, options);
                if (!response.ok) {
                    throw new Error(response.statusText);
                }
                const data = (yield response.json());
                cache.current[url] = data;
                if (cancelRequest.current)
                    return;
                dispatch({ type: 'fetched', payload: data });
            }
            catch (error) {
                if (cancelRequest.current)
                    return;
                dispatch({ type: 'error', payload: error });
            }
        });
        void fetchData();
        return () => {
            cancelRequest.current = true;
        };
    }, [url]);
    return state;
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useFetch);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useHover/useHover.js":
/*!****************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useHover/useHover.js ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! .. */ "./node_modules/usehooks-ts/dist/esm/index.js");


function useHover(elementRef) {
    const [value, setValue] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    const handleMouseEnter = () => setValue(true);
    const handleMouseLeave = () => setValue(false);
    (0,___WEBPACK_IMPORTED_MODULE_1__.useEventListener)('mouseenter', handleMouseEnter, elementRef);
    (0,___WEBPACK_IMPORTED_MODULE_1__.useEventListener)('mouseleave', handleMouseLeave, elementRef);
    return value;
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useHover);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useImageOnLoad/useImageOnLoad.js":
/*!****************************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useImageOnLoad/useImageOnLoad.js ***!
  \****************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

function useImageOnLoad() {
    const [isLoaded, setIsLoaded] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    const handleImageOnLoad = () => {
        setIsLoaded(true);
    };
    const css = {
        thumbnail: {
            visibility: isLoaded ? 'hidden' : 'visible',
            filter: 'blur(8px)',
            transition: 'visibility 0ms ease-out 500ms',
        },
        fullSize: {
            opacity: isLoaded ? 1 : 0,
            transition: 'opacity 500ms ease-in 0ms',
        },
    };
    return { handleImageOnLoad, css };
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useImageOnLoad);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useIntersectionObserver/useIntersectionObserver.js":
/*!**********************************************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useIntersectionObserver/useIntersectionObserver.js ***!
  \**********************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

function useIntersectionObserver(elementRef, { threshold = 0, root = null, rootMargin = '0%', freezeOnceVisible = false, }) {
    const [entry, setEntry] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)();
    const frozen = (entry === null || entry === void 0 ? void 0 : entry.isIntersecting) && freezeOnceVisible;
    const updateEntry = ([entry]) => {
        setEntry(entry);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        const node = elementRef === null || elementRef === void 0 ? void 0 : elementRef.current;
        const hasIOSupport = !!window.IntersectionObserver;
        if (!hasIOSupport || frozen || !node)
            return;
        const observerParams = { threshold, root, rootMargin };
        const observer = new IntersectionObserver(updateEntry, observerParams);
        observer.observe(node);
        return () => observer.disconnect();
    }, [elementRef === null || elementRef === void 0 ? void 0 : elementRef.current, JSON.stringify(threshold), root, rootMargin, frozen]);
    return entry;
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useIntersectionObserver);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useInterval/useInterval.js":
/*!**********************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useInterval/useInterval.js ***!
  \**********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! .. */ "./node_modules/usehooks-ts/dist/esm/index.js");


function useInterval(callback, delay) {
    const savedCallback = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(callback);
    (0,___WEBPACK_IMPORTED_MODULE_1__.useIsomorphicLayoutEffect)(() => {
        savedCallback.current = callback;
    }, [callback]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        if (!delay && delay !== 0) {
            return;
        }
        const id = setInterval(() => savedCallback.current(), delay);
        return () => clearInterval(id);
    }, [delay]);
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useInterval);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useIsClient/useIsClient.js":
/*!**********************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useIsClient/useIsClient.js ***!
  \**********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

function useIsClient() {
    const [isClient, setClient] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        setClient(true);
    }, []);
    return isClient;
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useIsClient);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useIsFirstRender/useIsFirstRender.js":
/*!********************************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useIsFirstRender/useIsFirstRender.js ***!
  \********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

function useIsFirstRender() {
    const isFirst = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(true);
    if (isFirst.current) {
        isFirst.current = false;
        return true;
    }
    return isFirst.current;
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useIsFirstRender);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useIsMounted/useIsMounted.js":
/*!************************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useIsMounted/useIsMounted.js ***!
  \************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

function useIsMounted() {
    const isMounted = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        isMounted.current = true;
        return () => {
            isMounted.current = false;
        };
    }, []);
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => isMounted.current, []);
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useIsMounted);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useIsomorphicLayoutEffect/useIsomorphicLayoutEffect.js":
/*!**************************************************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useIsomorphicLayoutEffect/useIsomorphicLayoutEffect.js ***!
  \**************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : react__WEBPACK_IMPORTED_MODULE_0__.useEffect;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useIsomorphicLayoutEffect);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useLocalStorage/useLocalStorage.js":
/*!******************************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useLocalStorage/useLocalStorage.js ***!
  \******************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! .. */ "./node_modules/usehooks-ts/dist/esm/index.js");


function useLocalStorage(key, initialValue) {
    const readValue = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
        if (typeof window === 'undefined') {
            return initialValue;
        }
        try {
            const item = window.localStorage.getItem(key);
            return item ? parseJSON(item) : initialValue;
        }
        catch (error) {
            console.warn(`Error reading localStorage key “${key}”:`, error);
            return initialValue;
        }
    }, [initialValue, key]);
    const [storedValue, setStoredValue] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(readValue);
    const setValue = (0,___WEBPACK_IMPORTED_MODULE_1__.useEventCallback)(value => {
        if (typeof window === 'undefined') {
            console.warn(`Tried setting localStorage key “${key}” even though environment is not a client`);
        }
        try {
            const newValue = value instanceof Function ? value(storedValue) : value;
            window.localStorage.setItem(key, JSON.stringify(newValue));
            setStoredValue(newValue);
            window.dispatchEvent(new Event('local-storage'));
        }
        catch (error) {
            console.warn(`Error setting localStorage key “${key}”:`, error);
        }
    });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        setStoredValue(readValue());
    }, []);
    const handleStorageChange = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((event) => {
        if ((event === null || event === void 0 ? void 0 : event.key) && event.key !== key) {
            return;
        }
        setStoredValue(readValue());
    }, [key, readValue]);
    (0,___WEBPACK_IMPORTED_MODULE_1__.useEventListener)('storage', handleStorageChange);
    (0,___WEBPACK_IMPORTED_MODULE_1__.useEventListener)('local-storage', handleStorageChange);
    return [storedValue, setValue];
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useLocalStorage);
function parseJSON(value) {
    try {
        return value === 'undefined' ? undefined : JSON.parse(value !== null && value !== void 0 ? value : '');
    }
    catch (_a) {
        console.log('parsing error on', { value });
        return undefined;
    }
}


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useLockedBody/useLockedBody.js":
/*!**************************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useLockedBody/useLockedBody.js ***!
  \**************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! .. */ "./node_modules/usehooks-ts/dist/esm/index.js");


function useLockedBody(initialLocked = false, rootId = '___gatsby') {
    const [locked, setLocked] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initialLocked);
    (0,___WEBPACK_IMPORTED_MODULE_1__.useIsomorphicLayoutEffect)(() => {
        if (!locked) {
            return;
        }
        const originalOverflow = document.body.style.overflow;
        const originalPaddingRight = document.body.style.paddingRight;
        document.body.style.overflow = 'hidden';
        const root = document.getElementById(rootId);
        const scrollBarWidth = root ? root.offsetWidth - root.scrollWidth : 0;
        if (scrollBarWidth) {
            document.body.style.paddingRight = `${scrollBarWidth}px`;
        }
        return () => {
            document.body.style.overflow = originalOverflow;
            if (scrollBarWidth) {
                document.body.style.paddingRight = originalPaddingRight;
            }
        };
    }, [locked]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        if (locked !== initialLocked) {
            setLocked(initialLocked);
        }
    }, [initialLocked]);
    return [locked, setLocked];
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useLockedBody);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useMap/useMap.js":
/*!************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useMap/useMap.js ***!
  \************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

function useMap(initialState = new Map()) {
    const [map, setMap] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(new Map(initialState));
    const actions = {
        set: (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((key, value) => {
            setMap(prev => {
                const copy = new Map(prev);
                copy.set(key, value);
                return copy;
            });
        }, []),
        setAll: (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(entries => {
            setMap(() => new Map(entries));
        }, []),
        remove: (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(key => {
            setMap(prev => {
                const copy = new Map(prev);
                copy.delete(key);
                return copy;
            });
        }, []),
        reset: (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
            setMap(() => new Map());
        }, []),
    };
    return [map, actions];
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useMap);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useMediaQuery/useMediaQuery.js":
/*!**************************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useMediaQuery/useMediaQuery.js ***!
  \**************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

function useMediaQuery(query) {
    const getMatches = (query) => {
        if (typeof window !== 'undefined') {
            return window.matchMedia(query).matches;
        }
        return false;
    };
    const [matches, setMatches] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(getMatches(query));
    function handleChange() {
        setMatches(getMatches(query));
    }
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        const matchMedia = window.matchMedia(query);
        handleChange();
        if (matchMedia.addListener) {
            matchMedia.addListener(handleChange);
        }
        else {
            matchMedia.addEventListener('change', handleChange);
        }
        return () => {
            if (matchMedia.removeListener) {
                matchMedia.removeListener(handleChange);
            }
            else {
                matchMedia.removeEventListener('change', handleChange);
            }
        };
    }, [query]);
    return matches;
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useMediaQuery);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useOnClickOutside/useOnClickOutside.js":
/*!**********************************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useOnClickOutside/useOnClickOutside.js ***!
  \**********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! .. */ "./node_modules/usehooks-ts/dist/esm/index.js");

function useOnClickOutside(ref, handler, mouseEvent = 'mousedown') {
    (0,___WEBPACK_IMPORTED_MODULE_0__.useEventListener)(mouseEvent, event => {
        const el = ref === null || ref === void 0 ? void 0 : ref.current;
        if (!el || el.contains(event.target)) {
            return;
        }
        handler(event);
    });
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useOnClickOutside);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useReadLocalStorage/useReadLocalStorage.js":
/*!**************************************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useReadLocalStorage/useReadLocalStorage.js ***!
  \**************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! .. */ "./node_modules/usehooks-ts/dist/esm/index.js");


function useReadLocalStorage(key) {
    const readValue = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
        if (typeof window === 'undefined') {
            return null;
        }
        try {
            const item = window.localStorage.getItem(key);
            return item ? JSON.parse(item) : null;
        }
        catch (error) {
            console.warn(`Error reading localStorage key “${key}”:`, error);
            return null;
        }
    }, [key]);
    const [storedValue, setStoredValue] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(readValue);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        setStoredValue(readValue());
    }, []);
    const handleStorageChange = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((event) => {
        if ((event === null || event === void 0 ? void 0 : event.key) && event.key !== key) {
            return;
        }
        setStoredValue(readValue());
    }, [key, readValue]);
    (0,___WEBPACK_IMPORTED_MODULE_1__.useEventListener)('storage', handleStorageChange);
    (0,___WEBPACK_IMPORTED_MODULE_1__.useEventListener)('local-storage', handleStorageChange);
    return storedValue;
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useReadLocalStorage);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useScreen/useScreen.js":
/*!******************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useScreen/useScreen.js ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! .. */ "./node_modules/usehooks-ts/dist/esm/index.js");


function useScreen() {
    const getScreen = () => {
        if (typeof window !== 'undefined' && window.screen) {
            return window.screen;
        }
        return undefined;
    };
    const [screen, setScreen] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(getScreen());
    function handleSize() {
        setScreen(getScreen());
    }
    (0,___WEBPACK_IMPORTED_MODULE_1__.useEventListener)('resize', handleSize);
    (0,___WEBPACK_IMPORTED_MODULE_1__.useIsomorphicLayoutEffect)(() => {
        handleSize();
    }, []);
    return screen;
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useScreen);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useScript/useScript.js":
/*!******************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useScript/useScript.js ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

const cachedScriptStatuses = {};
function getScriptNode(src) {
    const node = document.querySelector(`script[src="${src}"]`);
    const status = node === null || node === void 0 ? void 0 : node.getAttribute('data-status');
    return {
        node,
        status,
    };
}
function useScript(src, options) {
    const [status, setStatus] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(() => {
        var _a;
        if (!src || (options === null || options === void 0 ? void 0 : options.shouldPreventLoad)) {
            return 'idle';
        }
        if (typeof window === 'undefined') {
            return 'loading';
        }
        return (_a = cachedScriptStatuses[src]) !== null && _a !== void 0 ? _a : 'loading';
    });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        var _a, _b;
        if (!src || (options === null || options === void 0 ? void 0 : options.shouldPreventLoad)) {
            return;
        }
        const cachedScriptStatus = cachedScriptStatuses[src];
        if (cachedScriptStatus === 'ready' || cachedScriptStatus === 'error') {
            setStatus(cachedScriptStatus);
            return;
        }
        const script = getScriptNode(src);
        let scriptNode = script.node;
        if (!scriptNode) {
            scriptNode = document.createElement('script');
            scriptNode.src = src;
            scriptNode.async = true;
            scriptNode.setAttribute('data-status', 'loading');
            document.body.appendChild(scriptNode);
            const setAttributeFromEvent = (event) => {
                const scriptStatus = event.type === 'load' ? 'ready' : 'error';
                scriptNode === null || scriptNode === void 0 ? void 0 : scriptNode.setAttribute('data-status', scriptStatus);
            };
            scriptNode.addEventListener('load', setAttributeFromEvent);
            scriptNode.addEventListener('error', setAttributeFromEvent);
        }
        else {
            setStatus((_b = (_a = script.status) !== null && _a !== void 0 ? _a : cachedScriptStatus) !== null && _b !== void 0 ? _b : 'loading');
        }
        const setStateFromEvent = (event) => {
            const newStatus = event.type === 'load' ? 'ready' : 'error';
            setStatus(newStatus);
            cachedScriptStatuses[src] = newStatus;
        };
        scriptNode.addEventListener('load', setStateFromEvent);
        scriptNode.addEventListener('error', setStateFromEvent);
        return () => {
            if (scriptNode) {
                scriptNode.removeEventListener('load', setStateFromEvent);
                scriptNode.removeEventListener('error', setStateFromEvent);
            }
            if (scriptNode && (options === null || options === void 0 ? void 0 : options.removeOnUnmount)) {
                scriptNode.remove();
            }
        };
    }, [src, options === null || options === void 0 ? void 0 : options.shouldPreventLoad, options === null || options === void 0 ? void 0 : options.removeOnUnmount]);
    return status;
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useScript);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useSessionStorage/useSessionStorage.js":
/*!**********************************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useSessionStorage/useSessionStorage.js ***!
  \**********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! .. */ "./node_modules/usehooks-ts/dist/esm/index.js");


function useSessionStorage(key, initialValue) {
    const readValue = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
        if (typeof window === 'undefined') {
            return initialValue;
        }
        try {
            const item = window.sessionStorage.getItem(key);
            return item ? parseJSON(item) : initialValue;
        }
        catch (error) {
            console.warn(`Error reading sessionStorage key “${key}”:`, error);
            return initialValue;
        }
    }, [initialValue, key]);
    const [storedValue, setStoredValue] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(readValue);
    const setValue = (0,___WEBPACK_IMPORTED_MODULE_1__.useEventCallback)(value => {
        if (typeof window == 'undefined') {
            console.warn(`Tried setting sessionStorage key “${key}” even though environment is not a client`);
        }
        try {
            const newValue = value instanceof Function ? value(storedValue) : value;
            window.sessionStorage.setItem(key, JSON.stringify(newValue));
            setStoredValue(newValue);
            window.dispatchEvent(new Event('session-storage'));
        }
        catch (error) {
            console.warn(`Error setting sessionStorage key “${key}”:`, error);
        }
    });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        setStoredValue(readValue());
    }, []);
    const handleStorageChange = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((event) => {
        if ((event === null || event === void 0 ? void 0 : event.key) && event.key !== key) {
            return;
        }
        setStoredValue(readValue());
    }, [key, readValue]);
    (0,___WEBPACK_IMPORTED_MODULE_1__.useEventListener)('storage', handleStorageChange);
    (0,___WEBPACK_IMPORTED_MODULE_1__.useEventListener)('session-storage', handleStorageChange);
    return [storedValue, setValue];
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useSessionStorage);
function parseJSON(value) {
    try {
        return value === 'undefined' ? undefined : JSON.parse(value !== null && value !== void 0 ? value : '');
    }
    catch (_a) {
        console.log('parsing error on', { value });
        return undefined;
    }
}


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useSsr/useSsr.js":
/*!************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useSsr/useSsr.js ***!
  \************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function useSsr() {
    const isDOM = typeof window !== 'undefined' &&
        window.document &&
        window.document.documentElement;
    return {
        isBrowser: isDOM,
        isServer: !isDOM,
    };
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useSsr);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useStep/useStep.js":
/*!**************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useStep/useStep.js ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

function useStep(maxStep) {
    const [currentStep, setCurrentStep] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(1);
    const canGoToNextStep = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => currentStep + 1 <= maxStep, [currentStep, maxStep]);
    const canGoToPrevStep = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => currentStep - 1 >= 1, [currentStep]);
    const setStep = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(step => {
        const newStep = step instanceof Function ? step(currentStep) : step;
        if (newStep >= 1 && newStep <= maxStep) {
            setCurrentStep(newStep);
            return;
        }
        throw new Error('Step not valid');
    }, [maxStep, currentStep]);
    const goToNextStep = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
        if (canGoToNextStep) {
            setCurrentStep(step => step + 1);
        }
    }, [canGoToNextStep]);
    const goToPrevStep = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
        if (canGoToPrevStep) {
            setCurrentStep(step => step - 1);
        }
    }, [canGoToPrevStep]);
    const reset = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
        setCurrentStep(1);
    }, []);
    return [
        currentStep,
        {
            goToNextStep,
            goToPrevStep,
            canGoToNextStep,
            canGoToPrevStep,
            setStep,
            reset,
        },
    ];
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useStep);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useTernaryDarkMode/useTernaryDarkMode.js":
/*!************************************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useTernaryDarkMode/useTernaryDarkMode.js ***!
  \************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! .. */ "./node_modules/usehooks-ts/dist/esm/index.js");


const COLOR_SCHEME_QUERY = '(prefers-color-scheme: dark)';
function useTernaryDarkMode() {
    const isDarkOS = (0,___WEBPACK_IMPORTED_MODULE_1__.useMediaQuery)(COLOR_SCHEME_QUERY);
    const [ternaryDarkMode, setTernaryDarkMode] = (0,___WEBPACK_IMPORTED_MODULE_1__.useLocalStorage)('usehooks-ts-ternary-dark-mode', 'system');
    const [isDarkMode, setDarkMode] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(isDarkOS);
    (0,___WEBPACK_IMPORTED_MODULE_1__.useUpdateEffect)(() => {
        if (ternaryDarkMode === 'system') {
            setDarkMode(isDarkOS);
        }
    }, [isDarkOS]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        switch (ternaryDarkMode) {
            case 'light':
                setDarkMode(false);
                break;
            case 'system':
                setDarkMode(isDarkOS);
                break;
            case 'dark':
                setDarkMode(true);
                break;
        }
    }, [ternaryDarkMode, isDarkOS]);
    function toggleTernaryDarkMode() {
        const toggleDict = {
            light: 'system',
            system: 'dark',
            dark: 'light',
        };
        setTernaryDarkMode(prevMode => toggleDict[prevMode]);
    }
    return {
        isDarkMode,
        ternaryDarkMode,
        setTernaryDarkMode,
        toggleTernaryDarkMode,
    };
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useTernaryDarkMode);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useTimeout/useTimeout.js":
/*!********************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useTimeout/useTimeout.js ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! .. */ "./node_modules/usehooks-ts/dist/esm/index.js");


function useTimeout(callback, delay) {
    const savedCallback = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(callback);
    (0,___WEBPACK_IMPORTED_MODULE_1__.useIsomorphicLayoutEffect)(() => {
        savedCallback.current = callback;
    }, [callback]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        if (!delay && delay !== 0) {
            return;
        }
        const id = setTimeout(() => savedCallback.current(), delay);
        return () => clearTimeout(id);
    }, [delay]);
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useTimeout);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useToggle/useToggle.js":
/*!******************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useToggle/useToggle.js ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

function useToggle(defaultValue) {
    const [value, setValue] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!!defaultValue);
    const toggle = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => setValue(x => !x), []);
    return [value, toggle, setValue];
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useToggle);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useUpdateEffect/useUpdateEffect.js":
/*!******************************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useUpdateEffect/useUpdateEffect.js ***!
  \******************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! .. */ "./node_modules/usehooks-ts/dist/esm/index.js");


function useUpdateEffect(effect, deps) {
    const isFirst = (0,___WEBPACK_IMPORTED_MODULE_1__.useIsFirstRender)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        if (!isFirst) {
            return effect();
        }
    }, deps);
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useUpdateEffect);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useWindowSize/useWindowSize.js":
/*!**************************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useWindowSize/useWindowSize.js ***!
  \**************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! .. */ "./node_modules/usehooks-ts/dist/esm/index.js");


function useWindowSize() {
    const [windowSize, setWindowSize] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        width: 0,
        height: 0,
    });
    const handleSize = () => {
        setWindowSize({
            width: window.innerWidth,
            height: window.innerHeight,
        });
    };
    (0,___WEBPACK_IMPORTED_MODULE_1__.useEventListener)('resize', handleSize);
    (0,___WEBPACK_IMPORTED_MODULE_1__.useIsomorphicLayoutEffect)(() => {
        handleSize();
    }, []);
    return windowSize;
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useWindowSize);


/***/ }),

/***/ "@fluentui/utilities":
/*!**************************************!*\
  !*** external "@fluentui/utilities" ***!
  \**************************************/
/***/ ((module) => {

module.exports = require("@fluentui/utilities");

/***/ }),

/***/ "adaptive-expressions":
/*!***************************************!*\
  !*** external "adaptive-expressions" ***!
  \***************************************/
/***/ ((module) => {

module.exports = require("adaptive-expressions");

/***/ }),

/***/ "adaptivecards":
/*!********************************!*\
  !*** external "adaptivecards" ***!
  \********************************/
/***/ ((module) => {

module.exports = require("adaptivecards");

/***/ }),

/***/ "adaptivecards-templating/lib/template-engine":
/*!***************************************************************!*\
  !*** external "adaptivecards-templating/lib/template-engine" ***!
  \***************************************************************/
/***/ ((module) => {

module.exports = require("adaptivecards-templating/lib/template-engine");

/***/ }),

/***/ "botframework-webchat":
/*!***************************************!*\
  !*** external "botframework-webchat" ***!
  \***************************************/
/***/ ((module) => {

module.exports = require("botframework-webchat");

/***/ }),

/***/ "dayjs":
/*!************************!*\
  !*** external "dayjs" ***!
  \************************/
/***/ ((module) => {

module.exports = require("dayjs");

/***/ }),

/***/ "dayjs/plugin/advancedFormat":
/*!**********************************************!*\
  !*** external "dayjs/plugin/advancedFormat" ***!
  \**********************************************/
/***/ ((module) => {

module.exports = require("dayjs/plugin/advancedFormat");

/***/ }),

/***/ "dayjs/plugin/duration":
/*!****************************************!*\
  !*** external "dayjs/plugin/duration" ***!
  \****************************************/
/***/ ((module) => {

module.exports = require("dayjs/plugin/duration");

/***/ }),

/***/ "dayjs/plugin/isoWeek":
/*!***************************************!*\
  !*** external "dayjs/plugin/isoWeek" ***!
  \***************************************/
/***/ ((module) => {

module.exports = require("dayjs/plugin/isoWeek");

/***/ }),

/***/ "dayjs/plugin/relativeTime":
/*!********************************************!*\
  !*** external "dayjs/plugin/relativeTime" ***!
  \********************************************/
/***/ ((module) => {

module.exports = require("dayjs/plugin/relativeTime");

/***/ }),

/***/ "dayjs/plugin/utc":
/*!***********************************!*\
  !*** external "dayjs/plugin/utc" ***!
  \***********************************/
/***/ ((module) => {

module.exports = require("dayjs/plugin/utc");

/***/ }),

/***/ "react":
/*!************************!*\
  !*** external "react" ***!
  \************************/
/***/ ((module) => {

module.exports = require("react");

/***/ }),

/***/ "react-jss":
/*!****************************!*\
  !*** external "react-jss" ***!
  \****************************/
/***/ ((module) => {

module.exports = require("react-jss");

/***/ }),

/***/ "recoil":
/*!*************************!*\
  !*** external "recoil" ***!
  \*************************/
/***/ ((module) => {

module.exports = require("recoil");

/***/ }),

/***/ "tslib":
/*!************************!*\
  !*** external "tslib" ***!
  \************************/
/***/ ((module) => {

module.exports = require("tslib");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module is referenced by other modules so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__("./src/index.ts");
/******/ 	var __webpack_export_target__ = exports;
/******/ 	for(var i in __webpack_exports__) __webpack_export_target__[i] = __webpack_exports__[i];
/******/ 	if(__webpack_exports__.__esModule) Object.defineProperty(__webpack_export_target__, "__esModule", { value: true });
/******/ 	
/******/ })()
;
//# sourceMappingURL=index.js.map